
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6818"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6818"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kNOdC", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f24f56a526d65c9e$export$ffb0004e005737fa; }, function (v) { return $f24f56a526d65c9e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $f24f56a526d65c9e$export$34b9dba7ce09269b; }, function (v) { return $f24f56a526d65c9e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $f24f56a526d65c9e$export$25062201e9e25d76; }, function (v) { return $f24f56a526d65c9e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f24f56a526d65c9e$export$ffb0004e005737fa;
var $f24f56a526d65c9e$export$34b9dba7ce09269b;
var $f24f56a526d65c9e$export$25062201e9e25d76;
"use strict";
var $f24f56a526d65c9e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f24f56a526d65c9e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $f24f56a526d65c9e$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $f24f56a526d65c9e$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$f24f56a526d65c9e$export$ffb0004e005737fa = $f24f56a526d65c9e$var$REACT_FRAGMENT_TYPE;
$f24f56a526d65c9e$export$34b9dba7ce09269b = $f24f56a526d65c9e$var$jsxProd;
$f24f56a526d65c9e$export$25062201e9e25d76 = $f24f56a526d65c9e$var$jsxProd;

});

parcelRegister("GDJFN", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $0802bf0880b1ef59$export$9c16c1426311996d; }, function (v) { return $0802bf0880b1ef59$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $0802bf0880b1ef59$export$dca3b0875bd9a954; }, function (v) { return $0802bf0880b1ef59$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0802bf0880b1ef59$export$16fa2f45be04daa8; }, function (v) { return $0802bf0880b1ef59$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0802bf0880b1ef59$export$ffb0004e005737fa; }, function (v) { return $0802bf0880b1ef59$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0802bf0880b1ef59$export$e2c29f18771995cb; }, function (v) { return $0802bf0880b1ef59$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0802bf0880b1ef59$export$221d75b3f55bb0bd; }, function (v) { return $0802bf0880b1ef59$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0802bf0880b1ef59$export$5f8d39834fd61797; }, function (v) { return $0802bf0880b1ef59$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0802bf0880b1ef59$export$74bf444e3cd11ea5; }, function (v) { return $0802bf0880b1ef59$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $0802bf0880b1ef59$export$1ced07cd6b1985ce; }, function (v) { return $0802bf0880b1ef59$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $0802bf0880b1ef59$export$abd8e32b826d7ea7; }, function (v) { return $0802bf0880b1ef59$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $0802bf0880b1ef59$export$69a3209f1a06c04d; }, function (v) { return $0802bf0880b1ef59$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $0802bf0880b1ef59$export$8c538325882c7eec; }, function (v) { return $0802bf0880b1ef59$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0802bf0880b1ef59$export$e530037191fcd5d7; }, function (v) { return $0802bf0880b1ef59$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0802bf0880b1ef59$export$fd42f52fd3ae1109; }, function (v) { return $0802bf0880b1ef59$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0802bf0880b1ef59$export$c8a8987d4410bf2d; }, function (v) { return $0802bf0880b1ef59$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $0802bf0880b1ef59$export$7d1e3a5e95ceca43; }, function (v) { return $0802bf0880b1ef59$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0802bf0880b1ef59$export$257a8862b851cb5b; }, function (v) { return $0802bf0880b1ef59$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0802bf0880b1ef59$export$a8257692ac88316c; }, function (v) { return $0802bf0880b1ef59$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0802bf0880b1ef59$export$488013bae63b21da; }, function (v) { return $0802bf0880b1ef59$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0802bf0880b1ef59$export$7c73462e0d25e514; }, function (v) { return $0802bf0880b1ef59$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0802bf0880b1ef59$export$7568632d0d33d16d; }, function (v) { return $0802bf0880b1ef59$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $0802bf0880b1ef59$export$f93f40ac0ca7e3a8; }, function (v) { return $0802bf0880b1ef59$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $0802bf0880b1ef59$export$1f96ae73734a86cc; }, function (v) { return $0802bf0880b1ef59$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $0802bf0880b1ef59$export$9a47ced3238df325; }, function (v) { return $0802bf0880b1ef59$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0802bf0880b1ef59$export$35808ee640e87ca7; }, function (v) { return $0802bf0880b1ef59$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0802bf0880b1ef59$export$fae74005e78b1a27; }, function (v) { return $0802bf0880b1ef59$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0802bf0880b1ef59$export$dc8fbce3eb94dc1e; }, function (v) { return $0802bf0880b1ef59$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0802bf0880b1ef59$export$6a7bc4e911dc01cf; }, function (v) { return $0802bf0880b1ef59$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0802bf0880b1ef59$export$6d9c69b0de29b591; }, function (v) { return $0802bf0880b1ef59$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $0802bf0880b1ef59$export$7f54fc3180508a52; }, function (v) { return $0802bf0880b1ef59$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $0802bf0880b1ef59$export$f680877a34711e37; }, function (v) { return $0802bf0880b1ef59$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0802bf0880b1ef59$export$d5a552a76deda3c2; }, function (v) { return $0802bf0880b1ef59$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0802bf0880b1ef59$export$aaabe4eda9ed9969; }, function (v) { return $0802bf0880b1ef59$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0802bf0880b1ef59$export$e5c5a5f917a5871c; }, function (v) { return $0802bf0880b1ef59$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0802bf0880b1ef59$export$1538c33de8887b59; }, function (v) { return $0802bf0880b1ef59$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $0802bf0880b1ef59$export$fca7f784ae7a249a; }, function (v) { return $0802bf0880b1ef59$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $0802bf0880b1ef59$export$13e3392192263954; }, function (v) { return $0802bf0880b1ef59$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0802bf0880b1ef59$export$b8f5890fc79d6aca; }, function (v) { return $0802bf0880b1ef59$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0802bf0880b1ef59$export$60241385465d0a34; }, function (v) { return $0802bf0880b1ef59$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0802bf0880b1ef59$export$306c0aa65ff9ec16; }, function (v) { return $0802bf0880b1ef59$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0802bf0880b1ef59$export$7b286972b8d8ccbf; }, function (v) { return $0802bf0880b1ef59$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0802bf0880b1ef59$export$83d89fbfd8236492; }, function (v) { return $0802bf0880b1ef59$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0802bf0880b1ef59$export$9c16c1426311996d;
var $0802bf0880b1ef59$export$dca3b0875bd9a954;
var $0802bf0880b1ef59$export$16fa2f45be04daa8;
var $0802bf0880b1ef59$export$ffb0004e005737fa;
var $0802bf0880b1ef59$export$e2c29f18771995cb;
var $0802bf0880b1ef59$export$221d75b3f55bb0bd;
var $0802bf0880b1ef59$export$5f8d39834fd61797;
var $0802bf0880b1ef59$export$74bf444e3cd11ea5;
var $0802bf0880b1ef59$export$1ced07cd6b1985ce;
var $0802bf0880b1ef59$export$abd8e32b826d7ea7;
var $0802bf0880b1ef59$export$69a3209f1a06c04d;
var $0802bf0880b1ef59$export$8c538325882c7eec;
var $0802bf0880b1ef59$export$e530037191fcd5d7;
var $0802bf0880b1ef59$export$fd42f52fd3ae1109;
var $0802bf0880b1ef59$export$c8a8987d4410bf2d;
var $0802bf0880b1ef59$export$7d1e3a5e95ceca43;
var $0802bf0880b1ef59$export$257a8862b851cb5b;
var $0802bf0880b1ef59$export$a8257692ac88316c;
var $0802bf0880b1ef59$export$488013bae63b21da;
var $0802bf0880b1ef59$export$7c73462e0d25e514;
var $0802bf0880b1ef59$export$7568632d0d33d16d;
var $0802bf0880b1ef59$export$f93f40ac0ca7e3a8;
var $0802bf0880b1ef59$export$1f96ae73734a86cc;
var $0802bf0880b1ef59$export$9a47ced3238df325;
var $0802bf0880b1ef59$export$35808ee640e87ca7;
var $0802bf0880b1ef59$export$fae74005e78b1a27;
var $0802bf0880b1ef59$export$dc8fbce3eb94dc1e;
var $0802bf0880b1ef59$export$6a7bc4e911dc01cf;
var $0802bf0880b1ef59$export$6d9c69b0de29b591;
var $0802bf0880b1ef59$export$7f54fc3180508a52;
var $0802bf0880b1ef59$export$f680877a34711e37;
var $0802bf0880b1ef59$export$d5a552a76deda3c2;
var $0802bf0880b1ef59$export$aaabe4eda9ed9969;
var $0802bf0880b1ef59$export$e5c5a5f917a5871c;
var $0802bf0880b1ef59$export$1538c33de8887b59;
var $0802bf0880b1ef59$export$fca7f784ae7a249a;
var $0802bf0880b1ef59$export$13e3392192263954;
var $0802bf0880b1ef59$export$b8f5890fc79d6aca;
var $0802bf0880b1ef59$export$60241385465d0a34;
var $0802bf0880b1ef59$export$306c0aa65ff9ec16;
var $0802bf0880b1ef59$export$7b286972b8d8ccbf;
var $0802bf0880b1ef59$export$83d89fbfd8236492;
"use strict";
var $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0802bf0880b1ef59$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $0802bf0880b1ef59$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $0802bf0880b1ef59$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $0802bf0880b1ef59$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $0802bf0880b1ef59$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $0802bf0880b1ef59$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $0802bf0880b1ef59$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $0802bf0880b1ef59$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $0802bf0880b1ef59$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $0802bf0880b1ef59$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $0802bf0880b1ef59$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $0802bf0880b1ef59$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $0802bf0880b1ef59$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $0802bf0880b1ef59$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$0802bf0880b1ef59$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $0802bf0880b1ef59$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0802bf0880b1ef59$var$assign = Object.assign, $0802bf0880b1ef59$var$emptyObject = {};
function $0802bf0880b1ef59$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0802bf0880b1ef59$var$emptyObject;
    this.updater = updater || $0802bf0880b1ef59$var$ReactNoopUpdateQueue;
}
$0802bf0880b1ef59$var$Component.prototype.isReactComponent = {};
$0802bf0880b1ef59$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$0802bf0880b1ef59$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $0802bf0880b1ef59$var$ComponentDummy() {}
$0802bf0880b1ef59$var$ComponentDummy.prototype = $0802bf0880b1ef59$var$Component.prototype;
function $0802bf0880b1ef59$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $0802bf0880b1ef59$var$emptyObject;
    this.updater = updater || $0802bf0880b1ef59$var$ReactNoopUpdateQueue;
}
var $0802bf0880b1ef59$var$pureComponentPrototype = $0802bf0880b1ef59$var$PureComponent.prototype = new $0802bf0880b1ef59$var$ComponentDummy();
$0802bf0880b1ef59$var$pureComponentPrototype.constructor = $0802bf0880b1ef59$var$PureComponent;
$0802bf0880b1ef59$var$assign($0802bf0880b1ef59$var$pureComponentPrototype, $0802bf0880b1ef59$var$Component.prototype);
$0802bf0880b1ef59$var$pureComponentPrototype.isPureReactComponent = !0;
var $0802bf0880b1ef59$var$isArrayImpl = Array.isArray;
function $0802bf0880b1ef59$var$noop() {}
var $0802bf0880b1ef59$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $0802bf0880b1ef59$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0802bf0880b1ef59$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $0802bf0880b1ef59$var$cloneAndReplaceKey(oldElement, newKey) {
    return $0802bf0880b1ef59$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $0802bf0880b1ef59$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE;
}
function $0802bf0880b1ef59$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $0802bf0880b1ef59$var$userProvidedKeyEscapeRegex = /\/+/g;
function $0802bf0880b1ef59$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $0802bf0880b1ef59$var$escape("" + element.key) : index.toString(36);
}
function $0802bf0880b1ef59$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($0802bf0880b1ef59$var$noop, $0802bf0880b1ef59$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $0802bf0880b1ef59$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $0802bf0880b1ef59$var$REACT_ELEMENT_TYPE:
                case $0802bf0880b1ef59$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $0802bf0880b1ef59$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $0802bf0880b1ef59$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $0802bf0880b1ef59$var$getElementKey(children, 0) : nameSoFar, $0802bf0880b1ef59$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($0802bf0880b1ef59$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $0802bf0880b1ef59$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($0802bf0880b1ef59$var$isValidElement(callback) && (callback = $0802bf0880b1ef59$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($0802bf0880b1ef59$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($0802bf0880b1ef59$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $0802bf0880b1ef59$var$getElementKey(nameSoFar, i), invokeCallback += $0802bf0880b1ef59$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $0802bf0880b1ef59$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $0802bf0880b1ef59$var$getElementKey(nameSoFar, i++), invokeCallback += $0802bf0880b1ef59$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $0802bf0880b1ef59$var$mapIntoArray($0802bf0880b1ef59$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $0802bf0880b1ef59$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $0802bf0880b1ef59$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $0802bf0880b1ef59$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $0802bf0880b1ef59$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $0802bf0880b1ef59$var$Children = {
    map: $0802bf0880b1ef59$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $0802bf0880b1ef59$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $0802bf0880b1ef59$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $0802bf0880b1ef59$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$0802bf0880b1ef59$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$0802bf0880b1ef59$export$9c16c1426311996d = $0802bf0880b1ef59$var$REACT_ACTIVITY_TYPE;
$0802bf0880b1ef59$export$dca3b0875bd9a954 = $0802bf0880b1ef59$var$Children;
$0802bf0880b1ef59$export$16fa2f45be04daa8 = $0802bf0880b1ef59$var$Component;
$0802bf0880b1ef59$export$ffb0004e005737fa = $0802bf0880b1ef59$var$REACT_FRAGMENT_TYPE;
$0802bf0880b1ef59$export$e2c29f18771995cb = $0802bf0880b1ef59$var$REACT_PROFILER_TYPE;
$0802bf0880b1ef59$export$221d75b3f55bb0bd = $0802bf0880b1ef59$var$PureComponent;
$0802bf0880b1ef59$export$5f8d39834fd61797 = $0802bf0880b1ef59$var$REACT_STRICT_MODE_TYPE;
$0802bf0880b1ef59$export$74bf444e3cd11ea5 = $0802bf0880b1ef59$var$REACT_SUSPENSE_TYPE;
$0802bf0880b1ef59$export$1ced07cd6b1985ce = $0802bf0880b1ef59$var$ReactSharedInternals;
$0802bf0880b1ef59$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $0802bf0880b1ef59$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$0802bf0880b1ef59$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$0802bf0880b1ef59$export$8c538325882c7eec = function() {
    return null;
};
$0802bf0880b1ef59$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $0802bf0880b1ef59$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$0802bf0880b1ef59$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $0802bf0880b1ef59$var$ReactElement(element.type, key, props);
};
$0802bf0880b1ef59$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $0802bf0880b1ef59$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $0802bf0880b1ef59$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$0802bf0880b1ef59$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$0802bf0880b1ef59$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $0802bf0880b1ef59$var$ReactElement(type, key, props);
};
$0802bf0880b1ef59$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0802bf0880b1ef59$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$0802bf0880b1ef59$export$a8257692ac88316c = $0802bf0880b1ef59$var$isValidElement;
$0802bf0880b1ef59$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $0802bf0880b1ef59$var$lazyInitializer
    };
};
$0802bf0880b1ef59$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $0802bf0880b1ef59$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$0802bf0880b1ef59$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $0802bf0880b1ef59$var$ReactSharedInternals.T, currentTransition = {};
    $0802bf0880b1ef59$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $0802bf0880b1ef59$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($0802bf0880b1ef59$var$noop, $0802bf0880b1ef59$var$reportGlobalError);
    } catch (error) {
        $0802bf0880b1ef59$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $0802bf0880b1ef59$var$ReactSharedInternals.T = prevTransition;
    }
};
$0802bf0880b1ef59$export$f93f40ac0ca7e3a8 = function() {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useCacheRefresh();
};
$0802bf0880b1ef59$export$1f96ae73734a86cc = function(usable) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.use(usable);
};
$0802bf0880b1ef59$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$0802bf0880b1ef59$export$35808ee640e87ca7 = function(callback, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$0802bf0880b1ef59$export$fae74005e78b1a27 = function(Context) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useContext(Context);
};
$0802bf0880b1ef59$export$dc8fbce3eb94dc1e = function() {};
$0802bf0880b1ef59$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$0802bf0880b1ef59$export$6d9c69b0de29b591 = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useEffect(create, deps);
};
$0802bf0880b1ef59$export$7f54fc3180508a52 = function(callback) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$0802bf0880b1ef59$export$f680877a34711e37 = function() {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useId();
};
$0802bf0880b1ef59$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$0802bf0880b1ef59$export$aaabe4eda9ed9969 = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$0802bf0880b1ef59$export$e5c5a5f917a5871c = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$0802bf0880b1ef59$export$1538c33de8887b59 = function(create, deps) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useMemo(create, deps);
};
$0802bf0880b1ef59$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$0802bf0880b1ef59$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$0802bf0880b1ef59$export$b8f5890fc79d6aca = function(initialValue) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useRef(initialValue);
};
$0802bf0880b1ef59$export$60241385465d0a34 = function(initialState) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useState(initialState);
};
$0802bf0880b1ef59$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$0802bf0880b1ef59$export$7b286972b8d8ccbf = function() {
    return $0802bf0880b1ef59$var$ReactSharedInternals.H.useTransition();
};
$0802bf0880b1ef59$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("5p4Xp", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $3ef321f56e16f92a$export$882461b6382ed46c; }, function (v) { return $3ef321f56e16f92a$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $3ef321f56e16f92a$export$757ceba2d55c277e; }, function (v) { return $3ef321f56e16f92a$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $3ef321f56e16f92a$export$83d89fbfd8236492; }, function (v) { return $3ef321f56e16f92a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $3ef321f56e16f92a$export$882461b6382ed46c;
var $3ef321f56e16f92a$export$757ceba2d55c277e;
var $3ef321f56e16f92a$export$83d89fbfd8236492;
"use strict";

var $1c3ne = parcelRequire("1c3ne");

var $4Iuzv = parcelRequire("4Iuzv");

var $hSThT = parcelRequire("hSThT");
function $3ef321f56e16f92a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $3ef321f56e16f92a$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $3ef321f56e16f92a$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $3ef321f56e16f92a$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $3ef321f56e16f92a$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $3ef321f56e16f92a$var$assertIsMounted(fiber) {
    if ($3ef321f56e16f92a$var$getNearestMountedFiber(fiber) !== fiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
}
function $3ef321f56e16f92a$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $3ef321f56e16f92a$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $3ef321f56e16f92a$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $3ef321f56e16f92a$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $3ef321f56e16f92a$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $3ef321f56e16f92a$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $3ef321f56e16f92a$var$assign = Object.assign, $3ef321f56e16f92a$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $3ef321f56e16f92a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $3ef321f56e16f92a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $3ef321f56e16f92a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $3ef321f56e16f92a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $3ef321f56e16f92a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $3ef321f56e16f92a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $3ef321f56e16f92a$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $3ef321f56e16f92a$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $3ef321f56e16f92a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $3ef321f56e16f92a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $3ef321f56e16f92a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$3ef321f56e16f92a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $3ef321f56e16f92a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $3ef321f56e16f92a$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $3ef321f56e16f92a$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $3ef321f56e16f92a$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $3ef321f56e16f92a$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $3ef321f56e16f92a$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $3ef321f56e16f92a$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $3ef321f56e16f92a$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $3ef321f56e16f92a$var$getComponentNameFromType(type.type) || "Memo";
        case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $3ef321f56e16f92a$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $3ef321f56e16f92a$var$isArrayImpl = Array.isArray, $3ef321f56e16f92a$var$ReactSharedInternals = $4Iuzv.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $3ef321f56e16f92a$var$ReactDOMSharedInternals = $hSThT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $3ef321f56e16f92a$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $3ef321f56e16f92a$var$valueStack = [], $3ef321f56e16f92a$var$index = -1;
function $3ef321f56e16f92a$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $3ef321f56e16f92a$var$pop(cursor) {
    0 > $3ef321f56e16f92a$var$index || (cursor.current = $3ef321f56e16f92a$var$valueStack[$3ef321f56e16f92a$var$index], $3ef321f56e16f92a$var$valueStack[$3ef321f56e16f92a$var$index] = null, $3ef321f56e16f92a$var$index--);
}
function $3ef321f56e16f92a$var$push(cursor, value) {
    $3ef321f56e16f92a$var$index++;
    $3ef321f56e16f92a$var$valueStack[$3ef321f56e16f92a$var$index] = cursor.current;
    cursor.current = value;
}
var $3ef321f56e16f92a$var$contextStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$contextFiberStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$rootInstanceStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$hostTransitionProviderCursor = $3ef321f56e16f92a$var$createCursor(null);
function $3ef321f56e16f92a$var$pushHostContainer(fiber, nextRootInstance) {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$rootInstanceStackCursor, nextRootInstance);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextFiberStackCursor, fiber);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $3ef321f56e16f92a$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $3ef321f56e16f92a$var$getOwnHostContext(nextRootInstance), fiber = $3ef321f56e16f92a$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextStackCursor);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextStackCursor, fiber);
}
function $3ef321f56e16f92a$var$popHostContainer() {
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextStackCursor);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextFiberStackCursor);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$rootInstanceStackCursor);
}
function $3ef321f56e16f92a$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$hostTransitionProviderCursor, fiber);
    var context = $3ef321f56e16f92a$var$contextStackCursor.current;
    var JSCompiler_inline_result = $3ef321f56e16f92a$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextFiberStackCursor, fiber), $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$contextStackCursor, JSCompiler_inline_result));
}
function $3ef321f56e16f92a$var$popHostContext(fiber) {
    $3ef321f56e16f92a$var$contextFiberStackCursor.current === fiber && ($3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextStackCursor), $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$contextFiberStackCursor));
    $3ef321f56e16f92a$var$hostTransitionProviderCursor.current === fiber && ($3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$hostTransitionProviderCursor), $3ef321f56e16f92a$var$HostTransitionContext._currentValue = $3ef321f56e16f92a$var$sharedNotPendingObject);
}
var $3ef321f56e16f92a$var$prefix, $3ef321f56e16f92a$var$suffix;
function $3ef321f56e16f92a$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $3ef321f56e16f92a$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $3ef321f56e16f92a$var$prefix = match && match[1] || "";
        $3ef321f56e16f92a$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $3ef321f56e16f92a$var$prefix + name + $3ef321f56e16f92a$var$suffix;
}
var $3ef321f56e16f92a$var$reentry = !1;
function $3ef321f56e16f92a$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $3ef321f56e16f92a$var$reentry) return "";
    $3ef321f56e16f92a$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $3ef321f56e16f92a$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $3ef321f56e16f92a$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $3ef321f56e16f92a$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $3ef321f56e16f92a$var$describeBuiltInComponentFrame("Suspense Fallback") : $3ef321f56e16f92a$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $3ef321f56e16f92a$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $3ef321f56e16f92a$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $3ef321f56e16f92a$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $3ef321f56e16f92a$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $3ef321f56e16f92a$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $3ef321f56e16f92a$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $3ef321f56e16f92a$var$hasOwnProperty = Object.prototype.hasOwnProperty, $3ef321f56e16f92a$var$scheduleCallback$3 = $1c3ne.unstable_scheduleCallback, $3ef321f56e16f92a$var$cancelCallback$1 = $1c3ne.unstable_cancelCallback, $3ef321f56e16f92a$var$shouldYield = $1c3ne.unstable_shouldYield, $3ef321f56e16f92a$var$requestPaint = $1c3ne.unstable_requestPaint, $3ef321f56e16f92a$var$now = $1c3ne.unstable_now, $3ef321f56e16f92a$var$getCurrentPriorityLevel = $1c3ne.unstable_getCurrentPriorityLevel, $3ef321f56e16f92a$var$ImmediatePriority = $1c3ne.unstable_ImmediatePriority, $3ef321f56e16f92a$var$UserBlockingPriority = $1c3ne.unstable_UserBlockingPriority, $3ef321f56e16f92a$var$NormalPriority$1 = $1c3ne.unstable_NormalPriority, $3ef321f56e16f92a$var$LowPriority = $1c3ne.unstable_LowPriority, $3ef321f56e16f92a$var$IdlePriority = $1c3ne.unstable_IdlePriority, $3ef321f56e16f92a$var$log$1 = $1c3ne.log, $3ef321f56e16f92a$var$unstable_setDisableYieldValue = $1c3ne.unstable_setDisableYieldValue, $3ef321f56e16f92a$var$rendererID = null, $3ef321f56e16f92a$var$injectedHook = null;
function $3ef321f56e16f92a$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $3ef321f56e16f92a$var$log$1 && $3ef321f56e16f92a$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.setStrictMode) try {
        $3ef321f56e16f92a$var$injectedHook.setStrictMode($3ef321f56e16f92a$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $3ef321f56e16f92a$var$clz32 = Math.clz32 ? Math.clz32 : $3ef321f56e16f92a$var$clz32Fallback, $3ef321f56e16f92a$var$log = Math.log, $3ef321f56e16f92a$var$LN2 = Math.LN2;
function $3ef321f56e16f92a$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($3ef321f56e16f92a$var$log(x) / $3ef321f56e16f92a$var$LN2 | 0) | 0;
}
var $3ef321f56e16f92a$var$nextTransitionUpdateLane = 256, $3ef321f56e16f92a$var$nextTransitionDeferredLane = 262144, $3ef321f56e16f92a$var$nextRetryLane = 4194304;
function $3ef321f56e16f92a$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $3ef321f56e16f92a$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $3ef321f56e16f92a$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $3ef321f56e16f92a$var$claimNextRetryLane() {
    var lane = $3ef321f56e16f92a$var$nextRetryLane;
    $3ef321f56e16f92a$var$nextRetryLane <<= 1;
    0 === ($3ef321f56e16f92a$var$nextRetryLane & 62914560) && ($3ef321f56e16f92a$var$nextRetryLane = 4194304);
    return lane;
}
function $3ef321f56e16f92a$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $3ef321f56e16f92a$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $3ef321f56e16f92a$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $3ef321f56e16f92a$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $3ef321f56e16f92a$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $3ef321f56e16f92a$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $3ef321f56e16f92a$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $3ef321f56e16f92a$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $3ef321f56e16f92a$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $3ef321f56e16f92a$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $3ef321f56e16f92a$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $3ef321f56e16f92a$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $3ef321f56e16f92a$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $3ef321f56e16f92a$var$resolveUpdatePriority() {
    var updatePriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $3ef321f56e16f92a$var$getEventPriority(updatePriority.type);
}
function $3ef321f56e16f92a$var$runWithPriority(priority, fn) {
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        return $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $3ef321f56e16f92a$var$randomKey = Math.random().toString(36).slice(2), $3ef321f56e16f92a$var$internalInstanceKey = "__reactFiber$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalPropsKey = "__reactProps$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalContainerInstanceKey = "__reactContainer$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalEventHandlersKey = "__reactEvents$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalEventHandlerListenersKey = "__reactListeners$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalEventHandlesSetKey = "__reactHandles$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalRootNodeResourcesKey = "__reactResources$" + $3ef321f56e16f92a$var$randomKey, $3ef321f56e16f92a$var$internalHoistableMarker = "__reactMarker$" + $3ef321f56e16f92a$var$randomKey;
function $3ef321f56e16f92a$var$detachDeletedInstance(node) {
    delete node[$3ef321f56e16f92a$var$internalInstanceKey];
    delete node[$3ef321f56e16f92a$var$internalPropsKey];
    delete node[$3ef321f56e16f92a$var$internalEventHandlersKey];
    delete node[$3ef321f56e16f92a$var$internalEventHandlerListenersKey];
    delete node[$3ef321f56e16f92a$var$internalEventHandlesSetKey];
}
function $3ef321f56e16f92a$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$3ef321f56e16f92a$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$3ef321f56e16f92a$var$internalContainerInstanceKey] || parentNode[$3ef321f56e16f92a$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $3ef321f56e16f92a$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$3ef321f56e16f92a$var$internalInstanceKey]) return parentNode;
                targetNode = $3ef321f56e16f92a$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $3ef321f56e16f92a$var$getInstanceFromNode(node) {
    if (node = node[$3ef321f56e16f92a$var$internalInstanceKey] || node[$3ef321f56e16f92a$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $3ef321f56e16f92a$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(33));
}
function $3ef321f56e16f92a$var$getResourcesFromRoot(root) {
    var resources = root[$3ef321f56e16f92a$var$internalRootNodeResourcesKey];
    resources || (resources = root[$3ef321f56e16f92a$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $3ef321f56e16f92a$var$markNodeAsHoistable(node) {
    node[$3ef321f56e16f92a$var$internalHoistableMarker] = !0;
}
var $3ef321f56e16f92a$var$allNativeEvents = new Set(), $3ef321f56e16f92a$var$registrationNameDependencies = {};
function $3ef321f56e16f92a$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $3ef321f56e16f92a$var$registerDirectEvent(registrationName, dependencies);
    $3ef321f56e16f92a$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $3ef321f56e16f92a$var$registerDirectEvent(registrationName, dependencies) {
    $3ef321f56e16f92a$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$3ef321f56e16f92a$var$allNativeEvents.add(dependencies[registrationName]);
}
var $3ef321f56e16f92a$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $3ef321f56e16f92a$var$illegalAttributeNameCache = {}, $3ef321f56e16f92a$var$validatedAttributeNameCache = {};
function $3ef321f56e16f92a$var$isAttributeNameSafe(attributeName) {
    if ($3ef321f56e16f92a$var$hasOwnProperty.call($3ef321f56e16f92a$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($3ef321f56e16f92a$var$hasOwnProperty.call($3ef321f56e16f92a$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($3ef321f56e16f92a$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $3ef321f56e16f92a$var$validatedAttributeNameCache[attributeName] = !0;
    $3ef321f56e16f92a$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $3ef321f56e16f92a$var$setValueForAttribute(node, name, value) {
    if ($3ef321f56e16f92a$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $3ef321f56e16f92a$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $3ef321f56e16f92a$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $3ef321f56e16f92a$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $3ef321f56e16f92a$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $3ef321f56e16f92a$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $3ef321f56e16f92a$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $3ef321f56e16f92a$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $3ef321f56e16f92a$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $3ef321f56e16f92a$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $3ef321f56e16f92a$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $3ef321f56e16f92a$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $3ef321f56e16f92a$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $3ef321f56e16f92a$var$getToStringValue(value);
        } else element.value !== "" + $3ef321f56e16f92a$var$getToStringValue(value) && (element.value = "" + $3ef321f56e16f92a$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $3ef321f56e16f92a$var$setDefaultValue(element, type, $3ef321f56e16f92a$var$getToStringValue(value)) : null != defaultValue ? $3ef321f56e16f92a$var$setDefaultValue(element, type, $3ef321f56e16f92a$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $3ef321f56e16f92a$var$getToStringValue(name) : element.removeAttribute("name");
}
function $3ef321f56e16f92a$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $3ef321f56e16f92a$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $3ef321f56e16f92a$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $3ef321f56e16f92a$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $3ef321f56e16f92a$var$track(element);
}
function $3ef321f56e16f92a$var$setDefaultValue(node, type, value) {
    "number" === type && $3ef321f56e16f92a$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $3ef321f56e16f92a$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $3ef321f56e16f92a$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $3ef321f56e16f92a$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $3ef321f56e16f92a$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $3ef321f56e16f92a$var$getToStringValue(defaultValue) : "";
}
function $3ef321f56e16f92a$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(92));
            if ($3ef321f56e16f92a$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $3ef321f56e16f92a$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $3ef321f56e16f92a$var$track(element);
}
function $3ef321f56e16f92a$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $3ef321f56e16f92a$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $3ef321f56e16f92a$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $3ef321f56e16f92a$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $3ef321f56e16f92a$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $3ef321f56e16f92a$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $3ef321f56e16f92a$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $3ef321f56e16f92a$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $3ef321f56e16f92a$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $3ef321f56e16f92a$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $3ef321f56e16f92a$var$sanitizeURL(url) {
    return $3ef321f56e16f92a$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $3ef321f56e16f92a$var$noop$1() {}
var $3ef321f56e16f92a$var$currentReplayingEvent = null;
function $3ef321f56e16f92a$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $3ef321f56e16f92a$var$restoreTarget = null, $3ef321f56e16f92a$var$restoreQueue = null;
function $3ef321f56e16f92a$var$restoreStateOfTarget(target) {
    var internalInstance = $3ef321f56e16f92a$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$3ef321f56e16f92a$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $3ef321f56e16f92a$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$3ef321f56e16f92a$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(90));
                            $3ef321f56e16f92a$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $3ef321f56e16f92a$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $3ef321f56e16f92a$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $3ef321f56e16f92a$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $3ef321f56e16f92a$var$isInsideEventHandler = !1;
function $3ef321f56e16f92a$var$batchedUpdates$1(fn, a, b) {
    if ($3ef321f56e16f92a$var$isInsideEventHandler) return fn(a, b);
    $3ef321f56e16f92a$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($3ef321f56e16f92a$var$isInsideEventHandler = !1, null !== $3ef321f56e16f92a$var$restoreTarget || null !== $3ef321f56e16f92a$var$restoreQueue) {
            if ($3ef321f56e16f92a$var$flushSyncWork$1(), $3ef321f56e16f92a$var$restoreTarget && (a = $3ef321f56e16f92a$var$restoreTarget, fn = $3ef321f56e16f92a$var$restoreQueue, $3ef321f56e16f92a$var$restoreQueue = $3ef321f56e16f92a$var$restoreTarget = null, $3ef321f56e16f92a$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$3ef321f56e16f92a$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $3ef321f56e16f92a$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$3ef321f56e16f92a$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $3ef321f56e16f92a$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $3ef321f56e16f92a$var$passiveBrowserEventsSupported = !1;
if ($3ef321f56e16f92a$var$canUseDOM) try {
    var $3ef321f56e16f92a$var$options = {};
    Object.defineProperty($3ef321f56e16f92a$var$options, "passive", {
        get: function() {
            $3ef321f56e16f92a$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $3ef321f56e16f92a$var$options, $3ef321f56e16f92a$var$options);
    window.removeEventListener("test", $3ef321f56e16f92a$var$options, $3ef321f56e16f92a$var$options);
} catch (e) {
    $3ef321f56e16f92a$var$passiveBrowserEventsSupported = !1;
}
var $3ef321f56e16f92a$var$root = null, $3ef321f56e16f92a$var$startText = null, $3ef321f56e16f92a$var$fallbackText = null;
function $3ef321f56e16f92a$var$getData() {
    if ($3ef321f56e16f92a$var$fallbackText) return $3ef321f56e16f92a$var$fallbackText;
    var start, startValue = $3ef321f56e16f92a$var$startText, startLength = startValue.length, end, endValue = "value" in $3ef321f56e16f92a$var$root ? $3ef321f56e16f92a$var$root.value : $3ef321f56e16f92a$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $3ef321f56e16f92a$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $3ef321f56e16f92a$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $3ef321f56e16f92a$var$functionThatReturnsTrue() {
    return !0;
}
function $3ef321f56e16f92a$var$functionThatReturnsFalse() {
    return !1;
}
function $3ef321f56e16f92a$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $3ef321f56e16f92a$var$functionThatReturnsTrue : $3ef321f56e16f92a$var$functionThatReturnsFalse;
        this.isPropagationStopped = $3ef321f56e16f92a$var$functionThatReturnsFalse;
        return this;
    }
    $3ef321f56e16f92a$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $3ef321f56e16f92a$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $3ef321f56e16f92a$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $3ef321f56e16f92a$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $3ef321f56e16f92a$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $3ef321f56e16f92a$var$SyntheticEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$EventInterface), $3ef321f56e16f92a$var$UIEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    view: 0,
    detail: 0
}), $3ef321f56e16f92a$var$SyntheticUIEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$UIEventInterface), $3ef321f56e16f92a$var$lastMovementX, $3ef321f56e16f92a$var$lastMovementY, $3ef321f56e16f92a$var$lastMouseEvent, $3ef321f56e16f92a$var$MouseEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $3ef321f56e16f92a$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $3ef321f56e16f92a$var$lastMouseEvent && ($3ef321f56e16f92a$var$lastMouseEvent && "mousemove" === event.type ? ($3ef321f56e16f92a$var$lastMovementX = event.screenX - $3ef321f56e16f92a$var$lastMouseEvent.screenX, $3ef321f56e16f92a$var$lastMovementY = event.screenY - $3ef321f56e16f92a$var$lastMouseEvent.screenY) : $3ef321f56e16f92a$var$lastMovementY = $3ef321f56e16f92a$var$lastMovementX = 0, $3ef321f56e16f92a$var$lastMouseEvent = event);
        return $3ef321f56e16f92a$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $3ef321f56e16f92a$var$lastMovementY;
    }
}), $3ef321f56e16f92a$var$SyntheticMouseEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$MouseEventInterface), $3ef321f56e16f92a$var$DragEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$MouseEventInterface, {
    dataTransfer: 0
}), $3ef321f56e16f92a$var$SyntheticDragEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$DragEventInterface), $3ef321f56e16f92a$var$FocusEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    relatedTarget: 0
}), $3ef321f56e16f92a$var$SyntheticFocusEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$FocusEventInterface), $3ef321f56e16f92a$var$AnimationEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3ef321f56e16f92a$var$SyntheticAnimationEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$AnimationEventInterface), $3ef321f56e16f92a$var$ClipboardEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $3ef321f56e16f92a$var$SyntheticClipboardEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$ClipboardEventInterface), $3ef321f56e16f92a$var$CompositionEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    data: 0
}), $3ef321f56e16f92a$var$SyntheticCompositionEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$CompositionEventInterface), $3ef321f56e16f92a$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $3ef321f56e16f92a$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $3ef321f56e16f92a$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $3ef321f56e16f92a$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $3ef321f56e16f92a$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $3ef321f56e16f92a$var$getEventModifierState() {
    return $3ef321f56e16f92a$var$modifierStateGetter;
}
var $3ef321f56e16f92a$var$KeyboardEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $3ef321f56e16f92a$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $3ef321f56e16f92a$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $3ef321f56e16f92a$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $3ef321f56e16f92a$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $3ef321f56e16f92a$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $3ef321f56e16f92a$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $3ef321f56e16f92a$var$SyntheticKeyboardEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$KeyboardEventInterface), $3ef321f56e16f92a$var$PointerEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $3ef321f56e16f92a$var$SyntheticPointerEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$PointerEventInterface), $3ef321f56e16f92a$var$TouchEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $3ef321f56e16f92a$var$getEventModifierState
}), $3ef321f56e16f92a$var$SyntheticTouchEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$TouchEventInterface), $3ef321f56e16f92a$var$TransitionEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $3ef321f56e16f92a$var$SyntheticTransitionEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$TransitionEventInterface), $3ef321f56e16f92a$var$WheelEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $3ef321f56e16f92a$var$SyntheticWheelEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$WheelEventInterface), $3ef321f56e16f92a$var$ToggleEventInterface = $3ef321f56e16f92a$var$assign({}, $3ef321f56e16f92a$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $3ef321f56e16f92a$var$SyntheticToggleEvent = $3ef321f56e16f92a$var$createSyntheticEvent($3ef321f56e16f92a$var$ToggleEventInterface), $3ef321f56e16f92a$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $3ef321f56e16f92a$var$canUseCompositionEvent = $3ef321f56e16f92a$var$canUseDOM && "CompositionEvent" in window, $3ef321f56e16f92a$var$documentMode = null;
$3ef321f56e16f92a$var$canUseDOM && "documentMode" in document && ($3ef321f56e16f92a$var$documentMode = document.documentMode);
var $3ef321f56e16f92a$var$canUseTextInputEvent = $3ef321f56e16f92a$var$canUseDOM && "TextEvent" in window && !$3ef321f56e16f92a$var$documentMode, $3ef321f56e16f92a$var$useFallbackCompositionData = $3ef321f56e16f92a$var$canUseDOM && (!$3ef321f56e16f92a$var$canUseCompositionEvent || $3ef321f56e16f92a$var$documentMode && 8 < $3ef321f56e16f92a$var$documentMode && 11 >= $3ef321f56e16f92a$var$documentMode), $3ef321f56e16f92a$var$SPACEBAR_CHAR = String.fromCharCode(32), $3ef321f56e16f92a$var$hasSpaceKeypress = !1;
function $3ef321f56e16f92a$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $3ef321f56e16f92a$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $3ef321f56e16f92a$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $3ef321f56e16f92a$var$isComposing = !1;
function $3ef321f56e16f92a$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $3ef321f56e16f92a$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $3ef321f56e16f92a$var$hasSpaceKeypress = !0;
            return $3ef321f56e16f92a$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $3ef321f56e16f92a$var$SPACEBAR_CHAR && $3ef321f56e16f92a$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $3ef321f56e16f92a$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($3ef321f56e16f92a$var$isComposing) return "compositionend" === domEventName || !$3ef321f56e16f92a$var$canUseCompositionEvent && $3ef321f56e16f92a$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $3ef321f56e16f92a$var$getData(), $3ef321f56e16f92a$var$fallbackText = $3ef321f56e16f92a$var$startText = $3ef321f56e16f92a$var$root = null, $3ef321f56e16f92a$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $3ef321f56e16f92a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $3ef321f56e16f92a$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $3ef321f56e16f92a$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$3ef321f56e16f92a$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $3ef321f56e16f92a$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $3ef321f56e16f92a$var$restoreTarget ? $3ef321f56e16f92a$var$restoreQueue ? $3ef321f56e16f92a$var$restoreQueue.push(target) : $3ef321f56e16f92a$var$restoreQueue = [
        target
    ] : $3ef321f56e16f92a$var$restoreTarget = target;
    inst = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $3ef321f56e16f92a$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $3ef321f56e16f92a$var$activeElement$1 = null, $3ef321f56e16f92a$var$activeElementInst$1 = null;
function $3ef321f56e16f92a$var$runEventInBatch(dispatchQueue) {
    $3ef321f56e16f92a$var$processDispatchQueue(dispatchQueue, 0);
}
function $3ef321f56e16f92a$var$getInstIfValueChanged(targetInst) {
    var targetNode = $3ef321f56e16f92a$var$getNodeFromInstance(targetInst);
    if ($3ef321f56e16f92a$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $3ef321f56e16f92a$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $3ef321f56e16f92a$var$isInputEventSupported = !1;
if ($3ef321f56e16f92a$var$canUseDOM) {
    var $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$286;
    if ($3ef321f56e16f92a$var$canUseDOM) {
        var $3ef321f56e16f92a$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$3ef321f56e16f92a$var$isSupported$jscomp$inline_427) {
            var $3ef321f56e16f92a$var$element$jscomp$inline_428 = document.createElement("div");
            $3ef321f56e16f92a$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $3ef321f56e16f92a$var$isSupported$jscomp$inline_427 = "function" === typeof $3ef321f56e16f92a$var$element$jscomp$inline_428.oninput;
        }
        $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$286 = $3ef321f56e16f92a$var$isSupported$jscomp$inline_427;
    } else $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$286 = !1;
    $3ef321f56e16f92a$var$isInputEventSupported = $3ef321f56e16f92a$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $3ef321f56e16f92a$var$stopWatchingForValueChange() {
    $3ef321f56e16f92a$var$activeElement$1 && ($3ef321f56e16f92a$var$activeElement$1.detachEvent("onpropertychange", $3ef321f56e16f92a$var$handlePropertyChange), $3ef321f56e16f92a$var$activeElementInst$1 = $3ef321f56e16f92a$var$activeElement$1 = null);
}
function $3ef321f56e16f92a$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $3ef321f56e16f92a$var$getInstIfValueChanged($3ef321f56e16f92a$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $3ef321f56e16f92a$var$createAndAccumulateChangeEvent(dispatchQueue, $3ef321f56e16f92a$var$activeElementInst$1, nativeEvent, $3ef321f56e16f92a$var$getEventTarget(nativeEvent));
        $3ef321f56e16f92a$var$batchedUpdates$1($3ef321f56e16f92a$var$runEventInBatch, dispatchQueue);
    }
}
function $3ef321f56e16f92a$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($3ef321f56e16f92a$var$stopWatchingForValueChange(), $3ef321f56e16f92a$var$activeElement$1 = target, $3ef321f56e16f92a$var$activeElementInst$1 = targetInst, $3ef321f56e16f92a$var$activeElement$1.attachEvent("onpropertychange", $3ef321f56e16f92a$var$handlePropertyChange)) : "focusout" === domEventName && $3ef321f56e16f92a$var$stopWatchingForValueChange();
}
function $3ef321f56e16f92a$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $3ef321f56e16f92a$var$getInstIfValueChanged($3ef321f56e16f92a$var$activeElementInst$1);
}
function $3ef321f56e16f92a$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $3ef321f56e16f92a$var$getInstIfValueChanged(targetInst);
}
function $3ef321f56e16f92a$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $3ef321f56e16f92a$var$getInstIfValueChanged(targetInst);
}
function $3ef321f56e16f92a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $3ef321f56e16f92a$var$objectIs = "function" === typeof Object.is ? Object.is : $3ef321f56e16f92a$var$is;
function $3ef321f56e16f92a$var$shallowEqual(objA, objB) {
    if ($3ef321f56e16f92a$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$3ef321f56e16f92a$var$hasOwnProperty.call(objB, currentKey) || !$3ef321f56e16f92a$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $3ef321f56e16f92a$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $3ef321f56e16f92a$var$getNodeForCharacterOffset(root, offset) {
    var node = $3ef321f56e16f92a$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $3ef321f56e16f92a$var$getLeafNode(node);
    }
}
function $3ef321f56e16f92a$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $3ef321f56e16f92a$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $3ef321f56e16f92a$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $3ef321f56e16f92a$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $3ef321f56e16f92a$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $3ef321f56e16f92a$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $3ef321f56e16f92a$var$skipSelectionChangeEvent = $3ef321f56e16f92a$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $3ef321f56e16f92a$var$activeElement = null, $3ef321f56e16f92a$var$activeElementInst = null, $3ef321f56e16f92a$var$lastSelection = null, $3ef321f56e16f92a$var$mouseDown = !1;
function $3ef321f56e16f92a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $3ef321f56e16f92a$var$mouseDown || null == $3ef321f56e16f92a$var$activeElement || $3ef321f56e16f92a$var$activeElement !== $3ef321f56e16f92a$var$getActiveElement(doc) || (doc = $3ef321f56e16f92a$var$activeElement, "selectionStart" in doc && $3ef321f56e16f92a$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $3ef321f56e16f92a$var$lastSelection && $3ef321f56e16f92a$var$shallowEqual($3ef321f56e16f92a$var$lastSelection, doc) || ($3ef321f56e16f92a$var$lastSelection = doc, doc = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners($3ef321f56e16f92a$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $3ef321f56e16f92a$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $3ef321f56e16f92a$var$activeElement)));
}
function $3ef321f56e16f92a$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $3ef321f56e16f92a$var$vendorPrefixes = {
    animationend: $3ef321f56e16f92a$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $3ef321f56e16f92a$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $3ef321f56e16f92a$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $3ef321f56e16f92a$var$makePrefixMap("Transition", "TransitionEnd")
}, $3ef321f56e16f92a$var$prefixedEventNames = {}, $3ef321f56e16f92a$var$style = {};
$3ef321f56e16f92a$var$canUseDOM && ($3ef321f56e16f92a$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $3ef321f56e16f92a$var$vendorPrefixes.animationend.animation, delete $3ef321f56e16f92a$var$vendorPrefixes.animationiteration.animation, delete $3ef321f56e16f92a$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $3ef321f56e16f92a$var$vendorPrefixes.transitionend.transition);
function $3ef321f56e16f92a$var$getVendorPrefixedEventName(eventName) {
    if ($3ef321f56e16f92a$var$prefixedEventNames[eventName]) return $3ef321f56e16f92a$var$prefixedEventNames[eventName];
    if (!$3ef321f56e16f92a$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $3ef321f56e16f92a$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $3ef321f56e16f92a$var$style) return $3ef321f56e16f92a$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $3ef321f56e16f92a$var$ANIMATION_END = $3ef321f56e16f92a$var$getVendorPrefixedEventName("animationend"), $3ef321f56e16f92a$var$ANIMATION_ITERATION = $3ef321f56e16f92a$var$getVendorPrefixedEventName("animationiteration"), $3ef321f56e16f92a$var$ANIMATION_START = $3ef321f56e16f92a$var$getVendorPrefixedEventName("animationstart"), $3ef321f56e16f92a$var$TRANSITION_RUN = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitionrun"), $3ef321f56e16f92a$var$TRANSITION_START = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitionstart"), $3ef321f56e16f92a$var$TRANSITION_CANCEL = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitioncancel"), $3ef321f56e16f92a$var$TRANSITION_END = $3ef321f56e16f92a$var$getVendorPrefixedEventName("transitionend"), $3ef321f56e16f92a$var$topLevelEventsToReactNames = new Map(), $3ef321f56e16f92a$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$3ef321f56e16f92a$var$simpleEventPluginEvents.push("scrollEnd");
function $3ef321f56e16f92a$var$registerSimpleEvent(domEventName, reactName) {
    $3ef321f56e16f92a$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $3ef321f56e16f92a$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $3ef321f56e16f92a$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $3ef321f56e16f92a$var$concurrentQueues = [], $3ef321f56e16f92a$var$concurrentQueuesIndex = 0, $3ef321f56e16f92a$var$concurrentlyUpdatedLanes = 0;
function $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $3ef321f56e16f92a$var$concurrentQueuesIndex, i = $3ef321f56e16f92a$var$concurrentlyUpdatedLanes = $3ef321f56e16f92a$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        var queue = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        var update = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        var lane = $3ef321f56e16f92a$var$concurrentQueues[i];
        $3ef321f56e16f92a$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $3ef321f56e16f92a$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = fiber;
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = queue;
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = update;
    $3ef321f56e16f92a$var$concurrentQueues[$3ef321f56e16f92a$var$concurrentQueuesIndex++] = lane;
    $3ef321f56e16f92a$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
}
function $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, null, null, lane);
    return $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
}
function $3ef321f56e16f92a$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $3ef321f56e16f92a$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $3ef321f56e16f92a$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $3ef321f56e16f92a$var$nestedUpdateCount) throw $3ef321f56e16f92a$var$nestedUpdateCount = 0, $3ef321f56e16f92a$var$rootWithNestedUpdates = null, Error($3ef321f56e16f92a$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $3ef321f56e16f92a$var$emptyContextObject = {};
function $3ef321f56e16f92a$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $3ef321f56e16f92a$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $3ef321f56e16f92a$var$FiberNode(tag, pendingProps, key, mode);
}
function $3ef321f56e16f92a$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $3ef321f56e16f92a$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $3ef321f56e16f92a$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $3ef321f56e16f92a$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $3ef321f56e16f92a$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $3ef321f56e16f92a$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $3ef321f56e16f92a$var$isHostHoistableType(type, pendingProps, $3ef321f56e16f92a$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $3ef321f56e16f92a$var$REACT_ACTIVITY_TYPE:
            return type = $3ef321f56e16f92a$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $3ef321f56e16f92a$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE:
            return $3ef321f56e16f92a$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $3ef321f56e16f92a$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $3ef321f56e16f92a$var$REACT_PROFILER_TYPE:
            return type = $3ef321f56e16f92a$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $3ef321f56e16f92a$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE:
            return type = $3ef321f56e16f92a$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $3ef321f56e16f92a$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $3ef321f56e16f92a$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $3ef321f56e16f92a$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $3ef321f56e16f92a$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $3ef321f56e16f92a$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($3ef321f56e16f92a$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $3ef321f56e16f92a$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $3ef321f56e16f92a$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $3ef321f56e16f92a$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $3ef321f56e16f92a$var$createFiberFromText(content, mode, lanes) {
    content = $3ef321f56e16f92a$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $3ef321f56e16f92a$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $3ef321f56e16f92a$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $3ef321f56e16f92a$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $3ef321f56e16f92a$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $3ef321f56e16f92a$var$CapturedStacks = new WeakMap();
function $3ef321f56e16f92a$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $3ef321f56e16f92a$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $3ef321f56e16f92a$var$getStackByFiberInDevAndProd(source)
        };
        $3ef321f56e16f92a$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $3ef321f56e16f92a$var$getStackByFiberInDevAndProd(source)
    };
}
var $3ef321f56e16f92a$var$forkStack = [], $3ef321f56e16f92a$var$forkStackIndex = 0, $3ef321f56e16f92a$var$treeForkProvider = null, $3ef321f56e16f92a$var$treeForkCount = 0, $3ef321f56e16f92a$var$idStack = [], $3ef321f56e16f92a$var$idStackIndex = 0, $3ef321f56e16f92a$var$treeContextProvider = null, $3ef321f56e16f92a$var$treeContextId = 1, $3ef321f56e16f92a$var$treeContextOverflow = "";
function $3ef321f56e16f92a$var$pushTreeFork(workInProgress, totalChildren) {
    $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex++] = $3ef321f56e16f92a$var$treeForkCount;
    $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex++] = $3ef321f56e16f92a$var$treeForkProvider;
    $3ef321f56e16f92a$var$treeForkProvider = workInProgress;
    $3ef321f56e16f92a$var$treeForkCount = totalChildren;
}
function $3ef321f56e16f92a$var$pushTreeId(workInProgress, totalChildren, index) {
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextId;
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextOverflow;
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextProvider;
    $3ef321f56e16f92a$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $3ef321f56e16f92a$var$treeContextId;
    workInProgress = $3ef321f56e16f92a$var$treeContextOverflow;
    var baseLength = 32 - $3ef321f56e16f92a$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $3ef321f56e16f92a$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $3ef321f56e16f92a$var$treeContextId = 1 << 32 - $3ef321f56e16f92a$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $3ef321f56e16f92a$var$treeContextOverflow = length + workInProgress;
    } else $3ef321f56e16f92a$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $3ef321f56e16f92a$var$treeContextOverflow = workInProgress;
}
function $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($3ef321f56e16f92a$var$pushTreeFork(workInProgress, 1), $3ef321f56e16f92a$var$pushTreeId(workInProgress, 1, 0));
}
function $3ef321f56e16f92a$var$popTreeContext(workInProgress) {
    for(; workInProgress === $3ef321f56e16f92a$var$treeForkProvider;)$3ef321f56e16f92a$var$treeForkProvider = $3ef321f56e16f92a$var$forkStack[--$3ef321f56e16f92a$var$forkStackIndex], $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex] = null, $3ef321f56e16f92a$var$treeForkCount = $3ef321f56e16f92a$var$forkStack[--$3ef321f56e16f92a$var$forkStackIndex], $3ef321f56e16f92a$var$forkStack[$3ef321f56e16f92a$var$forkStackIndex] = null;
    for(; workInProgress === $3ef321f56e16f92a$var$treeContextProvider;)$3ef321f56e16f92a$var$treeContextProvider = $3ef321f56e16f92a$var$idStack[--$3ef321f56e16f92a$var$idStackIndex], $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex] = null, $3ef321f56e16f92a$var$treeContextOverflow = $3ef321f56e16f92a$var$idStack[--$3ef321f56e16f92a$var$idStackIndex], $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex] = null, $3ef321f56e16f92a$var$treeContextId = $3ef321f56e16f92a$var$idStack[--$3ef321f56e16f92a$var$idStackIndex], $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex] = null;
}
function $3ef321f56e16f92a$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextId;
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextOverflow;
    $3ef321f56e16f92a$var$idStack[$3ef321f56e16f92a$var$idStackIndex++] = $3ef321f56e16f92a$var$treeContextProvider;
    $3ef321f56e16f92a$var$treeContextId = suspendedContext.id;
    $3ef321f56e16f92a$var$treeContextOverflow = suspendedContext.overflow;
    $3ef321f56e16f92a$var$treeContextProvider = workInProgress;
}
var $3ef321f56e16f92a$var$hydrationParentFiber = null, $3ef321f56e16f92a$var$nextHydratableInstance = null, $3ef321f56e16f92a$var$isHydrating = !1, $3ef321f56e16f92a$var$hydrationErrors = null, $3ef321f56e16f92a$var$rootOrSingletonContext = !1, $3ef321f56e16f92a$var$HydrationMismatchException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(519));
function $3ef321f56e16f92a$var$throwOnHydrationMismatch(fiber) {
    var error = Error($3ef321f56e16f92a$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $3ef321f56e16f92a$var$queueHydrationError($3ef321f56e16f92a$var$createCapturedValueAtFiber(error, fiber));
    throw $3ef321f56e16f92a$var$HydrationMismatchException;
}
function $3ef321f56e16f92a$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$3ef321f56e16f92a$var$internalInstanceKey] = fiber;
    instance[$3ef321f56e16f92a$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("cancel", instance);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $3ef321f56e16f92a$var$mediaEventTypes.length; type++)$3ef321f56e16f92a$var$listenToNonDelegatedEvent($3ef321f56e16f92a$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", instance);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", instance);
            $3ef321f56e16f92a$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", instance), $3ef321f56e16f92a$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $3ef321f56e16f92a$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($3ef321f56e16f92a$var$listenToNonDelegatedEvent("beforetoggle", instance), $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $3ef321f56e16f92a$var$noop$1), instance = !0) : instance = !1;
    instance || $3ef321f56e16f92a$var$throwOnHydrationMismatch(fiber, !0);
}
function $3ef321f56e16f92a$var$popToNextHostParent(fiber) {
    for($3ef321f56e16f92a$var$hydrationParentFiber = fiber.return; $3ef321f56e16f92a$var$hydrationParentFiber;)switch($3ef321f56e16f92a$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $3ef321f56e16f92a$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $3ef321f56e16f92a$var$rootOrSingletonContext = !0;
            return;
        default:
            $3ef321f56e16f92a$var$hydrationParentFiber = $3ef321f56e16f92a$var$hydrationParentFiber.return;
    }
}
function $3ef321f56e16f92a$var$popHydrationState(fiber) {
    if (fiber !== $3ef321f56e16f92a$var$hydrationParentFiber) return !1;
    if (!$3ef321f56e16f92a$var$isHydrating) return $3ef321f56e16f92a$var$popToNextHostParent(fiber), $3ef321f56e16f92a$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $3ef321f56e16f92a$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $3ef321f56e16f92a$var$nextHydratableInstance && $3ef321f56e16f92a$var$throwOnHydrationMismatch(fiber);
    $3ef321f56e16f92a$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(317));
        $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(317));
        $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $3ef321f56e16f92a$var$nextHydratableInstance, $3ef321f56e16f92a$var$isSingletonScope(fiber.type) ? (fiber = $3ef321f56e16f92a$var$previousHydratableOnEnteringScopedSingleton, $3ef321f56e16f92a$var$previousHydratableOnEnteringScopedSingleton = null, $3ef321f56e16f92a$var$nextHydratableInstance = fiber) : $3ef321f56e16f92a$var$nextHydratableInstance = tag) : $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$hydrationParentFiber ? $3ef321f56e16f92a$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $3ef321f56e16f92a$var$resetHydrationState() {
    $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$hydrationParentFiber = null;
    $3ef321f56e16f92a$var$isHydrating = !1;
}
function $3ef321f56e16f92a$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $3ef321f56e16f92a$var$hydrationErrors;
    null !== queuedErrors && (null === $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors ? $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = queuedErrors : $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors.push.apply($3ef321f56e16f92a$var$workInProgressRootRecoverableErrors, queuedErrors), $3ef321f56e16f92a$var$hydrationErrors = null);
    return queuedErrors;
}
function $3ef321f56e16f92a$var$queueHydrationError(error) {
    null === $3ef321f56e16f92a$var$hydrationErrors ? $3ef321f56e16f92a$var$hydrationErrors = [
        error
    ] : $3ef321f56e16f92a$var$hydrationErrors.push(error);
}
var $3ef321f56e16f92a$var$valueCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null, $3ef321f56e16f92a$var$lastContextDependency = null;
function $3ef321f56e16f92a$var$pushProvider(providerFiber, context, nextValue) {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $3ef321f56e16f92a$var$popProvider(context) {
    context._currentValue = $3ef321f56e16f92a$var$valueCursor.current;
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$valueCursor);
}
function $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $3ef321f56e16f92a$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $3ef321f56e16f92a$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($3ef321f56e16f92a$var$HostTransitionContext) : current = [
                $3ef321f56e16f92a$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $3ef321f56e16f92a$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$3ef321f56e16f92a$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $3ef321f56e16f92a$var$prepareToReadContext(workInProgress) {
    $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = workInProgress;
    $3ef321f56e16f92a$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $3ef321f56e16f92a$var$readContext(context) {
    return $3ef321f56e16f92a$var$readContextForConsumer($3ef321f56e16f92a$var$currentlyRenderingFiber$1, context);
}
function $3ef321f56e16f92a$var$readContextDuringReconciliation(consumer, context) {
    null === $3ef321f56e16f92a$var$currentlyRenderingFiber$1 && $3ef321f56e16f92a$var$prepareToReadContext(consumer);
    return $3ef321f56e16f92a$var$readContextForConsumer(consumer, context);
}
function $3ef321f56e16f92a$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $3ef321f56e16f92a$var$lastContextDependency) {
        if (null === consumer) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(308));
        $3ef321f56e16f92a$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$lastContextDependency.next = context;
    return value;
}
var $3ef321f56e16f92a$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $3ef321f56e16f92a$var$scheduleCallback$2 = $1c3ne.unstable_scheduleCallback, $3ef321f56e16f92a$var$NormalPriority = $1c3ne.unstable_NormalPriority, $3ef321f56e16f92a$var$CacheContext = {
    $$typeof: $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $3ef321f56e16f92a$var$createCache() {
    return {
        controller: new $3ef321f56e16f92a$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $3ef321f56e16f92a$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $3ef321f56e16f92a$var$scheduleCallback$2($3ef321f56e16f92a$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $3ef321f56e16f92a$var$currentEntangledListeners = null, $3ef321f56e16f92a$var$currentEntangledPendingCount = 0, $3ef321f56e16f92a$var$currentEntangledLane = 0, $3ef321f56e16f92a$var$currentEntangledActionThenable = null;
function $3ef321f56e16f92a$var$entangleAsyncAction(transition, thenable) {
    if (null === $3ef321f56e16f92a$var$currentEntangledListeners) {
        var entangledListeners = $3ef321f56e16f92a$var$currentEntangledListeners = [];
        $3ef321f56e16f92a$var$currentEntangledPendingCount = 0;
        $3ef321f56e16f92a$var$currentEntangledLane = $3ef321f56e16f92a$var$requestTransitionLane();
        $3ef321f56e16f92a$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $3ef321f56e16f92a$var$currentEntangledPendingCount++;
    thenable.then($3ef321f56e16f92a$var$pingEngtangledActionScope, $3ef321f56e16f92a$var$pingEngtangledActionScope);
    return thenable;
}
function $3ef321f56e16f92a$var$pingEngtangledActionScope() {
    if (0 === --$3ef321f56e16f92a$var$currentEntangledPendingCount && null !== $3ef321f56e16f92a$var$currentEntangledListeners) {
        null !== $3ef321f56e16f92a$var$currentEntangledActionThenable && ($3ef321f56e16f92a$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $3ef321f56e16f92a$var$currentEntangledListeners;
        $3ef321f56e16f92a$var$currentEntangledListeners = null;
        $3ef321f56e16f92a$var$currentEntangledLane = 0;
        $3ef321f56e16f92a$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $3ef321f56e16f92a$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $3ef321f56e16f92a$var$prevOnStartTransitionFinish = $3ef321f56e16f92a$var$ReactSharedInternals.S;
$3ef321f56e16f92a$var$ReactSharedInternals.S = function(transition, returnValue) {
    $3ef321f56e16f92a$var$globalMostRecentTransitionTime = $3ef321f56e16f92a$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $3ef321f56e16f92a$var$entangleAsyncAction(transition, returnValue);
    null !== $3ef321f56e16f92a$var$prevOnStartTransitionFinish && $3ef321f56e16f92a$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $3ef321f56e16f92a$var$resumedCache = $3ef321f56e16f92a$var$createCursor(null);
function $3ef321f56e16f92a$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $3ef321f56e16f92a$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $3ef321f56e16f92a$var$workInProgressRoot.pooledCache;
}
function $3ef321f56e16f92a$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$resumedCache, $3ef321f56e16f92a$var$resumedCache.current) : $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$resumedCache, prevCachePool.pool);
}
function $3ef321f56e16f92a$var$getSuspendedCache() {
    var cacheFromPool = $3ef321f56e16f92a$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $3ef321f56e16f92a$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $3ef321f56e16f92a$var$SuspenseException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(460)), $3ef321f56e16f92a$var$SuspenseyCommitException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(474)), $3ef321f56e16f92a$var$SuspenseActionException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(542)), $3ef321f56e16f92a$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $3ef321f56e16f92a$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $3ef321f56e16f92a$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($3ef321f56e16f92a$var$noop$1, $3ef321f56e16f92a$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $3ef321f56e16f92a$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($3ef321f56e16f92a$var$noop$1, $3ef321f56e16f92a$var$noop$1);
            else {
                thenableState = $3ef321f56e16f92a$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $3ef321f56e16f92a$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $3ef321f56e16f92a$var$suspendedThenable = thenable;
            throw $3ef321f56e16f92a$var$SuspenseException;
    }
}
function $3ef321f56e16f92a$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $3ef321f56e16f92a$var$suspendedThenable = x, $3ef321f56e16f92a$var$SuspenseException;
        throw x;
    }
}
var $3ef321f56e16f92a$var$suspendedThenable = null;
function $3ef321f56e16f92a$var$getSuspendedThenable() {
    if (null === $3ef321f56e16f92a$var$suspendedThenable) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(459));
    var thenable = $3ef321f56e16f92a$var$suspendedThenable;
    $3ef321f56e16f92a$var$suspendedThenable = null;
    return thenable;
}
function $3ef321f56e16f92a$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $3ef321f56e16f92a$var$SuspenseException || rejectedReason === $3ef321f56e16f92a$var$SuspenseActionException) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(483));
}
var $3ef321f56e16f92a$var$thenableState$1 = null, $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0;
function $3ef321f56e16f92a$var$unwrapThenable(thenable) {
    var index = $3ef321f56e16f92a$var$thenableIndexCounter$1;
    $3ef321f56e16f92a$var$thenableIndexCounter$1 += 1;
    null === $3ef321f56e16f92a$var$thenableState$1 && ($3ef321f56e16f92a$var$thenableState$1 = []);
    return $3ef321f56e16f92a$var$trackUsedThenable($3ef321f56e16f92a$var$thenableState$1, thenable, index);
}
function $3ef321f56e16f92a$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $3ef321f56e16f92a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $3ef321f56e16f92a$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $3ef321f56e16f92a$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $3ef321f56e16f92a$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $3ef321f56e16f92a$var$REACT_LAZY_TYPE && $3ef321f56e16f92a$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $3ef321f56e16f92a$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $3ef321f56e16f92a$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $3ef321f56e16f92a$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $3ef321f56e16f92a$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $3ef321f56e16f92a$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    return lanes = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $3ef321f56e16f92a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    return newChild = $3ef321f56e16f92a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    return newChild = $3ef321f56e16f92a$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild) || $3ef321f56e16f92a$var$getIteratorFn(newChild)) return newChild = $3ef321f56e16f92a$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    return newChild = $3ef321f56e16f92a$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild) || $3ef321f56e16f92a$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    return newChild = $3ef321f56e16f92a$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild) || $3ef321f56e16f92a$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $3ef321f56e16f92a$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $3ef321f56e16f92a$var$REACT_LAZY_TYPE && $3ef321f56e16f92a$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $3ef321f56e16f92a$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $3ef321f56e16f92a$var$REACT_FRAGMENT_TYPE ? (lanes = $3ef321f56e16f92a$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $3ef321f56e16f92a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $3ef321f56e16f92a$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $3ef321f56e16f92a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $3ef321f56e16f92a$var$REACT_LAZY_TYPE:
                    return newChild = $3ef321f56e16f92a$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($3ef321f56e16f92a$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($3ef321f56e16f92a$var$getIteratorFn(newChild)) {
                key = $3ef321f56e16f92a$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $3ef321f56e16f92a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $3ef321f56e16f92a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $3ef321f56e16f92a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $3ef321f56e16f92a$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $3ef321f56e16f92a$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $3ef321f56e16f92a$var$SuspenseException || x === $3ef321f56e16f92a$var$SuspenseActionException) throw x;
            var fiber = $3ef321f56e16f92a$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $3ef321f56e16f92a$var$reconcileChildFibers = $3ef321f56e16f92a$var$createChildReconciler(!0), $3ef321f56e16f92a$var$mountChildFibers = $3ef321f56e16f92a$var$createChildReconciler(!1), $3ef321f56e16f92a$var$hasForceUpdate = !1;
function $3ef321f56e16f92a$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $3ef321f56e16f92a$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $3ef321f56e16f92a$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($3ef321f56e16f92a$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
        $3ef321f56e16f92a$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $3ef321f56e16f92a$var$getRootForUpdatedFiber(fiber);
}
function $3ef321f56e16f92a$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $3ef321f56e16f92a$var$markRootEntangled(root, lane);
    }
}
function $3ef321f56e16f92a$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $3ef321f56e16f92a$var$didReadFromEntangledAsyncAction = !1;
function $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($3ef321f56e16f92a$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $3ef321f56e16f92a$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $3ef321f56e16f92a$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $3ef321f56e16f92a$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $3ef321f56e16f92a$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $3ef321f56e16f92a$var$currentEntangledLane && ($3ef321f56e16f92a$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $3ef321f56e16f92a$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $3ef321f56e16f92a$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $3ef321f56e16f92a$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $3ef321f56e16f92a$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$3ef321f56e16f92a$var$callCallback(callbacks[updateQueue], context);
}
var $3ef321f56e16f92a$var$currentTreeHiddenStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$prevEntangledRenderLanesCursor = $3ef321f56e16f92a$var$createCursor(0);
function $3ef321f56e16f92a$var$pushHiddenContext(fiber, context) {
    fiber = $3ef321f56e16f92a$var$entangledRenderLanes;
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$prevEntangledRenderLanesCursor, fiber);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$currentTreeHiddenStackCursor, context);
    $3ef321f56e16f92a$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $3ef321f56e16f92a$var$reuseHiddenContextOnStack() {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$prevEntangledRenderLanesCursor, $3ef321f56e16f92a$var$entangledRenderLanes);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$currentTreeHiddenStackCursor, $3ef321f56e16f92a$var$currentTreeHiddenStackCursor.current);
}
function $3ef321f56e16f92a$var$popHiddenContext() {
    $3ef321f56e16f92a$var$entangledRenderLanes = $3ef321f56e16f92a$var$prevEntangledRenderLanesCursor.current;
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$currentTreeHiddenStackCursor);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$prevEntangledRenderLanesCursor);
}
var $3ef321f56e16f92a$var$suspenseHandlerStackCursor = $3ef321f56e16f92a$var$createCursor(null), $3ef321f56e16f92a$var$shellBoundary = null;
function $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current & 1);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseHandlerStackCursor, handler);
    null === $3ef321f56e16f92a$var$shellBoundary && (null === current || null !== $3ef321f56e16f92a$var$currentTreeHiddenStackCursor.current ? $3ef321f56e16f92a$var$shellBoundary = handler : null !== current.memoizedState && ($3ef321f56e16f92a$var$shellBoundary = handler));
}
function $3ef321f56e16f92a$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseHandlerStackCursor, fiber);
    null === $3ef321f56e16f92a$var$shellBoundary && ($3ef321f56e16f92a$var$shellBoundary = fiber);
}
function $3ef321f56e16f92a$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current), $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseHandlerStackCursor, fiber), null === $3ef321f56e16f92a$var$shellBoundary && ($3ef321f56e16f92a$var$shellBoundary = fiber)) : $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(fiber);
}
function $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack() {
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current);
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseHandlerStackCursor, $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current);
}
function $3ef321f56e16f92a$var$popSuspenseHandler(fiber) {
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseHandlerStackCursor);
    $3ef321f56e16f92a$var$shellBoundary === fiber && ($3ef321f56e16f92a$var$shellBoundary = null);
    $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor);
}
var $3ef321f56e16f92a$var$suspenseStackCursor = $3ef321f56e16f92a$var$createCursor(0);
function $3ef321f56e16f92a$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $3ef321f56e16f92a$var$isSuspenseInstancePending(state) || $3ef321f56e16f92a$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $3ef321f56e16f92a$var$renderLanes = 0, $3ef321f56e16f92a$var$currentlyRenderingFiber = null, $3ef321f56e16f92a$var$currentHook = null, $3ef321f56e16f92a$var$workInProgressHook = null, $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !1, $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $3ef321f56e16f92a$var$localIdCounter = 0, $3ef321f56e16f92a$var$thenableIndexCounter = 0, $3ef321f56e16f92a$var$thenableState = null, $3ef321f56e16f92a$var$globalClientIdCounter = 0;
function $3ef321f56e16f92a$var$throwInvalidHookError() {
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(321));
}
function $3ef321f56e16f92a$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$3ef321f56e16f92a$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $3ef321f56e16f92a$var$renderLanes = nextRenderLanes;
    $3ef321f56e16f92a$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $3ef321f56e16f92a$var$HooksDispatcherOnMount : $3ef321f56e16f92a$var$HooksDispatcherOnUpdate;
    $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $3ef321f56e16f92a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $3ef321f56e16f92a$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $3ef321f56e16f92a$var$finishRenderingHooks(current) {
    $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $3ef321f56e16f92a$var$currentHook && null !== $3ef321f56e16f92a$var$currentHook.next;
    $3ef321f56e16f92a$var$renderLanes = 0;
    $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$currentHook = $3ef321f56e16f92a$var$currentlyRenderingFiber = null;
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !1;
    $3ef321f56e16f92a$var$thenableIndexCounter = 0;
    $3ef321f56e16f92a$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(300));
    null === current || $3ef321f56e16f92a$var$didReceiveUpdate || (current = current.dependencies, null !== current && $3ef321f56e16f92a$var$checkIfContextChanged(current) && ($3ef321f56e16f92a$var$didReceiveUpdate = !0));
}
function $3ef321f56e16f92a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $3ef321f56e16f92a$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass && ($3ef321f56e16f92a$var$thenableState = null);
        $3ef321f56e16f92a$var$thenableIndexCounter = 0;
        $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $3ef321f56e16f92a$var$TransitionAwareHostComponent() {
    var dispatcher = $3ef321f56e16f92a$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $3ef321f56e16f92a$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $3ef321f56e16f92a$var$currentHook ? $3ef321f56e16f92a$var$currentHook.memoizedState : null) !== dispatcher && ($3ef321f56e16f92a$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $3ef321f56e16f92a$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $3ef321f56e16f92a$var$localIdCounter;
    $3ef321f56e16f92a$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $3ef321f56e16f92a$var$resetHooksOnUnwind(workInProgress) {
    if ($3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !1;
    }
    $3ef321f56e16f92a$var$renderLanes = 0;
    $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$currentHook = $3ef321f56e16f92a$var$currentlyRenderingFiber = null;
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $3ef321f56e16f92a$var$thenableIndexCounter = $3ef321f56e16f92a$var$localIdCounter = 0;
    $3ef321f56e16f92a$var$thenableState = null;
}
function $3ef321f56e16f92a$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $3ef321f56e16f92a$var$workInProgressHook ? $3ef321f56e16f92a$var$currentlyRenderingFiber.memoizedState = $3ef321f56e16f92a$var$workInProgressHook = hook : $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$workInProgressHook.next = hook;
    return $3ef321f56e16f92a$var$workInProgressHook;
}
function $3ef321f56e16f92a$var$updateWorkInProgressHook() {
    if (null === $3ef321f56e16f92a$var$currentHook) {
        var nextCurrentHook = $3ef321f56e16f92a$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $3ef321f56e16f92a$var$currentHook.next;
    var nextWorkInProgressHook = null === $3ef321f56e16f92a$var$workInProgressHook ? $3ef321f56e16f92a$var$currentlyRenderingFiber.memoizedState : $3ef321f56e16f92a$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $3ef321f56e16f92a$var$workInProgressHook = nextWorkInProgressHook, $3ef321f56e16f92a$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $3ef321f56e16f92a$var$currentlyRenderingFiber.alternate) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(467));
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(310));
        }
        $3ef321f56e16f92a$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $3ef321f56e16f92a$var$currentHook.memoizedState,
            baseState: $3ef321f56e16f92a$var$currentHook.baseState,
            baseQueue: $3ef321f56e16f92a$var$currentHook.baseQueue,
            queue: $3ef321f56e16f92a$var$currentHook.queue,
            next: null
        };
        null === $3ef321f56e16f92a$var$workInProgressHook ? $3ef321f56e16f92a$var$currentlyRenderingFiber.memoizedState = $3ef321f56e16f92a$var$workInProgressHook = nextCurrentHook : $3ef321f56e16f92a$var$workInProgressHook = $3ef321f56e16f92a$var$workInProgressHook.next = nextCurrentHook;
    }
    return $3ef321f56e16f92a$var$workInProgressHook;
}
function $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $3ef321f56e16f92a$var$useThenable(thenable) {
    var index = $3ef321f56e16f92a$var$thenableIndexCounter;
    $3ef321f56e16f92a$var$thenableIndexCounter += 1;
    null === $3ef321f56e16f92a$var$thenableState && ($3ef321f56e16f92a$var$thenableState = []);
    thenable = $3ef321f56e16f92a$var$trackUsedThenable($3ef321f56e16f92a$var$thenableState, thenable, index);
    index = $3ef321f56e16f92a$var$currentlyRenderingFiber;
    null === (null === $3ef321f56e16f92a$var$workInProgressHook ? index.memoizedState : $3ef321f56e16f92a$var$workInProgressHook.next) && (index = index.alternate, $3ef321f56e16f92a$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $3ef321f56e16f92a$var$HooksDispatcherOnMount : $3ef321f56e16f92a$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $3ef321f56e16f92a$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $3ef321f56e16f92a$var$useThenable(usable);
        if (usable.$$typeof === $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE) return $3ef321f56e16f92a$var$readContext(usable);
    }
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(438, String(usable)));
}
function $3ef321f56e16f92a$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $3ef321f56e16f92a$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue(), $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $3ef321f56e16f92a$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $3ef321f56e16f92a$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $3ef321f56e16f92a$var$updateReducer(reducer) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    return $3ef321f56e16f92a$var$updateReducerImpl(hook, $3ef321f56e16f92a$var$currentHook, reducer);
}
function $3ef321f56e16f92a$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($3ef321f56e16f92a$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $3ef321f56e16f92a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($3ef321f56e16f92a$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $3ef321f56e16f92a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $3ef321f56e16f92a$var$currentlyRenderingFiber.lanes |= revertLane, $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $3ef321f56e16f92a$var$currentlyRenderingFiber.lanes |= updateLane, $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$3ef321f56e16f92a$var$objectIs(pendingQueue, hook.memoizedState) && ($3ef321f56e16f92a$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $3ef321f56e16f92a$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $3ef321f56e16f92a$var$rerenderReducer(reducer) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $3ef321f56e16f92a$var$objectIs(newState, hook.memoizedState) || ($3ef321f56e16f92a$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $3ef321f56e16f92a$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $3ef321f56e16f92a$var$currentlyRenderingFiber, hook = $3ef321f56e16f92a$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $3ef321f56e16f92a$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$3ef321f56e16f92a$var$objectIs(($3ef321f56e16f92a$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $3ef321f56e16f92a$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $3ef321f56e16f92a$var$updateEffect($3ef321f56e16f92a$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $3ef321f56e16f92a$var$workInProgressHook && $3ef321f56e16f92a$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $3ef321f56e16f92a$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $3ef321f56e16f92a$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $3ef321f56e16f92a$var$workInProgressRoot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($3ef321f56e16f92a$var$renderLanes & 127) || $3ef321f56e16f92a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $3ef321f56e16f92a$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue(), $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $3ef321f56e16f92a$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $3ef321f56e16f92a$var$checkIfSnapshotChanged(inst) && $3ef321f56e16f92a$var$forceStoreRerender(fiber);
}
function $3ef321f56e16f92a$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $3ef321f56e16f92a$var$checkIfSnapshotChanged(inst) && $3ef321f56e16f92a$var$forceStoreRerender(fiber);
    });
}
function $3ef321f56e16f92a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$3ef321f56e16f92a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $3ef321f56e16f92a$var$forceStoreRerender(fiber) {
    var root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $3ef321f56e16f92a$var$mountStateImpl(initialState) {
    var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3ef321f56e16f92a$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $3ef321f56e16f92a$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $3ef321f56e16f92a$var$updateReducerImpl(hook, $3ef321f56e16f92a$var$currentHook, "function" === typeof reducer ? reducer : $3ef321f56e16f92a$var$basicStateReducer);
}
function $3ef321f56e16f92a$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $3ef321f56e16f92a$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $3ef321f56e16f92a$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $3ef321f56e16f92a$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T, currentTransition = {};
        $3ef321f56e16f92a$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $3ef321f56e16f92a$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $3ef321f56e16f92a$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $3ef321f56e16f92a$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $3ef321f56e16f92a$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $3ef321f56e16f92a$var$onActionError(actionQueue, node, error$66);
    }
}
function $3ef321f56e16f92a$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $3ef321f56e16f92a$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $3ef321f56e16f92a$var$onActionError(actionQueue, node, error);
    }) : $3ef321f56e16f92a$var$onActionSuccess(actionQueue, node, returnValue);
}
function $3ef321f56e16f92a$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $3ef321f56e16f92a$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $3ef321f56e16f92a$var$runActionStateAction(actionQueue, nextState)));
}
function $3ef321f56e16f92a$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $3ef321f56e16f92a$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $3ef321f56e16f92a$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $3ef321f56e16f92a$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $3ef321f56e16f92a$var$mountActionState(action, initialStateProp) {
    if ($3ef321f56e16f92a$var$isHydrating) {
        var ssrFormState = $3ef321f56e16f92a$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $3ef321f56e16f92a$var$currentlyRenderingFiber;
                if ($3ef321f56e16f92a$var$isHydrating) {
                    if ($3ef321f56e16f92a$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $3ef321f56e16f92a$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $3ef321f56e16f92a$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $3ef321f56e16f92a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $3ef321f56e16f92a$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $3ef321f56e16f92a$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $3ef321f56e16f92a$var$dispatchSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $3ef321f56e16f92a$var$mountStateImpl(!1);
    inRootOrSingleton = $3ef321f56e16f92a$var$dispatchOptimisticSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $3ef321f56e16f92a$var$dispatchActionState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $3ef321f56e16f92a$var$updateActionState(action) {
    var stateHook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    return $3ef321f56e16f92a$var$updateActionStateImpl(stateHook, $3ef321f56e16f92a$var$currentHook, action);
}
function $3ef321f56e16f92a$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $3ef321f56e16f92a$var$updateReducerImpl(stateHook, currentStateHook, $3ef321f56e16f92a$var$actionStateReducer)[0];
    stateHook = $3ef321f56e16f92a$var$updateReducer($3ef321f56e16f92a$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $3ef321f56e16f92a$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $3ef321f56e16f92a$var$SuspenseException) throw $3ef321f56e16f92a$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($3ef321f56e16f92a$var$currentlyRenderingFiber.flags |= 2048, $3ef321f56e16f92a$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $3ef321f56e16f92a$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $3ef321f56e16f92a$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $3ef321f56e16f92a$var$rerenderActionState(action) {
    var stateHook = $3ef321f56e16f92a$var$updateWorkInProgressHook(), currentStateHook = $3ef321f56e16f92a$var$currentHook;
    if (null !== currentStateHook) return $3ef321f56e16f92a$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $3ef321f56e16f92a$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $3ef321f56e16f92a$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue(), $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $3ef321f56e16f92a$var$updateRef() {
    return $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
}
function $3ef321f56e16f92a$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
    $3ef321f56e16f92a$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $3ef321f56e16f92a$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $3ef321f56e16f92a$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $3ef321f56e16f92a$var$currentHook && null !== deps && $3ef321f56e16f92a$var$areHookInputsEqual(deps, $3ef321f56e16f92a$var$currentHook.memoizedState.deps) ? hook.memoizedState = $3ef321f56e16f92a$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($3ef321f56e16f92a$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $3ef321f56e16f92a$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $3ef321f56e16f92a$var$mountEffect(create, deps) {
    $3ef321f56e16f92a$var$mountEffectImpl(8390656, 8, create, deps);
}
function $3ef321f56e16f92a$var$updateEffect(create, deps) {
    $3ef321f56e16f92a$var$updateEffectImpl(2048, 8, create, deps);
}
function $3ef321f56e16f92a$var$useEffectEventImpl(payload) {
    $3ef321f56e16f92a$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $3ef321f56e16f92a$var$createFunctionComponentUpdateQueue(), $3ef321f56e16f92a$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $3ef321f56e16f92a$var$updateEvent(callback) {
    var ref = $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
    $3ef321f56e16f92a$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($3ef321f56e16f92a$var$executionContext & 2)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $3ef321f56e16f92a$var$updateInsertionEffect(create, deps) {
    return $3ef321f56e16f92a$var$updateEffectImpl(4, 2, create, deps);
}
function $3ef321f56e16f92a$var$updateLayoutEffect(create, deps) {
    return $3ef321f56e16f92a$var$updateEffectImpl(4, 4, create, deps);
}
function $3ef321f56e16f92a$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $3ef321f56e16f92a$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $3ef321f56e16f92a$var$updateEffectImpl(4, 4, $3ef321f56e16f92a$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $3ef321f56e16f92a$var$mountDebugValue() {}
function $3ef321f56e16f92a$var$updateCallback(callback, deps) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $3ef321f56e16f92a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $3ef321f56e16f92a$var$updateMemo(nextCreate, deps) {
    var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $3ef321f56e16f92a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($3ef321f56e16f92a$var$renderLanes & 1073741824) && 0 === ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $3ef321f56e16f92a$var$requestDeferredLane();
    $3ef321f56e16f92a$var$currentlyRenderingFiber.lanes |= hook;
    $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $3ef321f56e16f92a$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($3ef321f56e16f92a$var$objectIs(value, prevValue)) return value;
    if (null !== $3ef321f56e16f92a$var$currentTreeHiddenStackCursor.current) return hook = $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue), $3ef321f56e16f92a$var$objectIs(hook, prevValue) || ($3ef321f56e16f92a$var$didReceiveUpdate = !0), hook;
    if (0 === ($3ef321f56e16f92a$var$renderLanes & 42) || 0 !== ($3ef321f56e16f92a$var$renderLanes & 1073741824) && 0 === ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 261930)) return $3ef321f56e16f92a$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $3ef321f56e16f92a$var$requestDeferredLane();
    $3ef321f56e16f92a$var$currentlyRenderingFiber.lanes |= hook;
    $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $3ef321f56e16f92a$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T, currentTransition = {};
    $3ef321f56e16f92a$var$ReactSharedInternals.T = currentTransition;
    $3ef321f56e16f92a$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $3ef321f56e16f92a$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $3ef321f56e16f92a$var$chainThenableValue(returnValue, finishedState);
            $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $3ef321f56e16f92a$var$requestUpdateLane(fiber));
        } else $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, finishedState, $3ef321f56e16f92a$var$requestUpdateLane(fiber));
    } catch (error) {
        $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $3ef321f56e16f92a$var$requestUpdateLane());
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $3ef321f56e16f92a$var$noop() {}
function $3ef321f56e16f92a$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(476));
    var queue = $3ef321f56e16f92a$var$ensureFormComponentIsStateful(formFiber).queue;
    $3ef321f56e16f92a$var$startTransition(formFiber, queue, pendingState, $3ef321f56e16f92a$var$sharedNotPendingObject, null === action ? $3ef321f56e16f92a$var$noop : function() {
        $3ef321f56e16f92a$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $3ef321f56e16f92a$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $3ef321f56e16f92a$var$sharedNotPendingObject,
        baseState: $3ef321f56e16f92a$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $3ef321f56e16f92a$var$basicStateReducer,
            lastRenderedState: $3ef321f56e16f92a$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $3ef321f56e16f92a$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $3ef321f56e16f92a$var$requestFormReset$1(formFiber) {
    var stateHook = $3ef321f56e16f92a$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $3ef321f56e16f92a$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $3ef321f56e16f92a$var$requestUpdateLane());
}
function $3ef321f56e16f92a$var$useHostTransitionStatus() {
    return $3ef321f56e16f92a$var$readContext($3ef321f56e16f92a$var$HostTransitionContext);
}
function $3ef321f56e16f92a$var$updateId() {
    return $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
}
function $3ef321f56e16f92a$var$updateRefresh() {
    return $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
}
function $3ef321f56e16f92a$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $3ef321f56e16f92a$var$requestUpdateLane();
                fiber = $3ef321f56e16f92a$var$createUpdate(lane);
                var root$69 = $3ef321f56e16f92a$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(root$69, provider, lane), $3ef321f56e16f92a$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $3ef321f56e16f92a$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $3ef321f56e16f92a$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $3ef321f56e16f92a$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber) ? $3ef321f56e16f92a$var$enqueueRenderPhaseUpdate(queue, action) : (action = $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(action, fiber, lane), $3ef321f56e16f92a$var$entangleTransitionUpdate(action, queue, lane)));
}
function $3ef321f56e16f92a$var$dispatchSetState(fiber, queue, action) {
    var lane = $3ef321f56e16f92a$var$requestUpdateLane();
    $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $3ef321f56e16f92a$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber)) $3ef321f56e16f92a$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($3ef321f56e16f92a$var$objectIs(eagerState, currentState)) return $3ef321f56e16f92a$var$enqueueUpdate$1(fiber, queue, update, 0), null === $3ef321f56e16f92a$var$workInProgressRoot && $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $3ef321f56e16f92a$var$scheduleUpdateOnFiber(action, fiber, lane), $3ef321f56e16f92a$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $3ef321f56e16f92a$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $3ef321f56e16f92a$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $3ef321f56e16f92a$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $3ef321f56e16f92a$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $3ef321f56e16f92a$var$currentlyRenderingFiber || null !== alternate && alternate === $3ef321f56e16f92a$var$currentlyRenderingFiber;
}
function $3ef321f56e16f92a$var$enqueueRenderPhaseUpdate(queue, update) {
    $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdateDuringThisPass = $3ef321f56e16f92a$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $3ef321f56e16f92a$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $3ef321f56e16f92a$var$markRootEntangled(root, lane);
    }
}
var $3ef321f56e16f92a$var$ContextOnlyDispatcher = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: $3ef321f56e16f92a$var$throwInvalidHookError,
    useContext: $3ef321f56e16f92a$var$throwInvalidHookError,
    useEffect: $3ef321f56e16f92a$var$throwInvalidHookError,
    useImperativeHandle: $3ef321f56e16f92a$var$throwInvalidHookError,
    useLayoutEffect: $3ef321f56e16f92a$var$throwInvalidHookError,
    useInsertionEffect: $3ef321f56e16f92a$var$throwInvalidHookError,
    useMemo: $3ef321f56e16f92a$var$throwInvalidHookError,
    useReducer: $3ef321f56e16f92a$var$throwInvalidHookError,
    useRef: $3ef321f56e16f92a$var$throwInvalidHookError,
    useState: $3ef321f56e16f92a$var$throwInvalidHookError,
    useDebugValue: $3ef321f56e16f92a$var$throwInvalidHookError,
    useDeferredValue: $3ef321f56e16f92a$var$throwInvalidHookError,
    useTransition: $3ef321f56e16f92a$var$throwInvalidHookError,
    useSyncExternalStore: $3ef321f56e16f92a$var$throwInvalidHookError,
    useId: $3ef321f56e16f92a$var$throwInvalidHookError,
    useHostTransitionStatus: $3ef321f56e16f92a$var$throwInvalidHookError,
    useFormState: $3ef321f56e16f92a$var$throwInvalidHookError,
    useActionState: $3ef321f56e16f92a$var$throwInvalidHookError,
    useOptimistic: $3ef321f56e16f92a$var$throwInvalidHookError,
    useMemoCache: $3ef321f56e16f92a$var$throwInvalidHookError,
    useCacheRefresh: $3ef321f56e16f92a$var$throwInvalidHookError
};
$3ef321f56e16f92a$var$ContextOnlyDispatcher.useEffectEvent = $3ef321f56e16f92a$var$throwInvalidHookError;
var $3ef321f56e16f92a$var$HooksDispatcherOnMount = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: function(callback, deps) {
        $3ef321f56e16f92a$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $3ef321f56e16f92a$var$readContext,
    useEffect: $3ef321f56e16f92a$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $3ef321f56e16f92a$var$mountEffectImpl(4194308, 4, $3ef321f56e16f92a$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $3ef321f56e16f92a$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $3ef321f56e16f92a$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($3ef321f56e16f92a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $3ef321f56e16f92a$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $3ef321f56e16f92a$var$dispatchReducerAction.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $3ef321f56e16f92a$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $3ef321f56e16f92a$var$dispatchSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $3ef321f56e16f92a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        return $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $3ef321f56e16f92a$var$mountStateImpl(!1);
        stateHook = $3ef321f56e16f92a$var$startTransition.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $3ef321f56e16f92a$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $3ef321f56e16f92a$var$currentlyRenderingFiber, hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        if ($3ef321f56e16f92a$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $3ef321f56e16f92a$var$workInProgressRoot) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(349));
            0 !== ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 127) || $3ef321f56e16f92a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $3ef321f56e16f92a$var$mountEffect($3ef321f56e16f92a$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $3ef321f56e16f92a$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $3ef321f56e16f92a$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook(), identifierPrefix = $3ef321f56e16f92a$var$workInProgressRoot.identifierPrefix;
        if ($3ef321f56e16f92a$var$isHydrating) {
            var JSCompiler_inline_result = $3ef321f56e16f92a$var$treeContextOverflow;
            var idWithLeadingBit = $3ef321f56e16f92a$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $3ef321f56e16f92a$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $3ef321f56e16f92a$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $3ef321f56e16f92a$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $3ef321f56e16f92a$var$useHostTransitionStatus,
    useFormState: $3ef321f56e16f92a$var$mountActionState,
    useActionState: $3ef321f56e16f92a$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $3ef321f56e16f92a$var$dispatchOptimisticSetState.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $3ef321f56e16f92a$var$useMemoCache,
    useCacheRefresh: function() {
        return $3ef321f56e16f92a$var$mountWorkInProgressHook().memoizedState = $3ef321f56e16f92a$var$refreshCache.bind(null, $3ef321f56e16f92a$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $3ef321f56e16f92a$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($3ef321f56e16f92a$var$executionContext & 2)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $3ef321f56e16f92a$var$HooksDispatcherOnUpdate = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: $3ef321f56e16f92a$var$updateCallback,
    useContext: $3ef321f56e16f92a$var$readContext,
    useEffect: $3ef321f56e16f92a$var$updateEffect,
    useImperativeHandle: $3ef321f56e16f92a$var$updateImperativeHandle,
    useInsertionEffect: $3ef321f56e16f92a$var$updateInsertionEffect,
    useLayoutEffect: $3ef321f56e16f92a$var$updateLayoutEffect,
    useMemo: $3ef321f56e16f92a$var$updateMemo,
    useReducer: $3ef321f56e16f92a$var$updateReducer,
    useRef: $3ef321f56e16f92a$var$updateRef,
    useState: function() {
        return $3ef321f56e16f92a$var$updateReducer($3ef321f56e16f92a$var$basicStateReducer);
    },
    useDebugValue: $3ef321f56e16f92a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
        return $3ef321f56e16f92a$var$updateDeferredValueImpl(hook, $3ef321f56e16f92a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $3ef321f56e16f92a$var$updateReducer($3ef321f56e16f92a$var$basicStateReducer)[0], start = $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $3ef321f56e16f92a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $3ef321f56e16f92a$var$updateSyncExternalStore,
    useId: $3ef321f56e16f92a$var$updateId,
    useHostTransitionStatus: $3ef321f56e16f92a$var$useHostTransitionStatus,
    useFormState: $3ef321f56e16f92a$var$updateActionState,
    useActionState: $3ef321f56e16f92a$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
        return $3ef321f56e16f92a$var$updateOptimisticImpl(hook, $3ef321f56e16f92a$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $3ef321f56e16f92a$var$useMemoCache,
    useCacheRefresh: $3ef321f56e16f92a$var$updateRefresh
};
$3ef321f56e16f92a$var$HooksDispatcherOnUpdate.useEffectEvent = $3ef321f56e16f92a$var$updateEvent;
var $3ef321f56e16f92a$var$HooksDispatcherOnRerender = {
    readContext: $3ef321f56e16f92a$var$readContext,
    use: $3ef321f56e16f92a$var$use,
    useCallback: $3ef321f56e16f92a$var$updateCallback,
    useContext: $3ef321f56e16f92a$var$readContext,
    useEffect: $3ef321f56e16f92a$var$updateEffect,
    useImperativeHandle: $3ef321f56e16f92a$var$updateImperativeHandle,
    useInsertionEffect: $3ef321f56e16f92a$var$updateInsertionEffect,
    useLayoutEffect: $3ef321f56e16f92a$var$updateLayoutEffect,
    useMemo: $3ef321f56e16f92a$var$updateMemo,
    useReducer: $3ef321f56e16f92a$var$rerenderReducer,
    useRef: $3ef321f56e16f92a$var$updateRef,
    useState: function() {
        return $3ef321f56e16f92a$var$rerenderReducer($3ef321f56e16f92a$var$basicStateReducer);
    },
    useDebugValue: $3ef321f56e16f92a$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
        return null === $3ef321f56e16f92a$var$currentHook ? $3ef321f56e16f92a$var$mountDeferredValueImpl(hook, value, initialValue) : $3ef321f56e16f92a$var$updateDeferredValueImpl(hook, $3ef321f56e16f92a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $3ef321f56e16f92a$var$rerenderReducer($3ef321f56e16f92a$var$basicStateReducer)[0], start = $3ef321f56e16f92a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $3ef321f56e16f92a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $3ef321f56e16f92a$var$updateSyncExternalStore,
    useId: $3ef321f56e16f92a$var$updateId,
    useHostTransitionStatus: $3ef321f56e16f92a$var$useHostTransitionStatus,
    useFormState: $3ef321f56e16f92a$var$rerenderActionState,
    useActionState: $3ef321f56e16f92a$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $3ef321f56e16f92a$var$updateWorkInProgressHook();
        if (null !== $3ef321f56e16f92a$var$currentHook) return $3ef321f56e16f92a$var$updateOptimisticImpl(hook, $3ef321f56e16f92a$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $3ef321f56e16f92a$var$useMemoCache,
    useCacheRefresh: $3ef321f56e16f92a$var$updateRefresh
};
$3ef321f56e16f92a$var$HooksDispatcherOnRerender.useEffectEvent = $3ef321f56e16f92a$var$updateEvent;
function $3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $3ef321f56e16f92a$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $3ef321f56e16f92a$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $3ef321f56e16f92a$var$requestUpdateLane(), update = $3ef321f56e16f92a$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $3ef321f56e16f92a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(payload, inst, lane), $3ef321f56e16f92a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $3ef321f56e16f92a$var$requestUpdateLane(), update = $3ef321f56e16f92a$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $3ef321f56e16f92a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(payload, inst, lane), $3ef321f56e16f92a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $3ef321f56e16f92a$var$requestUpdateLane(), update = $3ef321f56e16f92a$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $3ef321f56e16f92a$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(callback, inst, lane), $3ef321f56e16f92a$var$entangleTransitions(callback, inst, lane));
    }
};
function $3ef321f56e16f92a$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$3ef321f56e16f92a$var$shallowEqual(oldProps, newProps) || !$3ef321f56e16f92a$var$shallowEqual(oldState, newState) : !0;
}
function $3ef321f56e16f92a$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $3ef321f56e16f92a$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $3ef321f56e16f92a$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $3ef321f56e16f92a$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $3ef321f56e16f92a$var$defaultOnUncaughtError(error) {
    $3ef321f56e16f92a$var$reportGlobalError(error);
}
function $3ef321f56e16f92a$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $3ef321f56e16f92a$var$defaultOnRecoverableError(error) {
    $3ef321f56e16f92a$var$reportGlobalError(error);
}
function $3ef321f56e16f92a$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $3ef321f56e16f92a$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $3ef321f56e16f92a$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $3ef321f56e16f92a$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $3ef321f56e16f92a$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $3ef321f56e16f92a$var$createClassErrorUpdate(lane) {
    lane = $3ef321f56e16f92a$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $3ef321f56e16f92a$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $3ef321f56e16f92a$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $3ef321f56e16f92a$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed ? $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $3ef321f56e16f92a$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $3ef321f56e16f92a$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $3ef321f56e16f92a$var$shellBoundary ? $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $3ef321f56e16f92a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $3ef321f56e16f92a$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $3ef321f56e16f92a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $3ef321f56e16f92a$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $3ef321f56e16f92a$var$attachPingListener(root, value, rootRenderLanes);
        $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($3ef321f56e16f92a$var$isHydrating) return returnFiber = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $3ef321f56e16f92a$var$HydrationMismatchException && (root = Error($3ef321f56e16f92a$var$formatProdErrorMessage(422), {
        cause: value
    }), $3ef321f56e16f92a$var$queueHydrationError($3ef321f56e16f92a$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $3ef321f56e16f92a$var$HydrationMismatchException && (returnFiber = Error($3ef321f56e16f92a$var$formatProdErrorMessage(423), {
        cause: value
    }), $3ef321f56e16f92a$var$queueHydrationError($3ef321f56e16f92a$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $3ef321f56e16f92a$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $3ef321f56e16f92a$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $3ef321f56e16f92a$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($3ef321f56e16f92a$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $3ef321f56e16f92a$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors ? $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $3ef321f56e16f92a$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $3ef321f56e16f92a$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $3ef321f56e16f92a$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed || !$3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $3ef321f56e16f92a$var$createClassErrorUpdate(rootRenderLanes), $3ef321f56e16f92a$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $3ef321f56e16f92a$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $3ef321f56e16f92a$var$SelectiveHydrationException = Error($3ef321f56e16f92a$var$formatProdErrorMessage(461)), $3ef321f56e16f92a$var$didReceiveUpdate = !1;
function $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $3ef321f56e16f92a$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $3ef321f56e16f92a$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    nextProps = $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $3ef321f56e16f92a$var$checkDidRenderIdHook();
    if (null !== current && !$3ef321f56e16f92a$var$didReceiveUpdate) return $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, renderLanes), $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $3ef321f56e16f92a$var$isHydrating && key && $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$3ef321f56e16f92a$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $3ef321f56e16f92a$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $3ef321f56e16f92a$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $3ef321f56e16f92a$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $3ef321f56e16f92a$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $3ef321f56e16f92a$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($3ef321f56e16f92a$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($3ef321f56e16f92a$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($3ef321f56e16f92a$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $3ef321f56e16f92a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $3ef321f56e16f92a$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $3ef321f56e16f92a$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $3ef321f56e16f92a$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $3ef321f56e16f92a$var$pushHiddenContext(workInProgress, prevState) : $3ef321f56e16f92a$var$reuseHiddenContextOnStack(), $3ef321f56e16f92a$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $3ef321f56e16f92a$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($3ef321f56e16f92a$var$pushTransition(workInProgress, prevState.cachePool), $3ef321f56e16f92a$var$pushHiddenContext(workInProgress, prevState), $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $3ef321f56e16f92a$var$pushTransition(workInProgress, null), $3ef321f56e16f92a$var$reuseHiddenContextOnStack(), $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress));
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $3ef321f56e16f92a$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $3ef321f56e16f92a$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $3ef321f56e16f92a$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $3ef321f56e16f92a$var$pushTransition(workInProgress, null);
    $3ef321f56e16f92a$var$reuseHiddenContextOnStack();
    $3ef321f56e16f92a$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $3ef321f56e16f92a$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $3ef321f56e16f92a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $3ef321f56e16f92a$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $3ef321f56e16f92a$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($3ef321f56e16f92a$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $3ef321f56e16f92a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $3ef321f56e16f92a$var$bailoutOffscreenComponent(null, current);
            $3ef321f56e16f92a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $3ef321f56e16f92a$var$nextHydratableInstance) ? (current = $3ef321f56e16f92a$var$canHydrateHydrationBoundary(current, $3ef321f56e16f92a$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $3ef321f56e16f92a$var$treeContextProvider ? {
                    id: $3ef321f56e16f92a$var$treeContextId,
                    overflow: $3ef321f56e16f92a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $3ef321f56e16f92a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $3ef321f56e16f92a$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $3ef321f56e16f92a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $3ef321f56e16f92a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(558));
        } else if ($3ef321f56e16f92a$var$didReceiveUpdate || $3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $3ef321f56e16f92a$var$didReceiveUpdate || didSuspend) {
            nextProps = $3ef321f56e16f92a$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $3ef321f56e16f92a$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(current, dehydrated), $3ef321f56e16f92a$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $3ef321f56e16f92a$var$SelectiveHydrationException;
            $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible();
            workInProgress = $3ef321f56e16f92a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(dehydrated.nextSibling), $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$isHydrating = !0, $3ef321f56e16f92a$var$hydrationErrors = null, $3ef321f56e16f92a$var$rootOrSingletonContext = !1, null !== current && $3ef321f56e16f92a$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $3ef321f56e16f92a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $3ef321f56e16f92a$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $3ef321f56e16f92a$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $3ef321f56e16f92a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    Component = $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $3ef321f56e16f92a$var$checkDidRenderIdHook();
    if (null !== current && !$3ef321f56e16f92a$var$didReceiveUpdate) return $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, renderLanes), $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $3ef321f56e16f92a$var$isHydrating && nextProps && $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $3ef321f56e16f92a$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $3ef321f56e16f92a$var$finishRenderingHooks(current);
    Component = $3ef321f56e16f92a$var$checkDidRenderIdHook();
    if (null !== current && !$3ef321f56e16f92a$var$didReceiveUpdate) return $3ef321f56e16f92a$var$bailoutHooks(current, workInProgress, renderLanes), $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $3ef321f56e16f92a$var$isHydrating && Component && $3ef321f56e16f92a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $3ef321f56e16f92a$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $3ef321f56e16f92a$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $3ef321f56e16f92a$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $3ef321f56e16f92a$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $3ef321f56e16f92a$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $3ef321f56e16f92a$var$readContext(contextType) : $3ef321f56e16f92a$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $3ef321f56e16f92a$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $3ef321f56e16f92a$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $3ef321f56e16f92a$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $3ef321f56e16f92a$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $3ef321f56e16f92a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $3ef321f56e16f92a$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $3ef321f56e16f92a$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $3ef321f56e16f92a$var$hasForceUpdate || $3ef321f56e16f92a$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $3ef321f56e16f92a$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $3ef321f56e16f92a$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $3ef321f56e16f92a$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $3ef321f56e16f92a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $3ef321f56e16f92a$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $3ef321f56e16f92a$var$hasForceUpdate || null !== current && null !== current.dependencies && $3ef321f56e16f92a$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($3ef321f56e16f92a$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $3ef321f56e16f92a$var$hasForceUpdate || $3ef321f56e16f92a$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $3ef321f56e16f92a$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $3ef321f56e16f92a$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $3ef321f56e16f92a$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $3ef321f56e16f92a$var$resetHydrationState();
    workInProgress.flags |= 256;
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $3ef321f56e16f92a$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $3ef321f56e16f92a$var$getSuspendedCache()
    };
}
function $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $3ef321f56e16f92a$var$workInProgressDeferredLane);
    return current;
}
function $3ef321f56e16f92a$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($3ef321f56e16f92a$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($3ef321f56e16f92a$var$isHydrating) {
            showFallback ? $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $3ef321f56e16f92a$var$nextHydratableInstance) ? (current = $3ef321f56e16f92a$var$canHydrateHydrationBoundary(current, $3ef321f56e16f92a$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $3ef321f56e16f92a$var$treeContextProvider ? {
                    id: $3ef321f56e16f92a$var$treeContextId,
                    overflow: $3ef321f56e16f92a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $3ef321f56e16f92a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
            $3ef321f56e16f92a$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $3ef321f56e16f92a$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $3ef321f56e16f92a$var$SUSPENDED_MARKER, $3ef321f56e16f92a$var$bailoutOffscreenComponent(null, nextProps);
        $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $3ef321f56e16f92a$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $3ef321f56e16f92a$var$SUSPENDED_MARKER, workInProgress = $3ef321f56e16f92a$var$bailoutOffscreenComponent(null, nextProps));
        else if ($3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress), $3ef321f56e16f92a$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($3ef321f56e16f92a$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $3ef321f56e16f92a$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($3ef321f56e16f92a$var$didReceiveUpdate || $3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $3ef321f56e16f92a$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $3ef321f56e16f92a$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $3ef321f56e16f92a$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(current, nextProps), $3ef321f56e16f92a$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $3ef321f56e16f92a$var$SelectiveHydrationException;
            $3ef321f56e16f92a$var$isSuspenseInstancePending(nextPrimaryChildren) || $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible();
            workInProgress = $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $3ef321f56e16f92a$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(nextPrimaryChildren.nextSibling), $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$isHydrating = !0, $3ef321f56e16f92a$var$hydrationErrors = null, $3ef321f56e16f92a$var$rootOrSingletonContext = !1, null !== current && $3ef321f56e16f92a$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $3ef321f56e16f92a$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $3ef321f56e16f92a$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $3ef321f56e16f92a$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $3ef321f56e16f92a$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $3ef321f56e16f92a$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $3ef321f56e16f92a$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $3ef321f56e16f92a$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $3ef321f56e16f92a$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $3ef321f56e16f92a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $3ef321f56e16f92a$var$SUSPENDED_MARKER, $3ef321f56e16f92a$var$bailoutOffscreenComponent(current.child, nextProps);
    $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $3ef321f56e16f92a$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $3ef321f56e16f92a$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $3ef321f56e16f92a$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $3ef321f56e16f92a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $3ef321f56e16f92a$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $3ef321f56e16f92a$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $3ef321f56e16f92a$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $3ef321f56e16f92a$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $3ef321f56e16f92a$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, suspenseContext);
    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $3ef321f56e16f92a$var$isHydrating ? $3ef321f56e16f92a$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $3ef321f56e16f92a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $3ef321f56e16f92a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $3ef321f56e16f92a$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $3ef321f56e16f92a$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $3ef321f56e16f92a$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $3ef321f56e16f92a$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $3ef321f56e16f92a$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $3ef321f56e16f92a$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $3ef321f56e16f92a$var$checkIfContextChanged(current) ? !0 : !1;
}
function $3ef321f56e16f92a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, current.memoizedState.cache);
            $3ef321f56e16f92a$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $3ef321f56e16f92a$var$pushHostContext(workInProgress);
            break;
        case 4:
            $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $3ef321f56e16f92a$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $3ef321f56e16f92a$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $3ef321f56e16f92a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $3ef321f56e16f92a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($3ef321f56e16f92a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $3ef321f56e16f92a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $3ef321f56e16f92a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, current.memoizedState.cache);
    }
    return $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $3ef321f56e16f92a$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $3ef321f56e16f92a$var$didReceiveUpdate = !0;
        else {
            if (!$3ef321f56e16f92a$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $3ef321f56e16f92a$var$didReceiveUpdate = !1, $3ef321f56e16f92a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $3ef321f56e16f92a$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $3ef321f56e16f92a$var$didReceiveUpdate = !1, $3ef321f56e16f92a$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $3ef321f56e16f92a$var$pushTreeId(workInProgress, $3ef321f56e16f92a$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $3ef321f56e16f92a$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $3ef321f56e16f92a$var$shouldConstruct(current) ? (props = $3ef321f56e16f92a$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $3ef321f56e16f92a$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $3ef321f56e16f92a$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $3ef321f56e16f92a$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $3ef321f56e16f92a$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $3ef321f56e16f92a$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $3ef321f56e16f92a$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $3ef321f56e16f92a$var$getComponentNameFromType(current) || current;
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $3ef321f56e16f92a$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $3ef321f56e16f92a$var$resolveClassComponentProps(props, workInProgress.pendingProps), $3ef321f56e16f92a$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress);
                $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, props);
                props !== prevState.cache && $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, [
                    $3ef321f56e16f92a$var$CacheContext
                ], renderLanes, !0);
                $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $3ef321f56e16f92a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $3ef321f56e16f92a$var$createCapturedValueAtFiber(Error($3ef321f56e16f92a$var$formatProdErrorMessage(424)), workInProgress);
                        $3ef321f56e16f92a$var$queueHydrationError($$typeof);
                        workInProgress = $3ef321f56e16f92a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(current.firstChild);
                        $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress;
                        $3ef321f56e16f92a$var$isHydrating = !0;
                        $3ef321f56e16f92a$var$hydrationErrors = null;
                        $3ef321f56e16f92a$var$rootOrSingletonContext = !0;
                        renderLanes = $3ef321f56e16f92a$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $3ef321f56e16f92a$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $3ef321f56e16f92a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $3ef321f56e16f92a$var$markRef(current, workInProgress), null === current ? (renderLanes = $3ef321f56e16f92a$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $3ef321f56e16f92a$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer($3ef321f56e16f92a$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress, props[$3ef321f56e16f92a$var$internalPropsKey] = current, $3ef321f56e16f92a$var$setInitialProperties(props, renderLanes, current), $3ef321f56e16f92a$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $3ef321f56e16f92a$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $3ef321f56e16f92a$var$pushHostContext(workInProgress), null === current && $3ef321f56e16f92a$var$isHydrating && (props = workInProgress.stateNode = $3ef321f56e16f92a$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $3ef321f56e16f92a$var$rootInstanceStackCursor.current), $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$rootOrSingletonContext = !0, $$typeof = $3ef321f56e16f92a$var$nextHydratableInstance, $3ef321f56e16f92a$var$isSingletonScope(workInProgress.type) ? ($3ef321f56e16f92a$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(props.firstChild)) : $3ef321f56e16f92a$var$nextHydratableInstance = $$typeof), $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $3ef321f56e16f92a$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $3ef321f56e16f92a$var$isHydrating) {
                if ($$typeof = props = $3ef321f56e16f92a$var$nextHydratableInstance) props = $3ef321f56e16f92a$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $3ef321f56e16f92a$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$nextHydratableInstance = $3ef321f56e16f92a$var$getNextHydratable(props.firstChild), $3ef321f56e16f92a$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
            }
            $3ef321f56e16f92a$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $3ef321f56e16f92a$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $3ef321f56e16f92a$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $3ef321f56e16f92a$var$renderWithHooks(current, workInProgress, $3ef321f56e16f92a$var$TransitionAwareHostComponent, null, null, renderLanes), $3ef321f56e16f92a$var$HostTransitionContext._currentValue = $$typeof);
            $3ef321f56e16f92a$var$markRef(current, workInProgress);
            $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $3ef321f56e16f92a$var$isHydrating) {
                if (current = renderLanes = $3ef321f56e16f92a$var$nextHydratableInstance) renderLanes = $3ef321f56e16f92a$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $3ef321f56e16f92a$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $3ef321f56e16f92a$var$hydrationParentFiber = workInProgress, $3ef321f56e16f92a$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $3ef321f56e16f92a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $3ef321f56e16f92a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $3ef321f56e16f92a$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $3ef321f56e16f92a$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $3ef321f56e16f92a$var$pushProvider(workInProgress, workInProgress.type, props.value), $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $3ef321f56e16f92a$var$prepareToReadContext(workInProgress), $$typeof = $3ef321f56e16f92a$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $3ef321f56e16f92a$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $3ef321f56e16f92a$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $3ef321f56e16f92a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $3ef321f56e16f92a$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $3ef321f56e16f92a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $3ef321f56e16f92a$var$prepareToReadContext(workInProgress), props = $3ef321f56e16f92a$var$readContext($3ef321f56e16f92a$var$CacheContext), null === current ? ($$typeof = $3ef321f56e16f92a$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $3ef321f56e16f92a$var$workInProgressRoot, prevState = $3ef321f56e16f92a$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $3ef321f56e16f92a$var$initializeUpdateQueue(workInProgress), $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($3ef321f56e16f92a$var$cloneUpdateQueue(current, workInProgress), $3ef321f56e16f92a$var$processUpdateQueue(workInProgress, null, null, renderLanes), $3ef321f56e16f92a$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, props)) : (props = prevState.cache, $3ef321f56e16f92a$var$pushProvider(workInProgress, $3ef321f56e16f92a$var$CacheContext, props), props !== $$typeof.cache && $3ef321f56e16f92a$var$propagateContextChanges(workInProgress, [
                $3ef321f56e16f92a$var$CacheContext
            ], renderLanes, !0))), $3ef321f56e16f92a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $3ef321f56e16f92a$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $3ef321f56e16f92a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($3ef321f56e16f92a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $3ef321f56e16f92a$var$suspendedThenable = $3ef321f56e16f92a$var$noopSuspenseyCommitThenable, $3ef321f56e16f92a$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $3ef321f56e16f92a$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$3ef321f56e16f92a$var$preloadResource(resource)) {
        if ($3ef321f56e16f92a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $3ef321f56e16f92a$var$suspendedThenable = $3ef321f56e16f92a$var$noopSuspenseyCommitThenable, $3ef321f56e16f92a$var$SuspenseyCommitException;
    }
}
function $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $3ef321f56e16f92a$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $3ef321f56e16f92a$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$3ef321f56e16f92a$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $3ef321f56e16f92a$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $3ef321f56e16f92a$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $3ef321f56e16f92a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 1:
            return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext);
            $3ef321f56e16f92a$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $3ef321f56e16f92a$var$popHydrationState(workInProgress) ? $3ef321f56e16f92a$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $3ef321f56e16f92a$var$upgradeHydrationErrorsToRecoverable());
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($3ef321f56e16f92a$var$markUpdate(workInProgress), null !== nextResource ? ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), $3ef321f56e16f92a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), $3ef321f56e16f92a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($3ef321f56e16f92a$var$markUpdate(workInProgress), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), $3ef321f56e16f92a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), $3ef321f56e16f92a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $3ef321f56e16f92a$var$popHostContext(workInProgress);
            renderLanes = $3ef321f56e16f92a$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(166));
                    $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $3ef321f56e16f92a$var$contextStackCursor.current;
                $3ef321f56e16f92a$var$popHydrationState(workInProgress) ? $3ef321f56e16f92a$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $3ef321f56e16f92a$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $3ef321f56e16f92a$var$markUpdate(workInProgress));
            }
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $3ef321f56e16f92a$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(166));
                    $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $3ef321f56e16f92a$var$contextStackCursor.current;
                if ($3ef321f56e16f92a$var$popHydrationState(workInProgress)) $3ef321f56e16f92a$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer($3ef321f56e16f92a$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress;
                    nextResource[$3ef321f56e16f92a$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($3ef321f56e16f92a$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress);
                }
            }
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            $3ef321f56e16f92a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $3ef321f56e16f92a$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(166));
                current = $3ef321f56e16f92a$var$rootInstanceStackCursor.current;
                if ($3ef321f56e16f92a$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $3ef321f56e16f92a$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $3ef321f56e16f92a$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $3ef321f56e16f92a$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $3ef321f56e16f92a$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(557));
                        current[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress;
                    } else $3ef321f56e16f92a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $3ef321f56e16f92a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(558));
            }
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $3ef321f56e16f92a$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(317));
                        type[$3ef321f56e16f92a$var$internalInstanceKey] = workInProgress;
                    } else $3ef321f56e16f92a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $3ef321f56e16f92a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $3ef321f56e16f92a$var$popHostContainer(), null === current && $3ef321f56e16f92a$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 10:
            return $3ef321f56e16f92a$var$popProvider(workInProgress.type), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 19:
            $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $3ef321f56e16f92a$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $3ef321f56e16f92a$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $3ef321f56e16f92a$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $3ef321f56e16f92a$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$3ef321f56e16f92a$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, $3ef321f56e16f92a$var$suspenseStackCursor.current & 1 | 2);
                            $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $3ef321f56e16f92a$var$now() > $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $3ef321f56e16f92a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $3ef321f56e16f92a$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, current), $3ef321f56e16f92a$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$3ef321f56e16f92a$var$isHydrating) return $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
                    } else 2 * $3ef321f56e16f92a$var$now() - newProps.renderingStartTime > $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $3ef321f56e16f92a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $3ef321f56e16f92a$var$now(), current.sibling = null, renderLanes = $3ef321f56e16f92a$var$suspenseStackCursor.current, $3ef321f56e16f92a$var$push($3ef321f56e16f92a$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $3ef321f56e16f92a$var$isHydrating && $3ef321f56e16f92a$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $3ef321f56e16f92a$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress), $3ef321f56e16f92a$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($3ef321f56e16f92a$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $3ef321f56e16f92a$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $3ef321f56e16f92a$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext), $3ef321f56e16f92a$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $3ef321f56e16f92a$var$unwindWork(current, workInProgress) {
    $3ef321f56e16f92a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext), $3ef321f56e16f92a$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $3ef321f56e16f92a$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(340));
                $3ef321f56e16f92a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(340));
                $3ef321f56e16f92a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor), null;
        case 4:
            return $3ef321f56e16f92a$var$popHostContainer(), null;
        case 10:
            return $3ef321f56e16f92a$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $3ef321f56e16f92a$var$popSuspenseHandler(workInProgress), $3ef321f56e16f92a$var$popHiddenContext(), null !== current && $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $3ef321f56e16f92a$var$unwindInterruptedWork(current, interruptedWork) {
    $3ef321f56e16f92a$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext);
            $3ef321f56e16f92a$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $3ef321f56e16f92a$var$popHostContext(interruptedWork);
            break;
        case 4:
            $3ef321f56e16f92a$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $3ef321f56e16f92a$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $3ef321f56e16f92a$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$suspenseStackCursor);
            break;
        case 10:
            $3ef321f56e16f92a$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $3ef321f56e16f92a$var$popSuspenseHandler(interruptedWork);
            $3ef321f56e16f92a$var$popHiddenContext();
            null !== current && $3ef321f56e16f92a$var$pop($3ef321f56e16f92a$var$resumedCache);
            break;
        case 24:
            $3ef321f56e16f92a$var$popProvider($3ef321f56e16f92a$var$CacheContext);
    }
}
function $3ef321f56e16f92a$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $3ef321f56e16f92a$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $3ef321f56e16f92a$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $3ef321f56e16f92a$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $3ef321f56e16f92a$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $3ef321f56e16f92a$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $3ef321f56e16f92a$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $3ef321f56e16f92a$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $3ef321f56e16f92a$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$3ef321f56e16f92a$var$internalPropsKey] = newProps;
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $3ef321f56e16f92a$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $3ef321f56e16f92a$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $3ef321f56e16f92a$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $3ef321f56e16f92a$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $3ef321f56e16f92a$var$noop$1));
    else if (4 !== tag && (27 === tag && $3ef321f56e16f92a$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $3ef321f56e16f92a$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $3ef321f56e16f92a$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($3ef321f56e16f92a$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$3ef321f56e16f92a$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $3ef321f56e16f92a$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $3ef321f56e16f92a$var$setInitialProperties(singleton, type, props);
        singleton[$3ef321f56e16f92a$var$internalInstanceKey] = finishedWork;
        singleton[$3ef321f56e16f92a$var$internalPropsKey] = props;
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = !1, $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = !1, $3ef321f56e16f92a$var$needsFormReset = !1, $3ef321f56e16f92a$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $3ef321f56e16f92a$var$nextEffect = null;
function $3ef321f56e16f92a$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $3ef321f56e16f92a$var$eventsEnabled = $3ef321f56e16f92a$var$_enabled;
    root = $3ef321f56e16f92a$var$getActiveElementDeep(root);
    if ($3ef321f56e16f92a$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $3ef321f56e16f92a$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $3ef321f56e16f92a$var$_enabled = !1;
    for($3ef321f56e16f92a$var$nextEffect = firstChild; null !== $3ef321f56e16f92a$var$nextEffect;)if (firstChild = $3ef321f56e16f92a$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $3ef321f56e16f92a$var$nextEffect = root;
    else for(; null !== $3ef321f56e16f92a$var$nextEffect;){
        firstChild = $3ef321f56e16f92a$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $3ef321f56e16f92a$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $3ef321f56e16f92a$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $3ef321f56e16f92a$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $3ef321f56e16f92a$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $3ef321f56e16f92a$var$nextEffect = root;
            break;
        }
        $3ef321f56e16f92a$var$nextEffect = firstChild.return;
    }
}
function $3ef321f56e16f92a$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $3ef321f56e16f92a$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $3ef321f56e16f92a$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $3ef321f56e16f92a$var$commitClassCallbacks(finishedWork);
            flags & 512 && $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $3ef321f56e16f92a$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $3ef321f56e16f92a$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $3ef321f56e16f92a$var$commitHostMount(finishedWork);
            flags & 512 && $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $3ef321f56e16f92a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $3ef321f56e16f92a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $3ef321f56e16f92a$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $3ef321f56e16f92a$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $3ef321f56e16f92a$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $3ef321f56e16f92a$var$offscreenSubtreeWasHidden;
                prevProps = $3ef321f56e16f92a$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $3ef321f56e16f92a$var$offscreenSubtreeWasHidden;
                $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = flags;
                ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = prevProps;
                $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $3ef321f56e16f92a$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $3ef321f56e16f92a$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $3ef321f56e16f92a$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $3ef321f56e16f92a$var$hostParent = null, $3ef321f56e16f92a$var$hostParentIsContainer = !1;
function $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$3ef321f56e16f92a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $3ef321f56e16f92a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.onCommitFiberUnmount) try {
        $3ef321f56e16f92a$var$injectedHook.onCommitFiberUnmount($3ef321f56e16f92a$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $3ef321f56e16f92a$var$hostParent, prevHostParentIsContainer = $3ef321f56e16f92a$var$hostParentIsContainer;
            $3ef321f56e16f92a$var$isSingletonScope(deletedFiber.type) && ($3ef321f56e16f92a$var$hostParent = deletedFiber.stateNode, $3ef321f56e16f92a$var$hostParentIsContainer = !1);
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $3ef321f56e16f92a$var$releaseSingletonInstance(deletedFiber.stateNode);
            $3ef321f56e16f92a$var$hostParent = prevHostParent;
            $3ef321f56e16f92a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $3ef321f56e16f92a$var$hostParent;
            prevHostParentIsContainer = $3ef321f56e16f92a$var$hostParentIsContainer;
            $3ef321f56e16f92a$var$hostParent = null;
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $3ef321f56e16f92a$var$hostParent = prevHostParent;
            $3ef321f56e16f92a$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $3ef321f56e16f92a$var$hostParent) {
                if ($3ef321f56e16f92a$var$hostParentIsContainer) try {
                    (9 === $3ef321f56e16f92a$var$hostParent.nodeType ? $3ef321f56e16f92a$var$hostParent.body : "HTML" === $3ef321f56e16f92a$var$hostParent.nodeName ? $3ef321f56e16f92a$var$hostParent.ownerDocument.body : $3ef321f56e16f92a$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $3ef321f56e16f92a$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $3ef321f56e16f92a$var$hostParent && ($3ef321f56e16f92a$var$hostParentIsContainer ? (finishedRoot = $3ef321f56e16f92a$var$hostParent, $3ef321f56e16f92a$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $3ef321f56e16f92a$var$retryIfBlockedOn(finishedRoot)) : $3ef321f56e16f92a$var$clearHydrationBoundary($3ef321f56e16f92a$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $3ef321f56e16f92a$var$hostParent;
            prevHostParentIsContainer = $3ef321f56e16f92a$var$hostParentIsContainer;
            $3ef321f56e16f92a$var$hostParent = deletedFiber.stateNode.containerInfo;
            $3ef321f56e16f92a$var$hostParentIsContainer = !0;
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $3ef321f56e16f92a$var$hostParent = prevHostParent;
            $3ef321f56e16f92a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $3ef321f56e16f92a$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || ($3ef321f56e16f92a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $3ef321f56e16f92a$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = (prevHostParent = $3ef321f56e16f92a$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $3ef321f56e16f92a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $3ef321f56e16f92a$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $3ef321f56e16f92a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $3ef321f56e16f92a$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $3ef321f56e16f92a$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $3ef321f56e16f92a$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $3ef321f56e16f92a$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $3ef321f56e16f92a$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $3ef321f56e16f92a$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($3ef321f56e16f92a$var$isSingletonScope(parent.type)) {
                        $3ef321f56e16f92a$var$hostParent = parent.stateNode;
                        $3ef321f56e16f92a$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $3ef321f56e16f92a$var$hostParent = parent.stateNode;
                    $3ef321f56e16f92a$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $3ef321f56e16f92a$var$hostParent = parent.stateNode.containerInfo;
                    $3ef321f56e16f92a$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $3ef321f56e16f92a$var$hostParent) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(160));
        $3ef321f56e16f92a$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $3ef321f56e16f92a$var$hostParent = null;
        $3ef321f56e16f92a$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $3ef321f56e16f92a$var$currentHoistableRoot = null;
function $3ef321f56e16f92a$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($3ef321f56e16f92a$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $3ef321f56e16f92a$var$commitHookEffectListMount(3, finishedWork), $3ef321f56e16f92a$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            flags & 64 && $3ef321f56e16f92a$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$3ef321f56e16f92a$var$internalHoistableMarker] || currentResource[$3ef321f56e16f92a$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $3ef321f56e16f92a$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$3ef321f56e16f92a$var$internalInstanceKey] = finishedWork;
                                        $3ef321f56e16f92a$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $3ef321f56e16f92a$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $3ef321f56e16f92a$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $3ef321f56e16f92a$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $3ef321f56e16f92a$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$3ef321f56e16f92a$var$internalInstanceKey] = finishedWork;
                                $3ef321f56e16f92a$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $3ef321f56e16f92a$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $3ef321f56e16f92a$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $3ef321f56e16f92a$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $3ef321f56e16f92a$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $3ef321f56e16f92a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $3ef321f56e16f92a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($3ef321f56e16f92a$var$offscreenSubtreeWasHidden || null === current || $3ef321f56e16f92a$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $3ef321f56e16f92a$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $3ef321f56e16f92a$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($3ef321f56e16f92a$var$needsFormReset = !0);
            break;
        case 6:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $3ef321f56e16f92a$var$tagCaches = null;
            hoistableRoot = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$currentHoistableRoot = $3ef321f56e16f92a$var$getHoistableRoot(root.containerInfo);
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$currentHoistableRoot = hoistableRoot;
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $3ef321f56e16f92a$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $3ef321f56e16f92a$var$needsFormReset && ($3ef321f56e16f92a$var$needsFormReset = !1, $3ef321f56e16f92a$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$currentHoistableRoot = $3ef321f56e16f92a$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            $3ef321f56e16f92a$var$currentHoistableRoot = flags;
            break;
        case 12:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($3ef321f56e16f92a$var$globalMostRecentFallbackTime = $3ef321f56e16f92a$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $3ef321f56e16f92a$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $3ef321f56e16f92a$var$offscreenSubtreeWasHidden;
            $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $3ef321f56e16f92a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $3ef321f56e16f92a$var$offscreenSubtreeIsHidden || $3ef321f56e16f92a$var$offscreenSubtreeWasHidden || $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $3ef321f56e16f92a$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $3ef321f56e16f92a$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $3ef321f56e16f92a$var$hideOrUnhideDehydratedBoundary(instance, !0) : $3ef321f56e16f92a$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $3ef321f56e16f92a$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $3ef321f56e16f92a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraverseMutationEffects(root, finishedWork), $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork);
    }
}
function $3ef321f56e16f92a$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($3ef321f56e16f92a$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $3ef321f56e16f92a$var$getHostSibling(finishedWork);
                    $3ef321f56e16f92a$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($3ef321f56e16f92a$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $3ef321f56e16f92a$var$getHostSibling(finishedWork);
                    $3ef321f56e16f92a$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $3ef321f56e16f92a$var$getHostSibling(finishedWork);
                    $3ef321f56e16f92a$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $3ef321f56e16f92a$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $3ef321f56e16f92a$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $3ef321f56e16f92a$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $3ef321f56e16f92a$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $3ef321f56e16f92a$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $3ef321f56e16f92a$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $3ef321f56e16f92a$var$safelyDetachRef(finishedWork, finishedWork.return);
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $3ef321f56e16f92a$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$3ef321f56e16f92a$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $3ef321f56e16f92a$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $3ef321f56e16f92a$var$commitClassCallbacks(finishedWork);
                $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $3ef321f56e16f92a$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $3ef321f56e16f92a$var$commitHostMount(finishedWork);
                $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $3ef321f56e16f92a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $3ef321f56e16f92a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $3ef321f56e16f92a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $3ef321f56e16f92a$var$releaseCache(previousCache));
}
function $3ef321f56e16f92a$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $3ef321f56e16f92a$var$releaseCache(current));
}
function $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $3ef321f56e16f92a$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $3ef321f56e16f92a$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $3ef321f56e16f92a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $3ef321f56e16f92a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $3ef321f56e16f92a$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $3ef321f56e16f92a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $3ef321f56e16f92a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $3ef321f56e16f92a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $3ef321f56e16f92a$var$suspenseyCommitFlag = 8192;
function $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $3ef321f56e16f92a$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $3ef321f56e16f92a$var$suspenseyCommitFlag && null !== fiber.memoizedState && $3ef321f56e16f92a$var$suspendResource(suspendedState, $3ef321f56e16f92a$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $3ef321f56e16f92a$var$currentHoistableRoot;
            $3ef321f56e16f92a$var$currentHoistableRoot = $3ef321f56e16f92a$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $3ef321f56e16f92a$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $3ef321f56e16f92a$var$suspenseyCommitFlag, $3ef321f56e16f92a$var$suspenseyCommitFlag = 16777216, $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $3ef321f56e16f92a$var$suspenseyCommitFlag = previousHoistableRoot) : $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $3ef321f56e16f92a$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $3ef321f56e16f92a$var$nextEffect = childToDelete;
            $3ef321f56e16f92a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $3ef321f56e16f92a$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$3ef321f56e16f92a$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $3ef321f56e16f92a$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $3ef321f56e16f92a$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $3ef321f56e16f92a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $3ef321f56e16f92a$var$nextEffect = childToDelete;
            $3ef321f56e16f92a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $3ef321f56e16f92a$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $3ef321f56e16f92a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $3ef321f56e16f92a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $3ef321f56e16f92a$var$nextEffect;){
        var fiber = $3ef321f56e16f92a$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $3ef321f56e16f92a$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $3ef321f56e16f92a$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $3ef321f56e16f92a$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $3ef321f56e16f92a$var$nextEffect;){
            cache = $3ef321f56e16f92a$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $3ef321f56e16f92a$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $3ef321f56e16f92a$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $3ef321f56e16f92a$var$nextEffect = sibling;
                break a;
            }
            $3ef321f56e16f92a$var$nextEffect = returnFiber;
        }
    }
}
var $3ef321f56e16f92a$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $3ef321f56e16f92a$var$readContext($3ef321f56e16f92a$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $3ef321f56e16f92a$var$readContext($3ef321f56e16f92a$var$CacheContext).controller.signal;
    }
}, $3ef321f56e16f92a$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $3ef321f56e16f92a$var$executionContext = 0, $3ef321f56e16f92a$var$workInProgressRoot = null, $3ef321f56e16f92a$var$workInProgress = null, $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0, $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings = !1, $3ef321f56e16f92a$var$workInProgressRootIsPrerendering = !1, $3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener = !1, $3ef321f56e16f92a$var$entangledRenderLanes = 0, $3ef321f56e16f92a$var$workInProgressRootExitStatus = 0, $3ef321f56e16f92a$var$workInProgressRootSkippedLanes = 0, $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes = 0, $3ef321f56e16f92a$var$workInProgressRootPingedLanes = 0, $3ef321f56e16f92a$var$workInProgressDeferredLane = 0, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes = 0, $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors = null, $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = null, $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $3ef321f56e16f92a$var$globalMostRecentFallbackTime = 0, $3ef321f56e16f92a$var$globalMostRecentTransitionTime = 0, $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime = Infinity, $3ef321f56e16f92a$var$workInProgressTransitions = null, $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed = null, $3ef321f56e16f92a$var$pendingEffectsStatus = 0, $3ef321f56e16f92a$var$pendingEffectsRoot = null, $3ef321f56e16f92a$var$pendingFinishedWork = null, $3ef321f56e16f92a$var$pendingEffectsLanes = 0, $3ef321f56e16f92a$var$pendingEffectsRemainingLanes = 0, $3ef321f56e16f92a$var$pendingPassiveTransitions = null, $3ef321f56e16f92a$var$pendingRecoverableErrors = null, $3ef321f56e16f92a$var$nestedUpdateCount = 0, $3ef321f56e16f92a$var$rootWithNestedUpdates = null;
function $3ef321f56e16f92a$var$requestUpdateLane() {
    return 0 !== ($3ef321f56e16f92a$var$executionContext & 2) && 0 !== $3ef321f56e16f92a$var$workInProgressRootRenderLanes ? $3ef321f56e16f92a$var$workInProgressRootRenderLanes & -$3ef321f56e16f92a$var$workInProgressRootRenderLanes : null !== $3ef321f56e16f92a$var$ReactSharedInternals.T ? $3ef321f56e16f92a$var$requestTransitionLane() : $3ef321f56e16f92a$var$resolveUpdatePriority();
}
function $3ef321f56e16f92a$var$requestDeferredLane() {
    if (0 === $3ef321f56e16f92a$var$workInProgressDeferredLane) {
        if (0 === ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 536870912) || $3ef321f56e16f92a$var$isHydrating) {
            var lane = $3ef321f56e16f92a$var$nextTransitionDeferredLane;
            $3ef321f56e16f92a$var$nextTransitionDeferredLane <<= 1;
            0 === ($3ef321f56e16f92a$var$nextTransitionDeferredLane & 3932160) && ($3ef321f56e16f92a$var$nextTransitionDeferredLane = 262144);
            $3ef321f56e16f92a$var$workInProgressDeferredLane = lane;
        } else $3ef321f56e16f92a$var$workInProgressDeferredLane = 536870912;
    }
    lane = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $3ef321f56e16f92a$var$workInProgressDeferredLane;
}
function $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $3ef321f56e16f92a$var$workInProgressRoot && (2 === $3ef321f56e16f92a$var$workInProgressSuspendedReason || 9 === $3ef321f56e16f92a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $3ef321f56e16f92a$var$prepareFreshStack(root, 0), $3ef321f56e16f92a$var$markRootSuspended(root, $3ef321f56e16f92a$var$workInProgressRootRenderLanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !1);
    $3ef321f56e16f92a$var$markRootUpdated$1(root, lane);
    if (0 === ($3ef321f56e16f92a$var$executionContext & 2) || root !== $3ef321f56e16f92a$var$workInProgressRoot) root === $3ef321f56e16f92a$var$workInProgressRoot && (0 === ($3ef321f56e16f92a$var$executionContext & 2) && ($3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && $3ef321f56e16f92a$var$markRootSuspended(root, $3ef321f56e16f92a$var$workInProgressRootRenderLanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !1)), $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
}
function $3ef321f56e16f92a$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($3ef321f56e16f92a$var$executionContext & 6)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $3ef321f56e16f92a$var$renderRootConcurrent(root$jscomp$0, lanes) : $3ef321f56e16f92a$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $3ef321f56e16f92a$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $3ef321f56e16f92a$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$3ef321f56e16f92a$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $3ef321f56e16f92a$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($3ef321f56e16f92a$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $3ef321f56e16f92a$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors;
                            $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors ? $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors.push.apply($3ef321f56e16f92a$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $3ef321f56e16f92a$var$prepareFreshStack(root$jscomp$0, 0);
                $3ef321f56e16f92a$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $3ef321f56e16f92a$var$markRootSuspended(shouldTimeSlice, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !$3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $3ef321f56e16f92a$var$globalMostRecentFallbackTime + 300 - $3ef321f56e16f92a$var$now(), 10 < exitStatus)) {
                    $3ef321f56e16f92a$var$markRootSuspended(shouldTimeSlice, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !$3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $3ef321f56e16f92a$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $3ef321f56e16f92a$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $3ef321f56e16f92a$var$scheduleTimeout($3ef321f56e16f92a$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors, $3ef321f56e16f92a$var$workInProgressTransitions, $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $3ef321f56e16f92a$var$commitRootWhenReady(shouldTimeSlice, forceSync, $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors, $3ef321f56e16f92a$var$workInProgressTransitions, $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $3ef321f56e16f92a$var$ensureRootIsScheduled(root$jscomp$0);
}
function $3ef321f56e16f92a$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $3ef321f56e16f92a$var$noop$1
        };
        $3ef321f56e16f92a$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $3ef321f56e16f92a$var$globalMostRecentFallbackTime - $3ef321f56e16f92a$var$now() : (lanes & 4194048) === lanes ? $3ef321f56e16f92a$var$globalMostRecentTransitionTime - $3ef321f56e16f92a$var$now() : 0;
        timeoutOffset = $3ef321f56e16f92a$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $3ef321f56e16f92a$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($3ef321f56e16f92a$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $3ef321f56e16f92a$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $3ef321f56e16f92a$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $3ef321f56e16f92a$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$3ef321f56e16f92a$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $3ef321f56e16f92a$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$3ef321f56e16f92a$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $3ef321f56e16f92a$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $3ef321f56e16f92a$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $3ef321f56e16f92a$var$flushSyncWork$1() {
    return 0 === ($3ef321f56e16f92a$var$executionContext & 6) ? ($3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $3ef321f56e16f92a$var$resetWorkInProgressStack() {
    if (null !== $3ef321f56e16f92a$var$workInProgress) {
        if (0 === $3ef321f56e16f92a$var$workInProgressSuspendedReason) var interruptedWork = $3ef321f56e16f92a$var$workInProgress.return;
        else interruptedWork = $3ef321f56e16f92a$var$workInProgress, $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null, $3ef321f56e16f92a$var$resetHooksOnUnwind(interruptedWork), $3ef321f56e16f92a$var$thenableState$1 = null, $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0, interruptedWork = $3ef321f56e16f92a$var$workInProgress;
        for(; null !== interruptedWork;)$3ef321f56e16f92a$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $3ef321f56e16f92a$var$workInProgress = null;
    }
}
function $3ef321f56e16f92a$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $3ef321f56e16f92a$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $3ef321f56e16f92a$var$pendingEffectsLanes = 0;
    $3ef321f56e16f92a$var$resetWorkInProgressStack();
    $3ef321f56e16f92a$var$workInProgressRoot = root;
    $3ef321f56e16f92a$var$workInProgress = timeoutHandle = $3ef321f56e16f92a$var$createWorkInProgress(root.current, null);
    $3ef321f56e16f92a$var$workInProgressRootRenderLanes = lanes;
    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
    $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $3ef321f56e16f92a$var$workInProgressRootIsPrerendering = $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, lanes);
    $3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener = !1;
    $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes = $3ef321f56e16f92a$var$workInProgressDeferredLane = $3ef321f56e16f92a$var$workInProgressRootPingedLanes = $3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes = $3ef321f56e16f92a$var$workInProgressRootSkippedLanes = $3ef321f56e16f92a$var$workInProgressRootExitStatus = 0;
    $3ef321f56e16f92a$var$workInProgressRootRecoverableErrors = $3ef321f56e16f92a$var$workInProgressRootConcurrentErrors = null;
    $3ef321f56e16f92a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $3ef321f56e16f92a$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $3ef321f56e16f92a$var$entangledRenderLanes = lanes;
    $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $3ef321f56e16f92a$var$handleThrow(root, thrownValue) {
    $3ef321f56e16f92a$var$currentlyRenderingFiber = null;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$ContextOnlyDispatcher;
    thrownValue === $3ef321f56e16f92a$var$SuspenseException || thrownValue === $3ef321f56e16f92a$var$SuspenseActionException ? (thrownValue = $3ef321f56e16f92a$var$getSuspendedThenable(), $3ef321f56e16f92a$var$workInProgressSuspendedReason = 3) : thrownValue === $3ef321f56e16f92a$var$SuspenseyCommitException ? (thrownValue = $3ef321f56e16f92a$var$getSuspendedThenable(), $3ef321f56e16f92a$var$workInProgressSuspendedReason = 4) : $3ef321f56e16f92a$var$workInProgressSuspendedReason = thrownValue === $3ef321f56e16f92a$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $3ef321f56e16f92a$var$workInProgressThrownValue = thrownValue;
    null === $3ef321f56e16f92a$var$workInProgress && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 1, $3ef321f56e16f92a$var$logUncaughtError(root, $3ef321f56e16f92a$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $3ef321f56e16f92a$var$shouldRemainOnPreviousScreen() {
    var handler = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 4194048) === $3ef321f56e16f92a$var$workInProgressRootRenderLanes ? null === $3ef321f56e16f92a$var$shellBoundary ? !0 : !1 : ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 62914560) === $3ef321f56e16f92a$var$workInProgressRootRenderLanes || 0 !== ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 536870912) ? handler === $3ef321f56e16f92a$var$shellBoundary : !1;
}
function $3ef321f56e16f92a$var$pushDispatcher() {
    var prevDispatcher = $3ef321f56e16f92a$var$ReactSharedInternals.H;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = $3ef321f56e16f92a$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $3ef321f56e16f92a$var$ContextOnlyDispatcher : prevDispatcher;
}
function $3ef321f56e16f92a$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $3ef321f56e16f92a$var$ReactSharedInternals.A;
    $3ef321f56e16f92a$var$ReactSharedInternals.A = $3ef321f56e16f92a$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $3ef321f56e16f92a$var$renderDidSuspendDelayIfPossible() {
    $3ef321f56e16f92a$var$workInProgressRootExitStatus = 4;
    $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings || ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 4194048) !== $3ef321f56e16f92a$var$workInProgressRootRenderLanes && null !== $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current || ($3ef321f56e16f92a$var$workInProgressRootIsPrerendering = !0);
    0 === ($3ef321f56e16f92a$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($3ef321f56e16f92a$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $3ef321f56e16f92a$var$workInProgressRoot || $3ef321f56e16f92a$var$markRootSuspended($3ef321f56e16f92a$var$workInProgressRoot, $3ef321f56e16f92a$var$workInProgressRootRenderLanes, $3ef321f56e16f92a$var$workInProgressDeferredLane, !1);
}
function $3ef321f56e16f92a$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
    $3ef321f56e16f92a$var$executionContext |= 2;
    var prevDispatcher = $3ef321f56e16f92a$var$pushDispatcher(), prevAsyncDispatcher = $3ef321f56e16f92a$var$pushAsyncDispatcher();
    if ($3ef321f56e16f92a$var$workInProgressRoot !== root || $3ef321f56e16f92a$var$workInProgressRootRenderLanes !== lanes) $3ef321f56e16f92a$var$workInProgressTransitions = null, $3ef321f56e16f92a$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $3ef321f56e16f92a$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $3ef321f56e16f92a$var$workInProgressSuspendedReason && null !== $3ef321f56e16f92a$var$workInProgress) {
            var unitOfWork = $3ef321f56e16f92a$var$workInProgress, thrownValue = $3ef321f56e16f92a$var$workInProgressThrownValue;
            switch($3ef321f56e16f92a$var$workInProgressSuspendedReason){
                case 8:
                    $3ef321f56e16f92a$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $3ef321f56e16f92a$var$workInProgressSuspendedReason;
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $3ef321f56e16f92a$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $3ef321f56e16f92a$var$workInProgressSuspendedReason, $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $3ef321f56e16f92a$var$workLoopSync();
        exitStatus = $3ef321f56e16f92a$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $3ef321f56e16f92a$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null;
    $3ef321f56e16f92a$var$executionContext = prevExecutionContext;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = prevDispatcher;
    $3ef321f56e16f92a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $3ef321f56e16f92a$var$workInProgress && ($3ef321f56e16f92a$var$workInProgressRoot = null, $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0, $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $3ef321f56e16f92a$var$workLoopSync() {
    for(; null !== $3ef321f56e16f92a$var$workInProgress;)$3ef321f56e16f92a$var$performUnitOfWork($3ef321f56e16f92a$var$workInProgress);
}
function $3ef321f56e16f92a$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
    $3ef321f56e16f92a$var$executionContext |= 2;
    var prevDispatcher = $3ef321f56e16f92a$var$pushDispatcher(), prevAsyncDispatcher = $3ef321f56e16f92a$var$pushAsyncDispatcher();
    $3ef321f56e16f92a$var$workInProgressRoot !== root || $3ef321f56e16f92a$var$workInProgressRootRenderLanes !== lanes ? ($3ef321f56e16f92a$var$workInProgressTransitions = null, $3ef321f56e16f92a$var$workInProgressRootRenderTargetTime = $3ef321f56e16f92a$var$now() + 500, $3ef321f56e16f92a$var$prepareFreshStack(root, lanes)) : $3ef321f56e16f92a$var$workInProgressRootIsPrerendering = $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $3ef321f56e16f92a$var$workInProgressSuspendedReason && null !== $3ef321f56e16f92a$var$workInProgress) {
            lanes = $3ef321f56e16f92a$var$workInProgress;
            var thrownValue = $3ef321f56e16f92a$var$workInProgressThrownValue;
            b: switch($3ef321f56e16f92a$var$workInProgressSuspendedReason){
                case 1:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($3ef321f56e16f92a$var$isThenableResolved(thrownValue)) {
                        $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                        $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                        $3ef321f56e16f92a$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $3ef321f56e16f92a$var$workInProgressSuspendedReason && 9 !== $3ef321f56e16f92a$var$workInProgressSuspendedReason || $3ef321f56e16f92a$var$workInProgressRoot !== root || ($3ef321f56e16f92a$var$workInProgressSuspendedReason = 7);
                        $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $3ef321f56e16f92a$var$isThenableResolved(thrownValue) ? ($3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$replaySuspendedUnitOfWork(lanes)) : ($3ef321f56e16f92a$var$workInProgressSuspendedReason = 0, $3ef321f56e16f92a$var$workInProgressThrownValue = null, $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($3ef321f56e16f92a$var$workInProgress.tag){
                        case 26:
                            resource = $3ef321f56e16f92a$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $3ef321f56e16f92a$var$workInProgress;
                            if (resource ? $3ef321f56e16f92a$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                                $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $3ef321f56e16f92a$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($3ef321f56e16f92a$var$workInProgress = returnFiber, $3ef321f56e16f92a$var$completeUnitOfWork(returnFiber)) : $3ef321f56e16f92a$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $3ef321f56e16f92a$var$workInProgressSuspendedReason = 0;
                    $3ef321f56e16f92a$var$workInProgressThrownValue = null;
                    $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $3ef321f56e16f92a$var$resetWorkInProgressStack();
                    $3ef321f56e16f92a$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(462));
            }
        }
        $3ef321f56e16f92a$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $3ef321f56e16f92a$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null;
    $3ef321f56e16f92a$var$ReactSharedInternals.H = prevDispatcher;
    $3ef321f56e16f92a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $3ef321f56e16f92a$var$executionContext = prevExecutionContext;
    if (null !== $3ef321f56e16f92a$var$workInProgress) return 0;
    $3ef321f56e16f92a$var$workInProgressRoot = null;
    $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0;
    $3ef321f56e16f92a$var$finishQueueingConcurrentUpdates();
    return $3ef321f56e16f92a$var$workInProgressRootExitStatus;
}
function $3ef321f56e16f92a$var$workLoopConcurrentByScheduler() {
    for(; null !== $3ef321f56e16f92a$var$workInProgress && !$3ef321f56e16f92a$var$shouldYield();)$3ef321f56e16f92a$var$performUnitOfWork($3ef321f56e16f92a$var$workInProgress);
}
function $3ef321f56e16f92a$var$performUnitOfWork(unitOfWork) {
    var next = $3ef321f56e16f92a$var$beginWork(unitOfWork.alternate, unitOfWork, $3ef321f56e16f92a$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork) : $3ef321f56e16f92a$var$workInProgress = next;
}
function $3ef321f56e16f92a$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $3ef321f56e16f92a$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $3ef321f56e16f92a$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $3ef321f56e16f92a$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $3ef321f56e16f92a$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $3ef321f56e16f92a$var$resetHooksOnUnwind(next);
        default:
            $3ef321f56e16f92a$var$unwindInterruptedWork(current, next), next = $3ef321f56e16f92a$var$workInProgress = $3ef321f56e16f92a$var$resetWorkInProgress(next, $3ef321f56e16f92a$var$entangledRenderLanes), next = $3ef321f56e16f92a$var$beginWork(current, next, $3ef321f56e16f92a$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork) : $3ef321f56e16f92a$var$workInProgress = next;
}
function $3ef321f56e16f92a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $3ef321f56e16f92a$var$lastContextDependency = $3ef321f56e16f92a$var$currentlyRenderingFiber$1 = null;
    $3ef321f56e16f92a$var$resetHooksOnUnwind(unitOfWork);
    $3ef321f56e16f92a$var$thenableState$1 = null;
    $3ef321f56e16f92a$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($3ef321f56e16f92a$var$throwException(root, returnFiber, unitOfWork, thrownValue, $3ef321f56e16f92a$var$workInProgressRootRenderLanes)) {
            $3ef321f56e16f92a$var$workInProgressRootExitStatus = 1;
            $3ef321f56e16f92a$var$logUncaughtError(root, $3ef321f56e16f92a$var$createCapturedValueAtFiber(thrownValue, root.current));
            $3ef321f56e16f92a$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $3ef321f56e16f92a$var$workInProgress = returnFiber, error;
        $3ef321f56e16f92a$var$workInProgressRootExitStatus = 1;
        $3ef321f56e16f92a$var$logUncaughtError(root, $3ef321f56e16f92a$var$createCapturedValueAtFiber(thrownValue, root.current));
        $3ef321f56e16f92a$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($3ef321f56e16f92a$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($3ef321f56e16f92a$var$workInProgressRootIsPrerendering || 0 !== ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $3ef321f56e16f92a$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $3ef321f56e16f92a$var$unwindUnitOfWork(unitOfWork, root);
    } else $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork);
}
function $3ef321f56e16f92a$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $3ef321f56e16f92a$var$unwindUnitOfWork(completedWork, $3ef321f56e16f92a$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $3ef321f56e16f92a$var$completeWork(completedWork.alternate, completedWork, $3ef321f56e16f92a$var$entangledRenderLanes);
        if (null !== next) {
            $3ef321f56e16f92a$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $3ef321f56e16f92a$var$workInProgress = completedWork;
            return;
        }
        $3ef321f56e16f92a$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootExitStatus = 5);
}
function $3ef321f56e16f92a$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $3ef321f56e16f92a$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $3ef321f56e16f92a$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $3ef321f56e16f92a$var$workInProgress = unitOfWork;
            return;
        }
        $3ef321f56e16f92a$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $3ef321f56e16f92a$var$workInProgressRootExitStatus = 6;
    $3ef321f56e16f92a$var$workInProgress = null;
}
function $3ef321f56e16f92a$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $3ef321f56e16f92a$var$flushPendingEffects();
    while (0 !== $3ef321f56e16f92a$var$pendingEffectsStatus);
    if (0 !== ($3ef321f56e16f92a$var$executionContext & 6)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $3ef321f56e16f92a$var$concurrentlyUpdatedLanes;
        $3ef321f56e16f92a$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $3ef321f56e16f92a$var$workInProgressRoot && ($3ef321f56e16f92a$var$workInProgress = $3ef321f56e16f92a$var$workInProgressRoot = null, $3ef321f56e16f92a$var$workInProgressRootRenderLanes = 0);
        $3ef321f56e16f92a$var$pendingFinishedWork = finishedWork;
        $3ef321f56e16f92a$var$pendingEffectsRoot = root;
        $3ef321f56e16f92a$var$pendingEffectsLanes = lanes;
        $3ef321f56e16f92a$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $3ef321f56e16f92a$var$pendingPassiveTransitions = transitions;
        $3ef321f56e16f92a$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $3ef321f56e16f92a$var$scheduleCallback$1($3ef321f56e16f92a$var$NormalPriority$1, function() {
            $3ef321f56e16f92a$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $3ef321f56e16f92a$var$ReactSharedInternals.T;
            $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
            transitions = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
            $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $3ef321f56e16f92a$var$executionContext;
            $3ef321f56e16f92a$var$executionContext |= 4;
            try {
                $3ef321f56e16f92a$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $3ef321f56e16f92a$var$executionContext = spawnedLane, $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = transitions, $3ef321f56e16f92a$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $3ef321f56e16f92a$var$pendingEffectsStatus = 1;
        $3ef321f56e16f92a$var$flushMutationEffects();
        $3ef321f56e16f92a$var$flushLayoutEffects();
        $3ef321f56e16f92a$var$flushSpawnedWork();
    }
}
function $3ef321f56e16f92a$var$flushMutationEffects() {
    if (1 === $3ef321f56e16f92a$var$pendingEffectsStatus) {
        $3ef321f56e16f92a$var$pendingEffectsStatus = 0;
        var root = $3ef321f56e16f92a$var$pendingEffectsRoot, finishedWork = $3ef321f56e16f92a$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $3ef321f56e16f92a$var$ReactSharedInternals.T;
            $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
            var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
            $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
            $3ef321f56e16f92a$var$executionContext |= 4;
            try {
                $3ef321f56e16f92a$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $3ef321f56e16f92a$var$selectionInformation, curFocusedElem = $3ef321f56e16f92a$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $3ef321f56e16f92a$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $3ef321f56e16f92a$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $3ef321f56e16f92a$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $3ef321f56e16f92a$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $3ef321f56e16f92a$var$_enabled = !!$3ef321f56e16f92a$var$eventsEnabled;
                $3ef321f56e16f92a$var$selectionInformation = $3ef321f56e16f92a$var$eventsEnabled = null;
            } finally{
                $3ef321f56e16f92a$var$executionContext = prevExecutionContext, $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $3ef321f56e16f92a$var$pendingEffectsStatus = 2;
    }
}
function $3ef321f56e16f92a$var$flushLayoutEffects() {
    if (2 === $3ef321f56e16f92a$var$pendingEffectsStatus) {
        $3ef321f56e16f92a$var$pendingEffectsStatus = 0;
        var root = $3ef321f56e16f92a$var$pendingEffectsRoot, finishedWork = $3ef321f56e16f92a$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $3ef321f56e16f92a$var$ReactSharedInternals.T;
            $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
            var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
            $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
            $3ef321f56e16f92a$var$executionContext |= 4;
            try {
                $3ef321f56e16f92a$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $3ef321f56e16f92a$var$executionContext = prevExecutionContext, $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $3ef321f56e16f92a$var$pendingEffectsStatus = 3;
    }
}
function $3ef321f56e16f92a$var$flushSpawnedWork() {
    if (4 === $3ef321f56e16f92a$var$pendingEffectsStatus || 3 === $3ef321f56e16f92a$var$pendingEffectsStatus) {
        $3ef321f56e16f92a$var$pendingEffectsStatus = 0;
        $3ef321f56e16f92a$var$requestPaint();
        var root = $3ef321f56e16f92a$var$pendingEffectsRoot, finishedWork = $3ef321f56e16f92a$var$pendingFinishedWork, lanes = $3ef321f56e16f92a$var$pendingEffectsLanes, recoverableErrors = $3ef321f56e16f92a$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $3ef321f56e16f92a$var$pendingEffectsStatus = 5 : ($3ef321f56e16f92a$var$pendingEffectsStatus = 0, $3ef321f56e16f92a$var$pendingFinishedWork = $3ef321f56e16f92a$var$pendingEffectsRoot = null, $3ef321f56e16f92a$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $3ef321f56e16f92a$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.onCommitFiberRoot) try {
            $3ef321f56e16f92a$var$injectedHook.onCommitFiberRoot($3ef321f56e16f92a$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $3ef321f56e16f92a$var$ReactSharedInternals.T;
            remainingLanes = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
            $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2;
            $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $3ef321f56e16f92a$var$ReactSharedInternals.T = finishedWork, $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($3ef321f56e16f92a$var$pendingEffectsLanes & 3) && $3ef321f56e16f92a$var$flushPendingEffects();
        $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $3ef321f56e16f92a$var$rootWithNestedUpdates ? $3ef321f56e16f92a$var$nestedUpdateCount++ : ($3ef321f56e16f92a$var$nestedUpdateCount = 0, $3ef321f56e16f92a$var$rootWithNestedUpdates = root) : $3ef321f56e16f92a$var$nestedUpdateCount = 0;
        $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $3ef321f56e16f92a$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $3ef321f56e16f92a$var$releaseCache(remainingLanes)));
}
function $3ef321f56e16f92a$var$flushPendingEffects() {
    $3ef321f56e16f92a$var$flushMutationEffects();
    $3ef321f56e16f92a$var$flushLayoutEffects();
    $3ef321f56e16f92a$var$flushSpawnedWork();
    return $3ef321f56e16f92a$var$flushPassiveEffects();
}
function $3ef321f56e16f92a$var$flushPassiveEffects() {
    if (5 !== $3ef321f56e16f92a$var$pendingEffectsStatus) return !1;
    var root = $3ef321f56e16f92a$var$pendingEffectsRoot, remainingLanes = $3ef321f56e16f92a$var$pendingEffectsRemainingLanes;
    $3ef321f56e16f92a$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $3ef321f56e16f92a$var$lanesToEventPriority($3ef321f56e16f92a$var$pendingEffectsLanes), prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T, previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
        renderPriority = $3ef321f56e16f92a$var$pendingPassiveTransitions;
        $3ef321f56e16f92a$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $3ef321f56e16f92a$var$pendingEffectsRoot, lanes = $3ef321f56e16f92a$var$pendingEffectsLanes;
        $3ef321f56e16f92a$var$pendingEffectsStatus = 0;
        $3ef321f56e16f92a$var$pendingFinishedWork = $3ef321f56e16f92a$var$pendingEffectsRoot = null;
        $3ef321f56e16f92a$var$pendingEffectsLanes = 0;
        if (0 !== ($3ef321f56e16f92a$var$executionContext & 6)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(331));
        var prevExecutionContext = $3ef321f56e16f92a$var$executionContext;
        $3ef321f56e16f92a$var$executionContext |= 4;
        $3ef321f56e16f92a$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $3ef321f56e16f92a$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $3ef321f56e16f92a$var$executionContext = prevExecutionContext;
        $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($3ef321f56e16f92a$var$injectedHook && "function" === typeof $3ef321f56e16f92a$var$injectedHook.onPostCommitFiberRoot) try {
            $3ef321f56e16f92a$var$injectedHook.onPostCommitFiberRoot($3ef321f56e16f92a$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition, $3ef321f56e16f92a$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $3ef321f56e16f92a$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $3ef321f56e16f92a$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $3ef321f56e16f92a$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $3ef321f56e16f92a$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($3ef321f56e16f92a$var$markRootUpdated$1(rootFiber, 2), $3ef321f56e16f92a$var$ensureRootIsScheduled(rootFiber));
}
function $3ef321f56e16f92a$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $3ef321f56e16f92a$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $3ef321f56e16f92a$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed || !$3ef321f56e16f92a$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $3ef321f56e16f92a$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $3ef321f56e16f92a$var$createClassErrorUpdate(2);
                instance = $3ef321f56e16f92a$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($3ef321f56e16f92a$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $3ef321f56e16f92a$var$markRootUpdated$1(instance, 2), $3ef321f56e16f92a$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $3ef321f56e16f92a$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $3ef321f56e16f92a$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($3ef321f56e16f92a$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $3ef321f56e16f92a$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $3ef321f56e16f92a$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $3ef321f56e16f92a$var$workInProgressRoot === root && ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $3ef321f56e16f92a$var$workInProgressRootExitStatus || 3 === $3ef321f56e16f92a$var$workInProgressRootExitStatus && ($3ef321f56e16f92a$var$workInProgressRootRenderLanes & 62914560) === $3ef321f56e16f92a$var$workInProgressRootRenderLanes && 300 > $3ef321f56e16f92a$var$now() - $3ef321f56e16f92a$var$globalMostRecentFallbackTime ? 0 === ($3ef321f56e16f92a$var$executionContext & 2) && $3ef321f56e16f92a$var$prepareFreshStack(root, 0) : $3ef321f56e16f92a$var$workInProgressRootPingedLanes |= pingedLanes, $3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes === $3ef321f56e16f92a$var$workInProgressRootRenderLanes && ($3ef321f56e16f92a$var$workInProgressSuspendedRetryLanes = 0));
    $3ef321f56e16f92a$var$ensureRootIsScheduled(root);
}
function $3ef321f56e16f92a$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $3ef321f56e16f92a$var$claimNextRetryLane());
    boundaryFiber = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($3ef321f56e16f92a$var$markRootUpdated$1(boundaryFiber, retryLane), $3ef321f56e16f92a$var$ensureRootIsScheduled(boundaryFiber));
}
function $3ef321f56e16f92a$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $3ef321f56e16f92a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $3ef321f56e16f92a$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $3ef321f56e16f92a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $3ef321f56e16f92a$var$scheduleCallback$1(priorityLevel, callback) {
    return $3ef321f56e16f92a$var$scheduleCallback$3(priorityLevel, callback);
}
var $3ef321f56e16f92a$var$firstScheduledRoot = null, $3ef321f56e16f92a$var$lastScheduledRoot = null, $3ef321f56e16f92a$var$didScheduleMicrotask = !1, $3ef321f56e16f92a$var$mightHavePendingSyncWork = !1, $3ef321f56e16f92a$var$isFlushingWork = !1, $3ef321f56e16f92a$var$currentEventTransitionLane = 0;
function $3ef321f56e16f92a$var$ensureRootIsScheduled(root) {
    root !== $3ef321f56e16f92a$var$lastScheduledRoot && null === root.next && (null === $3ef321f56e16f92a$var$lastScheduledRoot ? $3ef321f56e16f92a$var$firstScheduledRoot = $3ef321f56e16f92a$var$lastScheduledRoot = root : $3ef321f56e16f92a$var$lastScheduledRoot = $3ef321f56e16f92a$var$lastScheduledRoot.next = root);
    $3ef321f56e16f92a$var$mightHavePendingSyncWork = !0;
    $3ef321f56e16f92a$var$didScheduleMicrotask || ($3ef321f56e16f92a$var$didScheduleMicrotask = !0, $3ef321f56e16f92a$var$scheduleImmediateRootScheduleTask());
}
function $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$3ef321f56e16f92a$var$isFlushingWork && $3ef321f56e16f92a$var$mightHavePendingSyncWork) {
        $3ef321f56e16f92a$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $3ef321f56e16f92a$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $3ef321f56e16f92a$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $3ef321f56e16f92a$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $3ef321f56e16f92a$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $3ef321f56e16f92a$var$getNextLanes(root$170, root$170 === $3ef321f56e16f92a$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $3ef321f56e16f92a$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $3ef321f56e16f92a$var$isFlushingWork = !1;
    }
}
function $3ef321f56e16f92a$var$processRootScheduleInImmediateTask() {
    $3ef321f56e16f92a$var$processRootScheduleInMicrotask();
}
function $3ef321f56e16f92a$var$processRootScheduleInMicrotask() {
    $3ef321f56e16f92a$var$mightHavePendingSyncWork = $3ef321f56e16f92a$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $3ef321f56e16f92a$var$currentEventTransitionLane && $3ef321f56e16f92a$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $3ef321f56e16f92a$var$currentEventTransitionLane);
    for(var currentTime = $3ef321f56e16f92a$var$now(), prev = null, root = $3ef321f56e16f92a$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $3ef321f56e16f92a$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $3ef321f56e16f92a$var$firstScheduledRoot = next : prev.next = next, null === next && ($3ef321f56e16f92a$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $3ef321f56e16f92a$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $3ef321f56e16f92a$var$pendingEffectsStatus && 5 !== $3ef321f56e16f92a$var$pendingEffectsStatus || $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $3ef321f56e16f92a$var$currentEventTransitionLane && ($3ef321f56e16f92a$var$currentEventTransitionLane = 0);
}
function $3ef321f56e16f92a$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $3ef321f56e16f92a$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $3ef321f56e16f92a$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $3ef321f56e16f92a$var$workInProgressRoot;
    suspendedLanes = $3ef321f56e16f92a$var$workInProgressRootRenderLanes;
    suspendedLanes = $3ef321f56e16f92a$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $3ef321f56e16f92a$var$workInProgressSuspendedReason || 9 === $3ef321f56e16f92a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $3ef321f56e16f92a$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $3ef321f56e16f92a$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $3ef321f56e16f92a$var$cancelCallback$1(pingedLanes);
        switch($3ef321f56e16f92a$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $3ef321f56e16f92a$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $3ef321f56e16f92a$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $3ef321f56e16f92a$var$IdlePriority;
                break;
            default:
                suspendedLanes = $3ef321f56e16f92a$var$NormalPriority$1;
        }
        pingedLanes = $3ef321f56e16f92a$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $3ef321f56e16f92a$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $3ef321f56e16f92a$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $3ef321f56e16f92a$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $3ef321f56e16f92a$var$pendingEffectsStatus && 5 !== $3ef321f56e16f92a$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($3ef321f56e16f92a$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $3ef321f56e16f92a$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $3ef321f56e16f92a$var$getNextLanes(root, root === $3ef321f56e16f92a$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $3ef321f56e16f92a$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $3ef321f56e16f92a$var$scheduleTaskForRootDuringMicrotask(root, $3ef321f56e16f92a$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $3ef321f56e16f92a$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $3ef321f56e16f92a$var$performSyncWorkOnRoot(root, lanes) {
    if ($3ef321f56e16f92a$var$flushPendingEffects()) return null;
    $3ef321f56e16f92a$var$performWorkOnRoot(root, lanes, !0);
}
function $3ef321f56e16f92a$var$scheduleImmediateRootScheduleTask() {
    $3ef321f56e16f92a$var$scheduleMicrotask(function() {
        0 !== ($3ef321f56e16f92a$var$executionContext & 6) ? $3ef321f56e16f92a$var$scheduleCallback$3($3ef321f56e16f92a$var$ImmediatePriority, $3ef321f56e16f92a$var$processRootScheduleInImmediateTask) : $3ef321f56e16f92a$var$processRootScheduleInMicrotask();
    });
}
function $3ef321f56e16f92a$var$requestTransitionLane() {
    if (0 === $3ef321f56e16f92a$var$currentEventTransitionLane) {
        var actionScopeLane = $3ef321f56e16f92a$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $3ef321f56e16f92a$var$nextTransitionUpdateLane, $3ef321f56e16f92a$var$nextTransitionUpdateLane <<= 1, 0 === ($3ef321f56e16f92a$var$nextTransitionUpdateLane & 261888) && ($3ef321f56e16f92a$var$nextTransitionUpdateLane = 256));
        $3ef321f56e16f92a$var$currentEventTransitionLane = actionScopeLane;
    }
    return $3ef321f56e16f92a$var$currentEventTransitionLane;
}
function $3ef321f56e16f92a$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $3ef321f56e16f92a$var$sanitizeURL("" + actionProp);
}
function $3ef321f56e16f92a$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $3ef321f56e16f92a$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $3ef321f56e16f92a$var$coerceFormActionProp((nativeEventTarget[$3ef321f56e16f92a$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$3ef321f56e16f92a$var$internalPropsKey] || null) ? $3ef321f56e16f92a$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $3ef321f56e16f92a$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $3ef321f56e16f92a$var$currentEventTransitionLane) {
                                var formData = submitter ? $3ef321f56e16f92a$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $3ef321f56e16f92a$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $3ef321f56e16f92a$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $3ef321f56e16f92a$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $3ef321f56e16f92a$var$i$jscomp$inline_1577 = 0; $3ef321f56e16f92a$var$i$jscomp$inline_1577 < $3ef321f56e16f92a$var$simpleEventPluginEvents.length; $3ef321f56e16f92a$var$i$jscomp$inline_1577++){
    var $3ef321f56e16f92a$var$eventName$jscomp$inline_1578 = $3ef321f56e16f92a$var$simpleEventPluginEvents[$3ef321f56e16f92a$var$i$jscomp$inline_1577], $3ef321f56e16f92a$var$domEventName$jscomp$inline_1579 = $3ef321f56e16f92a$var$eventName$jscomp$inline_1578.toLowerCase(), $3ef321f56e16f92a$var$capitalizedEvent$jscomp$inline_1580 = $3ef321f56e16f92a$var$eventName$jscomp$inline_1578[0].toUpperCase() + $3ef321f56e16f92a$var$eventName$jscomp$inline_1578.slice(1);
    $3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$domEventName$jscomp$inline_1579, "on" + $3ef321f56e16f92a$var$capitalizedEvent$jscomp$inline_1580);
}
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$ANIMATION_END, "onAnimationEnd");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$ANIMATION_ITERATION, "onAnimationIteration");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$ANIMATION_START, "onAnimationStart");
$3ef321f56e16f92a$var$registerSimpleEvent("dblclick", "onDoubleClick");
$3ef321f56e16f92a$var$registerSimpleEvent("focusin", "onFocus");
$3ef321f56e16f92a$var$registerSimpleEvent("focusout", "onBlur");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_RUN, "onTransitionRun");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_START, "onTransitionStart");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_CANCEL, "onTransitionCancel");
$3ef321f56e16f92a$var$registerSimpleEvent($3ef321f56e16f92a$var$TRANSITION_END, "onTransitionEnd");
$3ef321f56e16f92a$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$3ef321f56e16f92a$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$3ef321f56e16f92a$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$3ef321f56e16f92a$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$3ef321f56e16f92a$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $3ef321f56e16f92a$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $3ef321f56e16f92a$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($3ef321f56e16f92a$var$mediaEventTypes));
function $3ef321f56e16f92a$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $3ef321f56e16f92a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $3ef321f56e16f92a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $3ef321f56e16f92a$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$3ef321f56e16f92a$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$3ef321f56e16f92a$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($3ef321f56e16f92a$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $3ef321f56e16f92a$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $3ef321f56e16f92a$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $3ef321f56e16f92a$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $3ef321f56e16f92a$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$3ef321f56e16f92a$var$listeningMarker]) {
        rootContainerElement[$3ef321f56e16f92a$var$listeningMarker] = !0;
        $3ef321f56e16f92a$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($3ef321f56e16f92a$var$nonDelegatedEvents.has(domEventName) || $3ef321f56e16f92a$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $3ef321f56e16f92a$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$3ef321f56e16f92a$var$listeningMarker] || (ownerDocument[$3ef321f56e16f92a$var$listeningMarker] = !0, $3ef321f56e16f92a$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $3ef321f56e16f92a$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($3ef321f56e16f92a$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $3ef321f56e16f92a$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $3ef321f56e16f92a$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $3ef321f56e16f92a$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$3ef321f56e16f92a$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $3ef321f56e16f92a$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $3ef321f56e16f92a$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $3ef321f56e16f92a$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $3ef321f56e16f92a$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $3ef321f56e16f92a$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticTouchEvent;
                        break;
                    case $3ef321f56e16f92a$var$ANIMATION_END:
                    case $3ef321f56e16f92a$var$ANIMATION_ITERATION:
                    case $3ef321f56e16f92a$var$ANIMATION_START:
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticAnimationEvent;
                        break;
                    case $3ef321f56e16f92a$var$TRANSITION_END:
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $3ef321f56e16f92a$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $3ef321f56e16f92a$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($3ef321f56e16f92a$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $3ef321f56e16f92a$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($3ef321f56e16f92a$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$3ef321f56e16f92a$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $3ef321f56e16f92a$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $3ef321f56e16f92a$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $3ef321f56e16f92a$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $3ef321f56e16f92a$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $3ef321f56e16f92a$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $3ef321f56e16f92a$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $3ef321f56e16f92a$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $3ef321f56e16f92a$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $3ef321f56e16f92a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $3ef321f56e16f92a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $3ef321f56e16f92a$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForChangeEvent;
                else if ($3ef321f56e16f92a$var$isTextInputElement(reactName)) {
                    if ($3ef321f56e16f92a$var$isInputEventSupported) getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $3ef321f56e16f92a$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $3ef321f56e16f92a$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForChangeEvent) : getTargetInstFunc = $3ef321f56e16f92a$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $3ef321f56e16f92a$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $3ef321f56e16f92a$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $3ef321f56e16f92a$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($3ef321f56e16f92a$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $3ef321f56e16f92a$var$activeElement = handleEventFunc, $3ef321f56e16f92a$var$activeElementInst = targetInst, $3ef321f56e16f92a$var$lastSelection = null;
                    break;
                case "focusout":
                    $3ef321f56e16f92a$var$lastSelection = $3ef321f56e16f92a$var$activeElementInst = $3ef321f56e16f92a$var$activeElement = null;
                    break;
                case "mousedown":
                    $3ef321f56e16f92a$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $3ef321f56e16f92a$var$mouseDown = !1;
                    $3ef321f56e16f92a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($3ef321f56e16f92a$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $3ef321f56e16f92a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($3ef321f56e16f92a$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $3ef321f56e16f92a$var$isComposing ? $3ef321f56e16f92a$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($3ef321f56e16f92a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($3ef321f56e16f92a$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $3ef321f56e16f92a$var$isComposing && (fallbackData = $3ef321f56e16f92a$var$getData()) : ($3ef321f56e16f92a$var$root = nativeEventTarget, $3ef321f56e16f92a$var$startText = "value" in $3ef321f56e16f92a$var$root ? $3ef321f56e16f92a$var$root.value : $3ef321f56e16f92a$var$root.textContent, $3ef321f56e16f92a$var$isComposing = !0)), handleEventFunc = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $3ef321f56e16f92a$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $3ef321f56e16f92a$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $3ef321f56e16f92a$var$canUseTextInputEvent ? $3ef321f56e16f92a$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $3ef321f56e16f92a$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $3ef321f56e16f92a$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $3ef321f56e16f92a$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $3ef321f56e16f92a$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $3ef321f56e16f92a$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $3ef321f56e16f92a$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $3ef321f56e16f92a$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($3ef321f56e16f92a$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $3ef321f56e16f92a$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($3ef321f56e16f92a$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $3ef321f56e16f92a$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $3ef321f56e16f92a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $3ef321f56e16f92a$var$getListener(target, registrationName), null != stateNode && listeners.unshift($3ef321f56e16f92a$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $3ef321f56e16f92a$var$getListener(target, registrationName), null != stateNode && listeners.push($3ef321f56e16f92a$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $3ef321f56e16f92a$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $3ef321f56e16f92a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $3ef321f56e16f92a$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($3ef321f56e16f92a$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($3ef321f56e16f92a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $3ef321f56e16f92a$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $3ef321f56e16f92a$var$normalizeMarkupForTextOrAttribute(clientText);
    return $3ef321f56e16f92a$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $3ef321f56e16f92a$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $3ef321f56e16f92a$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $3ef321f56e16f92a$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $3ef321f56e16f92a$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $3ef321f56e16f92a$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $3ef321f56e16f92a$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $3ef321f56e16f92a$var$setProp(domElement, tag, "name", props.name, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($3ef321f56e16f92a$var$setProp(domElement, tag, "encType", props.encType, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "method", props.method, props, null), $3ef321f56e16f92a$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $3ef321f56e16f92a$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $3ef321f56e16f92a$var$noop$1);
            break;
        case "onScroll":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $3ef321f56e16f92a$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", domElement);
            $3ef321f56e16f92a$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $3ef321f56e16f92a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $3ef321f56e16f92a$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $3ef321f56e16f92a$var$aliases.get(key) || key, $3ef321f56e16f92a$var$setValueForAttribute(domElement, key, value);
    }
}
function $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $3ef321f56e16f92a$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $3ef321f56e16f92a$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $3ef321f56e16f92a$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $3ef321f56e16f92a$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $3ef321f56e16f92a$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$3ef321f56e16f92a$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$3ef321f56e16f92a$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $3ef321f56e16f92a$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $3ef321f56e16f92a$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                    default:
                        $3ef321f56e16f92a$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $3ef321f56e16f92a$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $3ef321f56e16f92a$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $3ef321f56e16f92a$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $3ef321f56e16f92a$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $3ef321f56e16f92a$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $3ef321f56e16f92a$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(91));
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $3ef321f56e16f92a$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("cancel", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $3ef321f56e16f92a$var$mediaEventTypes.length; hasSrc++)$3ef321f56e16f92a$var$listenToNonDelegatedEvent($3ef321f56e16f92a$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", domElement);
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $3ef321f56e16f92a$var$listenToNonDelegatedEvent("error", domElement), $3ef321f56e16f92a$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($3ef321f56e16f92a$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $3ef321f56e16f92a$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $3ef321f56e16f92a$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $3ef321f56e16f92a$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $3ef321f56e16f92a$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $3ef321f56e16f92a$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $3ef321f56e16f92a$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $3ef321f56e16f92a$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $3ef321f56e16f92a$var$updateOptions(domElement, !!lastProps, tag, !0) : $3ef321f56e16f92a$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $3ef321f56e16f92a$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $3ef321f56e16f92a$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $3ef321f56e16f92a$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($3ef321f56e16f92a$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $3ef321f56e16f92a$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $3ef321f56e16f92a$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $3ef321f56e16f92a$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $3ef321f56e16f92a$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $3ef321f56e16f92a$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $3ef321f56e16f92a$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $3ef321f56e16f92a$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $3ef321f56e16f92a$var$eventsEnabled = null, $3ef321f56e16f92a$var$selectionInformation = null;
function $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $3ef321f56e16f92a$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $3ef321f56e16f92a$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $3ef321f56e16f92a$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $3ef321f56e16f92a$var$currentPopstateTransitionEvent = null;
function $3ef321f56e16f92a$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $3ef321f56e16f92a$var$currentPopstateTransitionEvent) return !1;
        $3ef321f56e16f92a$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $3ef321f56e16f92a$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $3ef321f56e16f92a$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $3ef321f56e16f92a$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $3ef321f56e16f92a$var$localPromise = "function" === typeof Promise ? Promise : void 0, $3ef321f56e16f92a$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $3ef321f56e16f92a$var$localPromise ? function(callback) {
    return $3ef321f56e16f92a$var$localPromise.resolve(null).then(callback).catch($3ef321f56e16f92a$var$handleErrorInNextTick);
} : $3ef321f56e16f92a$var$scheduleTimeout;
function $3ef321f56e16f92a$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $3ef321f56e16f92a$var$isSingletonScope(type) {
    return "head" === type;
}
function $3ef321f56e16f92a$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $3ef321f56e16f92a$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $3ef321f56e16f92a$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $3ef321f56e16f92a$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$3ef321f56e16f92a$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $3ef321f56e16f92a$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $3ef321f56e16f92a$var$retryIfBlockedOn(hydrationInstance);
}
function $3ef321f56e16f92a$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $3ef321f56e16f92a$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $3ef321f56e16f92a$var$clearContainerSparingly(node);
                $3ef321f56e16f92a$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $3ef321f56e16f92a$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$3ef321f56e16f92a$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $3ef321f56e16f92a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $3ef321f56e16f92a$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $3ef321f56e16f92a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $3ef321f56e16f92a$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $3ef321f56e16f92a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $3ef321f56e16f92a$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $3ef321f56e16f92a$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $3ef321f56e16f92a$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $3ef321f56e16f92a$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $3ef321f56e16f92a$var$previousHydratableOnEnteringScopedSingleton = null;
function $3ef321f56e16f92a$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $3ef321f56e16f92a$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $3ef321f56e16f92a$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $3ef321f56e16f92a$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $3ef321f56e16f92a$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(451));
    }
}
function $3ef321f56e16f92a$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $3ef321f56e16f92a$var$detachDeletedInstance(instance);
}
var $3ef321f56e16f92a$var$preloadPropsMap = new Map(), $3ef321f56e16f92a$var$preconnectsSet = new Set();
function $3ef321f56e16f92a$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $3ef321f56e16f92a$var$previousDispatcher = $3ef321f56e16f92a$var$ReactDOMSharedInternals.d;
$3ef321f56e16f92a$var$ReactDOMSharedInternals.d = {
    f: $3ef321f56e16f92a$var$flushSyncWork,
    r: $3ef321f56e16f92a$var$requestFormReset,
    D: $3ef321f56e16f92a$var$prefetchDNS,
    C: $3ef321f56e16f92a$var$preconnect,
    L: $3ef321f56e16f92a$var$preload,
    m: $3ef321f56e16f92a$var$preloadModule,
    X: $3ef321f56e16f92a$var$preinitScript,
    S: $3ef321f56e16f92a$var$preinitStyle,
    M: $3ef321f56e16f92a$var$preinitModuleScript
};
function $3ef321f56e16f92a$var$flushSyncWork() {
    var previousWasRendering = $3ef321f56e16f92a$var$previousDispatcher.f(), wasRendering = $3ef321f56e16f92a$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $3ef321f56e16f92a$var$requestFormReset(form) {
    var formInst = $3ef321f56e16f92a$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $3ef321f56e16f92a$var$requestFormReset$1(formInst) : $3ef321f56e16f92a$var$previousDispatcher.r(form);
}
var $3ef321f56e16f92a$var$globalDocument = "undefined" === typeof document ? null : document;
function $3ef321f56e16f92a$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $3ef321f56e16f92a$var$preconnectsSet.has(limitedEscapedHref) || ($3ef321f56e16f92a$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $3ef321f56e16f92a$var$setInitialProperties(href, "link", rel), $3ef321f56e16f92a$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $3ef321f56e16f92a$var$prefetchDNS(href) {
    $3ef321f56e16f92a$var$previousDispatcher.D(href);
    $3ef321f56e16f92a$var$preconnectAs("dns-prefetch", href, null);
}
function $3ef321f56e16f92a$var$preconnect(href, crossOrigin) {
    $3ef321f56e16f92a$var$previousDispatcher.C(href, crossOrigin);
    $3ef321f56e16f92a$var$preconnectAs("preconnect", href, crossOrigin);
}
function $3ef321f56e16f92a$var$preload(href, as, options) {
    $3ef321f56e16f92a$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $3ef321f56e16f92a$var$getStyleKey(href);
                break;
            case "script":
                key = $3ef321f56e16f92a$var$getScriptKey(href);
        }
        $3ef321f56e16f92a$var$preloadPropsMap.has(key) || (href = $3ef321f56e16f92a$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $3ef321f56e16f92a$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $3ef321f56e16f92a$var$setInitialProperties(as, "link", href), $3ef321f56e16f92a$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $3ef321f56e16f92a$var$preloadModule(href, options) {
    $3ef321f56e16f92a$var$previousDispatcher.m(href, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $3ef321f56e16f92a$var$getScriptKey(href);
        }
        if (!$3ef321f56e16f92a$var$preloadPropsMap.has(key) && (href = $3ef321f56e16f92a$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $3ef321f56e16f92a$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $3ef321f56e16f92a$var$setInitialProperties(as, "link", href);
            $3ef321f56e16f92a$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $3ef321f56e16f92a$var$preinitStyle(href, precedence, options) {
    $3ef321f56e16f92a$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $3ef321f56e16f92a$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $3ef321f56e16f92a$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $3ef321f56e16f92a$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $3ef321f56e16f92a$var$markNodeAsHoistable(link);
                $3ef321f56e16f92a$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $3ef321f56e16f92a$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $3ef321f56e16f92a$var$preinitScript(src, options) {
    $3ef321f56e16f92a$var$previousDispatcher.X(src, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $3ef321f56e16f92a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $3ef321f56e16f92a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key)), resource || (src = $3ef321f56e16f92a$var$assign({
            src: src,
            async: !0
        }, options), (options = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $3ef321f56e16f92a$var$markNodeAsHoistable(resource), $3ef321f56e16f92a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $3ef321f56e16f92a$var$preinitModuleScript(src, options) {
    $3ef321f56e16f92a$var$previousDispatcher.M(src, options);
    var ownerDocument = $3ef321f56e16f92a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $3ef321f56e16f92a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $3ef321f56e16f92a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(key)), resource || (src = $3ef321f56e16f92a$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $3ef321f56e16f92a$var$markNodeAsHoistable(resource), $3ef321f56e16f92a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $3ef321f56e16f92a$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $3ef321f56e16f92a$var$rootInstanceStackCursor.current) ? $3ef321f56e16f92a$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $3ef321f56e16f92a$var$getStyleKey(pendingProps.href), pendingProps = $3ef321f56e16f92a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $3ef321f56e16f92a$var$getStyleKey(pendingProps.href);
                var styles$243 = $3ef321f56e16f92a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $3ef321f56e16f92a$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $3ef321f56e16f92a$var$preloadPropsMap.set(type, pendingProps), styles$243 || $3ef321f56e16f92a$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $3ef321f56e16f92a$var$getScriptKey(pendingProps), pendingProps = $3ef321f56e16f92a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(444, type));
    }
}
function $3ef321f56e16f92a$var$getStyleKey(href) {
    return 'href="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $3ef321f56e16f92a$var$stylesheetPropsFromRawProps(rawProps) {
    return $3ef321f56e16f92a$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $3ef321f56e16f92a$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $3ef321f56e16f92a$var$setInitialProperties(key, "link", preloadProps), $3ef321f56e16f92a$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $3ef321f56e16f92a$var$getScriptKey(src) {
    return '[src="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $3ef321f56e16f92a$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $3ef321f56e16f92a$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $3ef321f56e16f92a$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $3ef321f56e16f92a$var$markNodeAsHoistable(instance), instance;
            var styleProps = $3ef321f56e16f92a$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $3ef321f56e16f92a$var$markNodeAsHoistable(instance);
            $3ef321f56e16f92a$var$setInitialProperties(instance, "style", styleProps);
            $3ef321f56e16f92a$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $3ef321f56e16f92a$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $3ef321f56e16f92a$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $3ef321f56e16f92a$var$stylesheetPropsFromRawProps(props);
            (styleProps = $3ef321f56e16f92a$var$preloadPropsMap.get(styleProps)) && $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $3ef321f56e16f92a$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $3ef321f56e16f92a$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $3ef321f56e16f92a$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $3ef321f56e16f92a$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($3ef321f56e16f92a$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $3ef321f56e16f92a$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $3ef321f56e16f92a$var$preloadPropsMap.get(instance$249)) instance = $3ef321f56e16f92a$var$assign({}, props), $3ef321f56e16f92a$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $3ef321f56e16f92a$var$markNodeAsHoistable(styleProps);
            $3ef321f56e16f92a$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $3ef321f56e16f92a$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $3ef321f56e16f92a$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $3ef321f56e16f92a$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $3ef321f56e16f92a$var$tagCaches = null;
function $3ef321f56e16f92a$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $3ef321f56e16f92a$var$tagCaches) {
        var cache = new Map();
        var caches = $3ef321f56e16f92a$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $3ef321f56e16f92a$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$3ef321f56e16f92a$var$internalHoistableMarker] || node[$3ef321f56e16f92a$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $3ef321f56e16f92a$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $3ef321f56e16f92a$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $3ef321f56e16f92a$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $3ef321f56e16f92a$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $3ef321f56e16f92a$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($3ef321f56e16f92a$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $3ef321f56e16f92a$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $3ef321f56e16f92a$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $3ef321f56e16f92a$var$stylesheetPropsFromRawProps(props);
            (key = $3ef321f56e16f92a$var$preloadPropsMap.get(key)) && $3ef321f56e16f92a$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $3ef321f56e16f92a$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $3ef321f56e16f92a$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $3ef321f56e16f92a$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $3ef321f56e16f92a$var$estimatedBytesWithinLimit = 0;
function $3ef321f56e16f92a$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $3ef321f56e16f92a$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $3ef321f56e16f92a$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $3ef321f56e16f92a$var$estimatedBytesWithinLimit && ($3ef321f56e16f92a$var$estimatedBytesWithinLimit = 62500 * $3ef321f56e16f92a$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $3ef321f56e16f92a$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $3ef321f56e16f92a$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $3ef321f56e16f92a$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $3ef321f56e16f92a$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $3ef321f56e16f92a$var$precedencesByRoot = null;
function $3ef321f56e16f92a$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $3ef321f56e16f92a$var$precedencesByRoot = new Map(), resources.forEach($3ef321f56e16f92a$var$insertStylesheetIntoRoot, state), $3ef321f56e16f92a$var$precedencesByRoot = null, $3ef321f56e16f92a$var$onUnsuspend.call(state));
}
function $3ef321f56e16f92a$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $3ef321f56e16f92a$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $3ef321f56e16f92a$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $3ef321f56e16f92a$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $3ef321f56e16f92a$var$HostTransitionContext = {
    $$typeof: $3ef321f56e16f92a$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $3ef321f56e16f92a$var$sharedNotPendingObject,
    _currentValue2: $3ef321f56e16f92a$var$sharedNotPendingObject,
    _threadCount: 0
};
function $3ef321f56e16f92a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $3ef321f56e16f92a$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $3ef321f56e16f92a$var$createLaneMap(0);
    this.hiddenUpdates = $3ef321f56e16f92a$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $3ef321f56e16f92a$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $3ef321f56e16f92a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $3ef321f56e16f92a$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $3ef321f56e16f92a$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $3ef321f56e16f92a$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $3ef321f56e16f92a$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $3ef321f56e16f92a$var$emptyContextObject;
    parentComponent = $3ef321f56e16f92a$var$emptyContextObject;
    return parentComponent;
}
function $3ef321f56e16f92a$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $3ef321f56e16f92a$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $3ef321f56e16f92a$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $3ef321f56e16f92a$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($3ef321f56e16f92a$var$scheduleUpdateOnFiber(element, rootFiber, lane), $3ef321f56e16f92a$var$entangleTransitions(element, rootFiber, lane));
}
function $3ef321f56e16f92a$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $3ef321f56e16f92a$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $3ef321f56e16f92a$var$markRetryLaneImpl(fiber, retryLane);
}
function $3ef321f56e16f92a$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $3ef321f56e16f92a$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $3ef321f56e16f92a$var$requestUpdateLane();
        lane = $3ef321f56e16f92a$var$getBumpedLaneForHydrationByLane(lane);
        var root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, lane);
        $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $3ef321f56e16f92a$var$_enabled = !0;
function $3ef321f56e16f92a$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T;
    $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 2, $3ef321f56e16f92a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $3ef321f56e16f92a$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $3ef321f56e16f92a$var$ReactSharedInternals.T;
    $3ef321f56e16f92a$var$ReactSharedInternals.T = null;
    var previousPriority = $3ef321f56e16f92a$var$ReactDOMSharedInternals.p;
    try {
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = 8, $3ef321f56e16f92a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $3ef321f56e16f92a$var$ReactDOMSharedInternals.p = previousPriority, $3ef321f56e16f92a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $3ef321f56e16f92a$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($3ef321f56e16f92a$var$_enabled) {
        var blockedOn = $3ef321f56e16f92a$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $3ef321f56e16f92a$var$return_targetInst, targetContainer), $3ef321f56e16f92a$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($3ef321f56e16f92a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($3ef321f56e16f92a$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $3ef321f56e16f92a$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $3ef321f56e16f92a$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $3ef321f56e16f92a$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $3ef321f56e16f92a$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $3ef321f56e16f92a$var$ensureRootIsScheduled(fiber);
                                0 === ($3ef321f56e16f92a$var$executionContext & 6) && ($3ef321f56e16f92a$var$workInProgressRootRenderTargetTime = $3ef321f56e16f92a$var$now() + 500, $3ef321f56e16f92a$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $3ef321f56e16f92a$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $3ef321f56e16f92a$var$scheduleUpdateOnFiber(root, fiber, 2), $3ef321f56e16f92a$var$flushSyncWork$1(), $3ef321f56e16f92a$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $3ef321f56e16f92a$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $3ef321f56e16f92a$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $3ef321f56e16f92a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $3ef321f56e16f92a$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $3ef321f56e16f92a$var$getEventTarget(nativeEvent);
    return $3ef321f56e16f92a$var$findInstanceBlockingTarget(nativeEvent);
}
var $3ef321f56e16f92a$var$return_targetInst = null;
function $3ef321f56e16f92a$var$findInstanceBlockingTarget(targetNode) {
    $3ef321f56e16f92a$var$return_targetInst = null;
    targetNode = $3ef321f56e16f92a$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $3ef321f56e16f92a$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $3ef321f56e16f92a$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $3ef321f56e16f92a$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $3ef321f56e16f92a$var$return_targetInst = targetNode;
    return null;
}
function $3ef321f56e16f92a$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($3ef321f56e16f92a$var$getCurrentPriorityLevel()){
                case $3ef321f56e16f92a$var$ImmediatePriority:
                    return 2;
                case $3ef321f56e16f92a$var$UserBlockingPriority:
                    return 8;
                case $3ef321f56e16f92a$var$NormalPriority$1:
                case $3ef321f56e16f92a$var$LowPriority:
                    return 32;
                case $3ef321f56e16f92a$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $3ef321f56e16f92a$var$hasScheduledReplayAttempt = !1, $3ef321f56e16f92a$var$queuedFocus = null, $3ef321f56e16f92a$var$queuedDrag = null, $3ef321f56e16f92a$var$queuedMouse = null, $3ef321f56e16f92a$var$queuedPointers = new Map(), $3ef321f56e16f92a$var$queuedPointerCaptures = new Map(), $3ef321f56e16f92a$var$queuedExplicitHydrationTargets = [], $3ef321f56e16f92a$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $3ef321f56e16f92a$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $3ef321f56e16f92a$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $3ef321f56e16f92a$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $3ef321f56e16f92a$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $3ef321f56e16f92a$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $3ef321f56e16f92a$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $3ef321f56e16f92a$var$getInstanceFromNode(blockedOn), null !== blockedOn && $3ef321f56e16f92a$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $3ef321f56e16f92a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $3ef321f56e16f92a$var$queuedFocus = $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $3ef321f56e16f92a$var$queuedDrag = $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $3ef321f56e16f92a$var$queuedMouse = $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $3ef321f56e16f92a$var$queuedPointers.set(pointerId, $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $3ef321f56e16f92a$var$queuedPointerCaptures.set(pointerId, $3ef321f56e16f92a$var$accumulateOrCreateContinuousQueuedReplayableEvent($3ef321f56e16f92a$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $3ef321f56e16f92a$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $3ef321f56e16f92a$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $3ef321f56e16f92a$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $3ef321f56e16f92a$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $3ef321f56e16f92a$var$runWithPriority(queuedTarget.priority, function() {
                        $3ef321f56e16f92a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $3ef321f56e16f92a$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $3ef321f56e16f92a$var$runWithPriority(queuedTarget.priority, function() {
                        $3ef321f56e16f92a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $3ef321f56e16f92a$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $3ef321f56e16f92a$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $3ef321f56e16f92a$var$currentReplayingEvent = null;
        } else return targetContainers = $3ef321f56e16f92a$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $3ef321f56e16f92a$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $3ef321f56e16f92a$var$replayUnblockedEvents() {
    $3ef321f56e16f92a$var$hasScheduledReplayAttempt = !1;
    null !== $3ef321f56e16f92a$var$queuedFocus && $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent($3ef321f56e16f92a$var$queuedFocus) && ($3ef321f56e16f92a$var$queuedFocus = null);
    null !== $3ef321f56e16f92a$var$queuedDrag && $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent($3ef321f56e16f92a$var$queuedDrag) && ($3ef321f56e16f92a$var$queuedDrag = null);
    null !== $3ef321f56e16f92a$var$queuedMouse && $3ef321f56e16f92a$var$attemptReplayContinuousQueuedEvent($3ef321f56e16f92a$var$queuedMouse) && ($3ef321f56e16f92a$var$queuedMouse = null);
    $3ef321f56e16f92a$var$queuedPointers.forEach($3ef321f56e16f92a$var$attemptReplayContinuousQueuedEventInMap);
    $3ef321f56e16f92a$var$queuedPointerCaptures.forEach($3ef321f56e16f92a$var$attemptReplayContinuousQueuedEventInMap);
}
function $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $3ef321f56e16f92a$var$hasScheduledReplayAttempt || ($3ef321f56e16f92a$var$hasScheduledReplayAttempt = !0, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, $3ef321f56e16f92a$var$replayUnblockedEvents)));
}
var $3ef321f56e16f92a$var$lastScheduledReplayQueue = null;
function $3ef321f56e16f92a$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $3ef321f56e16f92a$var$lastScheduledReplayQueue !== formReplayingQueue && ($3ef321f56e16f92a$var$lastScheduledReplayQueue = formReplayingQueue, $1c3ne.unstable_scheduleCallback($1c3ne.unstable_NormalPriority, function() {
        $3ef321f56e16f92a$var$lastScheduledReplayQueue === formReplayingQueue && ($3ef321f56e16f92a$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $3ef321f56e16f92a$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $3ef321f56e16f92a$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $3ef321f56e16f92a$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $3ef321f56e16f92a$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $3ef321f56e16f92a$var$queuedFocus && $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked($3ef321f56e16f92a$var$queuedFocus, unblocked);
    null !== $3ef321f56e16f92a$var$queuedDrag && $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked($3ef321f56e16f92a$var$queuedDrag, unblocked);
    null !== $3ef321f56e16f92a$var$queuedMouse && $3ef321f56e16f92a$var$scheduleCallbackIfUnblocked($3ef321f56e16f92a$var$queuedMouse, unblocked);
    $3ef321f56e16f92a$var$queuedPointers.forEach(unblock);
    $3ef321f56e16f92a$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $3ef321f56e16f92a$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.length && (i = $3ef321f56e16f92a$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$3ef321f56e16f92a$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$3ef321f56e16f92a$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $3ef321f56e16f92a$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$3ef321f56e16f92a$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $3ef321f56e16f92a$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $3ef321f56e16f92a$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $3ef321f56e16f92a$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $3ef321f56e16f92a$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$3ef321f56e16f92a$var$ReactDOMHydrationRoot.prototype.render = $3ef321f56e16f92a$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(409));
    var current = root.current, lane = $3ef321f56e16f92a$var$requestUpdateLane();
    $3ef321f56e16f92a$var$updateContainerImpl(current, lane, children, root, null, null);
};
$3ef321f56e16f92a$var$ReactDOMHydrationRoot.prototype.unmount = $3ef321f56e16f92a$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $3ef321f56e16f92a$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $3ef321f56e16f92a$var$flushSyncWork$1();
        container[$3ef321f56e16f92a$var$internalContainerInstanceKey] = null;
    }
};
function $3ef321f56e16f92a$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$3ef321f56e16f92a$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $3ef321f56e16f92a$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $3ef321f56e16f92a$var$queuedExplicitHydrationTargets[i].priority; i++);
        $3ef321f56e16f92a$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $3ef321f56e16f92a$var$attemptExplicitHydrationTarget(target);
    }
};
var $3ef321f56e16f92a$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $4Iuzv.version;
if ("19.2.4" !== $3ef321f56e16f92a$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(527, $3ef321f56e16f92a$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$3ef321f56e16f92a$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $3ef321f56e16f92a$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $3ef321f56e16f92a$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $3ef321f56e16f92a$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $3ef321f56e16f92a$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $3ef321f56e16f92a$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$3ef321f56e16f92a$var$hook$jscomp$inline_2348.isDisabled && $3ef321f56e16f92a$var$hook$jscomp$inline_2348.supportsFiber) try {
        $3ef321f56e16f92a$var$rendererID = $3ef321f56e16f92a$var$hook$jscomp$inline_2348.inject($3ef321f56e16f92a$var$internals$jscomp$inline_2347), $3ef321f56e16f92a$var$injectedHook = $3ef321f56e16f92a$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$3ef321f56e16f92a$export$882461b6382ed46c = function(container, options) {
    if (!$3ef321f56e16f92a$var$isValidContainer(container)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $3ef321f56e16f92a$var$defaultOnUncaughtError, onCaughtError = $3ef321f56e16f92a$var$defaultOnCaughtError, onRecoverableError = $3ef321f56e16f92a$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $3ef321f56e16f92a$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $3ef321f56e16f92a$var$defaultOnDefaultTransitionIndicator);
    container[$3ef321f56e16f92a$var$internalContainerInstanceKey] = options.current;
    $3ef321f56e16f92a$var$listenToAllSupportedEvents(container);
    return new $3ef321f56e16f92a$var$ReactDOMRoot(options);
};
$3ef321f56e16f92a$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$3ef321f56e16f92a$var$isValidContainer(container)) throw Error($3ef321f56e16f92a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $3ef321f56e16f92a$var$defaultOnUncaughtError, onCaughtError = $3ef321f56e16f92a$var$defaultOnCaughtError, onRecoverableError = $3ef321f56e16f92a$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $3ef321f56e16f92a$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $3ef321f56e16f92a$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $3ef321f56e16f92a$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $3ef321f56e16f92a$var$requestUpdateLane();
    isStrictMode = $3ef321f56e16f92a$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $3ef321f56e16f92a$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $3ef321f56e16f92a$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $3ef321f56e16f92a$var$markRootUpdated$1(initialChildren, options);
    $3ef321f56e16f92a$var$ensureRootIsScheduled(initialChildren);
    container[$3ef321f56e16f92a$var$internalContainerInstanceKey] = initialChildren.current;
    $3ef321f56e16f92a$var$listenToAllSupportedEvents(container);
    return new $3ef321f56e16f92a$var$ReactDOMHydrationRoot(initialChildren);
};
$3ef321f56e16f92a$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("1c3ne", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fHP5D"));

});
parcelRegister("fHP5D", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $b6f28089b6d6561b$export$c4744153514ff05d; }, function (v) { return $b6f28089b6d6561b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $b6f28089b6d6561b$export$3e506c1ccc9cc1a7; }, function (v) { return $b6f28089b6d6561b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $b6f28089b6d6561b$export$e26fe2ed2fa76875; }, function (v) { return $b6f28089b6d6561b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $b6f28089b6d6561b$export$502329bbf4b505b1; }, function (v) { return $b6f28089b6d6561b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $b6f28089b6d6561b$export$6e3807111c4874c4; }, function (v) { return $b6f28089b6d6561b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $b6f28089b6d6561b$export$c27134553091fb3a; }, function (v) { return $b6f28089b6d6561b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $b6f28089b6d6561b$export$33ee1acdc04fd2a2; }, function (v) { return $b6f28089b6d6561b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $b6f28089b6d6561b$export$b00a404bbd5edef2; }, function (v) { return $b6f28089b6d6561b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $b6f28089b6d6561b$export$d66a1c1c77bd778b; }, function (v) { return $b6f28089b6d6561b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $b6f28089b6d6561b$export$d3dfb8e4810cb555; }, function (v) { return $b6f28089b6d6561b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $b6f28089b6d6561b$export$72fdf0e06517287b; }, function (v) { return $b6f28089b6d6561b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $b6f28089b6d6561b$export$816d2913ae6b83b1; }, function (v) { return $b6f28089b6d6561b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $b6f28089b6d6561b$export$61bcfe829111a1d0; }, function (v) { return $b6f28089b6d6561b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $b6f28089b6d6561b$export$7ee8c9beb337bc3f; }, function (v) { return $b6f28089b6d6561b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $b6f28089b6d6561b$export$b5836b71941fa3ed; }, function (v) { return $b6f28089b6d6561b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $b6f28089b6d6561b$export$cf845f2c119da08a; }, function (v) { return $b6f28089b6d6561b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b6f28089b6d6561b$export$c4744153514ff05d;
var $b6f28089b6d6561b$export$3e506c1ccc9cc1a7;
var $b6f28089b6d6561b$export$e26fe2ed2fa76875;
var $b6f28089b6d6561b$export$502329bbf4b505b1;
var $b6f28089b6d6561b$export$6e3807111c4874c4;
var $b6f28089b6d6561b$export$c27134553091fb3a;
var $b6f28089b6d6561b$export$33ee1acdc04fd2a2;
var $b6f28089b6d6561b$export$b00a404bbd5edef2;
var $b6f28089b6d6561b$export$d66a1c1c77bd778b;
var $b6f28089b6d6561b$export$d3dfb8e4810cb555;
var $b6f28089b6d6561b$export$72fdf0e06517287b;
var $b6f28089b6d6561b$export$816d2913ae6b83b1;
var $b6f28089b6d6561b$export$61bcfe829111a1d0;
var $b6f28089b6d6561b$export$7ee8c9beb337bc3f;
var $b6f28089b6d6561b$export$b5836b71941fa3ed;
var $b6f28089b6d6561b$export$cf845f2c119da08a;
"use strict";
function $b6f28089b6d6561b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $b6f28089b6d6561b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $b6f28089b6d6561b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $b6f28089b6d6561b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $b6f28089b6d6561b$var$compare(left, last)) rightIndex < length && 0 > $b6f28089b6d6561b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $b6f28089b6d6561b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $b6f28089b6d6561b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$b6f28089b6d6561b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b6f28089b6d6561b$var$localPerformance = performance;
    $b6f28089b6d6561b$export$c4744153514ff05d = function() {
        return $b6f28089b6d6561b$var$localPerformance.now();
    };
} else {
    var $b6f28089b6d6561b$var$localDate = Date, $b6f28089b6d6561b$var$initialTime = $b6f28089b6d6561b$var$localDate.now();
    $b6f28089b6d6561b$export$c4744153514ff05d = function() {
        return $b6f28089b6d6561b$var$localDate.now() - $b6f28089b6d6561b$var$initialTime;
    };
}
var $b6f28089b6d6561b$var$taskQueue = [], $b6f28089b6d6561b$var$timerQueue = [], $b6f28089b6d6561b$var$taskIdCounter = 1, $b6f28089b6d6561b$var$currentTask = null, $b6f28089b6d6561b$var$currentPriorityLevel = 3, $b6f28089b6d6561b$var$isPerformingWork = !1, $b6f28089b6d6561b$var$isHostCallbackScheduled = !1, $b6f28089b6d6561b$var$isHostTimeoutScheduled = !1, $b6f28089b6d6561b$var$needsPaint = !1, $b6f28089b6d6561b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $b6f28089b6d6561b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $b6f28089b6d6561b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $b6f28089b6d6561b$var$advanceTimers(currentTime) {
    for(var timer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$timerQueue);
        else if (timer.startTime <= currentTime) $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$timerQueue), timer.sortIndex = timer.expirationTime, $b6f28089b6d6561b$var$push($b6f28089b6d6561b$var$taskQueue, timer);
        else break;
        timer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue);
    }
}
function $b6f28089b6d6561b$var$handleTimeout(currentTime) {
    $b6f28089b6d6561b$var$isHostTimeoutScheduled = !1;
    $b6f28089b6d6561b$var$advanceTimers(currentTime);
    if (!$b6f28089b6d6561b$var$isHostCallbackScheduled) {
        if (null !== $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue)) $b6f28089b6d6561b$var$isHostCallbackScheduled = !0, $b6f28089b6d6561b$var$isMessageLoopRunning || ($b6f28089b6d6561b$var$isMessageLoopRunning = !0, $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue);
            null !== firstTimer && $b6f28089b6d6561b$var$requestHostTimeout($b6f28089b6d6561b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $b6f28089b6d6561b$var$isMessageLoopRunning = !1, $b6f28089b6d6561b$var$taskTimeoutID = -1, $b6f28089b6d6561b$var$frameInterval = 5, $b6f28089b6d6561b$var$startTime = -1;
function $b6f28089b6d6561b$var$shouldYieldToHost() {
    return $b6f28089b6d6561b$var$needsPaint ? !0 : $b6f28089b6d6561b$export$c4744153514ff05d() - $b6f28089b6d6561b$var$startTime < $b6f28089b6d6561b$var$frameInterval ? !1 : !0;
}
function $b6f28089b6d6561b$var$performWorkUntilDeadline() {
    $b6f28089b6d6561b$var$needsPaint = !1;
    if ($b6f28089b6d6561b$var$isMessageLoopRunning) {
        var currentTime = $b6f28089b6d6561b$export$c4744153514ff05d();
        $b6f28089b6d6561b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $b6f28089b6d6561b$var$isHostCallbackScheduled = !1;
                $b6f28089b6d6561b$var$isHostTimeoutScheduled && ($b6f28089b6d6561b$var$isHostTimeoutScheduled = !1, $b6f28089b6d6561b$var$localClearTimeout($b6f28089b6d6561b$var$taskTimeoutID), $b6f28089b6d6561b$var$taskTimeoutID = -1);
                $b6f28089b6d6561b$var$isPerformingWork = !0;
                var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
                try {
                    b: {
                        $b6f28089b6d6561b$var$advanceTimers(currentTime);
                        for($b6f28089b6d6561b$var$currentTask = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue); null !== $b6f28089b6d6561b$var$currentTask && !($b6f28089b6d6561b$var$currentTask.expirationTime > currentTime && $b6f28089b6d6561b$var$shouldYieldToHost());){
                            var callback = $b6f28089b6d6561b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $b6f28089b6d6561b$var$currentTask.callback = null;
                                $b6f28089b6d6561b$var$currentPriorityLevel = $b6f28089b6d6561b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($b6f28089b6d6561b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $b6f28089b6d6561b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $b6f28089b6d6561b$var$currentTask.callback = continuationCallback;
                                    $b6f28089b6d6561b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $b6f28089b6d6561b$var$currentTask === $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue) && $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$taskQueue);
                                $b6f28089b6d6561b$var$advanceTimers(currentTime);
                            } else $b6f28089b6d6561b$var$pop($b6f28089b6d6561b$var$taskQueue);
                            $b6f28089b6d6561b$var$currentTask = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue);
                        }
                        if (null !== $b6f28089b6d6561b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue);
                            null !== firstTimer && $b6f28089b6d6561b$var$requestHostTimeout($b6f28089b6d6561b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $b6f28089b6d6561b$var$currentTask = null, $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel, $b6f28089b6d6561b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline() : $b6f28089b6d6561b$var$isMessageLoopRunning = !1;
        }
    }
}
var $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $b6f28089b6d6561b$var$localSetImmediate) $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline = function() {
    $b6f28089b6d6561b$var$localSetImmediate($b6f28089b6d6561b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b6f28089b6d6561b$var$channel = new MessageChannel(), $b6f28089b6d6561b$var$port = $b6f28089b6d6561b$var$channel.port2;
    $b6f28089b6d6561b$var$channel.port1.onmessage = $b6f28089b6d6561b$var$performWorkUntilDeadline;
    $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline = function() {
        $b6f28089b6d6561b$var$port.postMessage(null);
    };
} else $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline = function() {
    $b6f28089b6d6561b$var$localSetTimeout($b6f28089b6d6561b$var$performWorkUntilDeadline, 0);
};
function $b6f28089b6d6561b$var$requestHostTimeout(callback, ms) {
    $b6f28089b6d6561b$var$taskTimeoutID = $b6f28089b6d6561b$var$localSetTimeout(function() {
        callback($b6f28089b6d6561b$export$c4744153514ff05d());
    }, ms);
}
$b6f28089b6d6561b$export$3e506c1ccc9cc1a7 = 5;
$b6f28089b6d6561b$export$e26fe2ed2fa76875 = 1;
$b6f28089b6d6561b$export$502329bbf4b505b1 = 4;
$b6f28089b6d6561b$export$6e3807111c4874c4 = 3;
$b6f28089b6d6561b$export$c27134553091fb3a = null;
$b6f28089b6d6561b$export$33ee1acdc04fd2a2 = 2;
$b6f28089b6d6561b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$b6f28089b6d6561b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b6f28089b6d6561b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$b6f28089b6d6561b$export$d3dfb8e4810cb555 = function() {
    return $b6f28089b6d6561b$var$currentPriorityLevel;
};
$b6f28089b6d6561b$export$72fdf0e06517287b = function(eventHandler) {
    switch($b6f28089b6d6561b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    $b6f28089b6d6561b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b6f28089b6d6561b$export$816d2913ae6b83b1 = function() {
    $b6f28089b6d6561b$var$needsPaint = !0;
};
$b6f28089b6d6561b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    $b6f28089b6d6561b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$b6f28089b6d6561b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $b6f28089b6d6561b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $b6f28089b6d6561b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $b6f28089b6d6561b$var$push($b6f28089b6d6561b$var$timerQueue, priorityLevel), null === $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$taskQueue) && priorityLevel === $b6f28089b6d6561b$var$peek($b6f28089b6d6561b$var$timerQueue) && ($b6f28089b6d6561b$var$isHostTimeoutScheduled ? ($b6f28089b6d6561b$var$localClearTimeout($b6f28089b6d6561b$var$taskTimeoutID), $b6f28089b6d6561b$var$taskTimeoutID = -1) : $b6f28089b6d6561b$var$isHostTimeoutScheduled = !0, $b6f28089b6d6561b$var$requestHostTimeout($b6f28089b6d6561b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $b6f28089b6d6561b$var$push($b6f28089b6d6561b$var$taskQueue, priorityLevel), $b6f28089b6d6561b$var$isHostCallbackScheduled || $b6f28089b6d6561b$var$isPerformingWork || ($b6f28089b6d6561b$var$isHostCallbackScheduled = !0, $b6f28089b6d6561b$var$isMessageLoopRunning || ($b6f28089b6d6561b$var$isMessageLoopRunning = !0, $b6f28089b6d6561b$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$b6f28089b6d6561b$export$b5836b71941fa3ed = $b6f28089b6d6561b$var$shouldYieldToHost;
$b6f28089b6d6561b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $b6f28089b6d6561b$var$currentPriorityLevel;
        $b6f28089b6d6561b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $b6f28089b6d6561b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("4Iuzv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("GDJFN"));

});

parcelRegister("hSThT", function(module, exports) {
'use strict';
function $d0525dc7624af49b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d0525dc7624af49b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d0525dc7624af49b$var$checkDCE();

module.exports = (parcelRequire("1ZiSy"));

});
parcelRegister("1ZiSy", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $172a21ee876390cc$export$69ce8ef3fe5cead0; }, function (v) { return $172a21ee876390cc$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $172a21ee876390cc$export$d39a5bbd09211389; }, function (v) { return $172a21ee876390cc$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $172a21ee876390cc$export$cd75ccfd720a3cd4; }, function (v) { return $172a21ee876390cc$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $172a21ee876390cc$export$a0816fa17a9e79be; }, function (v) { return $172a21ee876390cc$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $172a21ee876390cc$export$7292efcadded39f3; }, function (v) { return $172a21ee876390cc$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $172a21ee876390cc$export$da407abadb9b8f86; }, function (v) { return $172a21ee876390cc$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $172a21ee876390cc$export$314cfea32580671c; }, function (v) { return $172a21ee876390cc$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $172a21ee876390cc$export$513ccb98c53b8039; }, function (v) { return $172a21ee876390cc$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $172a21ee876390cc$export$dbca993bc2d264a; }, function (v) { return $172a21ee876390cc$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $172a21ee876390cc$export$4797a8006f0655d0; }, function (v) { return $172a21ee876390cc$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $172a21ee876390cc$export$c78a37762a8d58e1; }, function (v) { return $172a21ee876390cc$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $172a21ee876390cc$export$606f11b2eb45ecc6; }, function (v) { return $172a21ee876390cc$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $172a21ee876390cc$export$f7e8a0bf92324b1e; }, function (v) { return $172a21ee876390cc$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $172a21ee876390cc$export$83d89fbfd8236492; }, function (v) { return $172a21ee876390cc$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $172a21ee876390cc$export$69ce8ef3fe5cead0;
var $172a21ee876390cc$export$d39a5bbd09211389;
var $172a21ee876390cc$export$cd75ccfd720a3cd4;
var $172a21ee876390cc$export$a0816fa17a9e79be;
var $172a21ee876390cc$export$7292efcadded39f3;
var $172a21ee876390cc$export$da407abadb9b8f86;
var $172a21ee876390cc$export$314cfea32580671c;
var $172a21ee876390cc$export$513ccb98c53b8039;
var $172a21ee876390cc$export$dbca993bc2d264a;
var $172a21ee876390cc$export$4797a8006f0655d0;
var $172a21ee876390cc$export$c78a37762a8d58e1;
var $172a21ee876390cc$export$606f11b2eb45ecc6;
var $172a21ee876390cc$export$f7e8a0bf92324b1e;
var $172a21ee876390cc$export$83d89fbfd8236492;
"use strict";

var $4Iuzv = parcelRequire("4Iuzv");
function $172a21ee876390cc$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $172a21ee876390cc$var$noop() {}
var $172a21ee876390cc$var$Internals = {
    d: {
        f: $172a21ee876390cc$var$noop,
        r: function() {
            throw Error($172a21ee876390cc$var$formatProdErrorMessage(522));
        },
        D: $172a21ee876390cc$var$noop,
        C: $172a21ee876390cc$var$noop,
        L: $172a21ee876390cc$var$noop,
        m: $172a21ee876390cc$var$noop,
        X: $172a21ee876390cc$var$noop,
        S: $172a21ee876390cc$var$noop,
        M: $172a21ee876390cc$var$noop
    },
    p: 0,
    findDOMNode: null
}, $172a21ee876390cc$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $172a21ee876390cc$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $172a21ee876390cc$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $172a21ee876390cc$var$ReactSharedInternals = $4Iuzv.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $172a21ee876390cc$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$172a21ee876390cc$export$69ce8ef3fe5cead0 = $172a21ee876390cc$var$Internals;
$172a21ee876390cc$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($172a21ee876390cc$var$formatProdErrorMessage(299));
    return $172a21ee876390cc$var$createPortal$1(children, container, null, key);
};
$172a21ee876390cc$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $172a21ee876390cc$var$ReactSharedInternals.T, previousUpdatePriority = $172a21ee876390cc$var$Internals.p;
    try {
        if ($172a21ee876390cc$var$ReactSharedInternals.T = null, $172a21ee876390cc$var$Internals.p = 2, fn) return fn();
    } finally{
        $172a21ee876390cc$var$ReactSharedInternals.T = previousTransition, $172a21ee876390cc$var$Internals.p = previousUpdatePriority, $172a21ee876390cc$var$Internals.d.f();
    }
};
$172a21ee876390cc$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $172a21ee876390cc$var$Internals.d.C(href, options));
};
$172a21ee876390cc$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $172a21ee876390cc$var$Internals.d.D(href);
};
$172a21ee876390cc$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $172a21ee876390cc$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $172a21ee876390cc$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$172a21ee876390cc$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $172a21ee876390cc$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $172a21ee876390cc$var$Internals.d.M(href);
    }
};
$172a21ee876390cc$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(as, options.crossOrigin);
        $172a21ee876390cc$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$172a21ee876390cc$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $172a21ee876390cc$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $172a21ee876390cc$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $172a21ee876390cc$var$Internals.d.m(href);
    }
};
$172a21ee876390cc$export$4797a8006f0655d0 = function(form) {
    $172a21ee876390cc$var$Internals.d.r(form);
};
$172a21ee876390cc$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$172a21ee876390cc$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $172a21ee876390cc$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$172a21ee876390cc$export$f7e8a0bf92324b1e = function() {
    return $172a21ee876390cc$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$172a21ee876390cc$export$83d89fbfd8236492 = "19.2.4";

});



var $3c47adbabe8a32cb$exports = {};
'use strict';

$3c47adbabe8a32cb$exports = (parcelRequire("kNOdC"));



var $4Iuzv = parcelRequire("4Iuzv");
var $21fa618cfc67d6ae$exports = {};
'use strict';
function $21fa618cfc67d6ae$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($21fa618cfc67d6ae$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$21fa618cfc67d6ae$var$checkDCE();

$21fa618cfc67d6ae$exports = (parcelRequire("5p4Xp"));


/**
 * react-router v7.8.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Iuzv = parcelRequire("4Iuzv");
var $b11369f2b382bb4b$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-PVWAREVJ.mjs"
});
var $b11369f2b382bb4b$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $b11369f2b382bb4b$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $b11369f2b382bb4b$var$__typeError("Cannot " + msg);
var $b11369f2b382bb4b$var$__privateGet = (obj, member, getter)=>($b11369f2b382bb4b$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $b11369f2b382bb4b$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $b11369f2b382bb4b$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $b11369f2b382bb4b$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($b11369f2b382bb4b$export$e19cd5f9376f8cee || {});
var $b11369f2b382bb4b$var$PopStateEventType = "popstate";
function $b11369f2b382bb4b$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $b11369f2b382bb4b$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b11369f2b382bb4b$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $b11369f2b382bb4b$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b11369f2b382bb4b$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $b11369f2b382bb4b$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $b11369f2b382bb4b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $b11369f2b382bb4b$export$fe53371bee54353d(to);
    }
    return $b11369f2b382bb4b$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $b11369f2b382bb4b$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b11369f2b382bb4b$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b11369f2b382bb4b$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b11369f2b382bb4b$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b11369f2b382bb4b$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $b11369f2b382bb4b$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b11369f2b382bb4b$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b11369f2b382bb4b$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $b11369f2b382bb4b$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $b11369f2b382bb4b$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $b11369f2b382bb4b$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $b11369f2b382bb4b$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b11369f2b382bb4b$var$createKey()
    };
    return location;
}
function $b11369f2b382bb4b$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $b11369f2b382bb4b$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b11369f2b382bb4b$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $b11369f2b382bb4b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b11369f2b382bb4b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $b11369f2b382bb4b$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b11369f2b382bb4b$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $b11369f2b382bb4b$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($b11369f2b382bb4b$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($b11369f2b382bb4b$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $b11369f2b382bb4b$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $b11369f2b382bb4b$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $b11369f2b382bb4b$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $b11369f2b382bb4b$export$f4fcb186418daff5(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $b11369f2b382bb4b$var$_map;
var $b11369f2b382bb4b$export$b754276817659c2d = class {
    /**
   * Create a new `unstable_RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $b11369f2b382bb4b$var$__privateAdd(this, $b11369f2b382bb4b$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($b11369f2b382bb4b$var$__privateGet(this, $b11369f2b382bb4b$var$_map).has(context)) return $b11369f2b382bb4b$var$__privateGet(this, $b11369f2b382bb4b$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $b11369f2b382bb4b$var$__privateGet(this, $b11369f2b382bb4b$var$_map).set(context, value);
    }
};
$b11369f2b382bb4b$var$_map = new WeakMap();
var $b11369f2b382bb4b$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b11369f2b382bb4b$var$isUnsupportedLazyRouteObjectKey(key) {
    return $b11369f2b382bb4b$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $b11369f2b382bb4b$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "unstable_middleware",
    "children"
]);
function $b11369f2b382bb4b$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $b11369f2b382bb4b$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $b11369f2b382bb4b$var$isIndexRoute(route) {
    return route.index === true;
}
function $b11369f2b382bb4b$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b11369f2b382bb4b$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $b11369f2b382bb4b$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($b11369f2b382bb4b$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id
            };
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                ...mapRouteProperties2(route),
                id: id,
                children: void 0
            };
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b11369f2b382bb4b$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $b11369f2b382bb4b$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $b11369f2b382bb4b$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $b11369f2b382bb4b$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $b11369f2b382bb4b$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b11369f2b382bb4b$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b11369f2b382bb4b$var$flattenRoutes(routes);
    $b11369f2b382bb4b$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $b11369f2b382bb4b$var$decodePath(pathname);
        matches = $b11369f2b382bb4b$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $b11369f2b382bb4b$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $b11369f2b382bb4b$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $b11369f2b382bb4b$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b11369f2b382bb4b$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $b11369f2b382bb4b$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $b11369f2b382bb4b$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b11369f2b382bb4b$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $b11369f2b382bb4b$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $b11369f2b382bb4b$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b11369f2b382bb4b$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b11369f2b382bb4b$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $b11369f2b382bb4b$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $b11369f2b382bb4b$var$paramRe = /^:[\w-]+$/;
var $b11369f2b382bb4b$var$dynamicSegmentValue = 3;
var $b11369f2b382bb4b$var$indexRouteValue = 2;
var $b11369f2b382bb4b$var$emptySegmentValue = 1;
var $b11369f2b382bb4b$var$staticSegmentValue = 10;
var $b11369f2b382bb4b$var$splatPenalty = -2;
var $b11369f2b382bb4b$var$isSplat = (s)=>s === "*";
function $b11369f2b382bb4b$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b11369f2b382bb4b$var$isSplat)) initialScore += $b11369f2b382bb4b$var$splatPenalty;
    if (index) initialScore += $b11369f2b382bb4b$var$indexRouteValue;
    return segments.filter((s)=>!$b11369f2b382bb4b$var$isSplat(s)).reduce((score, segment)=>score + ($b11369f2b382bb4b$var$paramRe.test(segment) ? $b11369f2b382bb4b$var$dynamicSegmentValue : segment === "" ? $b11369f2b382bb4b$var$emptySegmentValue : $b11369f2b382bb4b$var$staticSegmentValue), initialScore);
}
function $b11369f2b382bb4b$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b11369f2b382bb4b$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b11369f2b382bb4b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $b11369f2b382bb4b$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b11369f2b382bb4b$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b11369f2b382bb4b$var$normalizePathname($b11369f2b382bb4b$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b11369f2b382bb4b$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $b11369f2b382bb4b$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b11369f2b382bb4b$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b11369f2b382bb4b$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $b11369f2b382bb4b$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b11369f2b382bb4b$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b11369f2b382bb4b$var$compilePath(path, caseSensitive = false, end = true) {
    $b11369f2b382bb4b$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $b11369f2b382bb4b$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b11369f2b382bb4b$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $b11369f2b382bb4b$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $b11369f2b382bb4b$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $b11369f2b382bb4b$var$joinPaths([
        basename,
        pathname
    ]);
}
function $b11369f2b382bb4b$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b11369f2b382bb4b$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b11369f2b382bb4b$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b11369f2b382bb4b$var$normalizeSearch(search),
        hash: $b11369f2b382bb4b$var$normalizeHash(hash)
    };
}
function $b11369f2b382bb4b$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b11369f2b382bb4b$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $b11369f2b382bb4b$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $b11369f2b382bb4b$var$getResolveToMatches(matches) {
    let pathMatches = $b11369f2b382bb4b$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $b11369f2b382bb4b$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $b11369f2b382bb4b$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $b11369f2b382bb4b$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $b11369f2b382bb4b$var$getInvalidPathError("?", "pathname", "search", to));
        $b11369f2b382bb4b$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $b11369f2b382bb4b$var$getInvalidPathError("#", "pathname", "hash", to));
        $b11369f2b382bb4b$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $b11369f2b382bb4b$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b11369f2b382bb4b$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $b11369f2b382bb4b$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $b11369f2b382bb4b$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $b11369f2b382bb4b$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $b11369f2b382bb4b$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $b11369f2b382bb4b$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $b11369f2b382bb4b$export$4051a07651545597(data2, init) {
    return new $b11369f2b382bb4b$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $b11369f2b382bb4b$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $b11369f2b382bb4b$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b11369f2b382bb4b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $b11369f2b382bb4b$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $b11369f2b382bb4b$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $b11369f2b382bb4b$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $b11369f2b382bb4b$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
// lib/router/router.ts
var $b11369f2b382bb4b$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $b11369f2b382bb4b$var$validMutationMethods = new Set($b11369f2b382bb4b$var$validMutationMethodsArr);
var $b11369f2b382bb4b$var$validRequestMethodsArr = [
    "GET",
    ...$b11369f2b382bb4b$var$validMutationMethodsArr
];
var $b11369f2b382bb4b$var$validRequestMethods = new Set($b11369f2b382bb4b$var$validRequestMethodsArr);
var $b11369f2b382bb4b$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $b11369f2b382bb4b$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $b11369f2b382bb4b$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $b11369f2b382bb4b$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $b11369f2b382bb4b$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $b11369f2b382bb4b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $b11369f2b382bb4b$var$isAbsoluteUrl = (url)=>$b11369f2b382bb4b$var$ABSOLUTE_URL_REGEX.test(url);
var $b11369f2b382bb4b$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $b11369f2b382bb4b$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $b11369f2b382bb4b$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $b11369f2b382bb4b$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $b11369f2b382bb4b$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let mapRouteProperties2 = init.mapRouteProperties || $b11369f2b382bb4b$var$defaultMapRouteProperties;
    let manifest = {};
    let dataRoutes = $b11369f2b382bb4b$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $b11369f2b382bb4b$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b11369f2b382bb4b$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $b11369f2b382bb4b$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b11369f2b382bb4b$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>m.route.loader)) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$b11369f2b382bb4b$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$b11369f2b382bb4b$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b11369f2b382bb4b$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $b11369f2b382bb4b$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b11369f2b382bb4b$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $b11369f2b382bb4b$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b11369f2b382bb4b$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b11369f2b382bb4b$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $b11369f2b382bb4b$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b11369f2b382bb4b$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b11369f2b382bb4b$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b11369f2b382bb4b$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b11369f2b382bb4b$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $b11369f2b382bb4b$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b11369f2b382bb4b$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $b11369f2b382bb4b$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b11369f2b382bb4b$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $b11369f2b382bb4b$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $b11369f2b382bb4b$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $b11369f2b382bb4b$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b11369f2b382bb4b$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $b11369f2b382bb4b$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.unstable_getContext ? await init.unstable_getContext() : new $b11369f2b382bb4b$export$b754276817659c2d();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $b11369f2b382bb4b$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $b11369f2b382bb4b$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($b11369f2b382bb4b$var$isErrorResult(result) && $b11369f2b382bb4b$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $b11369f2b382bb4b$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $b11369f2b382bb4b$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$b11369f2b382bb4b$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $b11369f2b382bb4b$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $b11369f2b382bb4b$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $b11369f2b382bb4b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $b11369f2b382bb4b$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $b11369f2b382bb4b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b11369f2b382bb4b$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $b11369f2b382bb4b$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($b11369f2b382bb4b$var$isErrorResult(result)) {
            let boundaryMatch = $b11369f2b382bb4b$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $b11369f2b382bb4b$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $b11369f2b382bb4b$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $b11369f2b382bb4b$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $b11369f2b382bb4b$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $b11369f2b382bb4b$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.unstable_middleware) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$b11369f2b382bb4b$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $b11369f2b382bb4b$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $b11369f2b382bb4b$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $b11369f2b382bb4b$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $b11369f2b382bb4b$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b11369f2b382bb4b$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $b11369f2b382bb4b$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $b11369f2b382bb4b$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b11369f2b382bb4b$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.unstable_getContext ? await init.unstable_getContext() : new $b11369f2b382bb4b$export$b754276817659c2d();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b11369f2b382bb4b$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b11369f2b382bb4b$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b11369f2b382bb4b$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b11369f2b382bb4b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $b11369f2b382bb4b$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $b11369f2b382bb4b$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($b11369f2b382bb4b$var$isRedirectResult(actionResult) || $b11369f2b382bb4b$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b11369f2b382bb4b$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($b11369f2b382bb4b$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $b11369f2b382bb4b$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b11369f2b382bb4b$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($b11369f2b382bb4b$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b11369f2b382bb4b$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b11369f2b382bb4b$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b11369f2b382bb4b$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b11369f2b382bb4b$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $b11369f2b382bb4b$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b11369f2b382bb4b$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $b11369f2b382bb4b$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $b11369f2b382bb4b$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $b11369f2b382bb4b$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $b11369f2b382bb4b$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b11369f2b382bb4b$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $b11369f2b382bb4b$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b11369f2b382bb4b$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b11369f2b382bb4b$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b11369f2b382bb4b$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $b11369f2b382bb4b$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $b11369f2b382bb4b$var$getDoneFetcher(void 0));
            return;
        }
        if ($b11369f2b382bb4b$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $b11369f2b382bb4b$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($b11369f2b382bb4b$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $b11369f2b382bb4b$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $b11369f2b382bb4b$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $b11369f2b382bb4b$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $b11369f2b382bb4b$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($b11369f2b382bb4b$var$isAbsoluteUrl(location)) {
                const url = $b11369f2b382bb4b$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b11369f2b382bb4b$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b11369f2b382bb4b$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($b11369f2b382bb4b$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $b11369f2b382bb4b$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $b11369f2b382bb4b$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $b11369f2b382bb4b$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($b11369f2b382bb4b$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $b11369f2b382bb4b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $b11369f2b382bb4b$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $b11369f2b382bb4b$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $b11369f2b382bb4b$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $b11369f2b382bb4b$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b11369f2b382bb4b$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b11369f2b382bb4b$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b11369f2b382bb4b$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b11369f2b382bb4b$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b11369f2b382bb4b$export$386d57f03f0b2883;
        $b11369f2b382bb4b$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $b11369f2b382bb4b$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $b11369f2b382bb4b$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $b11369f2b382bb4b$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $b11369f2b382bb4b$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$b11369f2b382bb4b$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $b11369f2b382bb4b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $b11369f2b382bb4b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $b11369f2b382bb4b$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $b11369f2b382bb4b$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $b11369f2b382bb4b$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b11369f2b382bb4b$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $b11369f2b382bb4b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    return router;
}
function $b11369f2b382bb4b$export$3336b097a6fbc59a(routes, opts) {
    $b11369f2b382bb4b$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties2 = opts?.mapRouteProperties || $b11369f2b382bb4b$var$defaultMapRouteProperties;
    let dataRoutes = $b11369f2b382bb4b$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, unstable_generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $b11369f2b382bb4b$var$createLocation("", $b11369f2b382bb4b$export$fe53371bee54353d(url), null, "default");
        let matches = $b11369f2b382bb4b$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $b11369f2b382bb4b$export$b754276817659c2d();
        if (!$b11369f2b382bb4b$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b11369f2b382bb4b$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b11369f2b382bb4b$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $b11369f2b382bb4b$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b11369f2b382bb4b$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $b11369f2b382bb4b$export$f5708dca728d7177(requestContext instanceof $b11369f2b382bb4b$export$b754276817659c2d, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            try {
                await $b11369f2b382bb4b$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $b11369f2b382bb4b$var$runServerMiddlewarePipeline({
                    request: request,
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : null, skipRevalidation === true);
                        if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($b11369f2b382bb4b$export$6e80290866a84dd4(error)) return error;
                    if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $b11369f2b382bb4b$export$f2680fa305b734ca(error.status, error.statusText, await $b11369f2b382bb4b$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($b11369f2b382bb4b$export$e0163cfdf7bc9cfa(error)) error = $b11369f2b382bb4b$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $b11369f2b382bb4b$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $b11369f2b382bb4b$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $b11369f2b382bb4b$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $b11369f2b382bb4b$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $b11369f2b382bb4b$export$f5708dca728d7177($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, unstable_generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $b11369f2b382bb4b$var$createLocation("", $b11369f2b382bb4b$export$fe53371bee54353d(url), null, "default");
        let matches = $b11369f2b382bb4b$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $b11369f2b382bb4b$export$b754276817659c2d();
        if (!$b11369f2b382bb4b$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b11369f2b382bb4b$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b11369f2b382bb4b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b11369f2b382bb4b$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b11369f2b382bb4b$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $b11369f2b382bb4b$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $b11369f2b382bb4b$export$f5708dca728d7177(requestContext instanceof $b11369f2b382bb4b$export$b754276817659c2d, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `unstable_RouterContextProvider`");
            await $b11369f2b382bb4b$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $b11369f2b382bb4b$var$runServerMiddlewarePipeline({
                request: request,
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $b11369f2b382bb4b$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($b11369f2b382bb4b$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($b11369f2b382bb4b$var$dataWithResponseInitToResponse(error));
                if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $b11369f2b382bb4b$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b11369f2b382bb4b$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $b11369f2b382bb4b$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($b11369f2b382bb4b$var$isDataStrategyResult(e) && $b11369f2b382bb4b$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($b11369f2b382bb4b$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b11369f2b382bb4b$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $b11369f2b382bb4b$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($b11369f2b382bb4b$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($b11369f2b382bb4b$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($b11369f2b382bb4b$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b11369f2b382bb4b$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $b11369f2b382bb4b$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($b11369f2b382bb4b$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b11369f2b382bb4b$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $b11369f2b382bb4b$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $b11369f2b382bb4b$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $b11369f2b382bb4b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, false);
                return $b11369f2b382bb4b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $b11369f2b382bb4b$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $b11369f2b382bb4b$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $b11369f2b382bb4b$var$callDataStrategyImpl(dataStrategy || $b11369f2b382bb4b$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($b11369f2b382bb4b$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $b11369f2b382bb4b$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($b11369f2b382bb4b$export$e0163cfdf7bc9cfa(result.result)) throw $b11369f2b382bb4b$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $b11369f2b382bb4b$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $b11369f2b382bb4b$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $b11369f2b382bb4b$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $b11369f2b382bb4b$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $b11369f2b382bb4b$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $b11369f2b382bb4b$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $b11369f2b382bb4b$var$resolveTo(to ? to : ".", $b11369f2b382bb4b$var$getResolveToMatches(contextualMatches), $b11369f2b382bb4b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $b11369f2b382bb4b$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $b11369f2b382bb4b$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $b11369f2b382bb4b$export$fe53371bee54353d(path);
}
function $b11369f2b382bb4b$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$b11369f2b382bb4b$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b11369f2b382bb4b$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b11369f2b382bb4b$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b11369f2b382bb4b$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $b11369f2b382bb4b$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$b11369f2b382bb4b$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$b11369f2b382bb4b$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b11369f2b382bb4b$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b11369f2b382bb4b$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b11369f2b382bb4b$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b11369f2b382bb4b$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b11369f2b382bb4b$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($b11369f2b382bb4b$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $b11369f2b382bb4b$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $b11369f2b382bb4b$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $b11369f2b382bb4b$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $b11369f2b382bb4b$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? $b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (route.loader == null) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $b11369f2b382bb4b$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($b11369f2b382bb4b$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $b11369f2b382bb4b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $b11369f2b382bb4b$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $b11369f2b382bb4b$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $b11369f2b382bb4b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $b11369f2b382bb4b$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $b11369f2b382bb4b$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $b11369f2b382bb4b$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($b11369f2b382bb4b$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $b11369f2b382bb4b$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!route.loader) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $b11369f2b382bb4b$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $b11369f2b382bb4b$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b11369f2b382bb4b$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $b11369f2b382bb4b$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $b11369f2b382bb4b$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$b11369f2b382bb4b$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $b11369f2b382bb4b$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $b11369f2b382bb4b$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $b11369f2b382bb4b$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$b11369f2b382bb4b$var$isSameRoute(aChild, bChild)));
}
var $b11369f2b382bb4b$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $b11369f2b382bb4b$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $b11369f2b382bb4b$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $b11369f2b382bb4b$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $b11369f2b382bb4b$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $b11369f2b382bb4b$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $b11369f2b382bb4b$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $b11369f2b382bb4b$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $b11369f2b382bb4b$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $b11369f2b382bb4b$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $b11369f2b382bb4b$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $b11369f2b382bb4b$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $b11369f2b382bb4b$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $b11369f2b382bb4b$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $b11369f2b382bb4b$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $b11369f2b382bb4b$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $b11369f2b382bb4b$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $b11369f2b382bb4b$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $b11369f2b382bb4b$var$isNonNullable(value) {
    return value !== void 0;
}
function $b11369f2b382bb4b$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.unstable_middleware) return void 0;
        return $b11369f2b382bb4b$var$loadLazyRouteProperty({
            key: "unstable_middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($b11369f2b382bb4b$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $b11369f2b382bb4b$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $b11369f2b382bb4b$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.unstable_middleware)) return $b11369f2b382bb4b$var$defaultDataStrategy(args);
    return $b11369f2b382bb4b$var$runClientMiddlewarePipeline(args, ()=>$b11369f2b382bb4b$var$defaultDataStrategy(args));
}
function $b11369f2b382bb4b$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $b11369f2b382bb4b$var$runMiddlewarePipeline(args, handler, processResult, $b11369f2b382bb4b$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $b11369f2b382bb4b$export$e0163cfdf7bc9cfa(result) ? $b11369f2b382bb4b$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $b11369f2b382bb4b$var$runClientMiddlewarePipeline(args, handler) {
    return $b11369f2b382bb4b$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $b11369f2b382bb4b$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            matches.findIndex((m)=>m.route.id === routeId) || 0, // or the shallowest route that needs to load data
            matches.findIndex((m)=>m.unstable_shouldCallHandler()) || 0);
            let boundaryRouteId = $b11369f2b382bb4b$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $b11369f2b382bb4b$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context } = args;
    let tuples = matches.flatMap((m)=>m.route.unstable_middleware ? m.route.unstable_middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $b11369f2b382bb4b$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $b11369f2b382bb4b$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $b11369f2b382bb4b$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $b11369f2b382bb4b$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $b11369f2b382bb4b$var$loadLazyRouteProperty({
        key: "unstable_middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $b11369f2b382bb4b$var$loadLazyRoute(match.route, $b11369f2b382bb4b$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $b11369f2b382bb4b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $b11369f2b382bb4b$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $b11369f2b382bb4b$var$shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $b11369f2b382bb4b$var$shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            if (isUsingNewApi || shouldLoad || handlerOverride && !$b11369f2b382bb4b$export$cbae47800eb95bc3(request.method) && (match.route.lazy || match.route.loader)) return $b11369f2b382bb4b$var$callLoaderOrAction({
                request: request,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $b11369f2b382bb4b$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: $b11369f2b382bb4b$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $b11369f2b382bb4b$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $b11369f2b382bb4b$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let unstable_runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `unstable_runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $b11369f2b382bb4b$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                unstable_runClientMiddleware: ()=>{
                    throw new Error("Cannot call `unstable_runClientMiddleware()` from within an `unstable_runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        unstable_runClientMiddleware: unstable_runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $b11369f2b382bb4b$var$callLoaderOrAction({ request: request, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $b11369f2b382bb4b$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b11369f2b382bb4b$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b11369f2b382bb4b$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $b11369f2b382bb4b$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $b11369f2b382bb4b$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $b11369f2b382bb4b$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $b11369f2b382bb4b$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($b11369f2b382bb4b$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $b11369f2b382bb4b$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $b11369f2b382bb4b$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $b11369f2b382bb4b$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($b11369f2b382bb4b$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $b11369f2b382bb4b$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $b11369f2b382bb4b$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$b11369f2b382bb4b$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $b11369f2b382bb4b$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $b11369f2b382bb4b$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($b11369f2b382bb4b$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $b11369f2b382bb4b$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $b11369f2b382bb4b$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b11369f2b382bb4b$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b11369f2b382bb4b$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $b11369f2b382bb4b$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b11369f2b382bb4b$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b11369f2b382bb4b$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b11369f2b382bb4b$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $b11369f2b382bb4b$export$f5708dca728d7177(!$b11369f2b382bb4b$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b11369f2b382bb4b$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $b11369f2b382bb4b$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $b11369f2b382bb4b$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $b11369f2b382bb4b$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b11369f2b382bb4b$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $b11369f2b382bb4b$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $b11369f2b382bb4b$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($b11369f2b382bb4b$var$isErrorResult(result)) {
            let boundaryMatch = $b11369f2b382bb4b$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($b11369f2b382bb4b$var$isRedirectResult(result)) $b11369f2b382bb4b$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $b11369f2b382bb4b$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b11369f2b382bb4b$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $b11369f2b382bb4b$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $b11369f2b382bb4b$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $b11369f2b382bb4b$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $b11369f2b382bb4b$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b11369f2b382bb4b$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b11369f2b382bb4b$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $b11369f2b382bb4b$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $b11369f2b382bb4b$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($b11369f2b382bb4b$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $b11369f2b382bb4b$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b11369f2b382bb4b$export$8ccf933b0513f8d0(path) : path;
    return $b11369f2b382bb4b$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $b11369f2b382bb4b$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $b11369f2b382bb4b$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $b11369f2b382bb4b$var$dataWithResponseInitToErrorResponse(data2) {
    return new $b11369f2b382bb4b$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $b11369f2b382bb4b$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $b11369f2b382bb4b$var$isDataStrategyResult(value));
}
function $b11369f2b382bb4b$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $b11369f2b382bb4b$var$isRedirectDataStrategyResult(result) {
    return $b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result.result) && $b11369f2b382bb4b$var$redirectStatusCodes.has(result.result.status);
}
function $b11369f2b382bb4b$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $b11369f2b382bb4b$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $b11369f2b382bb4b$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $b11369f2b382bb4b$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b11369f2b382bb4b$export$794b2760043cf8cd(statusCode) {
    return $b11369f2b382bb4b$var$redirectStatusCodes.has(statusCode);
}
function $b11369f2b382bb4b$export$6e80290866a84dd4(result) {
    return $b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result) && $b11369f2b382bb4b$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $b11369f2b382bb4b$var$isValidMethod(method) {
    return $b11369f2b382bb4b$var$validRequestMethods.has(method.toUpperCase());
}
function $b11369f2b382bb4b$export$cbae47800eb95bc3(method) {
    return $b11369f2b382bb4b$var$validMutationMethods.has(method.toUpperCase());
}
function $b11369f2b382bb4b$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b11369f2b382bb4b$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b11369f2b382bb4b$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b11369f2b382bb4b$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $b11369f2b382bb4b$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b11369f2b382bb4b$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $b11369f2b382bb4b$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $b11369f2b382bb4b$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b11369f2b382bb4b$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $b11369f2b382bb4b$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $b11369f2b382bb4b$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $b11369f2b382bb4b$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b11369f2b382bb4b$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $b11369f2b382bb4b$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b11369f2b382bb4b$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b11369f2b382bb4b$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $b11369f2b382bb4b$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $b11369f2b382bb4b$export$2eeee58951ff3c1c = $4Iuzv.createContext(null);
$b11369f2b382bb4b$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $b11369f2b382bb4b$export$315e3ffb01f217 = $4Iuzv.createContext(null);
$b11369f2b382bb4b$export$315e3ffb01f217.displayName = "DataRouterState";
var $b11369f2b382bb4b$export$717f757c655223f1 = $4Iuzv.createContext(false);
function $b11369f2b382bb4b$var$useIsRSCRouterContext() {
    return $4Iuzv.useContext($b11369f2b382bb4b$export$717f757c655223f1);
}
var $b11369f2b382bb4b$export$3681f408decb40d1 = $4Iuzv.createContext({
    isTransitioning: false
});
$b11369f2b382bb4b$export$3681f408decb40d1.displayName = "ViewTransition";
var $b11369f2b382bb4b$export$cb3f1df1bef00a39 = $4Iuzv.createContext(/* @__PURE__ */ new Map());
$b11369f2b382bb4b$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $b11369f2b382bb4b$var$AwaitContext = $4Iuzv.createContext(null);
$b11369f2b382bb4b$var$AwaitContext.displayName = "Await";
var $b11369f2b382bb4b$export$3044ab7fdabeaee6 = $4Iuzv.createContext(null);
$b11369f2b382bb4b$export$3044ab7fdabeaee6.displayName = "Navigation";
var $b11369f2b382bb4b$export$e6a44b110a0c44d3 = $4Iuzv.createContext(null);
$b11369f2b382bb4b$export$e6a44b110a0c44d3.displayName = "Location";
var $b11369f2b382bb4b$export$aac280ed165a4397 = $4Iuzv.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$b11369f2b382bb4b$export$aac280ed165a4397.displayName = "Route";
var $b11369f2b382bb4b$var$RouteErrorContext = $4Iuzv.createContext(null);
$b11369f2b382bb4b$var$RouteErrorContext.displayName = "RouteError";
var $b11369f2b382bb4b$export$945fecf35a8ef089 = true;
function $b11369f2b382bb4b$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $b11369f2b382bb4b$export$f5708dca728d7177($b11369f2b382bb4b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $b11369f2b382bb4b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $b11369f2b382bb4b$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $b11369f2b382bb4b$export$9c954a9d03d32f4a() {
    return $4Iuzv.useContext($b11369f2b382bb4b$export$e6a44b110a0c44d3) != null;
}
function $b11369f2b382bb4b$export$45d76561a5302f2b() {
    $b11369f2b382bb4b$export$f5708dca728d7177($b11369f2b382bb4b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $4Iuzv.useContext($b11369f2b382bb4b$export$e6a44b110a0c44d3).location;
}
function $b11369f2b382bb4b$export$1b3f31771c5d07c() {
    return $4Iuzv.useContext($b11369f2b382bb4b$export$e6a44b110a0c44d3).navigationType;
}
function $b11369f2b382bb4b$export$6c330e8992e8a295(pattern) {
    $b11369f2b382bb4b$export$f5708dca728d7177($b11369f2b382bb4b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $b11369f2b382bb4b$export$45d76561a5302f2b();
    return $4Iuzv.useMemo(()=>$b11369f2b382bb4b$export$81336c211d5ff295(pattern, $b11369f2b382bb4b$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $b11369f2b382bb4b$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $b11369f2b382bb4b$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6).static;
    if (!isStatic) $4Iuzv.useLayoutEffect(cb);
}
function $b11369f2b382bb4b$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    return isDataRoute ? $b11369f2b382bb4b$var$useNavigateStable() : $b11369f2b382bb4b$var$useNavigateUnstable();
}
function $b11369f2b382bb4b$var$useNavigateUnstable() {
    $b11369f2b382bb4b$export$f5708dca728d7177($b11369f2b382bb4b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $4Iuzv.useContext($b11369f2b382bb4b$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let { matches: matches } = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($b11369f2b382bb4b$var$getResolveToMatches(matches));
    let activeRef = $4Iuzv.useRef(false);
    $b11369f2b382bb4b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback((to, options = {})=>{
        $b11369f2b382bb4b$var$warning(activeRef.current, $b11369f2b382bb4b$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $b11369f2b382bb4b$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b11369f2b382bb4b$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $b11369f2b382bb4b$var$OutletContext = $4Iuzv.createContext(null);
function $b11369f2b382bb4b$export$4138103a3ae699cc() {
    return $4Iuzv.useContext($b11369f2b382bb4b$var$OutletContext);
}
function $b11369f2b382bb4b$export$a3be3530d8e40d0b(context) {
    let outlet = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397).outlet;
    if (outlet) return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
function $b11369f2b382bb4b$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $b11369f2b382bb4b$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($b11369f2b382bb4b$var$getResolveToMatches(matches));
    return $4Iuzv.useMemo(()=>$b11369f2b382bb4b$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $b11369f2b382bb4b$export$5d3fca4a98652595(routes, locationArg) {
    return $b11369f2b382bb4b$var$useRoutesImpl(routes, locationArg);
}
function $b11369f2b382bb4b$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $b11369f2b382bb4b$export$f5708dca728d7177($b11369f2b382bb4b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($b11369f2b382bb4b$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $b11369f2b382bb4b$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $b11369f2b382bb4b$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $b11369f2b382bb4b$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $b11369f2b382bb4b$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($b11369f2b382bb4b$export$945fecf35a8ef089) {
        $b11369f2b382bb4b$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $b11369f2b382bb4b$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $b11369f2b382bb4b$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $b11369f2b382bb4b$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $b11369f2b382bb4b$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b11369f2b382bb4b$var$DefaultErrorComponent() {
    let error = $b11369f2b382bb4b$export$ed527bf60f6e05f2();
    let message = $b11369f2b382bb4b$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($b11369f2b382bb4b$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $4Iuzv.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $4Iuzv.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $4Iuzv.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $4Iuzv.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $4Iuzv.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $b11369f2b382bb4b$var$defaultErrorElement = /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$DefaultErrorComponent, null);
var $b11369f2b382bb4b$var$RenderErrorBoundary = class extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $b11369f2b382bb4b$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $4Iuzv.useContext($b11369f2b382bb4b$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $b11369f2b382bb4b$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $b11369f2b382bb4b$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $b11369f2b382bb4b$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $b11369f2b382bb4b$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $4Iuzv.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            unstable_onError: unstable_onError
        }) : getChildren();
    }, null);
}
function $b11369f2b382bb4b$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $b11369f2b382bb4b$var$useDataRouterContext(hookName) {
    let ctx = $4Iuzv.useContext($b11369f2b382bb4b$export$2eeee58951ff3c1c);
    $b11369f2b382bb4b$export$f5708dca728d7177(ctx, $b11369f2b382bb4b$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $b11369f2b382bb4b$var$useDataRouterState(hookName) {
    let state = $4Iuzv.useContext($b11369f2b382bb4b$export$315e3ffb01f217);
    $b11369f2b382bb4b$export$f5708dca728d7177(state, $b11369f2b382bb4b$var$getDataRouterConsoleError(hookName));
    return state;
}
function $b11369f2b382bb4b$var$useRouteContext(hookName) {
    let route = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    $b11369f2b382bb4b$export$f5708dca728d7177(route, $b11369f2b382bb4b$var$getDataRouterConsoleError(hookName));
    return route;
}
function $b11369f2b382bb4b$var$useCurrentRouteId(hookName) {
    let route = $b11369f2b382bb4b$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $b11369f2b382bb4b$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $b11369f2b382bb4b$var$useRouteId() {
    return $b11369f2b382bb4b$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $b11369f2b382bb4b$export$d0fd4b7106de2769() {
    let state = $b11369f2b382bb4b$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $b11369f2b382bb4b$export$600dc272ed516c15() {
    let dataRouterContext = $b11369f2b382bb4b$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $b11369f2b382bb4b$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $4Iuzv.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $4Iuzv.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $b11369f2b382bb4b$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b11369f2b382bb4b$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $4Iuzv.useMemo(()=>matches.map((m)=>$b11369f2b382bb4b$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $b11369f2b382bb4b$export$1448a5050d252c4d() {
    let state = $b11369f2b382bb4b$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $b11369f2b382bb4b$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $b11369f2b382bb4b$export$fd5d37484eab868d(routeId) {
    let state = $b11369f2b382bb4b$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $b11369f2b382bb4b$export$fdc00f3f26066d5e() {
    let state = $b11369f2b382bb4b$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $b11369f2b382bb4b$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $b11369f2b382bb4b$export$ed527bf60f6e05f2() {
    let error = $4Iuzv.useContext($b11369f2b382bb4b$var$RouteErrorContext);
    let state = $b11369f2b382bb4b$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $b11369f2b382bb4b$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $b11369f2b382bb4b$export$78a72ddb39bdd145() {
    let value = $4Iuzv.useContext($b11369f2b382bb4b$var$AwaitContext);
    return value?._data;
}
function $b11369f2b382bb4b$export$17f53340677d5831() {
    let value = $4Iuzv.useContext($b11369f2b382bb4b$var$AwaitContext);
    return value?._error;
}
var $b11369f2b382bb4b$var$blockerId = 0;
function $b11369f2b382bb4b$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $b11369f2b382bb4b$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $b11369f2b382bb4b$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $4Iuzv.useState("");
    let blockerFunction = $4Iuzv.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $b11369f2b382bb4b$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $b11369f2b382bb4b$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $4Iuzv.useEffect(()=>{
        let key = String(++$b11369f2b382bb4b$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $4Iuzv.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $b11369f2b382bb4b$export$386d57f03f0b2883;
}
function $b11369f2b382bb4b$var$useNavigateStable() {
    let { router: router } = $b11369f2b382bb4b$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $b11369f2b382bb4b$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $4Iuzv.useRef(false);
    $b11369f2b382bb4b$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4Iuzv.useCallback(async (to, options = {})=>{
        $b11369f2b382bb4b$var$warning(activeRef.current, $b11369f2b382bb4b$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $b11369f2b382bb4b$var$alreadyWarned = {};
function $b11369f2b382bb4b$var$warningOnce(key, cond, message) {
    if (!cond && !$b11369f2b382bb4b$var$alreadyWarned[key]) {
        $b11369f2b382bb4b$var$alreadyWarned[key] = true;
        $b11369f2b382bb4b$var$warning(false, message);
    }
}
// lib/server-runtime/warnings.ts
var $b11369f2b382bb4b$var$alreadyWarned2 = {};
function $b11369f2b382bb4b$export$5b28268982f175ba(condition, message) {
    if (!condition && !$b11369f2b382bb4b$var$alreadyWarned2[message]) {
        $b11369f2b382bb4b$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function $b11369f2b382bb4b$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($b11369f2b382bb4b$export$945fecf35a8ef089) {
            if (route.element) $b11369f2b382bb4b$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $4Iuzv.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($b11369f2b382bb4b$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $b11369f2b382bb4b$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $4Iuzv.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($b11369f2b382bb4b$export$945fecf35a8ef089) {
            if (route.errorElement) $b11369f2b382bb4b$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $4Iuzv.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $b11369f2b382bb4b$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $b11369f2b382bb4b$export$f30f7e456d254e83(routes, opts) {
    return $b11369f2b382bb4b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $b11369f2b382bb4b$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $b11369f2b382bb4b$export$e2fd2c03906469db,
        mapRouteProperties: $b11369f2b382bb4b$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation
    }).initialize();
}
var $b11369f2b382bb4b$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $b11369f2b382bb4b$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let [state, setStateImpl] = $4Iuzv.useState(router.state);
    let [pendingState, setPendingState] = $4Iuzv.useState();
    let [vtContext, setVtContext] = $4Iuzv.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4Iuzv.useState();
    let [transition, setTransition] = $4Iuzv.useState();
    let [interruption, setInterruption] = $4Iuzv.useState();
    let fetcherData = $4Iuzv.useRef(/* @__PURE__ */ new Map());
    let logErrorsAndSetState = $4Iuzv.useCallback((newState)=>{
        setStateImpl((prevState)=>{
            if (newState.errors && unstable_onError) Object.entries(newState.errors).forEach(([routeId, error])=>{
                if (prevState.errors?.[routeId] !== error) unstable_onError(error);
            });
            return newState;
        });
    }, [
        unstable_onError
    ]);
    let setState = $4Iuzv.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $b11369f2b382bb4b$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $b11369f2b382bb4b$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            else $4Iuzv.startTransition(()=>logErrorsAndSetState(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        logErrorsAndSetState
    ]);
    $4Iuzv.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4Iuzv.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b11369f2b382bb4b$var$Deferred());
    }, [
        vtContext
    ]);
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $4Iuzv.startTransition(()=>logErrorsAndSetState(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        logErrorsAndSetState
    ]);
    $4Iuzv.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $4Iuzv.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $4Iuzv.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4Iuzv.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
var $b11369f2b382bb4b$var$MemoizedDataRoutes = $4Iuzv.memo($b11369f2b382bb4b$var$DataRoutes);
function $b11369f2b382bb4b$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $b11369f2b382bb4b$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $b11369f2b382bb4b$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = $b11369f2b382bb4b$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $b11369f2b382bb4b$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $b11369f2b382bb4b$export$f5708dca728d7177($b11369f2b382bb4b$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    $b11369f2b382bb4b$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    let { pathname: locationPathname } = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let navigate = $b11369f2b382bb4b$export$9770f232ac06a008();
    let path = $b11369f2b382bb4b$var$resolveTo(to, $b11369f2b382bb4b$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4Iuzv.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $b11369f2b382bb4b$export$910ae8079b2c2852(props) {
    return $b11369f2b382bb4b$export$a3be3530d8e40d0b(props.context);
}
function $b11369f2b382bb4b$export$e7b0ac011bb776c6(props) {
    $b11369f2b382bb4b$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $b11369f2b382bb4b$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false }) {
    $b11369f2b382bb4b$export$f5708dca728d7177(!$b11369f2b382bb4b$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4Iuzv.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $b11369f2b382bb4b$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4Iuzv.useMemo(()=>{
        let trailingPathname = $b11369f2b382bb4b$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $b11369f2b382bb4b$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $b11369f2b382bb4b$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $b11369f2b382bb4b$export$5d3fca4a98652595($b11369f2b382bb4b$export$16da398f5434bdec(children), location);
}
function $b11369f2b382bb4b$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $4Iuzv.useContext($b11369f2b382bb4b$export$2eeee58951ff3c1c);
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        unstable_onError: dataRouterContext?.unstable_onError
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$ResolveAwait, null, children));
}
var $b11369f2b382bb4b$var$AwaitErrorBoundary = class extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.unstable_onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $b11369f2b382bb4b$var$ResolveAwait({ children: children }) {
    let data2 = $b11369f2b382bb4b$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, toRender);
}
function $b11369f2b382bb4b$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $4Iuzv.Children.forEach(children, (element, index)=>{
        if (!$4Iuzv.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4Iuzv.Fragment) {
            routes.push.apply(routes, $b11369f2b382bb4b$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $b11369f2b382bb4b$export$f5708dca728d7177(element.type === $b11369f2b382bb4b$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $b11369f2b382bb4b$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b11369f2b382bb4b$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $b11369f2b382bb4b$export$9b5b6d122dea0c88 = $b11369f2b382bb4b$export$16da398f5434bdec;
function $b11369f2b382bb4b$export$daf73786167a7f72(matches) {
    return $b11369f2b382bb4b$var$_renderMatches(matches);
}
function $b11369f2b382bb4b$var$useRouteComponentProps() {
    return {
        params: $b11369f2b382bb4b$export$99eaa27ddbbb95ef(),
        loaderData: $b11369f2b382bb4b$export$1448a5050d252c4d(),
        actionData: $b11369f2b382bb4b$export$fdc00f3f26066d5e(),
        matches: $b11369f2b382bb4b$export$2378eb7f5ff86053()
    };
}
function $b11369f2b382bb4b$export$6c4f3826290c37af({ children: children }) {
    const props = $b11369f2b382bb4b$var$useRouteComponentProps();
    return $4Iuzv.cloneElement(children, props);
}
function $b11369f2b382bb4b$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $b11369f2b382bb4b$var$useRouteComponentProps();
        return $4Iuzv.createElement(Component4, props);
    };
}
function $b11369f2b382bb4b$var$useHydrateFallbackProps() {
    return {
        params: $b11369f2b382bb4b$export$99eaa27ddbbb95ef(),
        loaderData: $b11369f2b382bb4b$export$1448a5050d252c4d(),
        actionData: $b11369f2b382bb4b$export$fdc00f3f26066d5e()
    };
}
function $b11369f2b382bb4b$export$f8cff34f39c1932a({ children: children }) {
    const props = $b11369f2b382bb4b$var$useHydrateFallbackProps();
    return $4Iuzv.cloneElement(children, props);
}
function $b11369f2b382bb4b$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $b11369f2b382bb4b$var$useHydrateFallbackProps();
        return $4Iuzv.createElement(HydrateFallback, props);
    };
}
function $b11369f2b382bb4b$var$useErrorBoundaryProps() {
    return {
        params: $b11369f2b382bb4b$export$99eaa27ddbbb95ef(),
        loaderData: $b11369f2b382bb4b$export$1448a5050d252c4d(),
        actionData: $b11369f2b382bb4b$export$fdc00f3f26066d5e(),
        error: $b11369f2b382bb4b$export$ed527bf60f6e05f2()
    };
}
function $b11369f2b382bb4b$export$e5afde5c4b6d747b({ children: children }) {
    const props = $b11369f2b382bb4b$var$useErrorBoundaryProps();
    return $4Iuzv.cloneElement(children, props);
}
function $b11369f2b382bb4b$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $b11369f2b382bb4b$var$useErrorBoundaryProps();
        return $4Iuzv.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $b11369f2b382bb4b$var$defaultMethod = "get";
var $b11369f2b382bb4b$var$defaultEncType = "application/x-www-form-urlencoded";
function $b11369f2b382bb4b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b11369f2b382bb4b$var$isButtonElement(object) {
    return $b11369f2b382bb4b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b11369f2b382bb4b$var$isFormElement(object) {
    return $b11369f2b382bb4b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b11369f2b382bb4b$var$isInputElement(object) {
    return $b11369f2b382bb4b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b11369f2b382bb4b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b11369f2b382bb4b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b11369f2b382bb4b$var$isModifiedEvent(event);
}
function $b11369f2b382bb4b$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b11369f2b382bb4b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b11369f2b382bb4b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $b11369f2b382bb4b$var$_formDataSupportsSubmitter = null;
function $b11369f2b382bb4b$var$isFormDataSubmitterSupported() {
    if ($b11369f2b382bb4b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b11369f2b382bb4b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b11369f2b382bb4b$var$_formDataSupportsSubmitter = true;
    }
    return $b11369f2b382bb4b$var$_formDataSupportsSubmitter;
}
var $b11369f2b382bb4b$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b11369f2b382bb4b$var$getFormEncType(encType) {
    if (encType != null && !$b11369f2b382bb4b$var$supportedFormEncTypes.has(encType)) {
        $b11369f2b382bb4b$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$b11369f2b382bb4b$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $b11369f2b382bb4b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b11369f2b382bb4b$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $b11369f2b382bb4b$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $b11369f2b382bb4b$var$defaultMethod;
        encType = $b11369f2b382bb4b$var$getFormEncType(target.getAttribute("enctype")) || $b11369f2b382bb4b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b11369f2b382bb4b$var$isButtonElement(target) || $b11369f2b382bb4b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $b11369f2b382bb4b$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b11369f2b382bb4b$var$defaultMethod;
        encType = $b11369f2b382bb4b$var$getFormEncType(target.getAttribute("formenctype")) || $b11369f2b382bb4b$var$getFormEncType(form.getAttribute("enctype")) || $b11369f2b382bb4b$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$b11369f2b382bb4b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b11369f2b382bb4b$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $b11369f2b382bb4b$var$defaultMethod;
        action = null;
        encType = $b11369f2b382bb4b$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $b11369f2b382bb4b$var$HOLE = -1;
var $b11369f2b382bb4b$var$NAN = -2;
var $b11369f2b382bb4b$var$NEGATIVE_INFINITY = -3;
var $b11369f2b382bb4b$var$NEGATIVE_ZERO = -4;
var $b11369f2b382bb4b$var$NULL = -5;
var $b11369f2b382bb4b$var$POSITIVE_INFINITY = -6;
var $b11369f2b382bb4b$var$UNDEFINED = -7;
var $b11369f2b382bb4b$var$TYPE_BIGINT = "B";
var $b11369f2b382bb4b$var$TYPE_DATE = "D";
var $b11369f2b382bb4b$var$TYPE_ERROR = "E";
var $b11369f2b382bb4b$var$TYPE_MAP = "M";
var $b11369f2b382bb4b$var$TYPE_NULL_OBJECT = "N";
var $b11369f2b382bb4b$var$TYPE_PROMISE = "P";
var $b11369f2b382bb4b$var$TYPE_REGEXP = "R";
var $b11369f2b382bb4b$var$TYPE_SET = "S";
var $b11369f2b382bb4b$var$TYPE_SYMBOL = "Y";
var $b11369f2b382bb4b$var$TYPE_URL = "U";
var $b11369f2b382bb4b$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $b11369f2b382bb4b$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $b11369f2b382bb4b$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $b11369f2b382bb4b$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $b11369f2b382bb4b$var$UNDEFINED;
    if (input === null) return $b11369f2b382bb4b$var$NULL;
    if (Number.isNaN(input)) return $b11369f2b382bb4b$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $b11369f2b382bb4b$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $b11369f2b382bb4b$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $b11369f2b382bb4b$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $b11369f2b382bb4b$var$stringify.call(this, input, index);
    return index;
}
function $b11369f2b382bb4b$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$b11369f2b382bb4b$var$flatten.call(this, k)}":${$b11369f2b382bb4b$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$b11369f2b382bb4b$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$b11369f2b382bb4b$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$b11369f2b382bb4b$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$b11369f2b382bb4b$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $b11369f2b382bb4b$var$flatten.call(this, input2[i]) : $b11369f2b382bb4b$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$b11369f2b382bb4b$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$b11369f2b382bb4b$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$b11369f2b382bb4b$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$b11369f2b382bb4b$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$b11369f2b382bb4b$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$b11369f2b382bb4b$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$b11369f2b382bb4b$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $b11369f2b382bb4b$var$flatten.call(this, k),
                                    $b11369f2b382bb4b$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$b11369f2b382bb4b$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$b11369f2b382bb4b$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$b11369f2b382bb4b$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$b11369f2b382bb4b$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($b11369f2b382bb4b$var$isPlainObject(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$b11369f2b382bb4b$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$b11369f2b382bb4b$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $b11369f2b382bb4b$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $b11369f2b382bb4b$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $b11369f2b382bb4b$var$objectProtoNames;
}
// vendor/turbo-stream-v2/unflatten.ts
var $b11369f2b382bb4b$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $b11369f2b382bb4b$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $b11369f2b382bb4b$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $b11369f2b382bb4b$var$hydrate.call(this, startIndex);
}
function $b11369f2b382bb4b$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $b11369f2b382bb4b$var$UNDEFINED:
                set(void 0);
                continue;
            case $b11369f2b382bb4b$var$NULL:
                set(null);
                continue;
            case $b11369f2b382bb4b$var$NAN:
                set(NaN);
                continue;
            case $b11369f2b382bb4b$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $b11369f2b382bb4b$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $b11369f2b382bb4b$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $b11369f2b382bb4b$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $b11369f2b382bb4b$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $b11369f2b382bb4b$var$globalObj && $b11369f2b382bb4b$var$globalObj[errorType] ? new $b11369f2b382bb4b$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $b11369f2b382bb4b$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $b11369f2b382bb4b$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $b11369f2b382bb4b$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $b11369f2b382bb4b$var$Deferred2();
    const reader = readable.pipeThrough($b11369f2b382bb4b$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $b11369f2b382bb4b$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $b11369f2b382bb4b$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $b11369f2b382bb4b$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $b11369f2b382bb4b$var$unflatten.call(this, line)
    };
}
async function $b11369f2b382bb4b$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $b11369f2b382bb4b$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $b11369f2b382bb4b$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $b11369f2b382bb4b$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $b11369f2b382bb4b$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $b11369f2b382bb4b$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $b11369f2b382bb4b$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $b11369f2b382bb4b$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$b11369f2b382bb4b$var$TYPE_PROMISE}${deferredId}:[["${$b11369f2b382bb4b$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$b11369f2b382bb4b$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$b11369f2b382bb4b$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $b11369f2b382bb4b$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$b11369f2b382bb4b$var$TYPE_ERROR}${deferredId}:[["${$b11369f2b382bb4b$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$b11369f2b382bb4b$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$b11369f2b382bb4b$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $b11369f2b382bb4b$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $b11369f2b382bb4b$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $b11369f2b382bb4b$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $b11369f2b382bb4b$var$escapeHtml(html) {
    return html.replace($b11369f2b382bb4b$var$ESCAPE_REGEX, (match)=>$b11369f2b382bb4b$var$ESCAPE_LOOKUP[match]);
}
function $b11369f2b382bb4b$var$createHtml(html) {
    return {
        __html: html
    };
}
// lib/dom/ssr/invariant.ts
function $b11369f2b382bb4b$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $b11369f2b382bb4b$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $b11369f2b382bb4b$var$SingleFetchNoResultError = class extends Error {
};
var $b11369f2b382bb4b$export$ae9272e641ead836 = 202;
var $b11369f2b382bb4b$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $b11369f2b382bb4b$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $4Iuzv.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$b11369f2b382bb4b$var$escapeHtml(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, scriptTag, /* @__PURE__ */ $4Iuzv.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, scriptTag, /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Suspense, null, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $b11369f2b382bb4b$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $b11369f2b382bb4b$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $b11369f2b382bb4b$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $b11369f2b382bb4b$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.unstable_runClientMiddleware(dataStrategy);
}
function $b11369f2b382bb4b$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $b11369f2b382bb4b$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $b11369f2b382bb4b$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $b11369f2b382bb4b$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $b11369f2b382bb4b$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $b11369f2b382bb4b$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $b11369f2b382bb4b$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $b11369f2b382bb4b$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($b11369f2b382bb4b$export$3f1eb41d9a6a6a27(result.result) || $b11369f2b382bb4b$export$972111febbeef05b(result.result) || $b11369f2b382bb4b$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $b11369f2b382bb4b$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $b11369f2b382bb4b$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $b11369f2b382bb4b$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $b11369f2b382bb4b$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$b11369f2b382bb4b$var$createDeferred2());
    let singleFetchDfd = $b11369f2b382bb4b$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $b11369f2b382bb4b$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $b11369f2b382bb4b$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $b11369f2b382bb4b$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $b11369f2b382bb4b$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $b11369f2b382bb4b$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $b11369f2b382bb4b$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $b11369f2b382bb4b$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $b11369f2b382bb4b$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $b11369f2b382bb4b$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $b11369f2b382bb4b$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $b11369f2b382bb4b$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $b11369f2b382bb4b$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $b11369f2b382bb4b$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $b11369f2b382bb4b$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $b11369f2b382bb4b$export$a30aa2a0fce6c468(request));
    if (res.status === 404 && !res.headers.has("X-Remix-Response")) throw new $b11369f2b382bb4b$export$f2680fa305b734ca(404, "Not Found", true);
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $b11369f2b382bb4b$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($b11369f2b382bb4b$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $b11369f2b382bb4b$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $b11369f2b382bb4b$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($b11369f2b382bb4b$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$b11369f2b382bb4b$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $b11369f2b382bb4b$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $b11369f2b382bb4b$export$4023ad4ecd4126a2(body, global) {
    return $b11369f2b382bb4b$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $b11369f2b382bb4b$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$b11369f2b382bb4b$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $b11369f2b382bb4b$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $b11369f2b382bb4b$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $b11369f2b382bb4b$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $b11369f2b382bb4b$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $b11369f2b382bb4b$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $b11369f2b382bb4b$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $b11369f2b382bb4b$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $b11369f2b382bb4b$var$getModuleLinkHrefs(matches, manifest);
    return $b11369f2b382bb4b$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $b11369f2b382bb4b$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $b11369f2b382bb4b$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $b11369f2b382bb4b$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($b11369f2b382bb4b$var$prefetchStyleLink));
}
async function $b11369f2b382bb4b$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$b11369f2b382bb4b$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$b11369f2b382bb4b$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$b11369f2b382bb4b$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($b11369f2b382bb4b$var$prefetchStyleLink));
}
async function $b11369f2b382bb4b$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $b11369f2b382bb4b$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $b11369f2b382bb4b$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $b11369f2b382bb4b$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $b11369f2b382bb4b$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $b11369f2b382bb4b$var$dedupeLinkDescriptors(links.flat(1).filter($b11369f2b382bb4b$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $b11369f2b382bb4b$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $b11369f2b382bb4b$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $b11369f2b382bb4b$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $b11369f2b382bb4b$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $b11369f2b382bb4b$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $b11369f2b382bb4b$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$b11369f2b382bb4b$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($b11369f2b382bb4b$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $b11369f2b382bb4b$var$_isPreloadSupported;
function $b11369f2b382bb4b$var$isPreloadSupported() {
    if ($b11369f2b382bb4b$var$_isPreloadSupported !== void 0) return $b11369f2b382bb4b$var$_isPreloadSupported;
    let el = document.createElement("link");
    $b11369f2b382bb4b$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $b11369f2b382bb4b$var$_isPreloadSupported;
}
function $b11369f2b382bb4b$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $b11369f2b382bb4b$export$945fecf35a8ef089 ? /* @__PURE__ */ $4Iuzv.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $b11369f2b382bb4b$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $b11369f2b382bb4b$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $b11369f2b382bb4b$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $b11369f2b382bb4b$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$RemixRootDefaultErrorBoundary, {
            error: $b11369f2b382bb4b$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $4Iuzv.createElement(routeModule.Layout, null, /* @__PURE__ */ $4Iuzv.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $4Iuzv.createElement(routeModule.Layout, null, /* @__PURE__ */ $4Iuzv.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $4Iuzv.createElement(routeModule.Layout, null, /* @__PURE__ */ $4Iuzv.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $b11369f2b382bb4b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $b11369f2b382bb4b$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $b11369f2b382bb4b$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$b11369f2b382bb4b$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $b11369f2b382bb4b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $b11369f2b382bb4b$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $b11369f2b382bb4b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $b11369f2b382bb4b$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $b11369f2b382bb4b$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $b11369f2b382bb4b$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $b11369f2b382bb4b$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $b11369f2b382bb4b$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $b11369f2b382bb4b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $b11369f2b382bb4b$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $b11369f2b382bb4b$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $b11369f2b382bb4b$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $b11369f2b382bb4b$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$b11369f2b382bb4b$var$getRouteComponents(route, routeModule, isSpaMode),
                unstable_middleware: routeModule.unstable_clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $b11369f2b382bb4b$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $b11369f2b382bb4b$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            async serverLoader () {
                                $b11369f2b382bb4b$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $b11369f2b382bb4b$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $b11369f2b382bb4b$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $b11369f2b382bb4b$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        async serverAction () {
                            $b11369f2b382bb4b$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $b11369f2b382bb4b$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $b11369f2b382bb4b$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $b11369f2b382bb4b$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $b11369f2b382bb4b$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $b11369f2b382bb4b$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $b11369f2b382bb4b$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                unstable_middleware: route.hasClientMiddleware ? async ()=>{
                    let { unstable_clientMiddleware: unstable_clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $b11369f2b382bb4b$var$invariant2(unstable_clientMiddleware, "No `unstable_clientMiddleware` export found");
                    return unstable_clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $b11369f2b382bb4b$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $b11369f2b382bb4b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $b11369f2b382bb4b$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $b11369f2b382bb4b$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $b11369f2b382bb4b$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $b11369f2b382bb4b$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $b11369f2b382bb4b$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $b11369f2b382bb4b$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $b11369f2b382bb4b$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $b11369f2b382bb4b$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $b11369f2b382bb4b$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        unstable_clientMiddleware: routeModule.unstable_clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $b11369f2b382bb4b$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $b11369f2b382bb4b$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $b11369f2b382bb4b$var$nextPaths = /* @__PURE__ */ new Set();
var $b11369f2b382bb4b$var$discoveredPathsMaxSize = 1e3;
var $b11369f2b382bb4b$var$discoveredPaths = /* @__PURE__ */ new Set();
var $b11369f2b382bb4b$var$URL_LIMIT = 7680;
function $b11369f2b382bb4b$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $b11369f2b382bb4b$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $b11369f2b382bb4b$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $b11369f2b382bb4b$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$b11369f2b382bb4b$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($b11369f2b382bb4b$var$discoveredPaths.has(path)) return;
        await $b11369f2b382bb4b$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $b11369f2b382bb4b$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $4Iuzv.useEffect(()=>{
        if (!$b11369f2b382bb4b$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$b11369f2b382bb4b$var$discoveredPaths.has(pathname)) $b11369f2b382bb4b$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($b11369f2b382bb4b$var$nextPaths.keys()).filter((path)=>{
                if ($b11369f2b382bb4b$var$discoveredPaths.has(path)) {
                    $b11369f2b382bb4b$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $b11369f2b382bb4b$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $b11369f2b382bb4b$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $b11369f2b382bb4b$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $b11369f2b382bb4b$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $b11369f2b382bb4b$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    paths.sort().forEach((path)=>searchParams.append("p", path));
    searchParams.set("version", manifest.version);
    let url = new URL($b11369f2b382bb4b$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $b11369f2b382bb4b$var$URL_LIMIT) {
        $b11369f2b382bb4b$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            if (sessionStorage.getItem($b11369f2b382bb4b$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                console.error("Unable to discover routes due to manifest version mismatch.");
                return;
            }
            sessionStorage.setItem($b11369f2b382bb4b$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        sessionStorage.removeItem($b11369f2b382bb4b$var$MANIFEST_VERSION_STORAGE_KEY);
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$b11369f2b382bb4b$var$addToFifoQueue(p, $b11369f2b382bb4b$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $b11369f2b382bb4b$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $b11369f2b382bb4b$var$addToFifoQueue(path, queue) {
    if (queue.size >= $b11369f2b382bb4b$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $b11369f2b382bb4b$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $b11369f2b382bb4b$var$useDataRouterContext2() {
    let context = $4Iuzv.useContext($b11369f2b382bb4b$export$2eeee58951ff3c1c);
    $b11369f2b382bb4b$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $b11369f2b382bb4b$var$useDataRouterStateContext() {
    let context = $4Iuzv.useContext($b11369f2b382bb4b$export$315e3ffb01f217);
    $b11369f2b382bb4b$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $b11369f2b382bb4b$export$208d6a3bc3aa62bd = $4Iuzv.createContext(void 0);
$b11369f2b382bb4b$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $b11369f2b382bb4b$var$useFrameworkContext() {
    let context = $4Iuzv.useContext($b11369f2b382bb4b$export$208d6a3bc3aa62bd);
    $b11369f2b382bb4b$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $b11369f2b382bb4b$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $4Iuzv.useContext($b11369f2b382bb4b$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $4Iuzv.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $4Iuzv.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $4Iuzv.useRef(null);
    $4Iuzv.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $4Iuzv.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $b11369f2b382bb4b$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $b11369f2b382bb4b$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $b11369f2b382bb4b$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $b11369f2b382bb4b$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $b11369f2b382bb4b$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $b11369f2b382bb4b$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $b11369f2b382bb4b$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$b11369f2b382bb4b$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $b11369f2b382bb4b$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $b11369f2b382bb4b$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $b11369f2b382bb4b$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $b11369f2b382bb4b$var$useDataRouterStateContext();
    let matches = $b11369f2b382bb4b$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $4Iuzv.useMemo(()=>$b11369f2b382bb4b$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $4Iuzv.createElement("style", {
        [$b11369f2b382bb4b$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $4Iuzv.createElement("link", {
        [$b11369f2b382bb4b$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$b11369f2b382bb4b$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $4Iuzv.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $b11369f2b382bb4b$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $b11369f2b382bb4b$var$useDataRouterContext2();
    let matches = $4Iuzv.useMemo(()=>$b11369f2b382bb4b$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $b11369f2b382bb4b$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $b11369f2b382bb4b$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $4Iuzv.useState([]);
    $4Iuzv.useEffect(()=>{
        let interrupted = false;
        $b11369f2b382bb4b$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $b11369f2b382bb4b$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $b11369f2b382bb4b$var$useFrameworkContext();
    let { basename: basename } = $b11369f2b382bb4b$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $b11369f2b382bb4b$var$useDataRouterStateContext();
    let newMatchesForData = $4Iuzv.useMemo(()=>$b11369f2b382bb4b$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $4Iuzv.useMemo(()=>$b11369f2b382bb4b$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $4Iuzv.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $b11369f2b382bb4b$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $4Iuzv.useMemo(()=>$b11369f2b382bb4b$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $b11369f2b382bb4b$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $4Iuzv.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $4Iuzv.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $4Iuzv.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $b11369f2b382bb4b$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $b11369f2b382bb4b$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $b11369f2b382bb4b$var$useDataRouterStateContext();
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let _matches = $b11369f2b382bb4b$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$b11369f2b382bb4b$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $4Iuzv.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $4Iuzv.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $4Iuzv.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $4Iuzv.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: json
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $4Iuzv.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $b11369f2b382bb4b$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $b11369f2b382bb4b$var$isHydrated = false;
function $b11369f2b382bb4b$export$3be068dde909e563() {
    $b11369f2b382bb4b$var$isHydrated = true;
}
function $b11369f2b382bb4b$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $b11369f2b382bb4b$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $b11369f2b382bb4b$var$useDataRouterContext2();
    let { matches: routerMatches } = $b11369f2b382bb4b$var$useDataRouterStateContext();
    let isRSCRouterContext = $b11369f2b382bb4b$var$useIsRSCRouterContext();
    let enableFogOfWar = $b11369f2b382bb4b$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $b11369f2b382bb4b$var$getActiveMatches(routerMatches, null, isSpaMode);
    $4Iuzv.useEffect(()=>{
        $b11369f2b382bb4b$export$3be068dde909e563();
    }, []);
    let initialScripts = $4Iuzv.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $b11369f2b382bb4b$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($b11369f2b382bb4b$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $b11369f2b382bb4b$var$createHtml(contextScript),
            type: void 0
        }), /* @__PURE__ */ $4Iuzv.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: $b11369f2b382bb4b$var$createHtml(routeModulesScript),
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $b11369f2b382bb4b$var$isHydrated || isRSCRouterContext ? [] : $b11369f2b382bb4b$var$dedupe(manifest.entry.imports.concat($b11369f2b382bb4b$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $b11369f2b382bb4b$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $b11369f2b382bb4b$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $4Iuzv.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $4Iuzv.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $4Iuzv.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $4Iuzv.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $b11369f2b382bb4b$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $b11369f2b382bb4b$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $b11369f2b382bb4b$export$32e57f52df4b6e34 = class extends $4Iuzv.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $b11369f2b382bb4b$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $4Iuzv.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($b11369f2b382bb4b$export$972111febbeef05b(error)) return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $4Iuzv.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $b11369f2b382bb4b$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $4Iuzv.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $4Iuzv.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $b11369f2b382bb4b$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $b11369f2b382bb4b$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $4Iuzv.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $4Iuzv.createElement("head", null, /* @__PURE__ */ $4Iuzv.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $4Iuzv.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $4Iuzv.createElement("title", null, title)), /* @__PURE__ */ $4Iuzv.createElement("body", null, /* @__PURE__ */ $4Iuzv.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$ff0bf87698939488, null) : null)));
}
var $b11369f2b382bb4b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($b11369f2b382bb4b$var$isBrowser) window.__reactRouterVersion = "7.8.2";
} catch (e) {}
function $b11369f2b382bb4b$export$1f3f55432a00e06d(routes, opts) {
    return $b11369f2b382bb4b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $b11369f2b382bb4b$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $b11369f2b382bb4b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $b11369f2b382bb4b$export$9269a41d8c4635e,
        hydrationRouteProperties: $b11369f2b382bb4b$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $b11369f2b382bb4b$export$1ba7ed8a3a7b3765(routes, opts) {
    return $b11369f2b382bb4b$export$baddd0131ee8c05b({
        basename: opts?.basename,
        unstable_getContext: opts?.unstable_getContext,
        future: opts?.future,
        history: $b11369f2b382bb4b$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $b11369f2b382bb4b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $b11369f2b382bb4b$export$9269a41d8c4635e,
        hydrationRouteProperties: $b11369f2b382bb4b$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window
    }).initialize();
}
function $b11369f2b382bb4b$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $b11369f2b382bb4b$var$deserializeErrors(state.errors)
    };
    return state;
}
function $b11369f2b382bb4b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $b11369f2b382bb4b$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $b11369f2b382bb4b$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = $b11369f2b382bb4b$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $b11369f2b382bb4b$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $4Iuzv.useRef();
    if (historyRef.current == null) historyRef.current = $b11369f2b382bb4b$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $b11369f2b382bb4b$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $4Iuzv.useState({
        action: history.action,
        location: history.location
    });
    let setState = $4Iuzv.useCallback((newState)=>{
        $4Iuzv.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $4Iuzv.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$b11369f2b382bb4b$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $b11369f2b382bb4b$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $b11369f2b382bb4b$export$a6c7ac8248d6e38a = $4Iuzv.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $b11369f2b382bb4b$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($b11369f2b382bb4b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $b11369f2b382bb4b$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $b11369f2b382bb4b$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $b11369f2b382bb4b$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $b11369f2b382bb4b$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $b11369f2b382bb4b$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $4Iuzv.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $b11369f2b382bb4b$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, link, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$b11369f2b382bb4b$export$a6c7ac8248d6e38a.displayName = "Link";
var $b11369f2b382bb4b$export$b0d92dbee9b5b60d = $4Iuzv.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $b11369f2b382bb4b$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let routerState = $4Iuzv.useContext($b11369f2b382bb4b$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b11369f2b382bb4b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $b11369f2b382bb4b$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$b11369f2b382bb4b$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $b11369f2b382bb4b$export$a7fed597f4b8afd8 = $4Iuzv.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $b11369f2b382bb4b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $b11369f2b382bb4b$export$47c85c6e3a081d3();
    let formAction = $b11369f2b382bb4b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $b11369f2b382bb4b$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $4Iuzv.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$b11369f2b382bb4b$export$a7fed597f4b8afd8.displayName = "Form";
function $b11369f2b382bb4b$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $4Iuzv.useContext($b11369f2b382bb4b$export$208d6a3bc3aa62bd);
    let { basename: basename } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let matches = $b11369f2b382bb4b$export$2378eb7f5ff86053();
    $b11369f2b382bb4b$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $4Iuzv.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $b11369f2b382bb4b$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $4Iuzv.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $b11369f2b382bb4b$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$b11369f2b382bb4b$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $b11369f2b382bb4b$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $b11369f2b382bb4b$var$useDataRouterContext3(hookName) {
    let ctx = $4Iuzv.useContext($b11369f2b382bb4b$export$2eeee58951ff3c1c);
    $b11369f2b382bb4b$export$f5708dca728d7177(ctx, $b11369f2b382bb4b$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $b11369f2b382bb4b$var$useDataRouterState2(hookName) {
    let state = $4Iuzv.useContext($b11369f2b382bb4b$export$315e3ffb01f217);
    $b11369f2b382bb4b$export$f5708dca728d7177(state, $b11369f2b382bb4b$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $b11369f2b382bb4b$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $b11369f2b382bb4b$export$9770f232ac06a008();
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let path = $b11369f2b382bb4b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $4Iuzv.useCallback((event)=>{
        if ($b11369f2b382bb4b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $b11369f2b382bb4b$export$fe53371bee54353d(location) === $b11369f2b382bb4b$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $b11369f2b382bb4b$export$f1a78c17382fe22a(defaultInit) {
    $b11369f2b382bb4b$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $4Iuzv.useRef($b11369f2b382bb4b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4Iuzv.useRef(false);
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let searchParams = $4Iuzv.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b11369f2b382bb4b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $b11369f2b382bb4b$export$9770f232ac06a008();
    let setSearchParams = $4Iuzv.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b11369f2b382bb4b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $b11369f2b382bb4b$var$fetcherId = 0;
var $b11369f2b382bb4b$var$getUniqueFetcherId = ()=>`__${String(++$b11369f2b382bb4b$var$fetcherId)}__`;
function $b11369f2b382bb4b$export$47c85c6e3a081d3() {
    let { router: router } = $b11369f2b382bb4b$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let currentRouteId = $b11369f2b382bb4b$var$useRouteId();
    return $4Iuzv.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b11369f2b382bb4b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b11369f2b382bb4b$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $b11369f2b382bb4b$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let routeContext = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    $b11369f2b382bb4b$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$b11369f2b382bb4b$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $b11369f2b382bb4b$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $b11369f2b382bb4b$export$fe53371bee54353d(path);
}
function $b11369f2b382bb4b$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $b11369f2b382bb4b$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $b11369f2b382bb4b$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $4Iuzv.useContext($b11369f2b382bb4b$export$cb3f1df1bef00a39);
    let route = $4Iuzv.useContext($b11369f2b382bb4b$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $b11369f2b382bb4b$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $b11369f2b382bb4b$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $b11369f2b382bb4b$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $4Iuzv.useId();
    let [fetcherKey, setFetcherKey] = $4Iuzv.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $4Iuzv.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $4Iuzv.useCallback(async (href, opts)=>{
        $b11369f2b382bb4b$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $b11369f2b382bb4b$export$47c85c6e3a081d3();
    let submit = $4Iuzv.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4Iuzv.useMemo(()=>{
        let FetcherForm2 = $4Iuzv.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $b11369f2b382bb4b$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4Iuzv.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $b11369f2b382bb4b$export$fa996778a3a31087() {
    let state = $b11369f2b382bb4b$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $b11369f2b382bb4b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $b11369f2b382bb4b$var$savedScrollPositions = {};
function $b11369f2b382bb4b$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $b11369f2b382bb4b$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $b11369f2b382bb4b$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $b11369f2b382bb4b$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b11369f2b382bb4b$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $4Iuzv.useContext($b11369f2b382bb4b$export$3044ab7fdabeaee6);
    let location = $b11369f2b382bb4b$export$45d76561a5302f2b();
    let matches = $b11369f2b382bb4b$export$2378eb7f5ff86053();
    let navigation = $b11369f2b382bb4b$export$d0fd4b7106de2769();
    $4Iuzv.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $b11369f2b382bb4b$var$usePageHide($4Iuzv.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $b11369f2b382bb4b$var$getScrollRestorationKey(location, matches, basename, getKey);
            $b11369f2b382bb4b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b11369f2b382bb4b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b11369f2b382bb4b$var$savedScrollPositions));
        } catch (error) {
            $b11369f2b382bb4b$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $4Iuzv.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b11369f2b382bb4b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b11369f2b382bb4b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $4Iuzv.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($b11369f2b382bb4b$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$b11369f2b382bb4b$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $4Iuzv.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $b11369f2b382bb4b$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $b11369f2b382bb4b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $b11369f2b382bb4b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4Iuzv.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $b11369f2b382bb4b$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $b11369f2b382bb4b$export$b273b3273281a049(when);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4Iuzv.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $b11369f2b382bb4b$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $4Iuzv.useContext($b11369f2b382bb4b$export$3681f408decb40d1);
    $b11369f2b382bb4b$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $b11369f2b382bb4b$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $b11369f2b382bb4b$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $b11369f2b382bb4b$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $b11369f2b382bb4b$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $b11369f2b382bb4b$export$81336c211d5ff295(path.pathname, nextPath) != null || $b11369f2b382bb4b$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $b11369f2b382bb4b$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $b11369f2b382bb4b$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $b11369f2b382bb4b$var$getStatelessNavigator();
    return /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $b11369f2b382bb4b$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $b11369f2b382bb4b$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $b11369f2b382bb4b$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $b11369f2b382bb4b$var$serializeErrors(context.errors)
        };
        let json = $b11369f2b382bb4b$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $4Iuzv.createElement($4Iuzv.Fragment, null, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $4Iuzv.createElement($b11369f2b382bb4b$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $4Iuzv.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $b11369f2b382bb4b$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $b11369f2b382bb4b$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $b11369f2b382bb4b$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($b11369f2b382bb4b$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $b11369f2b382bb4b$var$getStatelessNavigator() {
    return {
        createHref: $b11369f2b382bb4b$var$createHref,
        encodeLocation: $b11369f2b382bb4b$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $b11369f2b382bb4b$export$69163f0b72ec60d9(routes, opts) {
    return $b11369f2b382bb4b$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $b11369f2b382bb4b$export$9269a41d8c4635e
    });
}
function $b11369f2b382bb4b$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $b11369f2b382bb4b$export$87cb1a9238dc3fba(routes, $b11369f2b382bb4b$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                unstable_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $b11369f2b382bb4b$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $b11369f2b382bb4b$var$createHref,
        encodeLocation: $b11369f2b382bb4b$var$encodeLocation,
        getFetcher () {
            return $b11369f2b382bb4b$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $b11369f2b382bb4b$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $b11369f2b382bb4b$var$createHref(to) {
    return typeof to === "string" ? to : $b11369f2b382bb4b$export$fe53371bee54353d(to);
}
function $b11369f2b382bb4b$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $b11369f2b382bb4b$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $b11369f2b382bb4b$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $b11369f2b382bb4b$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $b11369f2b382bb4b$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $b11369f2b382bb4b$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $b11369f2b382bb4b$var$htmlEscape(str) {
    return str.replace($b11369f2b382bb4b$var$ESCAPE_REGEX2, (match)=>$b11369f2b382bb4b$var$ESCAPE_LOOKUP2[match]);
}


// src/index.tsx

var $4Iuzv = parcelRequire("4Iuzv");
var $25d1886ae0d69bda$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $25d1886ae0d69bda$var$hasElementType = typeof Element !== 'undefined';
var $25d1886ae0d69bda$var$hasMap = typeof Map === 'function';
var $25d1886ae0d69bda$var$hasSet = typeof Set === 'function';
var $25d1886ae0d69bda$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $25d1886ae0d69bda$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$25d1886ae0d69bda$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($25d1886ae0d69bda$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$25d1886ae0d69bda$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($25d1886ae0d69bda$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($25d1886ae0d69bda$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($25d1886ae0d69bda$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$25d1886ae0d69bda$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$25d1886ae0d69bda$exports = function isEqual(a, b) {
    try {
        return $25d1886ae0d69bda$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $784b62d6b0fabae5$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $784b62d6b0fabae5$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$784b62d6b0fabae5$exports = $784b62d6b0fabae5$var$invariant;


var $28ad59042aff93bc$exports = {};
//
$28ad59042aff93bc$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $911b39ee4d517ac3$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($911b39ee4d517ac3$var$TAG_NAMES || {});
var $911b39ee4d517ac3$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $911b39ee4d517ac3$var$VALID_TAG_NAMES = Object.values($911b39ee4d517ac3$var$TAG_NAMES);
var $911b39ee4d517ac3$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $911b39ee4d517ac3$var$HTML_TAG_MAP = Object.entries($911b39ee4d517ac3$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $911b39ee4d517ac3$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $911b39ee4d517ac3$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $911b39ee4d517ac3$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $911b39ee4d517ac3$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $911b39ee4d517ac3$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $911b39ee4d517ac3$var$getInnermostProperty(propsList, $911b39ee4d517ac3$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $911b39ee4d517ac3$var$getInnermostProperty(propsList, $911b39ee4d517ac3$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $911b39ee4d517ac3$var$getOnChangeClientState = (propsList)=>$911b39ee4d517ac3$var$getInnermostProperty(propsList, $911b39ee4d517ac3$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $911b39ee4d517ac3$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $911b39ee4d517ac3$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $911b39ee4d517ac3$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $911b39ee4d517ac3$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $911b39ee4d517ac3$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $911b39ee4d517ac3$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $911b39ee4d517ac3$var$reducePropsToState = (propsList)=>({
        baseTag: $911b39ee4d517ac3$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $911b39ee4d517ac3$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $911b39ee4d517ac3$var$getInnermostProperty(propsList, $911b39ee4d517ac3$var$HELMET_PROPS.DEFER),
        encode: $911b39ee4d517ac3$var$getInnermostProperty(propsList, $911b39ee4d517ac3$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $911b39ee4d517ac3$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $911b39ee4d517ac3$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $911b39ee4d517ac3$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $911b39ee4d517ac3$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $911b39ee4d517ac3$var$getOnChangeClientState(propsList),
        scriptTags: $911b39ee4d517ac3$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $911b39ee4d517ac3$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $911b39ee4d517ac3$var$getTitleFromPropsList(propsList),
        titleAttributes: $911b39ee4d517ac3$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $911b39ee4d517ac3$var$getAnyTrueFromPropsList(propsList, $911b39ee4d517ac3$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $911b39ee4d517ac3$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $911b39ee4d517ac3$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $911b39ee4d517ac3$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($911b39ee4d517ac3$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $911b39ee4d517ac3$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $911b39ee4d517ac3$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $911b39ee4d517ac3$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $911b39ee4d517ac3$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $911b39ee4d517ac3$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $911b39ee4d517ac3$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $911b39ee4d517ac3$var$flattenArray(title);
    return attributeString ? `<${type} ${$911b39ee4d517ac3$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$911b39ee4d517ac3$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$911b39ee4d517ac3$var$HELMET_ATTRIBUTE}="true">${$911b39ee4d517ac3$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $911b39ee4d517ac3$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$911b39ee4d517ac3$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $911b39ee4d517ac3$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$911b39ee4d517ac3$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $911b39ee4d517ac3$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $911b39ee4d517ac3$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $911b39ee4d517ac3$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$911b39ee4d517ac3$var$HELMET_ATTRIBUTE]: true
    };
    const props = $911b39ee4d517ac3$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $911b39ee4d517ac3$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$911b39ee4d517ac3$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $911b39ee4d517ac3$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement(type, mappedTag);
    });
var $911b39ee4d517ac3$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$911b39ee4d517ac3$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$911b39ee4d517ac3$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$911b39ee4d517ac3$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$911b39ee4d517ac3$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$911b39ee4d517ac3$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$911b39ee4d517ac3$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $911b39ee4d517ac3$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $911b39ee4d517ac3$var$prioritizer(metaTags, $911b39ee4d517ac3$var$SEO_PRIORITY_TAGS.meta);
    const link = $911b39ee4d517ac3$var$prioritizer(linkTags, $911b39ee4d517ac3$var$SEO_PRIORITY_TAGS.link);
    const script = $911b39ee4d517ac3$var$prioritizer(scriptTags, $911b39ee4d517ac3$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$911b39ee4d517ac3$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$911b39ee4d517ac3$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$911b39ee4d517ac3$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$911b39ee4d517ac3$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$911b39ee4d517ac3$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$911b39ee4d517ac3$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $911b39ee4d517ac3$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>[],
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $911b39ee4d517ac3$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $911b39ee4d517ac3$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $911b39ee4d517ac3$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $911b39ee4d517ac3$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $911b39ee4d517ac3$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $911b39ee4d517ac3$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $911b39ee4d517ac3$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $911b39ee4d517ac3$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $911b39ee4d517ac3$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $911b39ee4d517ac3$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $911b39ee4d517ac3$var$server_default = $911b39ee4d517ac3$var$mapStateOnServer;
// src/HelmetData.ts
var $911b39ee4d517ac3$var$instances = [];
var $911b39ee4d517ac3$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $911b39ee4d517ac3$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $911b39ee4d517ac3$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $911b39ee4d517ac3$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $911b39ee4d517ac3$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $911b39ee4d517ac3$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $911b39ee4d517ac3$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $911b39ee4d517ac3$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
var $911b39ee4d517ac3$var$major = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).version.split(".")[0], 10);
var $911b39ee4d517ac3$var$isReact19 = $911b39ee4d517ac3$var$major >= 19;
// src/Provider.tsx
var $911b39ee4d517ac3$var$defaultValue = {};
var $911b39ee4d517ac3$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createContext($911b39ee4d517ac3$var$defaultValue);
var $911b39ee4d517ac3$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $4Iuzv.Component) {
    static canUseDOM = $911b39ee4d517ac3$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        if ($911b39ee4d517ac3$var$isReact19) this.helmetData = null;
        else this.helmetData = new $911b39ee4d517ac3$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        if ($911b39ee4d517ac3$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Fragment, null, this.props.children);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($911b39ee4d517ac3$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $911b39ee4d517ac3$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$911b39ee4d517ac3$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                const cssText = tag.cssText;
                newElement.appendChild(document.createTextNode(cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($911b39ee4d517ac3$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $911b39ee4d517ac3$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($911b39ee4d517ac3$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($911b39ee4d517ac3$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($911b39ee4d517ac3$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($911b39ee4d517ac3$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $911b39ee4d517ac3$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $911b39ee4d517ac3$var$flattenArray(title);
    $911b39ee4d517ac3$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $911b39ee4d517ac3$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $911b39ee4d517ac3$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $911b39ee4d517ac3$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $911b39ee4d517ac3$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $911b39ee4d517ac3$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $911b39ee4d517ac3$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $911b39ee4d517ac3$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $911b39ee4d517ac3$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $911b39ee4d517ac3$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $911b39ee4d517ac3$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $911b39ee4d517ac3$var$_helmetCallback = null;
var $911b39ee4d517ac3$var$handleStateChangeOnClient = (newState)=>{
    if ($911b39ee4d517ac3$var$_helmetCallback) cancelAnimationFrame($911b39ee4d517ac3$var$_helmetCallback);
    if (newState.defer) $911b39ee4d517ac3$var$_helmetCallback = requestAnimationFrame(()=>{
        $911b39ee4d517ac3$var$commitTagChanges(newState, ()=>{
            $911b39ee4d517ac3$var$_helmetCallback = null;
        });
    });
    else {
        $911b39ee4d517ac3$var$commitTagChanges(newState);
        $911b39ee4d517ac3$var$_helmetCallback = null;
    }
};
var $911b39ee4d517ac3$var$client_default = $911b39ee4d517ac3$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $911b39ee4d517ac3$var$HelmetDispatcher = class extends (0, $4Iuzv.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($28ad59042aff93bc$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $911b39ee4d517ac3$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const { context: _context, ...props } = instance.props;
            return props;
        }));
        if ($911b39ee4d517ac3$export$4719288a8f5f7e71.canUseDOM) $911b39ee4d517ac3$var$client_default(state);
        else if ($911b39ee4d517ac3$var$server_default) serverState = $911b39ee4d517ac3$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
var $911b39ee4d517ac3$var$react19Instances = [];
var $911b39ee4d517ac3$var$toHtmlAttributes = (props)=>{
    const result = {};
    for (const key of Object.keys(props))result[$911b39ee4d517ac3$var$HTML_TAG_MAP[key] || key] = props[key];
    return result;
};
var $911b39ee4d517ac3$var$toReactProps = (attrs)=>{
    const result = {};
    for (const key of Object.keys(attrs)){
        const mapped = $911b39ee4d517ac3$var$REACT_TAG_MAP[key];
        result[mapped || key] = attrs[key];
    }
    return result;
};
var $911b39ee4d517ac3$var$applyAttributes = (tagName, attributes)=>{
    if (!$911b39ee4d517ac3$var$isDocument) return;
    const el = document.getElementsByTagName(tagName)[0];
    if (!el) return;
    const managedAttr = "data-rh-managed";
    const prev = el.getAttribute(managedAttr);
    const prevKeys = prev ? prev.split(",") : [];
    const nextKeys = Object.keys(attributes);
    for (const key of prevKeys)if (!nextKeys.includes(key)) el.removeAttribute(key);
    for (const key of nextKeys){
        const value = attributes[key];
        if (value === void 0 || value === null || value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else el.setAttribute(key, String(value));
    }
    if (nextKeys.length > 0) el.setAttribute(managedAttr, nextKeys.join(","));
    else el.removeAttribute(managedAttr);
};
var $911b39ee4d517ac3$var$syncAllAttributes = ()=>{
    const htmlAttrs = {};
    const bodyAttrs = {};
    for (const instance of $911b39ee4d517ac3$var$react19Instances){
        const { htmlAttributes: htmlAttributes, bodyAttributes: bodyAttributes } = instance.props;
        if (htmlAttributes) Object.assign(htmlAttrs, $911b39ee4d517ac3$var$toHtmlAttributes(htmlAttributes));
        if (bodyAttributes) Object.assign(bodyAttrs, $911b39ee4d517ac3$var$toHtmlAttributes(bodyAttributes));
    }
    $911b39ee4d517ac3$var$applyAttributes("html" /* HTML */ , htmlAttrs);
    $911b39ee4d517ac3$var$applyAttributes("body" /* BODY */ , bodyAttrs);
};
var $911b39ee4d517ac3$var$React19Dispatcher = class extends (0, $4Iuzv.Component) {
    componentDidMount() {
        $911b39ee4d517ac3$var$react19Instances.push(this);
        $911b39ee4d517ac3$var$syncAllAttributes();
    }
    componentDidUpdate() {
        $911b39ee4d517ac3$var$syncAllAttributes();
    }
    componentWillUnmount() {
        const index = $911b39ee4d517ac3$var$react19Instances.indexOf(this);
        if (index !== -1) $911b39ee4d517ac3$var$react19Instances.splice(index, 1);
        $911b39ee4d517ac3$var$syncAllAttributes();
    }
    resolveTitle() {
        const { title: title, titleTemplate: titleTemplate, defaultTitle: defaultTitle } = this.props;
        if (title && titleTemplate) return titleTemplate.replace(/%s/g, ()=>Array.isArray(title) ? title.join("") : title);
        return title || defaultTitle || void 0;
    }
    renderTitle() {
        const title = this.resolveTitle();
        if (title === void 0) return null;
        const titleAttributes = this.props.titleAttributes || {};
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("title" /* TITLE */ , $911b39ee4d517ac3$var$toReactProps(titleAttributes), title);
    }
    renderBase() {
        const { base: base } = this.props;
        if (!base) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("base" /* BASE */ , $911b39ee4d517ac3$var$toReactProps(base));
    }
    renderMeta() {
        const { meta: meta } = this.props;
        if (!meta || !Array.isArray(meta)) return null;
        return meta.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("meta" /* META */ , {
                key: i,
                ...$911b39ee4d517ac3$var$toReactProps(attrs)
            }));
    }
    renderLink() {
        const { link: link } = this.props;
        if (!link || !Array.isArray(link)) return null;
        return link.map((attrs, i)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("link" /* LINK */ , {
                key: i,
                ...$911b39ee4d517ac3$var$toReactProps(attrs)
            }));
    }
    renderScript() {
        const { script: script } = this.props;
        if (!script || !Array.isArray(script)) return null;
        return script.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $911b39ee4d517ac3$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("script" /* SCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    renderStyle() {
        const { style: style } = this.props;
        if (!style || !Array.isArray(style)) return null;
        return style.map((attrs, i)=>{
            const { cssText: cssText, ...rest } = attrs;
            const props = $911b39ee4d517ac3$var$toReactProps(rest);
            if (cssText) props.dangerouslySetInnerHTML = {
                __html: cssText
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("style" /* STYLE */ , {
                key: i,
                ...props
            });
        });
    }
    renderNoscript() {
        const { noscript: noscript } = this.props;
        if (!noscript || !Array.isArray(noscript)) return null;
        return noscript.map((attrs, i)=>{
            const { innerHTML: innerHTML, ...rest } = attrs;
            const props = $911b39ee4d517ac3$var$toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("noscript" /* NOSCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Fragment, null, this.renderTitle(), this.renderBase(), this.renderMeta(), this.renderLink(), this.renderScript(), this.renderStyle(), this.renderNoscript());
    }
};
// src/index.tsx
var $911b39ee4d517ac3$export$dcef8f9bb9a41431 = class extends (0, $4Iuzv.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($25d1886ae0d69bda$exports)))($911b39ee4d517ac3$var$without(this.props, "helmetData"), $911b39ee4d517ac3$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($784b62d6b0fabae5$exports)))($911b39ee4d517ac3$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$911b39ee4d517ac3$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($784b62d6b0fabae5$exports)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$911b39ee4d517ac3$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $911b39ee4d517ac3$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $911b39ee4d517ac3$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        if ($911b39ee4d517ac3$var$isReact19) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($911b39ee4d517ac3$var$React19Dispatcher, {
            ...newProps
        });
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($911b39ee4d517ac3$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($911b39ee4d517ac3$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement($911b39ee4d517ac3$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $6059f8bddafa7ceb$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $6059f8bddafa7ceb$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $6059f8bddafa7ceb$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $6059f8bddafa7ceb$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $6059f8bddafa7ceb$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $6059f8bddafa7ceb$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $2f09ad858b8c1e5b$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $b19fae0a7807dbac$export$2e2bcd8739ae039 = (0, $4Iuzv.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $4Iuzv.createElement)("svg", {
        ref: ref,
        ...(0, $2f09ad858b8c1e5b$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $6059f8bddafa7ceb$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $6059f8bddafa7ceb$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $4Iuzv.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $aadec6bfdddb2a4a$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $4Iuzv.forwardRef)(({ className: className, ...props }, ref)=>(0, $4Iuzv.createElement)((0, $b19fae0a7807dbac$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $6059f8bddafa7ceb$export$3d46f4579dba46e5)(`lucide-${(0, $6059f8bddafa7ceb$export$73bda83cddbc7187)((0, $6059f8bddafa7ceb$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $6059f8bddafa7ceb$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $1f891ca354fd6960$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $1f891ca354fd6960$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("arrow-right", $1f891ca354fd6960$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0da400c7309ade55$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 18h16",
            key: "19g7jn"
        }
    ],
    [
        "path",
        {
            d: "M4 6h16",
            key: "1o0s65"
        }
    ]
];
const $0da400c7309ade55$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("menu", $0da400c7309ade55$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6ceff59181ea43fa$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $6ceff59181ea43fa$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("x", $6ceff59181ea43fa$export$3efd853dbb351e94);






var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $092d6d02f27aae3b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $092d6d02f27aae3b$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("search", $092d6d02f27aae3b$export$3efd853dbb351e94);


const $646411876a15270d$export$b6aad051bad07f12 = [
    /* --------------------------------------------------------------------------
     NEW CATEGORY 1 — CUSTOM ACOUSTIC & WEATHERPROOF ENCLOSURE
  --------------------------------------------------------------------------- */ {
        category: "Custom Acoustic & Weatherproof Enclosure",
        slug: "custom-acoustic-enclosures",
        type: "direct",
        categoryId: "CAT-CUST-ENCL",
        image: {
            url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_01.webp",
            alt: "Custom-engineered acoustic and weatherproof containers."
        },
        description: "High-performance sound-attenuated and weatherproof housing for critical power infrastructure.",
        items: [
            {
                id: "AGP-CONT-DC-CUSTOM",
                name: "Custom Acoustic & Weatherproof Enclosure",
                manufacturerPartNumber: "Custom-DC-GEN-ENCL",
                AGPPartNumber: "AGP-CONT-XXX",
                Make: "ESI-Art GenPower Solutions Ltd",
                images: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_02.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_03.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_04.webp",
                    "https://media.arcengltd.com/facility-images/Hamriyah_Facility_03.webp",
                    "https://media.arcengltd.com/facility-images/Sajja_Facility_04.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container Layout_ARC_ESI_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container Layout_ARC_ESI_02.webp"
                ],
                shortDescription: "Custom-engineered acoustic and weatherproof containers for data center standby power, rated for critical sound levels and hazardous environments.",
                description: "These heavy-duty generator containers are custom-engineered to provide a secure, climate-controlled environment for mission-critical data center power systems. Designed to meet the highest standards of reliability, our containers feature advanced acoustic insulation to achieve 'critical' sound levels, making them suitable for urban or noise-sensitive environments. Each module is built following rigorous manufacturing procedures and quality inspections. The integrated gas detection and fire suppression systems (CO2 or Water Mist) provide automated protection, while the IP-rated construction ensures that internal electronics remain protected from external contaminants. The structural design is analyzed for client-specific load requirements, ensuring durability for both onshore and offshore applications.",
                uses: [
                    "Mission-critical data center standby power protection",
                    "Urban noise-sensitive power installations",
                    "Hazardous environment (Zone II ATEX) power housing",
                    "Offshore and Onshore heavy-duty engine containment",
                    "High-risk zones requiring certified fire-rated protection"
                ],
                productRange: [
                    {
                        category: "Standard & Custom Containers",
                        options: "Standard ISO & High Cube configurations (20ft, 30ft, & 40ft)"
                    },
                    {
                        category: "Acoustic Enclosures",
                        options: "Custom-built sound-attenuated for Off-Shore & On-Shore"
                    },
                    {
                        category: "Specialized Safety Units",
                        options: "Fully certified Fire Rated Enclosures"
                    },
                    {
                        category: "Compact Solutions",
                        options: "Drop Over Canopies for quick installation"
                    },
                    {
                        category: "Critical Infrastructure",
                        options: "Dedicated Data Center Acoustic Solutions"
                    },
                    {
                        category: "Integration Services",
                        options: "Professional Engine & Alternator Coupling"
                    }
                ],
                details: {
                    EnvironmentalRating: "Weatherproof (Enclosure) / IP rated",
                    AcousticPerformance: "65 - 85 dBA @ 1 Meter (Customizable)",
                    FireSuppression: "Optional CO2 / Water Mist / Integrated Detection",
                    ElectricalCompliance: "Optional Zone II ATEX / IECEx Fittings",
                    FuelSystem: "Single or Double Wall Base Tank",
                    StructuralStandard: "Client-Specific Analysis (Seismic/Wind rated)",
                    Inspections: "Third-Party Certification (ABS, Lloyd\u2019s, etc.)"
                }
            }
        ]
    },
    /* --------------------------------------------------------------------------
     NEW CATEGORY 2 — MODULAR E-HOUSE & E-POD SOLUTIONS
  --------------------------------------------------------------------------- */ {
        category: "Modular E-House & E-POD Solutions",
        slug: "modular-e-house",
        type: "direct",
        categoryId: "CAT-EHOUSE",
        image: {
            url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_01.webp",
            alt: "Prefabricated modular substation for power distribution."
        },
        description: "Complete, plug-and-play power distribution centers for remote and demanding locations.",
        items: [
            {
                id: "AGP-EHOUSE-MOD-001",
                name: "Modular E-House & E-POD Solutions",
                manufacturerPartNumber: "MOD-EHOUSE-OS-OFF",
                AGPPartNumber: "AGP-PWR-EHOUSE",
                Make: "ESI-Art GenPower Solutions Ltd",
                images: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_02.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_03.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_04.webp"
                ],
                shortDescription: "A complete, plug-and-play power distribution center. Our customized E-House modules deliver reliable power infrastructure to the most remote and demanding locations.",
                description: "Our Electrical Houses (E-Houses) and E-PODs are prefabricated, modular substations designed to house critical electrical and automation equipment. Moving away from traditional brick-and-mortar substations, these steel-structure solutions offer a smarter, faster way to deploy power. \n\nEngineered for both Onshore and Offshore applications, our modules provide a controlled environment for sensitive equipment such as MV/LV Switchgears, Variable Frequency Drives (VFDs), and Control Panels. We offer a true One-Stop Solution: we handle the structural manufacturing, system integration (HVAC, F&G, Lighting), and factory testing before the unit ever reaches your site.",
                uses: [
                    "Rapid deployment of power infrastructure in remote sites",
                    "Offshore platform power distribution modules",
                    "Industrial plant substation upgrades with optimized footprint",
                    "Controlled environments for sensitive MV/LV Switchgear",
                    "Mobile power solutions for mining and oil & gas fields"
                ],
                productRange: [
                    {
                        category: "Climate Control",
                        options: "Heavy-duty HVAC systems for extreme desert or marine heat"
                    },
                    {
                        category: "Safety Systems",
                        options: "Integrated Fire & Gas (F&G) detection and suppression"
                    },
                    {
                        category: "Electrical & MEP",
                        options: "Complete internal lighting, small power, and auxiliary panels"
                    },
                    {
                        category: "Structural Integrity",
                        options: "IP55 rated steel enclosures with raised flooring and motorized louvers"
                    },
                    {
                        category: "Scalability",
                        options: "Modular coupling of 20ft/40ft ISO High Cube units"
                    }
                ],
                successStories: [
                    {
                        client: "Saudi Aramco (KSA)",
                        project: "Custom-built substations with HVAC, F&G, and raised flooring"
                    },
                    {
                        client: "Rolls-Royce Solutions (KSA)",
                        project: "4x MV Switchgear containers and 14x Custom Enclosures"
                    },
                    {
                        client: "Bahrain International Airport",
                        project: "E-House with full auxiliary integration"
                    },
                    {
                        client: "Drydocks World (Dubai)",
                        project: "Modularized containers for marine applications with full FAT"
                    }
                ],
                downloads: [
                    {
                        name: "Technical Specifications",
                        url: "#"
                    }
                ],
                details: {
                    ModuleType: "ISO Containerized (20ft/40ft) or Custom Steel Building",
                    Application: "Onshore (Desert/Industrial) & Offshore (Marine)",
                    ProtectionRating: "IP55 / NEMA 4X",
                    FireSafety: "Integrated Smoke/Heat Detection & Gas Suppression",
                    Flooring: "Anti-static Raised Flooring or Chequered Plate",
                    Cooling: "Redundant HVAC Units (Roof or Wall Mounted)",
                    Certifications: "Factory Acceptance Tested (FAT) prior to shipping"
                }
            }
        ]
    },
    /* --------------------------------------------------------------------------
     NEW CATEGORY 3 — PUMP SKIDS & CHEMICAL INJECTION PACKAGES
  --------------------------------------------------------------------------- */ {
        category: "Pump Skids & Chemical Injection Packages",
        slug: "pump-skids-injection",
        type: "direct",
        categoryId: "CAT-PUMP-SKID",
        image: {
            url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_01.webp",
            alt: "Modular pump skid for oil and gas intervention."
        },
        description: "Precision fluid delivery and well intervention solutions for the global energy sector.",
        items: [
            {
                id: "AGP-PUMP-SKID-003",
                name: "Pump Skids & Chemical Injection Packages",
                manufacturerPartNumber: "PUMP-INJ-OG-MOD",
                AGPPartNumber: "AGP-FLUID-INJ",
                Make: "ESI-Art GenPower Solutions Ltd",
                images: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_02.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_03.webp"
                ],
                shortDescription: "Engineered for the demanding Oil & Gas sector, our modular Pump Skids and Injection Packages provide precise fluid delivery and well intervention solutions.",
                description: "Our Pump Skids and Injection Packages are specialized equipment systems designed to support critical operations in various industries, with a primary focus on Oil & Gas Operations. These units are essential for well intervention and stimulation processes. \n\nEach package is engineered as a fully integrated solution, combining high-pressure pumping capabilities with precise chemical dosing systems. Whether you require a standalone injection unit or a complex system integrated with coiled tubing operations, our skids are built to deliver fluids and chemicals into the wellbore safely and efficiently. Designed for mobility and rapid deployment, our systems come mounted on heavy-duty structural steel skids, ensuring they can be easily transported and lifted into position on crowded drill sites or platforms.",
                uses: [
                    "Oil & Gas well stimulation and productivity improvement",
                    "Injection of corrosion inhibitors and biocides",
                    "Downhole fluid delivery for well intervention",
                    "Continuous fluid delivery support for Coiled Tubing units",
                    "High-pressure chemical dosing in harsh environments"
                ],
                productRange: [
                    {
                        category: "System Design",
                        options: "Integrated pumping, metering, and control in a single compact unit"
                    },
                    {
                        category: "Intervention Capability",
                        options: "Engineered for tasks such as well stimulation and downhole delivery"
                    },
                    {
                        category: "Precision Injection",
                        options: "Accurate dosing systems for controlled chemical flow rates"
                    },
                    {
                        category: "Modular Mounting",
                        options: "Robust frames with integrated lifting points for easy transport"
                    },
                    {
                        category: "Materials",
                        options: "High-grade stainless steel components to resist extreme corrosion"
                    }
                ],
                downloads: [
                    {
                        name: "Technical Specifications",
                        url: "#"
                    }
                ],
                details: {
                    PrimaryApplication: "Well Intervention, Stimulation, Chemical Injection",
                    MaxOperatingPressure: "Custom (up to 10,000 PSI / 15,000 PSI)",
                    SkidMaterial: "Heavy-Duty Carbon Steel (Galvanized or Painted)",
                    PipingMaterial: "Stainless Steel (316L) / Duplex / Inconel",
                    ControlSystem: "Manual / PLC Automated / Remote Operation",
                    Compliance: "API Standards / DNV Certified Frames (Offshore)"
                }
            }
        ]
    },
    /* --------------------------------------------------------------------------
     NEW CATEGORY 4 — SELF-BUNDED FUEL STORAGE
  --------------------------------------------------------------------------- */ {
        category: "Self-Bunded Fuel Storage",
        slug: "fuel-storage-tanks",
        type: "direct",
        categoryId: "CAT-FUEL-STORAGE",
        image: {
            url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp",
            alt: "Double-walled fuel storage tanks."
        },
        description: "Premium Acecube 110% self-bunded tanks for safe, compliant fuel storage and transport.",
        items: [
            {
                id: "AGP-FUEL-ACECUBE-004",
                name: "Self-Bunded Fuel Storage",
                manufacturerPartNumber: "AC-SB-FUEL-SERIES",
                AGPPartNumber: "AGP-FUEL-TANKS",
                Make: "Acecube / ESI-Art GenPower Solutions Ltd",
                images: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp"
                ],
                shortDescription: "Premium range of Acecube fuel tanks offering 110% self-bunded (double-walled) design for safe, compliant onsite fuel storage and transport in any environment.",
                description: "Our premium range of Acecube fuel tanks offers the ultimate solution for safe onsite fuel storage and transport. Featuring a 110% self-bunded (double-walled) design, these tanks ensure zero environmental contamination while maximizing durability and ease of use.\n\nFrom construction sites to offshore platforms, these tanks are engineered with a unique Hex-Corner Design for added structural strength and impact resistance. The smart engineering includes a removable inner tank for easy maintenance and a 'Letter Box' opening that allows fuel hoses to run while the cabinet remains securely locked and pressurized. Built to be stackable (up to 3-high empty) and easily maneuverable via bi-directional forklift pockets.",
                uses: [
                    "Secure onsite fuel storage for construction and mining",
                    "Auxiliary fuel supply for standby power generators",
                    "DNV 2.7-1 certified fuel transport for offshore platforms",
                    "Agricultural and industrial bulk fuel management",
                    "Remote site refueling with integrated pump dispensing"
                ],
                productRange: [
                    {
                        category: "Standard Series",
                        options: "Industry standard for general construction (950L - 10,000L)"
                    },
                    {
                        category: "Versatile Series",
                        options: "Enhanced life with galvanized hatch lids and corners (950L - 10,000L)"
                    },
                    {
                        category: "All-Terrain Series",
                        options: "Fully galvanized frame for extreme rust protection (Up to 60,000L)"
                    },
                    {
                        category: "Offshore Series",
                        options: "DNV 2.7-1 Certified with heavy-duty side frames (950L - 3,000L)"
                    },
                    {
                        category: "Bulk / ISO Solutions",
                        options: "CSC regulated containers with bund leak detection (20kL, 27kL, 60kL)"
                    }
                ],
                downloads: [
                    {
                        name: "Technical Specifications",
                        url: "#"
                    }
                ],
                details: {
                    Certifications: "UL 142, ULC S-601, UN/ADR 31AY, BS 799",
                    EnvironmentalCompliance: "PPG2 Compliant (110% Spill Prevention)",
                    StructuralDesign: "Hex-Corner Design with Stacking Corners",
                    LidSystem: "Pitched Outer Lid (Anti-rain accumulation)",
                    Security: "Lockable Primary & Secondary Hatches",
                    PumpCompatibility: "Mounting brackets included; Optional AC/DC Dispenser",
                    SafetyFeatures: "Emergency Vents & Optional Bund Leak Detector",
                    Handling: "Bi-directional Forklift Pockets & Corner Lifting Lugs"
                }
            }
        ]
    }
];



const $b46b4777f8e149b0$var$HeaderSearch = ()=>{
    const [query, setQuery] = (0, $4Iuzv.useState)("");
    const [results, setResults] = (0, $4Iuzv.useState)([]);
    const [highlightedIndex, setHighlightedIndex] = (0, $4Iuzv.useState)(-1);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const searchRef = (0, $4Iuzv.useRef)(null);
    (0, $4Iuzv.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setResults([]);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const handleSearchChange = (e)=>{
        const value = e.target.value;
        setQuery(value);
        setHighlightedIndex(-1);
        if (value.trim().length < 1) {
            setResults([]);
            return;
        }
        // Performance: Memoize this if your product list grows significantly
        const allItems = (0, $646411876a15270d$export$b6aad051bad07f12).flatMap((category)=>{
            const items = category.items || [];
            const subItems = category.subCategories?.flatMap((sub)=>sub.items || []) || [];
            return [
                ...items,
                ...subItems
            ].map((item)=>({
                    ...item,
                    categorySlug: category.slug
                }));
        });
        const filtered = allItems.filter((item)=>{
            const searchTerm = value.toLowerCase();
            return item.name?.toLowerCase().includes(searchTerm) || item.manufacturerPartNumber?.toLowerCase().includes(searchTerm);
        });
        setResults(filtered.slice(0, 5));
    };
    const handleSelect = (item)=>{
        setQuery("");
        setResults([]);
        setHighlightedIndex(-1);
        navigate(`/products/${item.categorySlug}/${item.id}`);
    };
    const handleSearchSubmit = (e)=>{
        if (e) e.preventDefault(); // SEO: Prevent page reload on form submit
        if (query.trim()) {
            navigate(`/search/${encodeURIComponent(query)}`);
            setResults([]);
        }
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter") {
            if (highlightedIndex >= 0 && results.length > 0) handleSelect(results[highlightedIndex]);
            else handleSearchSubmit();
        } else if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prev)=>prev < results.length - 1 ? prev + 1 : 0);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prev)=>prev > 0 ? prev - 1 : results.length - 1);
        } else if (e.key === "Escape") setResults([]);
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        ref: searchRef,
        className: "relative flex items-center",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("form", {
            role: "search",
            onSubmit: handleSearchSubmit,
            className: "relative w-full group",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("label", {
                    htmlFor: "product-search",
                    className: "sr-only",
                    children: "Search industrial products"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                    id: "product-search",
                    type: "search" // Use type="search" for mobile keyboard optimization
                    ,
                    placeholder: "Search items...",
                    autoComplete: "off",
                    className: "pl-4 pr-10 py-2 bg-white/20 text-white placeholder-white/70 rounded-full border border-white/20 shadow-sm focus:outline-none focus:ring-2 focus:ring-[#BF092F] focus:bg-white focus:text-[#44444E] transition-all duration-300 w-28 lg:w-48 xl:w-90 hover:bg-white/20 hover:border-white/40",
                    value: query,
                    onChange: handleSearchChange,
                    onKeyDown: handleKeyDown,
                    "aria-label": "Search products and technical specifications",
                    "aria-autocomplete": "list",
                    "aria-expanded": results.length > 0,
                    "aria-owns": "search-results-list"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                    type: "submit",
                    "aria-label": "Submit search",
                    className: "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer p-1 hover:bg-black/10 rounded-full transition-colors",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $092d6d02f27aae3b$export$2e2bcd8739ae039), {
                        className: "text-white/70 w-4 h-4 transition-colors duration-300 group-focus-within:text-[#44444E]"
                    })
                }),
                results.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("ul", {
                    id: "search-results-list",
                    role: "listbox",
                    className: "absolute z-[120] w-full bg-white shadow-2xl rounded-2xl mt-3 py-2 border border-gray-100 overflow-hidden animate-in fade-in zoom-in duration-200",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                            className: "px-4 py-1 text-[9px] font-bold text-[#44444E]/40 uppercase tracking-[0.2em] mb-1",
                            role: "presentation",
                            children: "Quick Matches"
                        }),
                        results.map((item, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                role: "option",
                                "aria-selected": highlightedIndex === index,
                                onClick: ()=>handleSelect(item),
                                className: `px-4 py-3 cursor-pointer transition-all duration-300 flex flex-col group ${highlightedIndex === index ? "bg-[#BF092F] text-white" : "hover:bg-gray-100 text-[#44444E]"}`,
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: `text-[10px] font-bold uppercase tracking-wider ${highlightedIndex === index ? "text-white" : "text-[#BF092F]"}`,
                                        children: item.manufacturerPartNumber
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: `text-[11px] font-medium ${highlightedIndex === index ? "text-white/90" : "text-[#44444E]/80"}`,
                                        children: item.name
                                    })
                                ]
                            }, item.id))
                    ]
                })
            ]
        })
    });
};
var $b46b4777f8e149b0$export$2e2bcd8739ae039 = $b46b4777f8e149b0$var$HeaderSearch;




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $14fb50132973b304$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $14fb50132973b304$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("chevron-down", $14fb50132973b304$export$3efd853dbb351e94);


const $1d8abed9f39d100d$export$135a7dba28bbc197 = [
    {
        id: "blaby-leicester",
        title: "UK - Blaby Facility",
        desc: "A specialized assembly and integration hub focused on high-specification industrial enclosures and modular power solution configuration.",
        location: "W3 Winchester Avenue, Blaby, Leicester, LE8 4GZ, UK",
        totalArea: "6,210 sq.ft",
        productionCapacity: "Up to 900 tons annually",
        highlights: [
            "Dedicated floor space for modular enclosure fit-outs and wiring",
            "Specialized assembly bays for custom industrial equipment integration",
            "Robust electrical infrastructure supporting testing of finished enclosure units",
            "System-level testing capabilities for complex power and control assemblies"
        ],
        facilityImg: [
            "https://media.arcengltd.com/facility-images/Blaby_Facility_01.webp",
            "https://media.arcengltd.com/facility-images/Blaby_Facility_09.webp",
            "https://media.arcengltd.com/facility-images/Blaby_Facility_07.webp",
            "https://media.arcengltd.com/facility-images/Blaby_Facility_08.webp"
        ],
        capabilityImg: [
            {
                img: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp",
                title: "Enclosure Integration & Wiring",
                desc: "Equipped for the precision installation of control systems, switchgear, and internal components within industrial enclosures."
            },
            {
                img: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp",
                title: "System Testing & Final QC",
                desc: "Designated area for rigorous electrical and functional testing of finished units prior to deployment."
            }
        ]
    },
    {
        id: "hamriyah",
        title: "UAE - Hamriyah Facility",
        desc: "State-of-the-art manufacturing facility equipped with advanced machinery for precision engineering and metal fabrication.",
        location: "Hamriyah Free Zone, Sharjah",
        totalArea: "120,000 sq.ft",
        productionCapacity: "Up to 1,800 tons annually",
        highlights: [
            "Advanced CNC machinery and welding stations",
            "In-house blasting and painting booth",
            "ISO-certified quality systems",
            "Specialized fabrication for power and industrial sectors"
        ],
        facilityImg: [
            "https://media.arcengltd.com/facility-images/Hamriyah_Facility_04.webp",
            "https://media.arcengltd.com/facility-images/Hamriyah_Facility_07.webp",
            "https://media.arcengltd.com/facility-images/Hamriyah_Facility_05.webp",
            "https://media.arcengltd.com/facility-images/Hamriyah_Facility_03.webp",
            "https://media.arcengltd.com/facility-images/Hamriyah_Facility_06.webp",
            "https://media.arcengltd.com/facility-images/Hamriyah_Facility_01.webp",
            "https://media.arcengltd.com/facility-images/Hamriyah_Facility_02.webp"
        ],
        capabilityImg: [
            {
                img: "https://media.arcengltd.com/facility-images/Hamriyah_Facility_Capability_01.webp",
                title: "Shearing Machine",
                desc: "High-precision shearing machine for accurate cutting of industrial-grade steel sheets."
            },
            {
                img: "https://media.arcengltd.com/facility-images/Hamriyah_Facility_Capability_02.webp",
                title: "CNC Plasma Cutter",
                desc: "CNC-controlled plasma cutting machine for complex shapes and heavy-duty cuts."
            },
            {
                img: "https://media.arcengltd.com/facility-images/Hamriyah_Facility_Capability_03.webp",
                title: "Bending Machine",
                desc: "Automated bending machine for precision-formed metal structures."
            }
        ]
    },
    {
        id: "sajja",
        title: "UAE - Sajja Facility",
        desc: "Modern production center featuring cutting-edge technology for industrial solutions and high-quality manufacturing processes.",
        location: "Sajja Industrial Area, Sharjah",
        totalArea: "85,000 sq.ft",
        productionCapacity: "Up to 1,200 tons annually",
        highlights: [
            "Dedicated assembly and testing area",
            "Heavy-duty fabrication bays",
            "High-efficiency workflow layout",
            "Advanced QA/QC inspection tools"
        ],
        facilityImg: [
            "https://media.arcengltd.com/facility-images/Sajja_Facility_03.webp",
            "https://media.arcengltd.com/facility-images/Sajja_Facility_04.webp",
            "https://media.arcengltd.com/facility-images/Sajja_Facility_02.webp",
            "https://media.arcengltd.com/facility-images/Sajja_Facility_01.webp"
        ],
        capabilityImg: [
            {
                img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_04.webp",
                title: "Heavy-Duty Welding Stations",
                desc: "Multiple welding lines equipped for large-scale industrial fabrication."
            },
            {
                img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_02.webp",
                title: "CNC Machining Zone",
                desc: "Advanced CNC units for machining with high repeatability and precision."
            },
            {
                img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_03.webp",
                title: "Assembly & Integration Area",
                desc: "Designated space for assembling complete power systems and industrial units."
            },
            {
                img: "https://media.arcengltd.com/facility-images/Sajja_Facility_Capability_01.webp",
                title: "QA/QC Inspection Tools",
                desc: "Fully equipped testing and inspection area ensuring reliability and compliance."
            }
        ]
    }
];



const $0eb0343417ecc711$var$HeaderFacilitiesDropdown = ()=>{
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const [activeFacilityId, setActiveFacilityId] = (0, $4Iuzv.useState)((0, $1d8abed9f39d100d$export$135a7dba28bbc197)[0]?.id);
    const currentFacility = (0, $1d8abed9f39d100d$export$135a7dba28bbc197).find((f)=>f.id === activeFacilityId) || (0, $1d8abed9f39d100d$export$135a7dba28bbc197)[0];
    const HoverEffect = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute inset-0 bg-white/10 backdrop-blur-lg rounded-xl scale-50 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] -z-10 border border-white/20 shadow-xl",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-[1.5px] bg-white group-hover:w-1/4 transition-all duration-300 ease-out rounded-full",
                    "aria-hidden": "true"
                })
            ]
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                to: "/facilities",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                className: "relative cursor-pointer inline-flex items-center tracking-widest text-white hover:text-white transition-all duration-300 px-2 py-2 text-[12px] lg:text-[13px] uppercase font-medium whitespace-nowrap group focus-visible:ring-2 focus-visible:ring-white/50 rounded-lg",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(HoverEffect, {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "absolute inset-0 bg-[#BF092F]/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-20",
                        "aria-hidden": "true"
                    }),
                    "Facilities",
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $14fb50132973b304$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 transition-transform duration-500 group-hover:rotate-180 ml-1",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute left-0 top-full pt-2 w-[550px] opacity-0 translate-y-1 invisible group-hover:opacity-100 group-hover:translate-y-0 group-hover:visible transition-all duration-500 z-50",
                role: "menu",
                "aria-label": "Facilities Submenu",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "bg-white shadow-[0_30px_60px_-15px_rgba(0,0,0,0.3)] rounded-xl border-t-4 border-[#BF092F] overflow-hidden",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-[240px_1fr]",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                                className: "bg-[#44444E] py-6 overflow-y-auto max-h-[400px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
                                "aria-label": "Global Infrastructure Locations",
                                children: (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((f)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                        to: `/facilities/${f.id}`,
                                        onMouseEnter: ()=>setActiveFacilityId(f.id),
                                        className: `cursor-pointer w-full px-6 py-3 text-left transition-all relative block ${activeFacilityId === f.id ? "bg-white text-[#44444E]" : "text-white/60 hover:text-white"}`,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex flex-col",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[11px] tracking-widest uppercase leading-tight",
                                                        children: f.name || f.title
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: `text-[9px] mt-1 ${activeFacilityId === f.id ? "text-gray-400" : "text-white/40"}`,
                                                        children: f.location
                                                    })
                                                ]
                                            }),
                                            activeFacilityId === f.id && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "absolute right-0 top-0 h-full w-1 bg-[#BF092F]"
                                            })
                                        ]
                                    }, f.id))
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                                className: "p-6 flex flex-col justify-center bg-gray-50/30",
                                "aria-live": "polite",
                                children: currentFacility && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "animate-fadeIn space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "aspect-video rounded-xl overflow-hidden border border-[#44444E]/10 bg-white shadow-md",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: currentFacility.facilityImg?.[0] || "/default-facility.jpg",
                                                alt: `Arc Engineering ${currentFacility.title} facility`,
                                                loading: "lazy",
                                                className: "w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[9px] bg-[#BF092F] text-white px-2 py-0.5 rounded-full font-bold uppercase tracking-widest",
                                                    children: "Production Centre"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                    className: "text-[13px] text-[#44444E] font-bold uppercase leading-tight",
                                                    children: currentFacility.title
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                                    className: "text-[10px] text-gray-500 line-clamp-2 leading-relaxed italic",
                                                    children: [
                                                        "Specialized engineering facility in ",
                                                        currentFacility.location,
                                                        "."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                            to: `/facilities/${currentFacility.id}`,
                                            className: "cursor-pointer w-full py-3 bg-[#44444E] text-white text-[10px] font-bold uppercase tracking-widest rounded-lg hover:bg-[#BF092F] transition-colors flex items-center justify-center gap-2 group/btn",
                                            children: [
                                                "View Specifications",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                    size: 12,
                                                    className: "group-hover/btn:translate-x-1 transition-transform",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("style", {
                children: `
        .custom-scrollbar::-webkit-scrollbar { width: 3px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { 
          background: #BF092F30; 
          border-radius: 10px; 
        }
      `
            })
        ]
    });
};
var $0eb0343417ecc711$export$2e2bcd8739ae039 = $0eb0343417ecc711$var$HeaderFacilitiesDropdown;




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b449058101bf1351$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
            key: "usdka0"
        }
    ]
];
const $b449058101bf1351$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("folder-open", $b449058101bf1351$export$3efd853dbb351e94);


const $b68fddb3388eb08a$export$39babdfab504f3da = [
    {
        categoryId: "cat-enclosure",
        categoryName: "Enclosure",
        categoryDescription: "Custom-engineered acoustic and weather-proof enclosures designed for power generation and industrial equipment, featuring advanced noise attenuation and climate control.",
        categoryImage: "https://media.arcengltd.com/project-images/ARC_Enclosure.webp",
        projects: [
            {
                id: "ENC-001",
                name: "20ft Custom Enclosure for C1100D5B",
                client: "Cummins Arabia",
                type: "Enclosure",
                location: "Sajja",
                description: [
                    "Design and Supply of 3 numbers of 20ft. Custom built Enclosure with 2,000 Ltr Single wall Base fuel Tank with instrumentation for C1100D5B Genset (Dimensions, L=6.058 m x W=2.438 m & H=2.890 m) (Noise Level: 85 dB (A) @ 3 m in a free field environment)"
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Arabia_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-002",
                name: "Multi-Capacity Genset Enclosure Series",
                client: "ADNOC",
                type: "Enclosure",
                location: "Sajja",
                description: [
                    "Enclosure for 80KVA Genset:",
                    [
                        "Compact design for small-scale power needs",
                        "Noise reduction features for quiet operation",
                        "Durable construction for long-term reliability"
                    ],
                    "Enclosure for 200KVA Genset:",
                    [
                        "Engineered for medium power requirements",
                        "Integrated ventilation and cooling systems",
                        "Weather-resistant design for outdoor use"
                    ],
                    "Enclosure for 325KVA Genset:",
                    [
                        "Custom-built for specific power needs",
                        "Enhanced noise attenuation features",
                        "Robust structure for harsh environments"
                    ],
                    "Enclosure for 1000KVA Genset:",
                    [
                        "Large-scale power solution with advanced features",
                        "Optimized for high-performance and safety",
                        "Integrated systems for efficient operation and maintenance"
                    ]
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_02.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_03.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ADNOC_04.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-003",
                name: "1250KVA (KTA50G3) High-Acoustic Packaging",
                client: "ENERGIA MTC LLC",
                type: "Enclosure",
                location: "Sajja",
                description: [
                    "Design, Supply and Packaging of 5 nos. of Custom-built Enclosure (L= 8.8 m X W= 2.7 m X H= 3.2 m)  for 1250KVA (KTA50G3) Gensets. Sound level to be achieved 85 dBA @ 1 meter, in free Field Environment with a special paint of C5M."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Energia Webuild_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-004",
                name: "40ft ISO Containerized Enclosure (C1400D5)",
                client: "Cummins",
                type: "Enclosure",
                location: "Sajja",
                description: [
                    "Supply \u2013 2 nos. a 40FT. ISO CONTAINER FOR C1400D5 GENSET. L=12.192 M X W=2.440 M & H=2.8920 M (NOISE LEVEL: 85 DB (A) @ 1.0 M / 70 DB (A) @ 7.0M)- with C4 painting, and delivered to Sashma, South Africa",
                    "Supply of Box type muffler inside the container (MS material) (NOISE LEVEL: 85 DB (A) @ 1.0 M / 70 DB (A) @ 7.0M)",
                    "Supply of 1750LTR single wall day fuel tank with instrumentation (Non Hazardous rated) along with internal piping"
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-005",
                name: "20ft Modified Enclosure & Underbelly Tank",
                client: "KGL Kuwait (Orange Container)",
                type: "Enclosure",
                location: "Sajja",
                description: [
                    "Design Supply 5 numbers to KGL Kuwait the Packaging of 20feet modified Enclosure for C700D5 \u2013 Genset \u2013 1 no. and C640D5 Genset \u2013 4 nos. . Sound level to be achieved 78 dBA @ 3 meter, / 87 dBA @ 1 meter, in free Field Environment with C5M painting",
                    "Supply of 3000LTR single wall underbelly fuel tank with instrumentation (Non Hazardous rated) along with internal piping"
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Orange Container_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-006",
                name: "Oil & Gas Custom Enclosure (C1100D5B)",
                client: "Cummins",
                type: "Enclosure",
                location: "Sajja",
                description: [
                    " Project description: Supply of 6 nos. of Custom built Enclosure for C1100D5B Genset with 2000 ltr Base Fuel Tank Noise- 85 dB(A)@ 1 mtr for Oil and Gas Project"
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_02.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_03.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cummins Enclosure_04.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-007",
                name: "20ft ISO Containerized C900D5 System",
                client: "White Container",
                type: "Enclosure",
                location: "Sajja",
                description: [
                    " Design, engineering, manufacturing, inspection, and installation of a C900D5 genset housed in a custom-built enclosure in a Standard 20ft ISO container. Noise level of 85 dB(A) at 3.0 meters. A 1650-liter single-wall base fuel tank is integrated into the design."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_White Container_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_White Container_02.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-008",
                name: "20ft High Cube Containerized 700KVA",
                client: "Energia - webuild",
                type: "Enclosure",
                location: "Hamriyah",
                description: [
                    "We supplied a 20ft. ISO High Cube (HC) container to ENERGIA, specifically designed to house a 700KVA genset, featuring:",
                    [
                        "Container Dimensions: L=6.058m x W=2.440m x H=2.890m",
                        "Noise Reduction: 85 dB(A) @ 1.0m",
                        "Genset Capacity: 700KVA"
                    ]
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Energia Webuild_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-009",
                name: "Dual Cummins C1250D5A Packaging",
                client: "Engginium",
                type: "Enclosure",
                location: "Hamriyah",
                description: [
                    "We packaged 2 units of Cummins C1250D5A gensets in custom-built enclosures for Engginium, featuring custom design and enhanced acoustic performance."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Engginium Cummins_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-010",
                name: "40ft Fire-Rated Storage & Rack System",
                client: "ACE CRANE",
                type: "Enclosure",
                location: "Hamriyah",
                description: [
                    "40 ft. used container with a 1-hour fire-rated enclosure. Features 10mm thick hot-dip galvanized chequered plate flooring and customized storage racks."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_ACE Cranes_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-011",
                name: "40ft HC Container for C1400D5",
                client: "Car and General (U) Ltd",
                type: "Enclosure",
                location: "Hamriyah",
                description: [
                    "40 ft High Cube (HC) container specifically designed to house the C1400D5 genset, optimized for space and durability."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Car and General (U) Ltd_01.webp"
                ],
                color: "from-black-900 to-black-500"
            },
            {
                id: "ENC-012",
                name: "Offshore Mud Skips & Acid Transporters",
                client: "JAKSON ENERGY SOLUTIONS LLC",
                type: "Enclosure",
                location: "Hamriyah",
                description: [
                    "Offshore equipment including Acid Transporters and Mud Skips for safe handling and transportation in offshore environments."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Projects_Hamriyah_Jackson Energy Solutions LLC_01.webp"
                ],
                color: "from-black-900 to-black-500"
            }
        ]
    },
    {
        categoryId: "cat-ehouse",
        categoryName: "E-House",
        categoryDescription: "Prefabricated, walk-in modular outdoor enclosures to house medium and low voltage switchgear, transformers, and auxiliary equipment.",
        categoryImage: "https://media.arcengltd.com/project-images/ARC_E-House.webp",
        projects: [
            {
                id: "EHS-001",
                name: "Modular Industrial E-House Solution",
                client: "EXPRO",
                type: "E-House",
                location: "Sajja",
                description: [
                    "Our comprehensive E-House solution includes Engineering, Manufacturing, Supply, and Commissioning for industrial and infrastructure projects."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_EXPRO_01.webp"
                ],
                color: "from-black-900 to-black-500"
            }
        ]
    },
    {
        categoryId: "cat-powerpack",
        categoryName: "Power-Pack",
        categoryDescription: "High-performance rental power solutions and specialized containerized engine units designed for rapid deployment and harsh environments.",
        categoryImage: "https://media.arcengltd.com/project-images/ARC_PowerPack_Systems.webp",
        projects: [
            {
                id: "PPK-001",
                name: "Rental Container for KTA 38/50 Series",
                client: "Power Pack",
                type: "Power-Pack",
                location: "Sajja",
                description: [
                    "Designed for KTA 38 and KTA 50 gensets, featuring noise reduction (85 dB) and durable construction for harsh environments."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_02.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_03.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_04.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_05.webp"
                ],
                color: "from-black-900 to-black-500"
            }
        ]
    },
    {
        categoryId: "cat-coolingshelter",
        categoryName: "Cooling-Shelter",
        categoryDescription: "Custom-built active cooling shelters integrated with redundant communication and F&G safety systems for extreme temperatures.",
        categoryImage: "https://media.arcengltd.com/project-images/ARC_Colling-Systems.webp",
        projects: [
            {
                id: "CSL-001",
                name: "Active Cooling Shelter with F&G Safety",
                client: "Dubai Petroleum",
                type: "Cooling-Shelter",
                location: "Sajja",
                description: [
                    "Custom-engineered Active Cooling Shelters with integrated advanced Fire & Gas (F&G) safety systems and redundant communication protocols."
                ],
                imageUrls: [
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cooling Shelter_01.webp",
                    "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_Cooling Shelter_02.webp"
                ],
                color: "from-black-900 to-black-500"
            }
        ]
    }
];



const $ff507c7671cabd1b$var$HeaderProjectsDropdown = ()=>{
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    // 1. Core State
    const projectTypes = (0, $b68fddb3388eb08a$export$39babdfab504f3da).map((cat)=>cat.categoryName);
    const [activeType, setActiveType] = (0, $4Iuzv.useState)(projectTypes[0]);
    const [activeProjectId, setActiveProjectId] = (0, $4Iuzv.useState)((0, $b68fddb3388eb08a$export$39babdfab504f3da)[0]?.projects[0]?.id);
    const activeCategory = (0, $b68fddb3388eb08a$export$39babdfab504f3da).find((cat)=>cat.categoryName === activeType);
    const filteredProjects = activeCategory ? activeCategory.projects : [];
    const currentProject = filteredProjects.find((p)=>p.id === activeProjectId) || filteredProjects[0];
    (0, $4Iuzv.useEffect)(()=>{
        if (filteredProjects?.length > 0) setActiveProjectId(filteredProjects[0].id);
    }, [
        activeType,
        filteredProjects
    ]);
    const HoverEffect = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute inset-0 bg-white/10 backdrop-blur-lg rounded-xl scale-50 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] -z-10 border border-white/20 shadow-xl",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-[1.5px] bg-white group-hover:w-1/4 transition-all duration-300 ease-out rounded-full",
                    "aria-hidden": "true"
                })
            ]
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                to: "/projects",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                className: "relative cursor-pointer inline-flex items-center tracking-widest text-white hover:text-white transition-all duration-300 px-2 py-2 text-[12px] lg:text-[13px] uppercase font-medium whitespace-nowrap group focus-visible:ring-2 focus-visible:ring-white/50 rounded-lg",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(HoverEffect, {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "absolute inset-0 bg-[#BF092F]/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-20",
                        "aria-hidden": "true"
                    }),
                    "Projects",
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $14fb50132973b304$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 transition-transform duration-500 group-hover:rotate-180 ml-1",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute left-[-120px] top-full pt-2 w-[900px] opacity-0 translate-y-1 invisible group-hover:opacity-100 group-hover:translate-y-0 group-hover:visible transition-all duration-500 z-50",
                role: "menu",
                "aria-label": "Project Portfolio Submenu",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "bg-white shadow-[0_30px_60px_-15px_rgba(0,0,0,0.3)] rounded-xl border-t-4 border-[#BF092F] overflow-hidden",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-[260px_1fr_300px]",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                                className: "bg-[#44444E] py-6 overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
                                "aria-label": "Portfolio Categories",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                    className: "flex flex-col w-full",
                                    role: "list",
                                    children: projectTypes.map((type)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                            role: "none",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                to: `/projects?type=${encodeURIComponent(type)}`,
                                                onMouseEnter: ()=>setActiveType(type),
                                                className: `cursor-pointer block w-full px-6 py-4 text-left transition-all relative ${activeType === type ? "bg-white text-[#44444E]" : "text-white/60 hover:text-white"}`,
                                                title: `View ${type} Engineering Projects`,
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[11px]  tracking-widest uppercase leading-tight",
                                                        children: type
                                                    }),
                                                    activeType === type && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "absolute right-0 top-0 h-full w-1 bg-[#BF092F]",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }, type))
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "relative p-8 bg-white border-r border-[#44444E]/10",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h4", {
                                        className: "text-[10px] text-[#BF092F] font-bold tracking-[0.2em] uppercase mb-6 flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b449058101bf1351$export$2e2bcd8739ae039), {
                                                size: 12,
                                                "aria-hidden": "true"
                                            }),
                                            activeType,
                                            " Portfolio"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "relative group/list",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "max-h-[380px] overflow-y-auto pr-2 custom-scrollbar",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                                    className: "flex flex-col gap-1 pb-10",
                                                    role: "list",
                                                    children: filteredProjects.map((project)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                            role: "none",
                                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                                to: `/projects/${project.id}`,
                                                                onMouseEnter: ()=>setActiveProjectId(project.id),
                                                                className: `cursor-pointer group flex items-center justify-between p-3 rounded-lg transition-all text-left ${activeProjectId === project.id ? "bg-[#BF092F]/5 shadow-sm" : "hover:bg-[#44444E]/5"}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                        className: "flex flex-col",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                                className: `text-[11px] uppercase tracking-wide transition-colors ${activeProjectId === project.id ? "text-[#BF092F] font-bold" : "text-[#44444E]"}`,
                                                                                children: project.name
                                                                            }),
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                                className: "text-[9px] text-gray-400 mt-0.5 font-medium",
                                                                                children: project.client
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                                        size: 12,
                                                                        className: `transition-all ${activeProjectId === project.id ? "opacity-100 translate-x-0 text-[#BF092F]" : "opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 text-[#BF092F]"}`,
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            })
                                                        }, project.id))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white via-white/80 to-transparent pointer-events-none",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                                className: "p-6 flex flex-col justify-center bg-gray-50/30 overflow-hidden",
                                "aria-live": "polite",
                                children: currentProject ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "animate-fadeIn space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "aspect-square rounded-xl overflow-hidden border border-[#44444E]/10 bg-white shadow-md",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: currentProject.imageUrls?.[0] || "/project-placeholder.jpg",
                                                // SEO: Contextual alt text with location or brand keywords
                                                alt: `Case Study: ${currentProject.name} engineering project by Arc Engineering Solutions Ltd`,
                                                loading: "lazy",
                                                width: "250",
                                                height: "250",
                                                className: "w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[9px] bg-[#BF092F] text-white px-2 py-0.5 rounded-full font-bold uppercase tracking-widest",
                                                    children: "Engineering Case Study"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                    className: "text-[13px] text-[#44444E] font-bold uppercase leading-tight",
                                                    children: currentProject.name
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-[10px] text-gray-500 line-clamp-2 leading-relaxed font-medium",
                                                    children: currentProject.description || `Successful deployment of ${currentProject.name} for ${currentProject.client || 'international infrastructure'}.`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                            to: `/projects/${currentProject.id}`,
                                            className: "cursor-pointer w-full py-3 bg-[#44444E] text-white text-[10px] font-bold uppercase tracking-widest rounded-lg hover:bg-[#BF092F] transition-colors flex items-center justify-center gap-2 group/btn",
                                            children: [
                                                "View Project Details",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                    size: 12,
                                                    className: "group-hover/btn:translate-x-1 transition-transform",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "text-center text-gray-400 text-[10px] uppercase font-bold",
                                    children: "Select a project to view details"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("style", {
                children: `
        .custom-scrollbar::-webkit-scrollbar { width: 3px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #44444E20; border-radius: 10px; }
        .custom-scrollbar:hover::-webkit-scrollbar-thumb { background: #BF092F50; }
      `
            })
        ]
    });
};
var $ff507c7671cabd1b$export$2e2bcd8739ae039 = $ff507c7671cabd1b$var$HeaderProjectsDropdown;




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $07349137581ac83e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12h-8",
            key: "1bmf0i"
        }
    ],
    [
        "path",
        {
            d: "M21 6H8",
            key: "1pqkrb"
        }
    ],
    [
        "path",
        {
            d: "M21 18h-8",
            key: "1tm79t"
        }
    ],
    [
        "path",
        {
            d: "M3 6v4c0 1.1.9 2 2 2h3",
            key: "1ywdgy"
        }
    ],
    [
        "path",
        {
            d: "M3 10v6c0 1.1.9 2 2 2h3",
            key: "2wc746"
        }
    ]
];
const $07349137581ac83e$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("list-tree", $07349137581ac83e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b123b081500fb353$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
            key: "1a0edw"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ]
];
const $b123b081500fb353$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("package", $b123b081500fb353$export$3efd853dbb351e94);




const $e227ff8b694a9b10$var$HeaderProductsDropDown = ()=>{
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    // 1. Core State
    const [activeCategorySlug, setActiveCategorySlug] = (0, $4Iuzv.useState)((0, $646411876a15270d$export$b6aad051bad07f12)[0]?.slug);
    const [activeSubOrItem, setActiveSubOrItem] = (0, $4Iuzv.useState)(null);
    const currentCategory = (0, $646411876a15270d$export$b6aad051bad07f12).find((p)=>p.slug === activeCategorySlug);
    const hasSubCategories = currentCategory?.subCategories?.length > 0;
    const displayList = hasSubCategories ? currentCategory.subCategories : currentCategory.items;
    (0, $4Iuzv.useEffect)(()=>{
        if (displayList?.length > 0) setActiveSubOrItem(displayList[0]);
    }, [
        activeCategorySlug,
        displayList
    ]);
    const getPreviewImage = ()=>{
        if (hasSubCategories && activeSubOrItem?.image?.url) return activeSubOrItem.image.url;
        if (!hasSubCategories && activeSubOrItem?.images?.[0]) return activeSubOrItem.images[0];
        return currentCategory?.image?.url || "https://placehold.co/600x400?text=Arc+Engineering";
    };
    const HoverEffect = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute inset-0 bg-white/10 backdrop-blur-lg rounded-xl scale-50 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] -z-10 border border-white/20 shadow-xl",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-[1.5px] bg-white group-hover:w-1/4 transition-all duration-300 ease-out rounded-full",
                    "aria-hidden": "true"
                })
            ]
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "relative group",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                to: "/products",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                className: "relative cursor-pointer inline-flex items-center tracking-widest text-white hover:text-white transition-all duration-300 px-2 py-2 text-[12px] lg:text-[13px] uppercase font-medium whitespace-nowrap group focus-visible:ring-2 focus-visible:ring-white/50 rounded-lg",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(HoverEffect, {}),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "absolute inset-0 bg-[#BF092F]/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 -z-20",
                        "aria-hidden": "true"
                    }),
                    "Products",
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $14fb50132973b304$export$2e2bcd8739ae039), {
                        className: "w-4 h-4 transition-transform duration-500 group-hover:rotate-180 ml-1",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute left-[-120px] top-full pt-2 w-[900px] opacity-0 translate-y-1 invisible group-hover:opacity-100 group-hover:translate-y-0 group-hover:visible transition-all duration-500 z-50",
                role: "menu",
                "aria-label": "Products Mega Menu",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "bg-white shadow-[0_30px_60px_-15px_rgba(0,0,0,0.3)] rounded-xl border-t-4 border-[#BF092F] overflow-hidden",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-[260px_1fr_300px]",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                                className: "bg-[#44444E] py-6 overflow-y-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
                                "aria-label": "Main Product Categories",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                    className: "flex flex-col w-full",
                                    role: "list",
                                    children: (0, $646411876a15270d$export$b6aad051bad07f12).map((cat)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                            role: "none",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                to: `/products?category=${cat.slug}`,
                                                onMouseEnter: ()=>setActiveCategorySlug(cat.slug),
                                                className: `cursor-pointer block w-full px-6 py-4 text-left transition-all relative ${activeCategorySlug === cat.slug ? "bg-white text-[#44444E]" : "text-white/60 hover:text-white"}`,
                                                title: `Browse ${cat.category} Solutions`,
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[11px]  tracking-widest uppercase leading-tight",
                                                        children: cat.category
                                                    }),
                                                    activeCategorySlug === cat.slug && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "absolute right-0 top-0 h-full w-1 bg-[#BF092F]",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        }, cat.slug))
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "relative p-8 bg-white border-r border-[#44444E]/10",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h4", {
                                        className: "text-[10px] text-[#BF092F] font-bold tracking-[0.2em] uppercase mb-6 flex items-center gap-2",
                                        children: [
                                            hasSubCategories ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $07349137581ac83e$export$2e2bcd8739ae039), {
                                                size: 12,
                                                "aria-hidden": "true"
                                            }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b123b081500fb353$export$2e2bcd8739ae039), {
                                                size: 12,
                                                "aria-hidden": "true"
                                            }),
                                            hasSubCategories ? "Technical Classifications" : "Product Range"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "max-h-[380px] overflow-y-auto pr-2 custom-scrollbar",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                            className: "flex flex-col gap-1 pb-10",
                                            role: "list",
                                            children: displayList?.map((item, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                    role: "none",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                        to: hasSubCategories ? `/products?category=${item.slug}` : `/products/${currentCategory.slug}/${item.id}`,
                                                        onMouseEnter: ()=>setActiveSubOrItem(item),
                                                        className: `cursor-pointer group flex items-center justify-between p-3 rounded-lg transition-all text-left ${activeSubOrItem?.name === item.name ? "bg-[#BF092F]/5 shadow-sm" : "hover:bg-[#44444E]/5"}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                className: "flex flex-col",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                        className: `text-[11px] uppercase tracking-wide transition-colors ${activeSubOrItem?.name === item.name ? "text-[#BF092F] font-bold" : "text-[#44444E]"}`,
                                                                        children: item.name
                                                                    }),
                                                                    item.items && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                                        className: "text-[9px] text-gray-400 mt-0.5 font-medium",
                                                                        children: [
                                                                            item.items.length,
                                                                            " Engineering Units"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: activeSubOrItem?.name === item.name ? "text-[#BF092F] translate-x-0" : "opacity-0 -translate-x-2",
                                                                "aria-hidden": "true"
                                                            })
                                                        ]
                                                    })
                                                }, item.slug || item.id || idx))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent pointer-events-none",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                                className: "p-6 flex flex-col justify-center bg-gray-50/30",
                                "aria-live": "polite",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "animate-fadeIn space-y-4",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "aspect-square rounded-xl overflow-hidden border border-[#44444E]/10 bg-white shadow-md",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: getPreviewImage(),
                                                // SEO: Context-rich dynamic alt tags
                                                alt: `${activeSubOrItem?.name} - Arc Engineering Solutions Ltd industrial power equipment module`,
                                                loading: "lazy",
                                                width: "250",
                                                height: "250",
                                                className: "w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "space-y-2",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[9px] bg-[#BF092F] text-white px-2 py-0.5 rounded-full font-bold uppercase tracking-widest",
                                                    children: hasSubCategories ? "Range Overview" : "Technical Detail"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                    className: "text-[13px] text-[#44444E] font-bold uppercase leading-tight",
                                                    children: activeSubOrItem?.name
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-[10px] text-gray-500 line-clamp-3 leading-relaxed font-medium",
                                                    children: activeSubOrItem?.description || activeSubOrItem?.shortDescription || `Specialized ${activeSubOrItem?.name || "engineering module"} designed for mission-critical UK and international infrastructure.`
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                            to: hasSubCategories ? `/products?category=${activeSubOrItem?.slug}` : `/products/${currentCategory.slug}/${activeSubOrItem?.id}`,
                                            className: "cursor-pointer w-full py-3 bg-[#44444E] text-white text-[10px] font-bold uppercase tracking-widest rounded-lg hover:bg-[#BF092F] transition-colors flex items-center justify-center gap-2 group/btn",
                                            children: [
                                                "Technical Specifications",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                    size: 12,
                                                    className: "group-hover/btn:translate-x-1 transition-transform",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("style", {
                children: `
        .custom-scrollbar::-webkit-scrollbar { width: 3px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #BF092F30; border-radius: 10px; }
      `
            })
        ]
    });
};
var $e227ff8b694a9b10$export$2e2bcd8739ae039 = $e227ff8b694a9b10$var$HeaderProductsDropDown;




var $4Iuzv = parcelRequire("4Iuzv");



const $0561781ac87dfa67$var$MobileHeaderSearch = ({ onSelect: onSelect })=>{
    const [query, setQuery] = (0, $4Iuzv.useState)("");
    const [results, setResults] = (0, $4Iuzv.useState)([]);
    const [activeIndex, setActiveIndex] = (0, $4Iuzv.useState)(-1);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const searchRef = (0, $4Iuzv.useRef)(null);
    (0, $4Iuzv.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (searchRef.current && !searchRef.current.contains(event.target)) setResults([]);
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);
    const handleSearchChange = (e)=>{
        const value = e.target.value;
        setQuery(value);
        setActiveIndex(-1); // Reset highlight when typing
        if (value.trim().length < 1) {
            setResults([]);
            return;
        }
        const allItems = (0, $646411876a15270d$export$b6aad051bad07f12).flatMap((c)=>c.type === "parent" ? c.subCategories.flatMap((s)=>(s.items || []).map((i)=>({
                        ...i,
                        categorySlug: s.slug
                    }))) : (c.items || []).map((i)=>({
                    ...i,
                    categorySlug: c.slug
                })));
        const filtered = allItems.filter((i)=>i.name?.toLowerCase().includes(value.toLowerCase()) || i.manufacturerPartNumber?.toLowerCase().includes(value.toLowerCase()));
        setResults(filtered.slice(0, 5));
    };
    // --- NEW KEYBOARD LOGIC ---
    const handleKeyDown = (e)=>{
        if (results.length === 0) return;
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveIndex((prev)=>prev < results.length - 1 ? prev + 1 : prev);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setActiveIndex((prev)=>prev > 0 ? prev - 1 : -1);
        } else if (e.key === "Enter" && activeIndex !== -1) {
            e.preventDefault();
            handleSelect(results[activeIndex]);
        }
    };
    // ---------------------------
    const handleSearchSubmit = (e)=>{
        if (e) e.preventDefault();
        // If user presses Enter without highlighting an item, perform general search
        if (activeIndex === -1 && query.trim()) {
            if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
            navigate(`/search/${encodeURIComponent(query)}`);
            setResults([]);
            if (onSelect) onSelect();
        }
    };
    const handleSelect = (item)=>{
        navigate(`/products/${item.categorySlug}/${item.id}`);
        setQuery("");
        setResults([]);
        if (onSelect) onSelect();
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        ref: searchRef,
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("form", {
                onSubmit: handleSearchSubmit,
                role: "search",
                action: "/search",
                method: "get",
                className: "relative group",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("label", {
                        htmlFor: "mobile-search-input",
                        className: "sr-only",
                        children: "Search Engineering Products & Parts"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "relative flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                                id: "mobile-search-input",
                                name: "q",
                                type: "search",
                                value: query,
                                onChange: handleSearchChange,
                                onKeyDown: handleKeyDown,
                                placeholder: "SEARCH REGISTRY...",
                                autoComplete: "off",
                                className: "w-full bg-white/5 border border-white/10 rounded-2xl py-4 pl-12 pr-12 text-white text-lg font-bold placeholder:text-white/20 focus:outline-none focus:border-[#BF092F] focus:bg-white/10 transition-all",
                                "aria-label": "Search Arc Engineering Products",
                                "aria-autocomplete": "list",
                                "aria-expanded": results.length > 0,
                                "aria-controls": "mobile-search-results"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $092d6d02f27aae3b$export$2e2bcd8739ae039), {
                                className: "absolute left-4 w-5 h-5 text-white/30",
                                "aria-hidden": "true"
                            }),
                            query && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setQuery("");
                                    setResults([]);
                                },
                                className: "absolute right-4 p-2 text-white/40 hover:text-white",
                                "aria-label": "Clear search input",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6ceff59181ea43fa$export$2e2bcd8739ae039), {
                                    size: 20,
                                    "aria-hidden": "true"
                                })
                            })
                        ]
                    })
                ]
            }),
            results.length > 0 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                id: "mobile-search-results",
                role: "listbox",
                className: "absolute z-[120] w-full bg-[#2A2A32]/98 backdrop-blur-xl mt-3 rounded-2xl overflow-hidden border border-white/10 shadow-2xl",
                children: results.map((item, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                        role: "none",
                        className: "border-b border-white/5 last:border-0",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                            to: `/products/${item.categorySlug}/${item.id}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                handleSelect(item);
                            },
                            className: `block px-6 py-4 cursor-pointer transition-all duration-300 ${activeIndex === idx ? "bg-[#BF092F] text-white" : "text-white/70"}`,
                            role: "option",
                            "aria-selected": activeIndex === idx,
                            title: `View details for ${item.name}`,
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col gap-0.5 pointer-events-none",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: `block text-[9px] font-black tracking-[0.2em] uppercase ${activeIndex === idx ? "text-white" : "text-[#BF092F]"}`,
                                        children: item.manufacturerPartNumber
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-sm font-bold leading-tight",
                                        children: item.name
                                    })
                                ]
                            })
                        })
                    }, item.id))
            })
        ]
    });
};
var $0561781ac87dfa67$export$2e2bcd8739ae039 = $0561781ac87dfa67$var$MobileHeaderSearch;




var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $604caf45884f5678$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 18-6-6 6-6",
            key: "1wnfg3"
        }
    ]
];
const $604caf45884f5678$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("chevron-left", $604caf45884f5678$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $66bbb33cdbaad554$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 10 5 5-5 5",
            key: "qqa56n"
        }
    ],
    [
        "path",
        {
            d: "M4 4v7a4 4 0 0 0 4 4h12",
            key: "z08zvw"
        }
    ]
];
const $66bbb33cdbaad554$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("corner-down-right", $66bbb33cdbaad554$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $572e082078ef0c98$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
            key: "1kt360"
        }
    ]
];
const $572e082078ef0c98$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("folder", $572e082078ef0c98$export$3efd853dbb351e94);



const $a7e2fcca7151b667$var$ProductsMobileDrawer = ({ isOpen: isOpen, onClose: onClose, onCloseAll: onCloseAll })=>{
    const [expandedCat, setExpandedCat] = (0, $4Iuzv.useState)(null);
    // SEO: Removed 'if (!isOpen) return null' 
    // We use CSS classes to hide/show so the links remain in the DOM for crawlers.
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `fixed inset-0 z-[130] bg-[#44444E] transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${isOpen ? "translate-x-0 opacity-100 visible" : "translate-x-full opacity-0 invisible"}`,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Product Categories Menu",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "h-full pt-28 flex flex-col relative",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "px-8 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                onClick: onClose,
                                className: "text-white/40 mb-8 flex items-center gap-2 hover:text-white transition-colors uppercase tracking-widest text-[10px] font-bold group",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " BACK"
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "border-l-4 border-[#BF092F] pl-4",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                                        className: "text-white text-2xl font-black uppercase tracking-tight",
                                        children: "Products"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-white/30 text-[9px] uppercase tracking-[0.2em]",
                                        children: "Arc Engineering Directory"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                        className: "flex-1 overflow-y-auto custom-scrollbar px-6 pb-20",
                        "aria-label": "Mobile Product Directory",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                            className: "space-y-3",
                            children: (0, $646411876a15270d$export$b6aad051bad07f12).map((cat)=>{
                                const isActive = expandedCat === cat.slug;
                                return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                    className: `rounded-2xl border transition-all duration-300 ${isActive ? "bg-white/5 border-white/10 shadow-lg" : "bg-transparent border-transparent"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>setExpandedCat(isActive ? null : cat.slug),
                                            "aria-expanded": isActive,
                                            "aria-controls": `submenu-${cat.slug}`,
                                            className: `w-full flex items-center justify-between p-5 transition-all ${isActive ? "text-white" : "text-white/60"}`,
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $572e082078ef0c98$export$2e2bcd8739ae039), {
                                                            size: 18,
                                                            className: `${isActive ? "text-[#BF092F]" : "text-white/20"} transition-colors`,
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-[13px] font-bold uppercase tracking-wider",
                                                            children: cat.category
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $14fb50132973b304$export$2e2bcd8739ae039), {
                                                    size: 16,
                                                    className: `transition-transform duration-500 ${isActive ? "rotate-180 text-[#BF092F]" : "text-white/20"}`,
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            id: `submenu-${cat.slug}`,
                                            className: `overflow-hidden transition-all duration-500 ease-in-out ${isActive ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0 lg:opacity-100"}`,
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("ul", {
                                                className: "px-6 pb-6 flex flex-col gap-2 border-t border-white/5 mt-1 pt-4",
                                                children: [
                                                    (cat.subCategories || cat.items || []).map((sub, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                                to: cat.subCategories ? `/products?category=${sub.slug}` : `/products/${cat.slug}/${sub.id}`,
                                                                onClick: onCloseAll,
                                                                className: "flex items-center gap-4 p-3 rounded-xl hover:bg-white/5 transition-colors group",
                                                                title: `View ${sub.name || sub.category}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $66bbb33cdbaad554$export$2e2bcd8739ae039), {
                                                                        size: 14,
                                                                        className: "text-[#BF092F]/40 group-hover:text-[#BF092F]",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                        className: "text-white/50 group-hover:text-white text-[11px] font-medium tracking-wide transition-colors",
                                                                        children: sub.name || sub.category
                                                                    })
                                                                ]
                                                            })
                                                        }, idx)),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                            to: `/products?category=${cat.slug}`,
                                                            onClick: onCloseAll,
                                                            className: "mt-4 block py-3 rounded-xl bg-[#BF092F]/10 text-[#BF092F] text-[9px] font-black uppercase tracking-widest text-center hover:bg-[#BF092F] hover:text-white transition-all",
                                                            children: [
                                                                "Explore All ",
                                                                cat.category
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, cat.slug);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                        className: "mt-auto py-10 flex flex-col items-center gap-4 border-t border-white/5 bg-[#44444E]/80 backdrop-blur-md",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-12 h-[1px] bg-[#BF092F]/50",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-white text-[10px] font-bold tracking-[0.4em] uppercase",
                                children: "Arc Engineering Solutions Ltd."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("style", {
                children: `
        .custom-scrollbar::-webkit-scrollbar { width: 2px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #BF092F40; border-radius: 10px; }
      `
            })
        ]
    });
};
var $a7e2fcca7151b667$export$2e2bcd8739ae039 = $a7e2fcca7151b667$var$ProductsMobileDrawer;




var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3a2fd91635d2c54c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const $3a2fd91635d2c54c$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("briefcase", $3a2fd91635d2c54c$export$3efd853dbb351e94);



/**
 * ProjectsMobileDrawer
 * * DESIGN: Slide-over navigation for mobile project discovery.
 * SEO: Uses <nav> and <ul> for semantic crawling.
 * ROUTING: Uses '?type=' query params to trigger filtering on ProjectsPage.
 */ const $eaedd3e4df4f9af9$var$ProjectsMobileDrawer = ({ isOpen: isOpen, onClose: onClose, onCloseAll: onCloseAll })=>{
    const [expandedCat, setExpandedCat] = (0, $4Iuzv.useState)(null);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `fixed inset-0 z-[130] bg-[#44444E] transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${isOpen ? "translate-x-0 opacity-100 visible" : "translate-x-full opacity-0 invisible"}`,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Project Case Studies Menu",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "h-full pt-28 flex flex-col relative",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "px-8 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                onClick: onClose,
                                className: "text-white/40 mb-8 flex items-center gap-2 hover:text-white transition-colors uppercase tracking-widest text-[10px] font-bold group",
                                "aria-label": "Back to previous menu",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " BACK"
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "border-l-4 border-[#BF092F] pl-4",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                                        className: "text-white text-2xl font-black uppercase tracking-tight",
                                        children: "Case Studies"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-white/30 text-[9px] uppercase tracking-[0.2em]",
                                        children: "Engineering Excellence Portfolio"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                        className: "flex-1 overflow-y-auto custom-scrollbar px-6 pb-20",
                        "aria-label": "Project Categories",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                            className: "space-y-3",
                            children: (0, $b68fddb3388eb08a$export$39babdfab504f3da).map((cat)=>{
                                const isActive = expandedCat === cat.categoryId;
                                return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                    className: `rounded-2xl border transition-all duration-300 ${isActive ? "bg-white/5 border-white/10 shadow-lg" : "bg-transparent border-transparent"}`,
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>setExpandedCat(isActive ? null : cat.categoryId),
                                            "aria-expanded": isActive,
                                            "aria-controls": `project-submenu-${cat.categoryId}`,
                                            className: `w-full flex items-center justify-between p-5 transition-all ${isActive ? "text-white" : "text-white/60"}`,
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-4",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3a2fd91635d2c54c$export$2e2bcd8739ae039), {
                                                            size: 18,
                                                            className: `${isActive ? "text-[#BF092F]" : "text-white/20"} transition-colors`,
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-[13px] font-bold uppercase tracking-wider",
                                                            children: cat.categoryName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $14fb50132973b304$export$2e2bcd8739ae039), {
                                                    size: 16,
                                                    className: `transition-transform duration-500 ${isActive ? "rotate-180 text-[#BF092F]" : "text-white/20"}`,
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            id: `project-submenu-${cat.categoryId}`,
                                            className: `overflow-hidden transition-all duration-500 ease-in-out ${isActive ? "max-h-[2000px] opacity-100" : "max-h-0 opacity-0"}`,
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("ul", {
                                                className: "px-6 pb-6 flex flex-col gap-2 border-t border-white/5 mt-1 pt-4",
                                                children: [
                                                    cat.projects.map((project)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                                to: `/projects/${project.id}`,
                                                                onClick: onCloseAll,
                                                                className: "flex items-center gap-4 p-3 rounded-xl hover:bg-white/5 transition-colors group",
                                                                title: `View case study: ${project.name}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $66bbb33cdbaad554$export$2e2bcd8739ae039), {
                                                                        size: 14,
                                                                        className: "text-[#BF092F]/40 group-hover:text-[#BF092F]",
                                                                        "aria-hidden": "true"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                        className: "flex flex-col",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                                className: "text-white/80 group-hover:text-white text-[11px] font-bold tracking-wide transition-colors",
                                                                                children: project.name
                                                                            }),
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                                                className: "text-[8px] text-white/20 uppercase font-black group-hover:text-[#BF092F]",
                                                                                children: [
                                                                                    "Client: ",
                                                                                    project.client
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }, project.id)),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                            to: `/projects?type=${encodeURIComponent(cat.categoryName)}`,
                                                            onClick: onCloseAll,
                                                            className: "mt-4 block py-3 rounded-xl bg-[#BF092F]/10 text-[#BF092F] text-[9px] font-black uppercase tracking-widest text-center hover:bg-[#BF092F] hover:text-white transition-all shadow-sm",
                                                            title: `Explore all ${cat.categoryName} projects`,
                                                            children: [
                                                                "Explore ",
                                                                cat.categoryName,
                                                                " Portfolio"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, cat.categoryId);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                        className: "mt-auto py-10 flex flex-col items-center gap-4 border-t border-white/5 bg-[#44444E]/90 backdrop-blur-md",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-12 h-[1px] bg-[#BF092F]/30",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-white text-[9px] font-black tracking-[0.5em] uppercase opacity-40",
                                children: "Arc Engineering Solutions Ltd."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("style", {
                children: `
        .custom-scrollbar::-webkit-scrollbar { width: 2px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #BF092F40; border-radius: 10px; }
      `
            })
        ]
    });
};
var $eaedd3e4df4f9af9$export$2e2bcd8739ae039 = $eaedd3e4df4f9af9$var$ProjectsMobileDrawer;



parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $37581b884d168f82$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ],
    [
        "path",
        {
            d: "M16 16h.01",
            key: "1f9h7w"
        }
    ],
    [
        "path",
        {
            d: "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z",
            key: "1iv0i2"
        }
    ],
    [
        "path",
        {
            d: "M8 16h.01",
            key: "18s6g9"
        }
    ]
];
const $37581b884d168f82$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("factory", $37581b884d168f82$export$3efd853dbb351e94);



/**
 * FacilitiesMobileDrawer
 * DESIGN: Slide-over navigation for manufacturing facility discovery.
 * SEO: Semantic <nav> and <ul> structure. Links are direct for better crawlability.
 * UPDATED: Clicking a facility now navigates directly to its page.
 */ const $808a3374f049859d$var$FacilitiesMobileDrawer = ({ isOpen: isOpen, onClose: onClose, onCloseAll: onCloseAll })=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: `fixed inset-0 z-[130] bg-[#44444E] transition-all duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${isOpen ? "translate-x-0 opacity-100 visible" : "translate-x-full opacity-0 invisible"}`,
        role: "dialog",
        "aria-modal": "true",
        "aria-label": "Global Facilities Menu",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "h-full pt-28 flex flex-col relative",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "px-8 mb-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                onClick: onClose,
                                className: "text-white/40 mb-8 flex items-center gap-2 hover:text-white transition-colors uppercase tracking-widest text-[10px] font-bold group",
                                "aria-label": "Back to previous menu",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    }),
                                    " BACK"
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "border-l-4 border-[#BF092F] pl-4",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                                        className: "text-white text-2xl font-black uppercase tracking-tight",
                                        children: "Our Facilities"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-white/30 text-[9px] uppercase tracking-[0.2em]",
                                        children: "Global Infrastructure Hubs"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                        className: "flex-1 overflow-y-auto custom-scrollbar px-6 pb-20",
                        "aria-label": "Manufacturing Facilities",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                            className: "space-y-3",
                            children: (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((fac)=>{
                                return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                        to: `/facilities/${fac.id}`,
                                        onClick: onCloseAll,
                                        className: "w-full flex items-center justify-between p-5 rounded-2xl border border-white/5 bg-white/5 hover:bg-white/10 hover:border-white/20 transition-all group",
                                        title: `View technical specifications for ${fac.title}`,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37581b884d168f82$export$2e2bcd8739ae039), {
                                                        size: 18,
                                                        className: "text-white/20 group-hover:text-[#BF092F] transition-colors",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[13px] font-bold uppercase tracking-wider text-left text-white/60 group-hover:text-white transition-colors",
                                                        children: fac.title
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "text-white/10 group-hover:text-[#BF092F] transition-all group-hover:translate-x-1",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    })
                                }, fac.id);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                        className: "mt-auto py-10 flex flex-col items-center gap-4 border-t border-white/5 bg-[#44444E]/90 backdrop-blur-md",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-12 h-[1px] bg-[#BF092F]/30",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-white text-[9px] font-black tracking-[0.5em] uppercase opacity-40 text-center",
                                children: "Arc Engineering Solutions Ltd."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("style", {
                children: `
        .custom-scrollbar::-webkit-scrollbar { width: 2px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: #BF092F40; border-radius: 10px; }
      `
            })
        ]
    });
};
var $808a3374f049859d$export$2e2bcd8739ae039 = $808a3374f049859d$var$FacilitiesMobileDrawer;


const $cf5a5aeeefcd27c2$var$Header = ()=>{
    const [mobileMenuOpen, setMobileMenuOpen] = (0, $4Iuzv.useState)(false);
    const [isProductsDrawerOpen, setIsProductsDrawerOpen] = (0, $4Iuzv.useState)(false);
    const [isProjectsDrawerOpen, setIsProjectsDrawerOpen] = (0, $4Iuzv.useState)(false);
    const [isFacilitiesDrawerOpen, setIsFacilitiesDrawerOpen] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const location = (0, $b11369f2b382bb4b$export$45d76561a5302f2b)();
    const navSchema = {
        "@context": "https://schema.org",
        "@type": "SiteNavigationElement",
        hasPart: [
            {
                "@type": "WebPage",
                name: "About",
                url: "https://arcengltd.com/about"
            },
            {
                "@type": "WebPage",
                name: "Products",
                url: "https://arcengltd.com/products"
            },
            {
                "@type": "WebPage",
                name: "Projects",
                url: "https://arcengltd.com/projects"
            },
            {
                "@type": "WebPage",
                name: "Facilities",
                url: "https://arcengltd.com/facilities"
            },
            {
                "@type": "WebPage",
                name: "Careers",
                url: "https://arcengltd.com/careers"
            },
            {
                "@type": "WebPage",
                name: "Contact",
                url: "https://arcengltd.com/contact"
            }
        ]
    };
    // 1. UPDATED NAV ITEMS: Facilities now uses the drawer trigger
    const navItems = [
        {
            name: "About",
            path: "/about"
        },
        {
            name: "Products",
            isDrawer: "products"
        },
        {
            name: "Projects",
            isDrawer: "projects"
        },
        {
            name: "Facilities",
            isDrawer: "facilities"
        },
        {
            name: "Careers",
            path: "/careers"
        },
        {
            name: "Contact",
            path: "/contact"
        }
    ];
    // 2. UPDATED NAV LOGIC: Added facilities check
    const handleMobileNav = (item)=>{
        if (item.isDrawer === "products") setIsProductsDrawerOpen(true);
        else if (item.isDrawer === "projects") setIsProjectsDrawerOpen(true);
        else if (item.isDrawer === "facilities") setIsFacilitiesDrawerOpen(true);
        else {
            setMobileMenuOpen(false);
            navigate(item.path);
        }
    };
    // 3. UPDATED SCROLL LOCK: Included isFacilitiesDrawerOpen
    (0, $4Iuzv.useEffect)(()=>{
        const isAnyDrawerOpen = mobileMenuOpen || isProductsDrawerOpen || isProjectsDrawerOpen || isFacilitiesDrawerOpen;
        document.body.style.overflow = isAnyDrawerOpen ? "hidden" : "unset";
    }, [
        mobileMenuOpen,
        isProductsDrawerOpen,
        isProjectsDrawerOpen,
        isFacilitiesDrawerOpen
    ]);
    const navLinkStyles = "relative cursor-pointer inline-flex items-center tracking-widest text-white transition-all duration-300 px-4 py-2 text-[12px] lg:text-[13px] uppercase whitespace-nowrap group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 rounded-lg";
    const HoverEffect = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute inset-0 bg-white/10 backdrop-blur-lg rounded-xl scale-50 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] -z-10 border border-white/20 shadow-xl",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-[1.5px] bg-white group-hover:w-1/4 transition-all duration-300 ease-out rounded-full",
                    "aria-hidden": "true"
                })
            ]
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
        className: "fixed top-0 left-0 w-full z-[100] pt-1 px-2",
        role: "banner",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("link", {
                        rel: "canonical",
                        href: `https://arcengltd.com${location.pathname}`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(navSchema)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "relative w-full mx-auto",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 -z-10 rounded-2xl shadow-2xl overflow-hidden",
                        style: {
                            background: "linear-gradient(110deg, #BF092F 64vw, #44444E 64vw)"
                        },
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "container mx-auto px-6",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "grid grid-cols-[1fr_auto_1fr] md:grid-cols-[auto_1fr_auto] h-18 md:h-20 items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "flex justify-start items-center",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        className: "flex-shrink-0 group/logo flex items-center relative",
                                        "aria-label": "Arc Engineering Home",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "absolute inset-0 bg-white/25 blur-xl rounded-full scale-125 opacity-60 group-hover:opacity-90 transition-opacity duration-500",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: "https://media.arcengltd.com/arc-profile/arc-logo-remove_bg.webp",
                                                alt: "Arc Engineering Solutions Ltd Logo",
                                                /* Added a subtle drop-shadow filter to the PNG itself for crispness */ className: "h-14 sm:h-14 md:h-20 w-auto transition-transform duration-500 group-hover/logo:scale-105 relative z-10 drop-shadow-[0_2px_8px_rgba(255,255,255,0.3)]",
                                                width: "150",
                                                height: "64",
                                                loading: "eager",
                                                fetchPriority: "high"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "md:hidden flex flex-col items-center justify-center text-center",
                                    "aria-hidden": "true",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white text-[10px] font-black tracking-[0.2em] uppercase whitespace-nowrap",
                                            children: "Arc Engineering"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/60 text-[7px] font-bold tracking-[0.3em] uppercase border-t border-white/10 pt-0.5",
                                            children: "Solutions Ltd."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex items-center justify-end",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                            className: "hidden md:flex items-center justify-end gap-x-2",
                                            "aria-label": "Main Navigation",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                    to: "/about",
                                                    className: navLinkStyles,
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(HoverEffect, {}),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            children: "About"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e227ff8b694a9b10$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ff507c7671cabd1b$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0eb0343417ecc711$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                    to: "/careers",
                                                    className: navLinkStyles,
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(HoverEffect, {}),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            children: "Careers"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                    to: "/contact",
                                                    className: navLinkStyles,
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(HoverEffect, {}),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            children: "Contact"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "pl-4 border-l border-white/10",
                                                    role: "search",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b46b4777f8e149b0$export$2e2bcd8739ae039), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>setMobileMenuOpen(!mobileMenuOpen),
                                            className: "text-white p-2 z-[110] relative md:hidden transition-transform active:scale-95",
                                            "aria-expanded": mobileMenuOpen,
                                            "aria-label": mobileMenuOpen ? "Close Menu" : "Open Menu",
                                            "aria-controls": "mobile-navigation",
                                            children: mobileMenuOpen ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6ceff59181ea43fa$export$2e2bcd8739ae039), {
                                                size: 28
                                            }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0da400c7309ade55$export$2e2bcd8739ae039), {
                                                size: 28
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                id: "mobile-navigation",
                className: `fixed inset-0 z-[105] transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] md:hidden ${mobileMenuOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"}`,
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-[#44444E]",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "h-full pt-28 px-8 relative z-10 overflow-y-auto pb-10",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "mb-12 flex justify-center w-full px-2",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0561781ac87dfa67$export$2e2bcd8739ae039), {
                                    onSelect: ()=>setMobileMenuOpen(false)
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                                className: "flex flex-col gap-2 max-w-sm mx-auto w-full",
                                "aria-label": "Mobile Navigation",
                                children: navItems?.map((item)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                        onClick: ()=>handleMobileNav(item),
                                        className: "group flex items-center justify-between py-4 border-b border-white/5 hover:border-[#BF092F]/50 transition-all text-left",
                                        "aria-label": item.isDrawer ? `Open ${item.name} menu` : `Go to ${item.name}`,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-white/80 group-hover:text-white text-xl uppercase tracking-[0.2em]",
                                                children: item.name
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "text-[#BF092F]",
                                                "aria-hidden": "true"
                                            })
                                        ]
                                    }, item.name))
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a7e2fcca7151b667$export$2e2bcd8739ae039), {
                                isOpen: isProductsDrawerOpen,
                                onClose: ()=>setIsProductsDrawerOpen(false),
                                onCloseAll: ()=>{
                                    setIsProductsDrawerOpen(false);
                                    setMobileMenuOpen(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $eaedd3e4df4f9af9$export$2e2bcd8739ae039), {
                                isOpen: isProjectsDrawerOpen,
                                onClose: ()=>setIsProjectsDrawerOpen(false),
                                onCloseAll: ()=>{
                                    setIsProjectsDrawerOpen(false);
                                    setMobileMenuOpen(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $808a3374f049859d$export$2e2bcd8739ae039), {
                                isOpen: isFacilitiesDrawerOpen,
                                onClose: ()=>setIsFacilitiesDrawerOpen(false),
                                onCloseAll: ()=>{
                                    setIsFacilitiesDrawerOpen(false);
                                    setMobileMenuOpen(false);
                                }
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                                className: "mt-12 flex flex-col items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-12 h-[1px] bg-[#BF092F]/50",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-white text-[10px] font-bold tracking-[0.4em] uppercase",
                                        children: "Arc Engineering Solutions Ltd."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $cf5a5aeeefcd27c2$export$2e2bcd8739ae039 = $cf5a5aeeefcd27c2$var$Header;



/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0ff9218d15909c02$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z",
            key: "1jg4f8"
        }
    ]
];
const $0ff9218d15909c02$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("facebook", $0ff9218d15909c02$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7dfa7cc464d9286c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
            key: "c2jq9f"
        }
    ],
    [
        "rect",
        {
            width: "4",
            height: "12",
            x: "2",
            y: "9",
            key: "mk3on5"
        }
    ],
    [
        "circle",
        {
            cx: "4",
            cy: "4",
            r: "2",
            key: "bt5ra8"
        }
    ]
];
const $7dfa7cc464d9286c$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("linkedin", $7dfa7cc464d9286c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f0a72ea34a993d6e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const $f0a72ea34a993d6e$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("mail", $f0a72ea34a993d6e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c0b373e8f780a95a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
            key: "1r0f0z"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "10",
            r: "3",
            key: "ilqhr7"
        }
    ]
];
const $c0b373e8f780a95a$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("map-pin", $c0b373e8f780a95a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $29e92dec75ed73a3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
            key: "9njp5v"
        }
    ]
];
const $29e92dec75ed73a3$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("phone", $29e92dec75ed73a3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c6007ae527fb4279$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
            key: "pff0z6"
        }
    ]
];
const $c6007ae527fb4279$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("twitter", $c6007ae527fb4279$export$3efd853dbb351e94);




const $4f481b2edf11cb85$var$Footer = ()=>{
    const currentYear = new Date().getFullYear();
    const location = (0, $b11369f2b382bb4b$export$45d76561a5302f2b)();
    // SEO: Structured Data (JSON-LD) for Arc Engineering Solutions Ltd
    const footerSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Arc Engineering Solutions Ltd",
        url: "https://arcengltd.com",
        logo: "https://res.cloudinary.com/dc912sjxj/image/upload/v1772287992/Gemini_Generated_Image_tler0wtler0wtler-removebg-preview_zhmv2k.png",
        contactPoint: {
            "@type": "ContactPoint",
            telephone: "+44-7492-949230",
            contactType: "customer service",
            email: "info@arcengltd.com",
            areaServed: [
                "GB",
                "Europe",
                "Worldwide"
            ],
            availableLanguage: "en"
        },
        address: {
            "@type": "PostalAddress",
            streetAddress: "W3 Winchester Avenue, Blaby",
            addressLocality: "Leicester",
            postalCode: "LE8 4GZ",
            addressCountry: "GB"
        }
    };
    const navLinks = [
        {
            name: "Home",
            path: "/"
        },
        {
            name: "About",
            path: "/about"
        },
        {
            name: "Products",
            path: "/products"
        },
        {
            name: "Facilities",
            path: "/facilities"
        },
        {
            name: "Projects",
            path: "/projects"
        },
        {
            name: "Careers",
            path: "/careers"
        },
        {
            name: "Contact",
            path: "/contact"
        }
    ];
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
        className: "relative w-full px-2 pb-2 mt-12 overflow-hidden",
        role: "contentinfo",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                type: "application/ld+json",
                children: JSON.stringify(footerSchema)
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "relative w-full mx-auto rounded-2xl shadow-2xl overflow-hidden bg-[#44444E]",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 -z-10 hidden md:block",
                        style: {
                            background: "linear-gradient(110deg, #44444E 36vw, #BF092F 36vw)"
                        }
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 -z-10 md:hidden bg-[#44444E]"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 opacity-[0.05] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "container mx-auto px-6 md:px-10 lg:px-12 py-16 lg:py-20 relative z-10",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-x-8 gap-y-12 items-start",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "lg:col-span-4 flex flex-col items-start space-y-6 md:space-y-8",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                to: "/",
                                                "aria-label": "Arc Engineering Solutions Home",
                                                className: "group relative",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "absolute inset-0 bg-white/20 blur-2xl rounded-full scale-150 opacity-50 group-hover:opacity-80 transition-opacity duration-500",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                        src: "https://media.arcengltd.com/arc-profile/arc-logo-remove_bg.webp",
                                                        alt: "Arc Engineering Solutions Ltd",
                                                        /* Drop shadow filter adds a crisp edge to the logo elements */ className: "h-14 md:h-20 w-auto transition-transform duration-500 group-hover:scale-105 relative z-10 drop-shadow-[0_4px_12px_rgba(255,255,255,0.25)]",
                                                        loading: "lazy"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-white/70 text-[10px] md:text-[11px] font-bold uppercase tracking-[0.25em] leading-loose max-w-sm border-l-2 border-[#BF092F] pl-5 italic relative z-10",
                                                children: "Engineering excellence in power solutions. Supporting UK, Europe, and Worldwide markets with bespoke industrial reliability."
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                                                className: "flex gap-3 relative z-10",
                                                "aria-label": "Social Media",
                                                children: [
                                                    (0, $0ff9218d15909c02$export$2e2bcd8739ae039),
                                                    (0, $c6007ae527fb4279$export$2e2bcd8739ae039),
                                                    (0, $7dfa7cc464d9286c$export$2e2bcd8739ae039)
                                                ].map((Icon, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                                        href: "#",
                                                        className: "p-3 bg-white/5 border border-white/10 text-white hover:bg-white hover:text-[#BF092F] transition-all rounded-xl",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(Icon, {
                                                            size: 16
                                                        })
                                                    }, i))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                        className: "lg:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                className: "text-[10px] font-black text-white/30 uppercase tracking-[0.5em] mb-8 lg:mb-10",
                                                children: "Directory"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                                className: "space-y-4 md:space-y-5",
                                                children: navLinks.map((link)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                            to: link.path,
                                                            className: `text-[11px] font-bold uppercase tracking-[0.2em] flex items-center gap-2 group transition-all ${location.pathname === link.path ? "text-[#BF092F]" : "text-white hover:text-white/60"}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                                    size: 12,
                                                                    className: `transition-all ${location.pathname === link.path ? "opacity-100 ml-0" : "opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0"} text-[#BF092F]`
                                                                }),
                                                                link.name
                                                            ]
                                                        })
                                                    }, link.name))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                        className: "lg:col-span-3",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                className: "text-[10px] font-black text-white/30 uppercase tracking-[0.5em] mb-8 lg:mb-10",
                                                children: "Product_Scope"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                                className: "space-y-4 md:space-y-5",
                                                children: (0, $646411876a15270d$export$b6aad051bad07f12).map((category)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                            to: `/products?category=${category.slug}`,
                                                            className: "text-[11px] font-bold text-white uppercase tracking-[0.2em] opacity-90 hover:opacity-100 transition-all flex items-center gap-2 group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "w-0 h-[1px] bg-[#BF092F] group-hover:w-3 transition-all duration-300"
                                                                }),
                                                                category.category
                                                            ]
                                                        })
                                                    }, category.slug))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "lg:col-span-3",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                className: "text-[10px] font-black text-white/30 uppercase tracking-[0.5em] mb-8 lg:mb-10",
                                                children: "Contact_Terminal"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "space-y-6 md:space-y-7",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("address", {
                                                        className: "not-italic flex items-start gap-4 group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                                                className: "text-white/40 group-hover:text-white transition-colors shrink-0",
                                                                size: 16
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                                                className: "text-[11px] font-bold text-white uppercase tracking-widest leading-relaxed",
                                                                children: [
                                                                    "W3 Winchester Avenue, Blaby, ",
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                                    " Leicester, LE8 4GZ, UK"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-center gap-4 group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $f0a72ea34a993d6e$export$2e2bcd8739ae039), {
                                                                className: "text-white/40 group-hover:text-white transition-colors shrink-0",
                                                                size: 16
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                                                href: "mailto:info@arcengltd.com",
                                                                className: "text-[11px] font-bold text-white uppercase tracking-widest transition-colors group-hover:text-white break-all",
                                                                children: "info@arcengltd.com"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-center gap-4 group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $29e92dec75ed73a3$export$2e2bcd8739ae039), {
                                                                className: "text-white/40 group-hover:text-white transition-colors shrink-0",
                                                                size: 16
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                                                href: "tel:+447492949230",
                                                                className: "text-[11px] font-bold text-white uppercase tracking-widest transition-colors group-hover:text-white",
                                                                children: "+44 7492 949230"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "mt-16 md:mt-20 pt-8 md:pt-10 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 md:gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                        className: "text-[9px] font-bold text-white/20 uppercase tracking-[0.4em] text-center md:text-left",
                                        children: [
                                            "\xa9 ",
                                            currentYear,
                                            " ARC ENGINEERING SOLUTIONS LTD",
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "mx-2 text-[#BF092F]",
                                                children: "/"
                                            }),
                                            " ALL_RIGHTS_RESERVED"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                                        className: "flex gap-6 md:gap-10",
                                        children: [
                                            "Privacy",
                                            "Terms",
                                            "Support"
                                        ].map((legal)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                                                href: "#",
                                                className: "text-[9px] font-bold text-white/20 uppercase tracking-[0.4em] hover:text-white transition-colors",
                                                children: legal
                                            }, legal))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "absolute bottom-[-10px] md:bottom-[-15px] right-[-10px] text-[80px] md:text-[180px] font-black text-white/[0.02] select-none pointer-events-none tracking-tighter leading-none",
                        "aria-hidden": "true",
                        children: "ARC"
                    })
                ]
            })
        ]
    });
};
var $4f481b2edf11cb85$export$2e2bcd8739ae039 = $4f481b2edf11cb85$var$Footer;



parcelRequire("4Iuzv");



var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $74612ecec2deb067$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
            key: "1xq2db"
        }
    ]
];
const $74612ecec2deb067$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("zap", $74612ecec2deb067$export$3efd853dbb351e94);



const $caaf1152e864e856$var$heroSentences = [
    "Engineered for Mission-Critical Reliability.",
    "Precision Engineering for Critical Sites.",
    "High-Performance UK Power Solutions."
];
const $caaf1152e864e856$var$HomePageSection1 = ()=>{
    const [currentIndex, setCurrentIndex] = (0, $4Iuzv.useState)(0);
    const [videoLoaded, setVideoLoaded] = (0, $4Iuzv.useState)(false);
    const videoRef = (0, $4Iuzv.useRef)(null);
    (0, $4Iuzv.useEffect)(()=>{
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.play().catch(()=>{});
        }
        const interval = setInterval(()=>{
            setCurrentIndex((prev)=>(prev + 1) % $caaf1152e864e856$var$heroSentences.length);
        }, 4500);
        return ()=>{
            clearInterval(interval);
            if (videoRef.current) videoRef.current.pause();
        };
    }, []);
    const slantDegree = "110deg";
    const firstGreyEnd = "60vw";
    const redStripeEnd = "62.9vw";
    const secondGreyEnd = "65.9vw";
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        className: "relative w-full overflow-hidden bg-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "Arc Engineering Solutions Ltd | UK-Led Power & Infrastructure Solutions"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "Arc Engineering Solutions Ltd delivers mission-critical power systems and UK-governed engineering solutions for global infrastructure."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("link", {
                        rel: "canonical",
                        href: "https://arcengltd.com/"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("link", {
                        rel: "preload",
                        href: "https://media.arcengltd.com/arc-profile/arc-company-video.mp4",
                        as: "video",
                        type: "video/mp4"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                className: "sr-only",
                children: "Arc Engineering Solutions Ltd: Global Leaders in Power Systems"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 pb-12",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "relative min-h-[600px] md:h-[75vh] w-full flex items-center overflow-hidden rounded-2xl shadow-2xl bg-[#44444E]",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "absolute inset-0 z-0",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("video", {
                                    ref: videoRef,
                                    autoPlay: true,
                                    loop: true,
                                    muted: true,
                                    playsInline: true,
                                    onLoadedData: ()=>setVideoLoaded(true),
                                    poster: "https://media.arcengltd.com/arc-profile/arc-hero-video-poster.webp",
                                    className: `absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out z-10 ${videoLoaded ? "opacity-50" : "opacity-0"}`,
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("source", {
                                        src: "https://media.arcengltd.com/arc-profile/arc-company-video.mp4",
                                        type: "video/mp4"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: `absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out z-0 ${videoLoaded ? "opacity-0" : "opacity-50"}`,
                                    style: {
                                        backgroundImage: "url('https://media.arcengltd.com/arc-profile/arc-hero-video-poster.webp')",
                                        backgroundColor: "#44444E"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "md:hidden absolute inset-0 bg-gradient-to-b from-black/90 via-black/40 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "hidden md:block absolute inset-0 z-10",
                            style: {
                                background: `linear-gradient(${slantDegree}, #44444E ${firstGreyEnd}, transparent ${firstGreyEnd}, transparent ${redStripeEnd}, #44444E ${redStripeEnd}, #44444E ${secondGreyEnd}, transparent ${secondGreyEnd})`
                            }
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "hidden md:block absolute inset-0 z-20",
                            style: {
                                background: `linear-gradient(${slantDegree}, transparent ${firstGreyEnd}, #BF092F ${firstGreyEnd}, #BF092F ${redStripeEnd}, transparent ${redStripeEnd})`
                            }
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "container mx-auto px-6 md:px-12 relative z-30",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "w-full md:max-w-[48%] lg:max-w-[45%] xl:max-w-[55%] py-12 md:py-16",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "relative h-[200px] md:h-[300px] lg:h-[380px] flex items-center",
                                        children: $caaf1152e864e856$var$heroSentences.map((text, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                className: `absolute left-0 transition-all duration-1000 ease-in-out font-semibold
                    text-5xl md:text-6xl lg:text-7xl xl:text-8xl 
                    text-white leading-[1.05] tracking-tighter ${index === currentIndex ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`,
                                                children: text.split(" ").map((word, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                        className: word.toLowerCase().match(/power|engineering|mission-critical|solutions/) ? "text-[#BF092F]" : "",
                                                        children: [
                                                            word,
                                                            " "
                                                        ]
                                                    }, i))
                                            }, index))
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-white/80 text-base md:text-xl lg:text-2xl tracking-tight leading-relaxed mb-12 border-l-4 border-[#BF092F] pl-10 max-w-[95%]",
                                        children: "Expertly engineered systems designed in the UK to power critical infrastructure across Europe and the globe."
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex flex-wrap gap-6 pb-20",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                to: "/products",
                                                className: "rounded-2xl group relative flex items-center gap-8 px-10 py-5 bg-[#BF092F] text-white transition-all hover:scale-105 shadow-xl shadow-[#BF092F]/20",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[11px] font-black uppercase tracking-[0.2em]",
                                                        children: "View Products"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                        size: 20,
                                                        className: "group-hover:translate-x-2 transition-transform"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                to: "/about",
                                                className: "rounded-2xl group flex items-center gap-8 px-10 py-5 border border-white/20 text-white transition-all hover:bg-white/10",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[11px] font-black uppercase tracking-[0.2em]",
                                                        children: "Our Expertise"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $74612ecec2deb067$export$2e2bcd8739ae039), {
                                                        size: 18,
                                                        className: "text-[#BF092F]"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $caaf1152e864e856$export$2e2bcd8739ae039 = $caaf1152e864e856$var$HomePageSection1;




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $902440550a78fec8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
            key: "169zse"
        }
    ]
];
const $902440550a78fec8$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("activity", $902440550a78fec8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $de1c4da7ce3700ef$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "m21 3-7 7",
            key: "1l2asr"
        }
    ],
    [
        "path",
        {
            d: "m3 21 7-7",
            key: "tjx5ai"
        }
    ],
    [
        "path",
        {
            d: "M9 21H3v-6",
            key: "wtvkvv"
        }
    ]
];
const $de1c4da7ce3700ef$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("maximize-2", $de1c4da7ce3700ef$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6d4de4f7a7e1d238$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m14 10 7-7",
            key: "oa77jy"
        }
    ],
    [
        "path",
        {
            d: "M20 10h-6V4",
            key: "mjg0md"
        }
    ],
    [
        "path",
        {
            d: "m3 21 7-7",
            key: "tjx5ai"
        }
    ],
    [
        "path",
        {
            d: "M4 14h6v6",
            key: "rmj7iw"
        }
    ]
];
const $6d4de4f7a7e1d238$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("minimize-2", $6d4de4f7a7e1d238$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4ddc5db54d26fa99$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "14",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "zuxfzm"
        }
    ],
    [
        "rect",
        {
            x: "6",
            y: "4",
            width: "4",
            height: "16",
            rx: "1",
            key: "1okwgv"
        }
    ]
];
const $4ddc5db54d26fa99$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("pause", $4ddc5db54d26fa99$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a03253895341c512$export$3efd853dbb351e94 = [
    [
        "polygon",
        {
            points: "6 3 20 12 6 21 6 3",
            key: "1oa8hb"
        }
    ]
];
const $a03253895341c512$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("play", $a03253895341c512$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0a88a9755721f014$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
            key: "uqj9uw"
        }
    ],
    [
        "path",
        {
            d: "M16 9a5 5 0 0 1 0 6",
            key: "1q6k2b"
        }
    ],
    [
        "path",
        {
            d: "M19.364 18.364a9 9 0 0 0 0-12.728",
            key: "ijwkga"
        }
    ]
];
const $0a88a9755721f014$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("volume-2", $0a88a9755721f014$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $10d355c1aac7e80f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
            key: "uqj9uw"
        }
    ],
    [
        "line",
        {
            x1: "22",
            x2: "16",
            y1: "9",
            y2: "15",
            key: "1ewh16"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "22",
            y1: "9",
            y2: "15",
            key: "5ykzw1"
        }
    ]
];
const $10d355c1aac7e80f$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("volume-x", $10d355c1aac7e80f$export$3efd853dbb351e94);



const $0117375c56681734$var$CompanyVideoSection = ({ videoSrc: videoSrc = "https://media.arcengltd.com/arc-profile/arc-company-video.mp4", posterSrc: posterSrc = "https://media.arcengltd.com/arc-profile/arc-hero-video-poster.webp", title: title = "Infrastructure Scale", tagline: tagline = "A visual overview of our 41,000 SQM manufacturing capacity and UK-led engineering protocols." })=>{
    const videoRef = (0, $4Iuzv.useRef)(null);
    const containerRef = (0, $4Iuzv.useRef)(null);
    const sectionRef = (0, $4Iuzv.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $4Iuzv.useState)(false);
    const [isMuted, setIsMuted] = (0, $4Iuzv.useState)(false);
    const [videoStarted, setVideoStarted] = (0, $4Iuzv.useState)(false);
    const [videoLoaded, setVideoLoaded] = (0, $4Iuzv.useState)(false);
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const [progress, setProgress] = (0, $4Iuzv.useState)(0);
    const [isFullscreen, setIsFullscreen] = (0, $4Iuzv.useState)(false);
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setIsVisible(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    (0, $4Iuzv.useEffect)(()=>{
        const handleFullscreenChange = ()=>{
            const doc = window.document;
            const isCurrentlyFull = doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement;
            setIsFullscreen(!!isCurrentlyFull);
        };
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        return ()=>{
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
        };
    }, []);
    const handleTimeUpdate = ()=>{
        if (videoRef.current) setProgress(videoRef.current.currentTime / videoRef.current.duration * 100);
    };
    const togglePlayPause = ()=>{
        if (!videoStarted) setVideoStarted(true);
        if (videoRef.current.paused) {
            videoRef.current.play();
            setIsPlaying(true);
        } else {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    };
    const handleFullScreen = (e)=>{
        e.stopPropagation();
        const doc = window.document;
        const elem = containerRef.current;
        if (!isFullscreen) {
            if (elem.requestFullscreen) elem.requestFullscreen();
            else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
        } else {
            if (doc.exitFullscreen) doc.exitFullscreen();
            else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen();
        }
    };
    // Matching reveal logic from TrustedPartners
    const revealClass = (visible, delay = "duration-1000")=>`transition-all ${delay} ease-[cubic-bezier(0.22,1,0.36,1)] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative w-full py-24 bg-white overflow-hidden",
        "aria-labelledby": "facility-video-title",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                    type: "application/ld+json",
                    children: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        "name": `Arc Engineering Solutions Ltd | ${title} Facility Insight`,
                        "description": tagline,
                        "thumbnailUrl": [
                            posterSrc
                        ],
                        "uploadDate": "2026-03-24T18:00:00+00:00",
                        "contentUrl": videoSrc,
                        "publisher": {
                            "@type": "Organization",
                            "name": "Arc Engineering Solutions Ltd"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "container mx-auto px-4 md:px-6 relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: `mb-16 ${revealClass(isVisible)}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-8 w-1 bg-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F] animate-pulse",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "text-sm text-[#44444E] uppercase font-bold tracking-[0.4em]",
                                        children: "Facility Insight"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col lg:flex-row lg:items-end justify-between gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                        id: "facility-video-title",
                                        className: "text-3xl md:text-5xl font-semibold text-[#44444E] leading-tight uppercase tracking-tight",
                                        children: [
                                            "Manufacturing ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "max-w-md text-gray-400 font-bold uppercase tracking-widest text-[10px] leading-relaxed pb-1 border-l-2 border-gray-100 pl-6 lg:ml-8",
                                        children: tagline
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        ref: containerRef,
                        className: `relative w-full aspect-[4/5] sm:aspect-video lg:max-h-[60vh] bg-[#44444E] rounded-2xl shadow-xl border border-gray-100 overflow-hidden ${revealClass(isVisible, "duration-[1200ms] delay-300")}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("video", {
                                ref: videoRef,
                                onTimeUpdate: handleTimeUpdate,
                                onLoadedData: ()=>setVideoLoaded(true),
                                className: `w-full h-full object-cover transition-opacity duration-1000 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`,
                                playsInline: true,
                                onClick: togglePlayPause,
                                preload: "metadata",
                                children: videoStarted && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("source", {
                                    src: videoSrc,
                                    type: "video/mp4"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: `absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${videoLoaded ? 'opacity-0 pointer-events-none' : 'opacity-100'}`,
                                style: {
                                    backgroundImage: `url(${posterSrc})`
                                }
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute bottom-6 left-1/2 -translate-x-1/2 w-[92%] sm:w-auto min-w-[280px] md:min-w-[400px] z-20",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: `backdrop-blur-xl bg-black/40 border border-white/10 rounded-2xl p-3 md:p-4 flex items-center justify-between gap-6 shadow-2xl transition-all duration-500 
              ${videoStarted && isPlaying ? 'opacity-0 translate-y-4 hover:opacity-100 hover:translate-y-0' : 'opacity-100 translate-y-0'}`,
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: togglePlayPause,
                                            className: "w-12 h-12 rounded-xl bg-[#BF092F] flex items-center justify-center text-white hover:bg-[#d1082d] transition-colors shrink-0",
                                            children: isPlaying ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $4ddc5db54d26fa99$export$2e2bcd8739ae039), {
                                                size: 20,
                                                fill: "currentColor"
                                            }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a03253895341c512$export$2e2bcd8739ae039), {
                                                size: 20,
                                                fill: "currentColor",
                                                className: "translate-x-0.5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex flex-col flex-1 min-w-0",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] font-black text-white uppercase tracking-widest truncate",
                                                    children: "Arc Engineering"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[8px] text-white/40 uppercase tracking-[0.2em] mt-1 truncate",
                                                    children: "UAE Production Facility"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex items-center gap-4 border-l border-white/10 pl-6 shrink-0",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        videoRef.current.muted = !isMuted;
                                                        setIsMuted(!isMuted);
                                                    },
                                                    className: "text-white/60 hover:text-white transition-colors",
                                                    children: isMuted ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $10d355c1aac7e80f$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0a88a9755721f014$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                    onClick: handleFullScreen,
                                                    className: "cursor-pointer text-white/60 hover:text-white transition-colors",
                                                    children: isFullscreen ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6d4de4f7a7e1d238$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $de1c4da7ce3700ef$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "absolute bottom-0 left-0 h-1 bg-white/10 w-full z-10",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "h-full bg-[#BF092F] transition-all duration-150 shadow-[0_0_10px_#BF092F]",
                                    style: {
                                        width: `${progress}%`
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                        className: "mt-8 flex flex-col md:flex-row items-center justify-between gap-4 opacity-50",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-[9px] font-black uppercase tracking-[0.3em] text-[#44444E] italic",
                                children: "UK Engineering Governance & Inspection Standards"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-[9px] font-bold uppercase tracking-[0.2em] text-gray-400",
                                children: "Direct FAT Protocols Available"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0117375c56681734$export$2e2bcd8739ae039 = $0117375c56681734$var$CompanyVideoSection;




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e1dea707e9b51b32$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $e1dea707e9b51b32$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("shield-check", $e1dea707e9b51b32$export$3efd853dbb351e94);






parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $52df24fc950c96b6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
            key: "zw3jo"
        }
    ],
    [
        "path",
        {
            d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
            key: "1wduqc"
        }
    ],
    [
        "path",
        {
            d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
            key: "kqbvx6"
        }
    ]
];
const $52df24fc950c96b6$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("layers", $52df24fc950c96b6$export$3efd853dbb351e94);



const $d87703466cb4334d$var$ProductCategoryCard = ({ category: category, onClick: onClick })=>{
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    // Helper to determine counts
    const modelCount = category.subCategories?.length || category.items?.length || 0;
    const countLabel = category.type === 'parent' ? 'Types' : 'Models';
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        onClick: ()=>onClick ? onClick() : navigate(`/products?category=${category.slug}`),
        className: "group relative flex flex-col h-full bg-white rounded-2xl shadow-xl border border-gray-100 cursor-pointer overflow-hidden transition-all duration-500 hover:shadow-2xl hover:border-[#BF092F]/20",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "h-56 relative overflow-hidden bg-gray-50",
                children: category.image?.url && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                    src: category.image.url,
                    alt: category.category || category.name,
                    className: "w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700 opacity-90"
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "p-8 flex flex-col justify-between flex-grow",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                className: "text-xl font-bold text-[#44444E] tracking-tight group-hover:text-[#BF092F] transition-colors mb-3",
                                children: category.category || category.name
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-[12px] text-gray-400 tracking-widest leading-relaxed line-clamp-2",
                                children: category.description || `${modelCount} ${countLabel} Available.`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mt-8 flex justify-between items-center pt-6 border-t border-gray-100",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $52df24fc950c96b6$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F]"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                        className: "text-[11px] font-bold text-[#44444E] uppercase tracking-widest",
                                        children: [
                                            modelCount,
                                            " ",
                                            countLabel
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                size: 18,
                                className: "text-gray-300 group-hover:text-[#BF092F] group-hover:translate-x-1 transition-all"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d87703466cb4334d$export$2e2bcd8739ae039 = $d87703466cb4334d$var$ProductCategoryCard;


function $a855ff4f4b23843d$export$2e2bcd8739ae039() {
    const sectionRef = (0, $4Iuzv.useRef)(null);
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    // SEO: Schema.org ItemList for industrial product categories
    const productListSchema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "Arc Engineering Solutions Ltd Product Range",
        "description": "UK-engineered generator enclosures, E-Houses, and power infrastructure.",
        "itemListElement": (0, $646411876a15270d$export$b6aad051bad07f12).map((product, index)=>({
                "@type": "ListItem",
                "position": index + 1,
                "name": product.title || product.name,
                "url": `https://arcengltd.com/products?category=${product.slug}`
            }))
    };
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setIsVisible(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    const revealClass = (visible, delay = "duration-1000")=>`transition-all ${delay} ease-[cubic-bezier(0.22,1,0.36,1)] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative py-24 bg-white overflow-hidden",
        "aria-labelledby": "features-heading",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                    type: "application/ld+json",
                    children: JSON.stringify(productListSchema)
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "relative z-10 container mx-auto px-4 md:px-6",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: `mb-16 ${revealClass(isVisible)}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-8 w-1 bg-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F] animate-pulse",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "text-sm text-[#44444E] uppercase font-bold tracking-[0.4em]",
                                        children: "Technical Capability"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col lg:flex-row lg:items-end justify-between gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                        id: "features-heading",
                                        className: "text-3xl md:text-5xl font-semibold text-[#44444E] leading-tight uppercase tracking-tight",
                                        children: [
                                            "UK ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Precision"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {
                                                className: "hidden md:block"
                                            }),
                                            " Global ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-gray-300",
                                                children: "Scale."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                        className: "max-w-md text-gray-400 font-bold uppercase tracking-widest text-[10px] leading-relaxed pb-1 border-l-2 border-gray-100 pl-6 lg:ml-8",
                                        children: [
                                            "Delivering high-performance ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("strong", {
                                                children: "power modules"
                                            }),
                                            " and bespoke ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("strong", {
                                                children: "BS EN compliant enclosures"
                                            }),
                                            " through UK-governed technical protocols."
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                        className: `grid grid-cols-2 md:grid-cols-4 gap-0 mb-20 rounded-2xl overflow-hidden border border-gray-100 shadow-xl bg-white ${revealClass(isVisible, "duration-[1200ms] delay-200")}`,
                        "aria-label": "Operational Statistics",
                        children: [
                            {
                                value: "41k",
                                label: "SQM Facilities"
                            },
                            {
                                value: "UKCA",
                                label: "Compliance"
                            },
                            {
                                value: "100%",
                                label: "FAT Certified"
                            },
                            {
                                value: "ISO",
                                label: "Quality Hub"
                            }
                        ].map((stat, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "p-8 border-r last:border-r-0 border-gray-100 flex flex-col items-center md:items-start group hover:bg-[#44444E] transition-all duration-500",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-3xl font-bold text-[#44444E] group-hover:text-white transition-colors tracking-tighter",
                                        children: stat.value
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[9px] font-black text-[#BF092F] uppercase tracking-[0.3em] mt-2",
                                        children: stat.label
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-8 mb-20",
                        "aria-label": "Product Categories",
                        children: (0, $646411876a15270d$export$b6aad051bad07f12).map((category, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                className: `transition-all duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`,
                                style: {
                                    transitionDelay: `${index * 100}ms`
                                },
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d87703466cb4334d$export$2e2bcd8739ae039), {
                                    category: category,
                                    onClick: ()=>navigate(`/products?category=${category.slug}`)
                                })
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                        className: `relative group overflow-hidden rounded-2xl bg-[#44444E] p-10 md:p-14 shadow-2xl ${revealClass(isVisible, "duration-[1200ms] delay-500")}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                size: 200,
                                className: "absolute -right-10 -bottom-10 text-white/5 rotate-12 transition-transform group-hover:rotate-0 duration-1000",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "text-center lg:text-left",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                className: "text-3xl font-black uppercase italic text-[#BF092F] mb-4",
                                                children: "Technical Consultancy"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                                className: "text-white/50 text-[11px] font-bold uppercase tracking-widest leading-loose max-w-xl",
                                                children: [
                                                    "Engage with our ",
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("strong", {
                                                        children: "Leicester-based engineering team"
                                                    }),
                                                    " for bespoke system architecture and worldwide infrastructure deployment."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: ()=>navigate("/contact"),
                                        "aria-label": "Contact Arc Engineering for Technical Consultancy",
                                        className: "px-10 py-4 border border-white/20 text-white text-[10px] font-black uppercase tracking-[0.3em] rounded-xl hover:bg-white/10 transition-all duration-500 hover:cursor-pointer",
                                        children: "Contact Us"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $937c5640447fbab0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
            key: "hh9hay"
        }
    ],
    [
        "path",
        {
            d: "m3.3 7 8.7 5 8.7-5",
            key: "g66t2b"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ]
];
const $937c5640447fbab0$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("box", $937c5640447fbab0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $90b1c37bd27f04c4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M17 20v2",
            key: "1rnc9c"
        }
    ],
    [
        "path",
        {
            d: "M17 2v2",
            key: "11trls"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M2 17h2",
            key: "7oei6x"
        }
    ],
    [
        "path",
        {
            d: "M2 7h2",
            key: "asdhe0"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "M20 17h2",
            key: "1fpfkl"
        }
    ],
    [
        "path",
        {
            d: "M20 7h2",
            key: "1o8tra"
        }
    ],
    [
        "path",
        {
            d: "M7 20v2",
            key: "4gnj0m"
        }
    ],
    [
        "path",
        {
            d: "M7 2v2",
            key: "1i4yhu"
        }
    ],
    [
        "rect",
        {
            x: "4",
            y: "4",
            width: "16",
            height: "16",
            rx: "2",
            key: "1vbyd7"
        }
    ],
    [
        "rect",
        {
            x: "8",
            y: "8",
            width: "8",
            height: "8",
            rx: "1",
            key: "z9xiuo"
        }
    ]
];
const $90b1c37bd27f04c4$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("cpu", $90b1c37bd27f04c4$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $087fce06e435c243$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
            key: "1ptgy4"
        }
    ],
    [
        "path",
        {
            d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
            key: "1sl1rz"
        }
    ]
];
const $087fce06e435c243$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("droplets", $087fce06e435c243$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $914ea2a5dc385aff$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
            key: "13o1zl"
        }
    ],
    [
        "path",
        {
            d: "M2 12h20",
            key: "9i4pu4"
        }
    ]
];
const $914ea2a5dc385aff$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("globe", $914ea2a5dc385aff$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da4c1087b2f19ca9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
            key: "1qme2f"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $da4c1087b2f19ca9$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("settings", $da4c1087b2f19ca9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $88751b2d8fd25e0f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 21V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11",
            key: "pb2vm6"
        }
    ],
    [
        "path",
        {
            d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 1.132-1.803l7.95-3.974a2 2 0 0 1 1.837 0l7.948 3.974A2 2 0 0 1 22 8z",
            key: "doq5xv"
        }
    ],
    [
        "path",
        {
            d: "M6 13h12",
            key: "yf64js"
        }
    ],
    [
        "path",
        {
            d: "M6 17h12",
            key: "1jwigz"
        }
    ]
];
const $88751b2d8fd25e0f$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("warehouse", $88751b2d8fd25e0f$export$3efd853dbb351e94);




function $154171f69b15d666$export$2e2bcd8739ae039() {
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const [showSpecs, setShowSpecs] = (0, $4Iuzv.useState)(false);
    const specsRef = (0, $4Iuzv.useRef)(null);
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setShowSpecs(true);
        }, {
            threshold: 0.1
        });
        if (specsRef.current) observer.observe(specsRef.current);
        return ()=>observer.disconnect();
    }, []);
    const revealClass = (visible, delay = "duration-1000")=>`transition-all ${delay} ease-[cubic-bezier(0.22,1,0.36,1)] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        id: "about",
        className: "relative bg-white py-24 overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "Engineering Excellence | Arc Engineering Solutions Ltd"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "UK-governed engineering providing global scale for Generator Enclosures, E-Houses, and mission-critical power infrastructure."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "container mx-auto px-4 md:px-6 relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: `mb-16 ${revealClass(isVisible)}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-8 w-1 bg-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F] animate-pulse",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "text-sm text-[#44444E] uppercase font-black tracking-[0.4em]",
                                        children: "Global Infrastructure"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col lg:flex-row lg:items-end justify-between gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                        className: "text-3xl md:text-5xl font-semibold text-[#44444E] leading-tight uppercase tracking-tighter",
                                        children: [
                                            "UK ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Engineering"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {
                                                className: "hidden md:block"
                                            }),
                                            " Global ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Scale."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "max-w-md text-gray-400 font-bold uppercase tracking-widest text-[10px] leading-relaxed pb-1 border-l-2 border-gray-100 pl-6 lg:ml-8",
                                        children: "Bespoke power infrastructure engineered to British standards for worldwide delivery."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                        className: `mb-12 ${revealClass(isVisible, "duration-[1200ms] delay-200")}`,
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "grid lg:grid-cols-12 gap-0 shadow-2xl rounded-2xl overflow-hidden border border-gray-100",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "lg:col-span-8 bg-white p-10 md:p-16 border-r border-gray-50",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                            className: "text-[11px] font-black text-[#BF092F] uppercase tracking-[0.4em] mb-8",
                                            children: "The_Hybrid_Model"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                            className: "text-2xl md:text-3xl font-semibold text-[#44444E] uppercase tracking-tight leading-tight mb-8",
                                            children: [
                                                "Direct ",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[#BF092F]",
                                                    children: "Manufacturing"
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                " With",
                                                " ",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[#BF092F]",
                                                    children: "UK Quality Governance."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-gray-500 uppercase tracking-widest text-[11px] font-medium leading-loose mb-10 max-w-2xl",
                                            children: "Arc Engineering Solutions Ltd bridges the gap between massive production capacity and stringent UK engineering precision, specializing in mission-critical E-House and Generator infrastructure."
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "grid grid-cols-2 md:grid-cols-4 gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$Stat, {
                                                    label: "QA Protocol",
                                                    val: "UK-Led"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$Stat, {
                                                    label: "Production",
                                                    val: "Direct"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$Stat, {
                                                    label: "Standards",
                                                    val: "BS EN"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$Stat, {
                                                    label: "Inspection",
                                                    val: "FAT"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("aside", {
                                    className: "lg:col-span-4 bg-[#44444E] p-10 md:p-12 text-white flex flex-col justify-between relative overflow-hidden group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                            size: 200,
                                            className: "absolute -right-10 -bottom-10 text-white/5 rotate-12 transition-transform group-hover:rotate-0 duration-1000",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "relative z-10",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                    className: "text-xl font-black uppercase italic text-[#BF092F] mb-8 border-b border-white/10 pb-4",
                                                    children: "Strategic Scope"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("ul", {
                                                    className: "space-y-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$TechItem, {
                                                            icon: (0, $74612ecec2deb067$export$2e2bcd8739ae039),
                                                            text: "Acoustic Enclosures"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$TechItem, {
                                                            icon: (0, $90b1c37bd27f04c4$export$2e2bcd8739ae039),
                                                            text: "Modular E-Houses"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$TechItem, {
                                                            icon: (0, $37581b884d168f82$export$2e2bcd8739ae039),
                                                            text: "Grid Infrastructure"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($154171f69b15d666$var$TechItem, {
                                                            icon: (0, $52df24fc950c96b6$export$2e2bcd8739ae039),
                                                            text: "Custom Fabrication"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "relative z-10 mt-12 pt-8 border-t border-white/10 text-[9px] font-mono text-white/40 uppercase tracking-[0.3em]",
                                            children: "Engineered for UK, European, and Worldwide Clients."
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        ref: specsRef,
                        className: `grid lg:grid-cols-2 gap-8 items-stretch mb-8 ${revealClass(showSpecs, "duration-[1200ms]")}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                className: "group relative bg-white p-10 rounded-3xl border border-gray-100 shadow-sm hover:shadow-2xl hover:border-[#BF092F]/20 transition-all duration-500 overflow-hidden flex flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "absolute top-0 right-0 p-8 text-gray-50 group-hover:text-[#BF092F]/5 transition-colors",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $937c5640447fbab0$export$2e2bcd8739ae039), {
                                            size: 140,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "relative z-10",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center gap-3 mb-8",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "h-6 w-1 bg-[#BF092F]",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                        className: "text-[10px] uppercase font-black tracking-[0.4em] text-[#44444E]/60",
                                                        children: "Power Packaging"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h4", {
                                                className: "text-2xl font-semibold text-[#44444E] uppercase tracking-tight mb-6 leading-tight",
                                                children: [
                                                    "Specialist Generator ",
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[#BF092F]",
                                                        children: "Container Systems"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-gray-500 font-medium uppercase tracking-widest text-[11px] leading-loose mb-8 max-w-md",
                                                children: "Bespoke enclosures engineered for critical structural integrity and high-performance acoustic attenuation."
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "flex flex-wrap gap-2 pt-6 border-t border-gray-100",
                                                children: [
                                                    "ISO Compliant",
                                                    "Acoustic Rated",
                                                    "Seismic Options"
                                                ].map((f)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[9px] font-black uppercase tracking-widest bg-gray-50 px-3 py-2 rounded-lg text-gray-400 group-hover:text-[#44444E] transition-colors",
                                                        children: f
                                                    }, f))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                className: "group relative bg-[#44444E] p-10 rounded-3xl shadow-2xl overflow-hidden flex flex-col justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "absolute top-0 right-0 p-8 text-white/5 group-hover:text-[#BF092F]/10 transition-colors",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $88751b2d8fd25e0f$export$2e2bcd8739ae039), {
                                            size: 140,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "relative z-10",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center gap-3 mb-8",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "h-6 w-1 bg-[#BF092F]",
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                        className: "text-[10px] uppercase font-black tracking-[0.4em] text-white/40",
                                                        children: "Integrated Power"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h4", {
                                                className: "text-2xl font-semibold text-white uppercase tracking-tight mb-6 leading-tight",
                                                children: [
                                                    "E-House & Modular ",
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[#BF092F]",
                                                        children: "POD Solutions"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-white/50 font-medium uppercase tracking-widest text-[11px] leading-loose mb-8 max-w-md",
                                                children: "Pre-fabricated, integrated electrical rooms (EPODs) designed for rapid site-ready deployment."
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "flex flex-wrap gap-2 pt-6 border-t border-white/10",
                                                children: [
                                                    "UKCA / CE Marked",
                                                    "Fire Integrated",
                                                    "Rapid Deployment"
                                                ].map((f)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[9px] font-black uppercase tracking-widest bg-white/5 px-3 py-2 rounded-lg text-white/40 group-hover:text-white transition-colors",
                                                        children: f
                                                    }, f))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: `mb-24 ${revealClass(showSpecs, "duration-[1200ms] delay-200")}`,
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "relative group overflow-hidden rounded-[2rem] border border-gray-100 shadow-2xl bg-[#44444E]",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "relative z-10 grid lg:grid-cols-12",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("aside", {
                                        className: "lg:col-span-4 p-12 md:p-16 bg-[#BF092F] text-white flex flex-col justify-between relative overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "absolute inset-0 opacity-10 pointer-events-none",
                                                "aria-hidden": "true",
                                                style: {
                                                    backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)",
                                                    backgroundSize: "24px 24px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "relative z-10",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-center gap-3 mb-8",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                className: "h-5 w-1 bg-white",
                                                                "aria-hidden": "true"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                                className: "text-[10px] uppercase font-black tracking-[0.4em] text-white/80",
                                                                children: "Supply_Chain_Assurance"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h4", {
                                                        className: "text-4xl font-black uppercase tracking-tighter leading-[0.9] mb-8",
                                                        children: [
                                                            "British ",
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-white/40",
                                                                children: "Design."
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                            "Global ",
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-white/40",
                                                                children: "Delivery."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "relative z-10 space-y-8",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                        className: "text-[11px] font-medium uppercase tracking-[0.2em] text-white/70 leading-relaxed max-w-xs",
                                                        children: "Managing a worldwide supply chain of high-performance technical ancillaries."
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                                        to: "/products",
                                                        className: "inline-flex items-center justify-center gap-6 px-8 py-5 bg-white text-[#BF092F] rounded-xl font-black text-[10px] uppercase tracking-[0.4em] hover:bg-[#44444E] hover:text-white transition-all duration-500 group/btn shadow-xl w-fit",
                                                        children: [
                                                            "Explore Range",
                                                            " ",
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                                size: 14,
                                                                className: "group-hover/btn:translate-x-2 transition-transform"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "lg:col-span-8 p-12 md:p-16 relative bg-[#44444E]",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "grid md:grid-cols-2 gap-12 relative z-10",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                        className: "inline-flex items-center gap-4 py-2 px-4 bg-white/5 border border-white/10 rounded-lg mb-7",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $087fce06e435c243$export$2e2bcd8739ae039), {
                                                                                className: "text-[#BF092F]",
                                                                                size: 20,
                                                                                "aria-hidden": "true"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                                                className: "text-[11px] font-black text-white uppercase tracking-[0.3em]",
                                                                                children: "Fluid Handling"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                        className: "text-[10px] text-white/40 font-medium uppercase tracking-[0.15em] leading-relaxed",
                                                                        children: "Instrumentation for mission-critical fuel systems."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    {
                                                                        name: "Digital Level Gauges"
                                                                    },
                                                                    {
                                                                        name: "Leakage Monitoring"
                                                                    },
                                                                    {
                                                                        name: "Environmental Alarms"
                                                                    }
                                                                ].map((item)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                                        className: "flex items-center justify-between group/item p-4 border border-white/5 rounded-xl hover:border-[#BF092F]/50 hover:bg-white/[0.02] transition-all",
                                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                            className: "flex items-center gap-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                                    className: "w-1.5 h-1.5 rounded-full bg-[#BF092F]",
                                                                                    "aria-hidden": "true"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                                    className: "text-[10px] font-bold text-white/70 uppercase tracking-widest",
                                                                                    children: item.name
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, item.name))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "space-y-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                        className: "inline-flex items-center gap-4 py-2 px-4 bg-white/5 border border-white/10 rounded-lg mb-7",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $da4c1087b2f19ca9$export$2e2bcd8739ae039), {
                                                                                className: "text-[#BF092F]",
                                                                                size: 20,
                                                                                "aria-hidden": "true"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                                                className: "text-[11px] font-black text-white uppercase tracking-[0.3em]",
                                                                                children: "Project Support"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                        className: "text-[10px] text-white/40 font-medium uppercase tracking-[0.15em] leading-relaxed",
                                                                        children: "Ancillary components for global grid standards."
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                                                className: "space-y-2",
                                                                children: [
                                                                    {
                                                                        name: "Vibration Control"
                                                                    },
                                                                    {
                                                                        name: "Thermal Insulation"
                                                                    },
                                                                    {
                                                                        name: "Acoustic Louvres"
                                                                    }
                                                                ].map((item)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                                        className: "flex items-center justify-between group/item p-4 border border-white/5 rounded-xl hover:border-[#BF092F]/50 hover:bg-white/[0.02] transition-all",
                                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                            className: "flex items-center gap-4",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                                    className: "w-1.5 h-1.5 rounded-full bg-[#BF092F]",
                                                                                    "aria-hidden": "true"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                                    className: "text-[10px] font-bold text-white/70 uppercase tracking-widest",
                                                                                    children: item.name
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, item.name))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "mt-16 pt-8 border-t border-white/5 flex flex-wrap gap-10",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex flex-col gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[8px] text-white/30 uppercase tracking-widest font-black",
                                                                children: "UK Governance"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[10px] text-white/60 uppercase font-bold tracking-widest underline decoration-[#BF092F] decoration-2 underline-offset-4",
                                                                children: "PROJECT ASSURED"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex flex-col gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[8px] text-white/30 uppercase tracking-widest font-black",
                                                                children: "Fulfillment"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[10px] text-white/60 uppercase font-bold tracking-widest",
                                                                children: "Worldwide Logistics"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: `grid md:grid-cols-2 gap-6 ${revealClass(showSpecs, "duration-[1200ms] delay-500")}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("aside", {
                                className: "bg-gray-50 p-8 rounded-2xl flex items-center gap-6 group hover:bg-white transition-all border border-transparent hover:border-gray-100 shadow-sm hover:shadow-xl",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-16 h-16 bg-[#44444E] rounded-xl flex items-center justify-center text-[#BF092F]",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $914ea2a5dc385aff$export$2e2bcd8739ae039), {
                                            size: 32,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                className: "font-bold text-[#44444E] uppercase text-sm tracking-widest",
                                                children: "Global Network"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1",
                                                children: "High-capacity manufacturing via UK-led facilities."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("aside", {
                                className: "bg-gray-50 p-8 rounded-2xl flex items-center gap-6 group hover:bg-white transition-all border border-transparent hover:border-gray-100 shadow-sm hover:shadow-xl",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-16 h-16 bg-[#BF092F] rounded-xl flex items-center justify-center text-white shadow-lg shadow-[#BF092F]/20",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                            size: 32,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                className: "font-bold text-[#44444E] uppercase text-sm tracking-widest",
                                                children: "UK Quality Assurance"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1",
                                                children: "All projects managed to British engineering standards."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $154171f69b15d666$var$Stat({ label: label, val: val }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "bg-gray-50 p-5 border border-gray-100 rounded-xl group hover:bg-white hover:shadow-lg transition-all text-center",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "text-sm font-black text-[#BF092F] uppercase tracking-widest mb-1",
                children: val
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "text-[9px] font-bold text-gray-400 uppercase tracking-tighter",
                children: label
            })
        ]
    });
}
function $154171f69b15d666$var$TechItem({ icon: Icon, text: text }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
        className: "flex items-center gap-4 group/item",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center group-hover/item:bg-[#BF092F] transition-all border border-white/10 group-hover/item:border-transparent",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(Icon, {
                    size: 16,
                    className: "text-[#BF092F] group-hover/item:text-white transition-colors",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                className: "text-[11px] font-bold uppercase tracking-[0.2em] text-white/70 group-hover/item:text-white transition-colors",
                children: text
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");
const $c6ba85f1a10a4dbc$export$dbe41a478099b642 = [
    {
        name: "Abu Dhabi National Oil Company",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/ADNOC_Logo.webp"
    },
    {
        name: "Expro International Group Ltd",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/EXPRO_Logo.webp"
    },
    {
        name: "Cummins Inc",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Cummins_Logo.webp"
    },
    {
        name: "Siemens",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Siemens_Logo.webp"
    },
    {
        name: "Dubai Petroleum and Dubai Supply Authority",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Dubai_Petroleum_and_Dubai_Supply_Authority_Logo.webp"
    },
    {
        name: "Al Bahar CAT",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Al-Bahar_CAT_Logo.webp"
    },
    {
        name: "Olayan Energy Ltd",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Olayan_Energy_Logo.webp"
    },
    {
        name: "Motoren- und Turbinen-Union (MTU)",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Motoren-_und_Turbinen-Union_MTU__Logo.webp"
    },
    {
        name: "Jakson Group",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Jakson_Group_Logo.webp"
    },
    {
        name: "Kanoo Energy",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Kanoo_Energy_Logo.webp"
    },
    {
        name: "Energia",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Energia_Logo.webp"
    },
    {
        name: "Peax Equipment Rental",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Peax_Logo.webp"
    },
    {
        name: "WT Petrotech USA",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/WT_Petrotech_USA_Logo.webp"
    },
    {
        name: "Webuild",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Webuild_Logo.webp"
    },
    {
        name: "Bifco",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Bifco_Logo.webp"
    },
    {
        name: "Intech",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Intech_Logo.webp"
    },
    {
        name: "Versar",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Versar_Logo.webp"
    },
    {
        name: "Al-Sultan & Khalaf Trading Co",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Al-Sultan_Khalaf_Trading_Co_Logo.webp"
    },
    {
        name: "Danway Group",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Danway_Logo.webp"
    },
    {
        name: "Hunter",
        logo: "https://media.arcengltd.com/cdn-cgi/image/width=400,height=200,fit=pad,background=transparent,trim=0,format=auto,quality=auto/partner-images/Hunter_Logo.webp"
    }
];




function $793560686aa44278$export$2e2bcd8739ae039() {
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const sectionRef = (0, $4Iuzv.useRef)(null);
    // SEO: Comprehensive Partner List for Search Engine Knowledge Graph
    const fullPartnerList = "Abu Dhabi National Oil Company (ADNOC), Siemens Energy, Cummins, Caterpillar (Al Bahar), Dubai Petroleum, Webuild, MTU, Jakson Group, Kanoo Energy, Expro";
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setIsVisible(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    const revealClass = (visible, delay = "duration-1000")=>`transition-all ${delay} ease-[cubic-bezier(0.22,1,0.36,1)] ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`;
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative w-full py-24 bg-white overflow-hidden",
        "aria-labelledby": "partners-title",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                    type: "application/ld+json",
                    children: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Arc Engineering Solutions Ltd",
                        "url": "https://arcengltd.com",
                        "description": `Strategic partner to global energy and infrastructure leaders including ${fullPartnerList}.`,
                        "brand": (0, $c6ba85f1a10a4dbc$export$dbe41a478099b642).map((p)=>({
                                "@type": "Brand",
                                "name": p.name
                            }))
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "container mx-auto px-4 md:px-6 relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: `mb-16 ${revealClass(isVisible)}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-8 w-1 bg-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F] animate-pulse",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "text-sm text-[#44444E] uppercase font-bold tracking-[0.4em]",
                                        children: "Global Network"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col lg:flex-row lg:items-end justify-between gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                        id: "partners-title",
                                        className: "text-3xl md:text-5xl font-semibold text-[#44444E] leading-tight uppercase tracking-tight",
                                        children: [
                                            "Strategic ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Partnerships"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                        className: "max-w-md text-gray-400 font-bold uppercase tracking-widest text-[10px] leading-relaxed pb-1 border-l-2 border-gray-100 pl-6 lg:ml-8",
                                        children: [
                                            "Our ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("strong", {
                                                children: "UK-led engineering"
                                            }),
                                            " and large-scale manufacturing are trusted by global leaders in ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("strong", {
                                                children: "Oil & Gas, Renewable Energy, and Mission-Critical Infrastructure."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: `grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden ${revealClass(isVisible, "duration-[1200ms] delay-300")}`,
                        children: (0, $c6ba85f1a10a4dbc$export$dbe41a478099b642).map((partner, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "group relative aspect-[3/2] bg-white border-r border-b border-gray-100 flex flex-col items-center justify-center p-8 transition-all duration-500 hover:z-20 hover:shadow-[0_20px_50px_rgba(0,0,0,0.1)] hover:-translate-y-1 cursor-crosshair overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "absolute inset-0 bg-gradient-to-br from-white via-white to-gray-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "absolute -bottom-10 -right-10 w-32 h-32 bg-[#BF092F]/5 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                        className: "absolute top-4 left-4 text-[8px] font-mono font-bold text-gray-300 group-hover:text-[#44444E] transition-colors uppercase tracking-widest z-10",
                                        children: [
                                            "NETWORK_0",
                                            index + 1
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $937c5640447fbab0$export$2e2bcd8739ae039), {
                                        className: "absolute top-4 right-4 text-gray-100 group-hover:text-[#BF092F] transition-all z-10",
                                        size: 14,
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "relative z-10 w-full flex justify-center items-center",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                            src: partner.logo,
                                            alt: `${partner.name} - Official Project Partner of Arc Engineering`,
                                            loading: "lazy",
                                            className: "w-[80%] h-auto object-contain grayscale opacity-40 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700 ease-out"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "absolute bottom-4 left-0 w-full px-4 opacity-0 group-hover:opacity-100 transition-all translate-y-2 group-hover:translate-y-0 duration-500 text-center z-10",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[9px] font-black text-[#BF092F] uppercase tracking-[0.3em]",
                                            children: partner.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "absolute bottom-0 left-0 w-0 h-[2px] bg-[#BF092F] group-hover:w-full transition-all duration-500",
                                        "aria-hidden": "true"
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $be1846e1ca97d842$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $be1846e1ca97d842$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("circle-check", $be1846e1ca97d842$export$3efd853dbb351e94);





var $4Iuzv = parcelRequire("4Iuzv");
const $60912ec5476cd0e6$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $60912ec5476cd0e6$var$rotate = (v)=>{
    const angle = $60912ec5476cd0e6$var$radToDeg(Math.atan2(v[1], v[0]));
    return $60912ec5476cd0e6$var$rebaseAngle(angle);
};
const $60912ec5476cd0e6$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $60912ec5476cd0e6$var$rotate,
    rotateZ: $60912ec5476cd0e6$var$rotate,
    skewX: (v)=>$60912ec5476cd0e6$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$60912ec5476cd0e6$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $60912ec5476cd0e6$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $60912ec5476cd0e6$var$rotateZ = $60912ec5476cd0e6$var$rotate;
const $60912ec5476cd0e6$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $60912ec5476cd0e6$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $60912ec5476cd0e6$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $60912ec5476cd0e6$var$scaleX,
    scaleY: $60912ec5476cd0e6$var$scaleY,
    scale: (v)=>($60912ec5476cd0e6$var$scaleX(v) + $60912ec5476cd0e6$var$scaleY(v)) / 2,
    rotateX: (v)=>$60912ec5476cd0e6$var$rebaseAngle($60912ec5476cd0e6$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$60912ec5476cd0e6$var$rebaseAngle($60912ec5476cd0e6$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $60912ec5476cd0e6$var$rotateZ,
    rotate: $60912ec5476cd0e6$var$rotateZ,
    skewX: (v)=>$60912ec5476cd0e6$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$60912ec5476cd0e6$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $60912ec5476cd0e6$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $60912ec5476cd0e6$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $60912ec5476cd0e6$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $60912ec5476cd0e6$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $60912ec5476cd0e6$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $60912ec5476cd0e6$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($60912ec5476cd0e6$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $60912ec5476cd0e6$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $60912ec5476cd0e6$export$f9111f9e16b73a26(transform, name);
};
function $60912ec5476cd0e6$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

const $5c3424ea1660fbd8$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $5c3424ea1660fbd8$export$9de1236619d9e756 = /*@__PURE__*/ $5c3424ea1660fbd8$var$checkStringStartsWith("--");
const $5c3424ea1660fbd8$var$startsAsVariableToken = /*@__PURE__*/ $5c3424ea1660fbd8$var$checkStringStartsWith("var(--");
const $5c3424ea1660fbd8$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $5c3424ea1660fbd8$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $5c3424ea1660fbd8$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $5c3424ea1660fbd8$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;

/**
 * Generate a list of every possible transform key.
 */ const $21de3bfd13be6c1d$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $21de3bfd13be6c1d$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($21de3bfd13be6c1d$export$280dc01950909d86))();


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $9a2bd418b4578e65$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $9a2bd418b4578e65$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $9a2bd418b4578e65$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $20ee05cfbd62a026$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $b411a0e1e2035a6e$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $b411a0e1e2035a6e$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$b411a0e1e2035a6e$var$isIdentityScale(scale) || !$b411a0e1e2035a6e$var$isIdentityScale(scaleX) || !$b411a0e1e2035a6e$var$isIdentityScale(scaleY);
}
function $b411a0e1e2035a6e$export$a545127cf1fbb600(values) {
    return $b411a0e1e2035a6e$export$bdf30dca883ea463(values) || $b411a0e1e2035a6e$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $b411a0e1e2035a6e$export$bf80f5f8f4dc327f(values) {
    return $b411a0e1e2035a6e$var$is2DTranslate(values.x) || $b411a0e1e2035a6e$var$is2DTranslate(values.y);
}
function $b411a0e1e2035a6e$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $98986c5ac90dc9e9$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $98986c5ac90dc9e9$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $98986c5ac90dc9e9$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $98986c5ac90dc9e9$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $98986c5ac90dc9e9$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $98986c5ac90dc9e9$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $98986c5ac90dc9e9$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $98986c5ac90dc9e9$export$d80074982803af5c(box, { x: x, y: y }) {
    $98986c5ac90dc9e9$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $98986c5ac90dc9e9$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $98986c5ac90dc9e9$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $98986c5ac90dc9e9$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $98986c5ac90dc9e9$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $98986c5ac90dc9e9$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $98986c5ac90dc9e9$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $b411a0e1e2035a6e$export$a545127cf1fbb600)(node.latestValues)) $98986c5ac90dc9e9$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $98986c5ac90dc9e9$var$TREE_SCALE_SNAP_MAX && treeScale.x > $98986c5ac90dc9e9$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $98986c5ac90dc9e9$var$TREE_SCALE_SNAP_MAX && treeScale.y > $98986c5ac90dc9e9$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $98986c5ac90dc9e9$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $98986c5ac90dc9e9$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $98986c5ac90dc9e9$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $98986c5ac90dc9e9$export$58b16271041fbfb(box, transform) {
    $98986c5ac90dc9e9$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $98986c5ac90dc9e9$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $07607abcfa7c0ab6$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $9a2bd418b4578e65$export$d3955c6a8f65a36b)((0, $9a2bd418b4578e65$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $07607abcfa7c0ab6$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $07607abcfa7c0ab6$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $98986c5ac90dc9e9$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $98986c5ac90dc9e9$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}



const $dd3d0cfb441d941e$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $21de3bfd13be6c1d$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $7e8fa5aacccc465e$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


const $7338642ed55f7b49$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $90bdd94fd26c3f66$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $90bdd94fd26c3f66$export$58f0f39f63f3cf42 = {
    ...$90bdd94fd26c3f66$export$98e628dec113755e,
    transform: (v)=>(0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $90bdd94fd26c3f66$export$dcdf75081b88279d = {
    ...$90bdd94fd26c3f66$export$98e628dec113755e,
    default: 1
};


/*#__NO_SIDE_EFFECTS__*/ const $c572ffa671c2bc09$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $c572ffa671c2bc09$export$41fc368e1a942b97 = /*@__PURE__*/ $c572ffa671c2bc09$var$createUnitType("deg");
const $c572ffa671c2bc09$export$626336c2cd4b14de = /*@__PURE__*/ $c572ffa671c2bc09$var$createUnitType("%");
const $c572ffa671c2bc09$export$91c0eda1d06bf008 = /*@__PURE__*/ $c572ffa671c2bc09$var$createUnitType("px");
const $c572ffa671c2bc09$export$f91e8c45a95a32f2 = /*@__PURE__*/ $c572ffa671c2bc09$var$createUnitType("vh");
const $c572ffa671c2bc09$export$aed3d7b7d206c196 = /*@__PURE__*/ $c572ffa671c2bc09$var$createUnitType("vw");
const $c572ffa671c2bc09$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$c572ffa671c2bc09$export$626336c2cd4b14de,
        parse: (v)=>$c572ffa671c2bc09$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$c572ffa671c2bc09$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $a00a88e9ec3f9434$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $3dde2d5276275002$export$d176691c1998a1f5 = [
    (0, $90bdd94fd26c3f66$export$98e628dec113755e),
    (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    (0, $c572ffa671c2bc09$export$626336c2cd4b14de),
    (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    (0, $c572ffa671c2bc09$export$aed3d7b7d206c196),
    (0, $c572ffa671c2bc09$export$f91e8c45a95a32f2),
    (0, $7e8fa5aacccc465e$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $3dde2d5276275002$export$eefdd52e3ccae428 = (v)=>$3dde2d5276275002$export$d176691c1998a1f5.find((0, $a00a88e9ec3f9434$export$6eae4d0a6a7ca7cd)(v));



let $fc095028715896dd$export$491112666e282270 = ()=>{};
let $fc095028715896dd$export$f5708dca728d7177 = ()=>{};
var $fc095028715896dd$var$check, $fc095028715896dd$var$message, $fc095028715896dd$var$errorCode, $fc095028715896dd$var$check1, $fc095028715896dd$var$message1, $fc095028715896dd$var$errorCode1;

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $101af06e328f09dc$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $fa03d5106176b1f7$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $fa03d5106176b1f7$export$b9f0c1f373aee2b0(current) {
    const match = $fa03d5106176b1f7$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $fa03d5106176b1f7$var$maxDepth = 4;
function $fa03d5106176b1f7$export$289398774300c991(current, element, depth = 1) {
    (0, $fc095028715896dd$export$f5708dca728d7177)(depth <= $fa03d5106176b1f7$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $fa03d5106176b1f7$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $101af06e328f09dc$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $5c3424ea1660fbd8$export$31f9caa2600b5723)(fallback) ? $fa03d5106176b1f7$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $8738d9231eb72cbb$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}






const $64237015b018e64e$export$8e5250d1aa9bf370 = (v)=>v === (0, $90bdd94fd26c3f66$export$98e628dec113755e) || v === (0, $c572ffa671c2bc09$export$91c0eda1d06bf008);
const $64237015b018e64e$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $64237015b018e64e$var$nonTranslationalTransformKeys = (0, $21de3bfd13be6c1d$export$280dc01950909d86).filter((key)=>!$64237015b018e64e$var$transformKeys.has(key));
function $64237015b018e64e$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $64237015b018e64e$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $64237015b018e64e$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $60912ec5476cd0e6$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $60912ec5476cd0e6$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$64237015b018e64e$export$781d46a8aa670d52.translateX = $64237015b018e64e$export$781d46a8aa670d52.x;
$64237015b018e64e$export$781d46a8aa670d52.translateY = $64237015b018e64e$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $38f396ca024a6caf$export$8793edee2d425525 = (any)=>any;


const $dfee85868ac3d151$export$dd826089e3c5e502 = {};


const $62c075969ee25a65$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $93753a2081bc00ed$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $2e9a34dec9629bb9$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $93753a2081bc00ed$export$84ce9a476f53d110).value) (0, $93753a2081bc00ed$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3000339309518216$var$maxElapsed = 40;
function $3000339309518216$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $62c075969ee25a65$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $2e9a34dec9629bb9$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $dfee85868ac3d151$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $dfee85868ac3d151$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3000339309518216$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $62c075969ee25a65$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $62c075969ee25a65$export$71ecace0a033b35a).length; i++)steps[(0, $62c075969ee25a65$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $95a89474cd9c2897$export$2cef06c20297c17d, cancel: $95a89474cd9c2897$export$ec99c0ef4978dccb, state: $95a89474cd9c2897$export$fff89137e9e818ce, steps: $95a89474cd9c2897$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $3000339309518216$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $38f396ca024a6caf$export$8793edee2d425525), true);


const $d6218563c70fe564$var$toResolve = new Set();
let $d6218563c70fe564$var$isScheduled = false;
let $d6218563c70fe564$var$anyNeedsMeasurement = false;
let $d6218563c70fe564$var$isForced = false;
function $d6218563c70fe564$var$measureAllKeyframes() {
    if ($d6218563c70fe564$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($d6218563c70fe564$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $64237015b018e64e$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $d6218563c70fe564$var$anyNeedsMeasurement = false;
    $d6218563c70fe564$var$isScheduled = false;
    $d6218563c70fe564$var$toResolve.forEach((resolver)=>resolver.complete($d6218563c70fe564$var$isForced));
    $d6218563c70fe564$var$toResolve.clear();
}
function $d6218563c70fe564$var$readAllKeyframes() {
    $d6218563c70fe564$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $d6218563c70fe564$var$anyNeedsMeasurement = true;
    });
}
function $d6218563c70fe564$export$78b96d2a12593b05() {
    $d6218563c70fe564$var$isForced = true;
    $d6218563c70fe564$var$readAllKeyframes();
    $d6218563c70fe564$var$measureAllKeyframes();
    $d6218563c70fe564$var$isForced = false;
}
class $d6218563c70fe564$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $d6218563c70fe564$var$toResolve.add(this);
            if (!$d6218563c70fe564$var$isScheduled) {
                $d6218563c70fe564$var$isScheduled = true;
                (0, $95a89474cd9c2897$export$2cef06c20297c17d).read($d6218563c70fe564$var$readAllKeyframes);
                (0, $95a89474cd9c2897$export$2cef06c20297c17d).resolveKeyframes($d6218563c70fe564$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $8738d9231eb72cbb$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $d6218563c70fe564$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $d6218563c70fe564$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $47ff4ec8464497cf$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $02d1530a9740ae25$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $47ff4ec8464497cf$export$ade84c85e44a6cb1)(value);
    else return true;
}




// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $663d31808dac64b9$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $9c4f2369fcefc980$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $20db4673a8f4c2aa$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $f67b2bdab0aa7e49$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $254d998b42244404$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $f67b2bdab0aa7e49$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $20db4673a8f4c2aa$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $254d998b42244404$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $9c4f2369fcefc980$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $dab772ce0bd73cdd$var$clampRgbUnit = (v)=>(0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(0, 255, v);
const $dab772ce0bd73cdd$export$7a99c86b5b1f4c9e = {
    ...(0, $90bdd94fd26c3f66$export$98e628dec113755e),
    transform: (v)=>Math.round($dab772ce0bd73cdd$var$clampRgbUnit(v))
};
const $dab772ce0bd73cdd$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $254d998b42244404$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $254d998b42244404$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $dab772ce0bd73cdd$export$7a99c86b5b1f4c9e.transform(red) + ", " + $dab772ce0bd73cdd$export$7a99c86b5b1f4c9e.transform(green) + ", " + $dab772ce0bd73cdd$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $663d31808dac64b9$export$83d2e9e3e4ee39ed)((0, $90bdd94fd26c3f66$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $6f47c0ea48e2efb7$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $6f47c0ea48e2efb7$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $254d998b42244404$export$2c8400d58aca05e)("#"),
    parse: $6f47c0ea48e2efb7$var$parseHex,
    transform: (0, $dab772ce0bd73cdd$export$4e46ac54fc82cf3b).transform
};






const $a43233cd311b50e3$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $254d998b42244404$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $254d998b42244404$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $c572ffa671c2bc09$export$626336c2cd4b14de).transform((0, $663d31808dac64b9$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $c572ffa671c2bc09$export$626336c2cd4b14de).transform((0, $663d31808dac64b9$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $663d31808dac64b9$export$83d2e9e3e4ee39ed)((0, $90bdd94fd26c3f66$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $1174160f464bd20e$export$35e9368ef982300f = {
    test: (v)=>(0, $dab772ce0bd73cdd$export$4e46ac54fc82cf3b).test(v) || (0, $6f47c0ea48e2efb7$export$834dfc94dde4b3d8).test(v) || (0, $a43233cd311b50e3$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $dab772ce0bd73cdd$export$4e46ac54fc82cf3b).test(v)) return (0, $dab772ce0bd73cdd$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $a43233cd311b50e3$export$810b04175080204c).test(v)) return (0, $a43233cd311b50e3$export$810b04175080204c).parse(v);
        else return (0, $6f47c0ea48e2efb7$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $dab772ce0bd73cdd$export$4e46ac54fc82cf3b).transform(v) : (0, $a43233cd311b50e3$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $1174160f464bd20e$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $1174160f464bd20e$export$35e9368ef982300f.transform(parsed);
    }
};


const $73babcb2635ebda3$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $418805e9b08dff8a$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $9c4f2369fcefc980$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $73babcb2635ebda3$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $418805e9b08dff8a$var$NUMBER_TOKEN = "number";
const $418805e9b08dff8a$var$COLOR_TOKEN = "color";
const $418805e9b08dff8a$var$VAR_TOKEN = "var";
const $418805e9b08dff8a$var$VAR_FUNCTION_TOKEN = "var(";
const $418805e9b08dff8a$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $418805e9b08dff8a$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $418805e9b08dff8a$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($418805e9b08dff8a$var$complexRegex, (parsedValue)=>{
        if ((0, $1174160f464bd20e$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($418805e9b08dff8a$var$COLOR_TOKEN);
            values.push((0, $1174160f464bd20e$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($418805e9b08dff8a$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($418805e9b08dff8a$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($418805e9b08dff8a$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $418805e9b08dff8a$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($418805e9b08dff8a$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $418805e9b08dff8a$var$parseComplexValue(v) {
    return $418805e9b08dff8a$export$b61fc7c44bf646d5(v).values;
}
function $418805e9b08dff8a$var$createTransformer(source) {
    const { split: split, types: types } = $418805e9b08dff8a$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $418805e9b08dff8a$var$NUMBER_TOKEN) output += (0, $663d31808dac64b9$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $418805e9b08dff8a$var$COLOR_TOKEN) output += (0, $1174160f464bd20e$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $418805e9b08dff8a$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $1174160f464bd20e$export$35e9368ef982300f).test(v) ? (0, $1174160f464bd20e$export$35e9368ef982300f).getAnimatableNone(v) : v;
function $418805e9b08dff8a$var$getAnimatableNone(v) {
    const parsed = $418805e9b08dff8a$var$parseComplexValue(v);
    const transformer = $418805e9b08dff8a$var$createTransformer(v);
    return transformer(parsed.map($418805e9b08dff8a$var$convertNumbersToZero));
}
const $418805e9b08dff8a$export$83a0e34f1302825b = {
    test: $418805e9b08dff8a$var$test,
    parse: $418805e9b08dff8a$var$parseComplexValue,
    createTransformer: $418805e9b08dff8a$var$createTransformer,
    getAnimatableNone: $418805e9b08dff8a$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $161d77ba841bec6a$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $161d77ba841bec6a$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $9c4f2369fcefc980$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $161d77ba841bec6a$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $161d77ba841bec6a$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $161d77ba841bec6a$export$3dea766d36a8935f = {
    ...(0, $418805e9b08dff8a$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($161d77ba841bec6a$var$functionRegex);
        return functions ? functions.map($161d77ba841bec6a$var$applyDefaultFilter).join(" ") : v;
    }
};





const $05156a29be9730e3$export$7d260a2a5f8bc19e = {
    ...(0, $90bdd94fd26c3f66$export$98e628dec113755e),
    transform: Math.round
};






const $dc0da6ff7e51f8aa$export$f2e4285fee37e26 = {
    rotate: (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    rotateX: (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    rotateY: (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    rotateZ: (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    scale: $90bdd94fd26c3f66$export$dcdf75081b88279d,
    scaleX: (0, $90bdd94fd26c3f66$export$dcdf75081b88279d),
    scaleY: (0, $90bdd94fd26c3f66$export$dcdf75081b88279d),
    scaleZ: (0, $90bdd94fd26c3f66$export$dcdf75081b88279d),
    skew: (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    skewX: (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    skewY: (0, $c572ffa671c2bc09$export$41fc368e1a942b97),
    distance: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    translateX: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    translateY: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    translateZ: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    x: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    y: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    z: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    perspective: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    transformPerspective: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    opacity: (0, $90bdd94fd26c3f66$export$58f0f39f63f3cf42),
    originX: (0, $c572ffa671c2bc09$export$44e2e1705876d7ed),
    originY: (0, $c572ffa671c2bc09$export$44e2e1705876d7ed),
    originZ: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008)
};


const $57965c2a12e95a8d$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderTopWidth: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderRightWidth: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderRadius: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    radius: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    maxWidth: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    height: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    maxHeight: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    top: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    right: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    bottom: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    left: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    paddingTop: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    paddingRight: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    paddingBottom: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    paddingLeft: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    margin: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    marginTop: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    marginRight: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    marginBottom: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    marginLeft: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $c572ffa671c2bc09$export$91c0eda1d06bf008),
    ...(0, $dc0da6ff7e51f8aa$export$f2e4285fee37e26),
    zIndex: (0, $05156a29be9730e3$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $90bdd94fd26c3f66$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $90bdd94fd26c3f66$export$58f0f39f63f3cf42),
    numOctaves: (0, $05156a29be9730e3$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $28aa011a5735522d$export$98cd7c72c5a731fb = {
    ...(0, $57965c2a12e95a8d$export$eec14432cd1cb67b),
    color: // Color props
    $1174160f464bd20e$export$35e9368ef982300f,
    backgroundColor: (0, $1174160f464bd20e$export$35e9368ef982300f),
    outlineColor: (0, $1174160f464bd20e$export$35e9368ef982300f),
    fill: (0, $1174160f464bd20e$export$35e9368ef982300f),
    stroke: (0, $1174160f464bd20e$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $1174160f464bd20e$export$35e9368ef982300f),
    borderTopColor: (0, $1174160f464bd20e$export$35e9368ef982300f),
    borderRightColor: (0, $1174160f464bd20e$export$35e9368ef982300f),
    borderBottomColor: (0, $1174160f464bd20e$export$35e9368ef982300f),
    borderLeftColor: (0, $1174160f464bd20e$export$35e9368ef982300f),
    filter: $161d77ba841bec6a$export$3dea766d36a8935f,
    WebkitFilter: (0, $161d77ba841bec6a$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $28aa011a5735522d$export$67d1babe0338d23b = (key)=>$28aa011a5735522d$export$98cd7c72c5a731fb[key];


function $e908fb2b7f5deed3$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $28aa011a5735522d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $161d77ba841bec6a$export$3dea766d36a8935f)) defaultValueType = (0, $418805e9b08dff8a$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $e958758250ba50a4$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $e958758250ba50a4$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$e958758250ba50a4$var$invalidTemplates.has(keyframe) && (0, $418805e9b08dff8a$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $e908fb2b7f5deed3$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $b8a4e33f3c678447$export$4983792d11b61017 extends (0, $d6218563c70fe564$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $5c3424ea1660fbd8$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $fa03d5106176b1f7$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $dd3d0cfb441d941e$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $3dde2d5276275002$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $3dde2d5276275002$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $64237015b018e64e$export$8e5250d1aa9bf370)(originType) && (0, $64237015b018e64e$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $64237015b018e64e$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $02d1530a9740ae25$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $e958758250ba50a4$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $64237015b018e64e$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $64237015b018e64e$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

const $3c4a286c67dcb5f1$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);






/**
 * A list of all ValueTypes
 */ const $4cbb369c113760b3$var$valueTypes = [
    ...(0, $3dde2d5276275002$export$d176691c1998a1f5),
    (0, $1174160f464bd20e$export$35e9368ef982300f),
    (0, $418805e9b08dff8a$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $4cbb369c113760b3$export$950e7e59ea1ffed7 = (v)=>$4cbb369c113760b3$var$valueTypes.find((0, $a00a88e9ec3f9434$export$6eae4d0a6a7ca7cd)(v));


const { schedule: $afa024ccba882b1b$export$bb76eed83315504c, cancel: $afa024ccba882b1b$export$3252729004b8456e } = /* @__PURE__ */ (0, $3000339309518216$export$510b0596a933801a)(queueMicrotask, false);

function $8739612c7250ccbb$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $8739612c7250ccbb$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $8739612c7250ccbb$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $5c95bc33b1b87b66$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $8739612c7250ccbb$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $8739612c7250ccbb$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $b68d897340517dfd$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




let $07d2abf88a6ff3f7$var$now;
function $07d2abf88a6ff3f7$var$clearTime() {
    $07d2abf88a6ff3f7$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $07d2abf88a6ff3f7$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($07d2abf88a6ff3f7$var$now === undefined) $07d2abf88a6ff3f7$export$2da9be4cfdb689b1.set((0, $95a89474cd9c2897$export$fff89137e9e818ce).isProcessing || (0, $dfee85868ac3d151$export$dd826089e3c5e502).useManualTiming ? (0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp : performance.now());
        return $07d2abf88a6ff3f7$var$now;
    },
    set: (newTime)=>{
        $07d2abf88a6ff3f7$var$now = newTime;
        queueMicrotask($07d2abf88a6ff3f7$var$clearTime);
    }
};



/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $190a8a8284ab6cc9$var$MAX_VELOCITY_DELTA = 30;
const $190a8a8284ab6cc9$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $190a8a8284ab6cc9$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $190a8a8284ab6cc9$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $190a8a8284ab6cc9$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $5c95bc33b1b87b66$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $95a89474cd9c2897$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($190a8a8284ab6cc9$export$67fcd818a264039d.current) $190a8a8284ab6cc9$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $190a8a8284ab6cc9$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $190a8a8284ab6cc9$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $b68d897340517dfd$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $190a8a8284ab6cc9$export$ce8bdc721e76545f(init, options) {
    return new $190a8a8284ab6cc9$export$8cea36d14ee64562(init, options);
}



const $2ffbe0bd0007e1d9$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $2ffbe0bd0007e1d9$export$65570e08d843624d = {};
for(const key in $2ffbe0bd0007e1d9$var$featureProps)$2ffbe0bd0007e1d9$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$2ffbe0bd0007e1d9$var$featureProps[key].some((name)=>!!props[name])
};


const $0ec9f723b7ee27bd$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $0ec9f723b7ee27bd$export$3d227df54007d73a = ()=>({
        x: $0ec9f723b7ee27bd$export$ff25708b37f72782(),
        y: $0ec9f723b7ee27bd$export$ff25708b37f72782()
    });
const $0ec9f723b7ee27bd$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $0ec9f723b7ee27bd$export$6459fc9e86be362e = ()=>({
        x: $0ec9f723b7ee27bd$export$6db76765312617ac(),
        y: $0ec9f723b7ee27bd$export$6db76765312617ac()
    });


const $0ab38ae2ebfb4def$export$4e09c449d6c407f7 = typeof window !== "undefined";


// Does this device prefer reduced motion? Returns `null` server-side.
const $6caf9553a3e71f69$export$ff7706047246b98b = {
    current: null
};
const $6caf9553a3e71f69$export$6476d16e2fd2d0db = {
    current: false
};


function $9f031e18841a3121$export$ca9f41fb23dded3d() {
    (0, $6caf9553a3e71f69$export$6476d16e2fd2d0db).current = true;
    if (!(0, $0ab38ae2ebfb4def$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $6caf9553a3e71f69$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $6caf9553a3e71f69$export$ff7706047246b98b).current = false;
}



const $7935409412df1473$export$bc2a978a17abfdde = new WeakMap();


function $f30b2a5cf584d33c$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $301484e5a72a11e0$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $53cb262a3dd5a1e0$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $53cb262a3dd5a1e0$export$1405a65085f40b9 = [
    "initial",
    ...$53cb262a3dd5a1e0$export$16e45afcc206d3a8
];


function $187a5815cc25f4a5$export$4b3c3bd8d910d78d(props) {
    return (0, $f30b2a5cf584d33c$export$aa71198ceeaf53ce)(props.animate) || (0, $53cb262a3dd5a1e0$export$1405a65085f40b9).some((name)=>(0, $301484e5a72a11e0$export$720b90e312cea233)(props[name]));
}
function $187a5815cc25f4a5$export$ce46fa4165cdec40(props) {
    return Boolean($187a5815cc25f4a5$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $b8d467070a7c6e21$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


function $4ef342dafb102405$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $4ef342dafb102405$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $4ef342dafb102405$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $4ef342dafb102405$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


const $114e1c9ccccab3db$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $114e1c9ccccab3db$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $d6218563c70fe564$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $95a89474cd9c2897$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $187a5815cc25f4a5$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $187a5815cc25f4a5$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $7935409412df1473$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $6caf9553a3e71f69$export$6476d16e2fd2d0db).current) (0, $9f031e18841a3121$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $6caf9553a3e71f69$export$ff7706047246b98b).current;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $21de3bfd13be6c1d$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $95a89474cd9c2897$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $2ffbe0bd0007e1d9$export$65570e08d843624d){
            const featureDefinition = (0, $2ffbe0bd0007e1d9$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $114e1c9ccccab3db$var$propEventHandlers.length; i++){
            const key = $114e1c9ccccab3db$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $b8d467070a7c6e21$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $101af06e328f09dc$export$65583ed5a868f2d9)(value) || (0, $47ff4ec8464497cf$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $4cbb369c113760b3$export$950e7e59ea1ffed7)(value) && (0, $418805e9b08dff8a$export$83a0e34f1302825b).test(target)) value = (0, $e908fb2b7f5deed3$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $4ef342dafb102405$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $5c95bc33b1b87b66$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $afa024ccba882b1b$export$bb76eed83315504c).render(this.render);
    }
}


class $278ed919a3ab8cb3$export$e49735c2a366bdc7 extends (0, $114e1c9ccccab3db$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $b8a4e33f3c678447$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $24968ad0fdf9d918$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $c422c07172e3da64$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $c422c07172e3da64$var$numTransforms = (0, $21de3bfd13be6c1d$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $c422c07172e3da64$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $c422c07172e3da64$var$numTransforms; i++){
        const key = (0, $21de3bfd13be6c1d$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $24968ad0fdf9d918$export$453ef540a9a1bd6b)(value, (0, $57965c2a12e95a8d$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $c422c07172e3da64$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $a64d70b6c78d35bf$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $21de3bfd13be6c1d$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $5c3424ea1660fbd8$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $24968ad0fdf9d918$export$453ef540a9a1bd6b)(value, (0, $57965c2a12e95a8d$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $c422c07172e3da64$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $b732d67c3a0e76cc$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}





const $3063faa9fe482faa$export$91ddd985b97788d1 = {};
function $3063faa9fe482faa$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $3063faa9fe482faa$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $5c3424ea1660fbd8$export$9de1236619d9e756)(key)) $3063faa9fe482faa$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $342bd31154d08f3b$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $21de3bfd13be6c1d$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $3063faa9fe482faa$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $8c8ab8ee64e611ef$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(prevProps.style[key]) || (0, $342bd31154d08f3b$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $fbdbfd1b7b4b91cf$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $fbdbfd1b7b4b91cf$export$23fea75b03ac16b3 extends (0, $278ed919a3ab8cb3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $b732d67c3a0e76cc$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $21de3bfd13be6c1d$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $60912ec5476cd0e6$export$1f10c01143b9f089)(key) : (0, $60912ec5476cd0e6$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $fbdbfd1b7b4b91cf$export$3735103072e4a80(instance);
            const value = ((0, $5c3424ea1660fbd8$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $07607abcfa7c0ab6$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $a64d70b6c78d35bf$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $8c8ab8ee64e611ef$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}





/**
 * Convert camelCase to dash-case properties.
 */ const $6be15922014291dd$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();




const $51444f34942d41e6$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $51444f34942d41e6$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $51444f34942d41e6$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $51444f34942d41e6$var$dashKeys : $51444f34942d41e6$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $c572ffa671c2bc09$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $c572ffa671c2bc09$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $c572ffa671c2bc09$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $6bf5fb41e8c59f21$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $a64d70b6c78d35bf$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $51444f34942d41e6$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $a6c4371628fb7038$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $dedcd02e60578fbd$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $3c703e4c7948db8a$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $b732d67c3a0e76cc$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $a6c4371628fb7038$export$28931db5d57958e5).has(key) ? (0, $6be15922014291dd$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




function $5a8893d7af93d31d$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $8c8ab8ee64e611ef$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(props[key]) || (0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $21de3bfd13be6c1d$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $8359f45e23ed9927$export$86bcdffbaf733d84 extends (0, $278ed919a3ab8cb3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $21de3bfd13be6c1d$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $28aa011a5735522d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $a6c4371628fb7038$export$28931db5d57958e5).has(key) ? (0, $6be15922014291dd$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $5a8893d7af93d31d$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $6bf5fb41e8c59f21$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $3c703e4c7948db8a$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $dedcd02e60578fbd$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c38d07537ff1a36c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $0495a5316e5c4c9e$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $c38d07537ff1a36c$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}


const $da054e8f0ed05935$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $0495a5316e5c4c9e$export$88f3fc2fd3766989)(Component) ? new (0, $8359f45e23ed9927$export$86bcdffbaf733d84)(options) : new (0, $fbdbfd1b7b4b91cf$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $4Iuzv.Fragment)
    });
};






var $4Iuzv = parcelRequire("4Iuzv");

var $4Iuzv = parcelRequire("4Iuzv");
"use client";
const $0e4236be71a40dd4$export$a3579ca508007a95 = (0, $4Iuzv.createContext)({});



var $4Iuzv = parcelRequire("4Iuzv");
"use client";
const $68ceafa408029e9d$export$40f10139ecf1f171 = (0, $4Iuzv.createContext)({
    strict: false
});



var $4Iuzv = parcelRequire("4Iuzv");
"use client";
/**
 * @public
 */ const $5bcd9ec5c3a0a98c$export$22a697fb29aac98d = (0, $4Iuzv.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $4Iuzv = parcelRequire("4Iuzv");
"use client";
const $42fe97da1105d4d3$export$2285bbca2c666415 = /* @__PURE__ */ (0, $4Iuzv.createContext)({});



var $4Iuzv = parcelRequire("4Iuzv");



function $29002c7374f6e40f$export$12fc32fc096a04a3(props, context) {
    if ((0, $187a5815cc25f4a5$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $301484e5a72a11e0$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $301484e5a72a11e0$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $74b75d2f8cd65562$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $29002c7374f6e40f$export$12fc32fc096a04a3)(props, (0, $4Iuzv.useContext)((0, $42fe97da1105d4d3$export$2285bbca2c666415)));
    return (0, $4Iuzv.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $74b75d2f8cd65562$var$variantLabelsAsDependency(initial),
        $74b75d2f8cd65562$var$variantLabelsAsDependency(animate)
    ]);
}
function $74b75d2f8cd65562$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}




var $4Iuzv = parcelRequire("4Iuzv");


var $4Iuzv = parcelRequire("4Iuzv");


const $6aef8f0a0aef266b$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $8d48ff238658da2d$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(source[key]) && !(0, $342bd31154d08f3b$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $8d48ff238658da2d$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $4Iuzv.useMemo)(()=>{
        const state = (0, $6aef8f0a0aef266b$export$8940b483cf52eeda)();
        (0, $a64d70b6c78d35bf$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $8d48ff238658da2d$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $8d48ff238658da2d$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $8d48ff238658da2d$var$useInitialMotionValues(props, visualState));
    return style;
}
function $8d48ff238658da2d$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $8d48ff238658da2d$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}



var $4Iuzv = parcelRequire("4Iuzv");



const $71a53c3b9f3df4a4$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $6aef8f0a0aef266b$export$8940b483cf52eeda)(),
        attrs: {}
    });



function $f83dae6b4804ad12$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $4Iuzv.useMemo)(()=>{
        const state = (0, $71a53c3b9f3df4a4$export$41be8b43e1c4d4f9)();
        (0, $6bf5fb41e8c59f21$export$5475d24f125d7053)(state, visualState, (0, $dedcd02e60578fbd$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $8d48ff238658da2d$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $b820f4d16c69a4c1$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $b820f4d16c69a4c1$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $b820f4d16c69a4c1$var$validMotionProps.has(key);
}


let $57cb3570c7371d5c$var$shouldForward = (key)=>!(0, $b820f4d16c69a4c1$export$2f9c46555243bf04)(key);
function $57cb3570c7371d5c$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $57cb3570c7371d5c$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $b820f4d16c69a4c1$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $57cb3570c7371d5c$export$59d6962c470509a5($57cb3570c7371d5c$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $57cb3570c7371d5c$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($57cb3570c7371d5c$var$shouldForward(key) || forwardMotionProps === true && (0, $b820f4d16c69a4c1$export$2f9c46555243bf04)(key) || !isDom && !(0, $b820f4d16c69a4c1$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



function $b09242e768229b12$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false) {
    const useVisualProps = (0, $0495a5316e5c4c9e$export$88f3fc2fd3766989)(Component) ? (0, $f83dae6b4804ad12$export$84309c4f53cb1bd5) : (0, $8d48ff238658da2d$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $57cb3570c7371d5c$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $4Iuzv.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref: ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $4Iuzv.useMemo)(()=>(0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $4Iuzv.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}




var $4Iuzv = parcelRequire("4Iuzv");



var $4Iuzv = parcelRequire("4Iuzv");
"use client";
/**
 * @public
 */ const $47ad9ed32fbb74bf$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $4Iuzv.createContext)(null);





var $4Iuzv = parcelRequire("4Iuzv");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $d2760f4a4b2f578c$export$fe4300aa8eebea86(init) {
    const ref = (0, $4Iuzv.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $aeacffbc55454f4a$export$fcc2206ecb6d74b(value) {
    return (0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(value) ? value.get() : value;
}


function $e80da6436d383a06$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $e80da6436d383a06$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $e80da6436d383a06$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $aeacffbc55454f4a$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $187a5815cc25f4a5$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $187a5815cc25f4a5$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $f30b2a5cf584d33c$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $4ef342dafb102405$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $e80da6436d383a06$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $4Iuzv.useContext)((0, $42fe97da1105d4d3$export$2285bbca2c666415));
        const presenceContext = (0, $4Iuzv.useContext)((0, $47ad9ed32fbb74bf$export$f224e4635b6f8ce2));
        const make = ()=>$e80da6436d383a06$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $d2760f4a4b2f578c$export$fe4300aa8eebea86)(make);
    };




const $5591b5bf5f355cfa$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $e80da6436d383a06$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: $8c8ab8ee64e611ef$export$16da615486abaa45,
    createRenderState: (0, $6aef8f0a0aef266b$export$8940b483cf52eeda)
});





const $fd7ff084be10fd13$export$9922240e40b88c48 = /*@__PURE__*/ (0, $e80da6436d383a06$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $5a8893d7af93d31d$export$16da615486abaa45),
    createRenderState: (0, $71a53c3b9f3df4a4$export$41be8b43e1c4d4f9)
});





function $ebf63fa1412b53b8$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $2ffbe0bd0007e1d9$export$65570e08d843624d)[key] = {
        ...(0, $2ffbe0bd0007e1d9$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $b641196a86d401a7$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $4Iuzv = parcelRequire("4Iuzv");
function $a7f5a52353a78153$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3b1c659072984347$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $4Iuzv.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $a7f5a52353a78153$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $4Iuzv = parcelRequire("4Iuzv");

const $fe70a0b734cc421a$export$ed7b8fa9dbf0105d = "framerAppearId";
const $fe70a0b734cc421a$export$8592e1c077c890a6 = "data-" + (0, $6be15922014291dd$export$9fd24a634729c672)($fe70a0b734cc421a$export$ed7b8fa9dbf0105d);







var $4Iuzv = parcelRequire("4Iuzv");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $e42eaf0b8833144b$export$da5f7b802957459a = (0, $4Iuzv.createContext)({});




var $4Iuzv = parcelRequire("4Iuzv");

const $b52b43714f18dcbf$export$700979bc83e7db82 = (0, $0ab38ae2ebfb4def$export$4e09c449d6c407f7) ? (0, $4Iuzv.useLayoutEffect) : (0, $4Iuzv.useEffect);


function $a285781c1417b596$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $4Iuzv.useContext)((0, $42fe97da1105d4d3$export$2285bbca2c666415));
    const lazyContext = (0, $4Iuzv.useContext)((0, $68ceafa408029e9d$export$40f10139ecf1f171));
    const presenceContext = (0, $4Iuzv.useContext)((0, $47ad9ed32fbb74bf$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $4Iuzv.useContext)((0, $5bcd9ec5c3a0a98c$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $4Iuzv.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $4Iuzv.useContext)((0, $e42eaf0b8833144b$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $a285781c1417b596$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $4Iuzv.useRef)(false);
    (0, $4Iuzv.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $fe70a0b734cc421a$export$8592e1c077c890a6];
    const wantsHandoff = (0, $4Iuzv.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $b52b43714f18dcbf$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $4Iuzv.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $a285781c1417b596$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $a285781c1417b596$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $a7f5a52353a78153$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $a285781c1417b596$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $a285781c1417b596$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $e800fdafc2875faa$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $ebf63fa1412b53b8$export$449561ec5703cdc8)(preloadedFeatures);
    const useVisualState = (0, $0495a5316e5c4c9e$export$88f3fc2fd3766989)(Component) ? (0, $fd7ff084be10fd13$export$9922240e40b88c48) : (0, $5591b5bf5f355cfa$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $4Iuzv.useContext)((0, $5bcd9ec5c3a0a98c$export$22a697fb29aac98d)),
            ...props,
            layoutId: $e800fdafc2875faa$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $74b75d2f8cd65562$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $0ab38ae2ebfb4def$export$4e09c449d6c407f7)) {
            $e800fdafc2875faa$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $e800fdafc2875faa$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $a285781c1417b596$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $3c47adbabe8a32cb$exports.jsxs)((0, $42fe97da1105d4d3$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $3c47adbabe8a32cb$exports.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, $b09242e768229b12$export$e25bb1e5b53cbdff)(Component, props, (0, $3b1c659072984347$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $4Iuzv.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $b641196a86d401a7$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $e800fdafc2875faa$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $4Iuzv.useContext)((0, $0e4236be71a40dd4$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $e800fdafc2875faa$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $4Iuzv.useContext)((0, $68ceafa408029e9d$export$40f10139ecf1f171)).strict;
}
function $e800fdafc2875faa$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $2ffbe0bd0007e1d9$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $284eaa2fc3f0b527$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $e800fdafc2875faa$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $e800fdafc2875faa$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $e800fdafc2875faa$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}




function $b58e24a4f199c871$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $4ef342dafb102405$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


function $507ac92f9c6e3809$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}



const $bd1d2bd7a20ceed0$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $c2c10c5ca322ec4b$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(value));
}
function $c2c10c5ca322ec4b$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $bd1d2bd7a20ceed0$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $c2c10c5ca322ec4b$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $b58e24a4f199c871$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $c2c10c5ca322ec4b$var$resolveFinalValueInKeyframes(target[key]);
        $c2c10c5ca322ec4b$var$setMotionValue(visualElement, key, value);
    }
}




function $404d836655454fa4$export$98397f3adbf6259f(value) {
    return Boolean((0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(value) && value.add);
}


function $317fcd766e0f028f$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $404d836655454fa4$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $dfee85868ac3d151$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $dfee85868ac3d151$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $12044ed968f5561b$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $fe70a0b734cc421a$export$8592e1c077c890a6];
}




/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $0f83839b9b6e3889$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $0f83839b9b6e3889$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $8dfb3194b07560fa$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $8dfb3194b07560fa$export$a4627e546088548d = (...transformers)=>transformers.reduce($8dfb3194b07560fa$var$combineFunctions);



const $6c76de8f1380e08b$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};









// Adapted from https://gist.github.com/mjackson/5311256
function $6ecaea7acc9ab74f$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $6ecaea7acc9ab74f$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $6ecaea7acc9ab74f$var$hueToRgb(p, q, hue + 1 / 3);
        green = $6ecaea7acc9ab74f$var$hueToRgb(p, q, hue);
        blue = $6ecaea7acc9ab74f$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $4cad977f318bc5b3$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $6f907982e85e5244$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $6f907982e85e5244$var$colorTypes = [
    (0, $6f47c0ea48e2efb7$export$834dfc94dde4b3d8),
    (0, $dab772ce0bd73cdd$export$4e46ac54fc82cf3b),
    (0, $a43233cd311b50e3$export$810b04175080204c)
];
const $6f907982e85e5244$var$getColorType = (v)=>$6f907982e85e5244$var$colorTypes.find((type)=>type.test(v));
function $6f907982e85e5244$var$asRGBA(color) {
    const type = $6f907982e85e5244$var$getColorType(color);
    (0, $fc095028715896dd$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $a43233cd311b50e3$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $6ecaea7acc9ab74f$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $6f907982e85e5244$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $6f907982e85e5244$var$asRGBA(from);
    const toRGBA = $6f907982e85e5244$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $4cad977f318bc5b3$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $6f907982e85e5244$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $6f907982e85e5244$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $6f907982e85e5244$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $dab772ce0bd73cdd$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $168e2310db9c1475$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $168e2310db9c1475$export$fed62ccc3fb1a568(origin, target) {
    if ($168e2310db9c1475$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $37713378c3146929$var$mixNumber(a, b) {
    return (p)=>(0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $37713378c3146929$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $37713378c3146929$var$mixNumber;
    else if (typeof a === "string") return (0, $5c3424ea1660fbd8$export$31f9caa2600b5723)(a) ? (0, $4cad977f318bc5b3$export$a6f92d4bae65c0f1) : (0, $1174160f464bd20e$export$35e9368ef982300f).test(a) ? (0, $6f907982e85e5244$export$51e568cf5c039bac) : $37713378c3146929$export$65516310a87d8205;
    else if (Array.isArray(a)) return $37713378c3146929$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $1174160f464bd20e$export$35e9368ef982300f).test(a) ? (0, $6f907982e85e5244$export$51e568cf5c039bac) : $37713378c3146929$export$ebc23b6840c51ba1;
    return 0, $4cad977f318bc5b3$export$a6f92d4bae65c0f1;
}
function $37713378c3146929$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$37713378c3146929$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $37713378c3146929$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $37713378c3146929$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $37713378c3146929$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $37713378c3146929$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $418805e9b08dff8a$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $418805e9b08dff8a$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $418805e9b08dff8a$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $168e2310db9c1475$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $168e2310db9c1475$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $168e2310db9c1475$export$fed62ccc3fb1a568)(origin, target);
        return (0, $8dfb3194b07560fa$export$a4627e546088548d)($37713378c3146929$export$3bbefa2f402845c4($37713378c3146929$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $fc095028715896dd$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $4cad977f318bc5b3$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $908bd09a64cfcbe5$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $37713378c3146929$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $a99f267236875cbb$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $95a89474cd9c2897$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $95a89474cd9c2897$export$fff89137e9e818ce).isProcessing ? (0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp : (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now()
    };
};



const $eb004f7d2b5718d6$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $791aed85419bcffb$export$f4ff70a5b4808fd8 = 20000;
function $791aed85419bcffb$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $791aed85419bcffb$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $791aed85419bcffb$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $b5a3690ef6f44f5b$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $791aed85419bcffb$export$cbdd6b3d40ea54e2)(generator), (0, $791aed85419bcffb$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(duration)
    };
}



const $401008e9d5f74fe1$var$velocitySampleDuration = 5; // ms
function $401008e9d5f74fe1$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $401008e9d5f74fe1$var$velocitySampleDuration, 0);
    return (0, $b68d897340517dfd$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $c9413732978cdb3f$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};




const $4f6da8ccc8600efd$var$safeMin = 0.001;
function $4f6da8ccc8600efd$export$b15f158dc6d6f458({ duration: duration = (0, $c9413732978cdb3f$export$86436497e7b05d16).duration, bounce: bounce = (0, $c9413732978cdb3f$export$86436497e7b05d16).bounce, velocity: velocity = (0, $c9413732978cdb3f$export$86436497e7b05d16).velocity, mass: mass = (0, $c9413732978cdb3f$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $fc095028715896dd$export$491112666e282270)(duration <= (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)((0, $c9413732978cdb3f$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)((0, $c9413732978cdb3f$export$86436497e7b05d16).minDamping, (0, $c9413732978cdb3f$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)((0, $c9413732978cdb3f$export$86436497e7b05d16).minDuration, (0, $c9413732978cdb3f$export$86436497e7b05d16).maxDuration, (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $4f6da8ccc8600efd$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $4f6da8ccc8600efd$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $4f6da8ccc8600efd$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $4f6da8ccc8600efd$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$4f6da8ccc8600efd$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $4f6da8ccc8600efd$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $c9413732978cdb3f$export$86436497e7b05d16).stiffness,
        damping: (0, $c9413732978cdb3f$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $4f6da8ccc8600efd$var$rootIterations = 12;
function $4f6da8ccc8600efd$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $4f6da8ccc8600efd$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $4f6da8ccc8600efd$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $82758965a89f707b$var$durationKeys = [
    "duration",
    "bounce"
];
const $82758965a89f707b$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $82758965a89f707b$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $82758965a89f707b$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $c9413732978cdb3f$export$86436497e7b05d16).velocity,
        stiffness: (0, $c9413732978cdb3f$export$86436497e7b05d16).stiffness,
        damping: (0, $c9413732978cdb3f$export$86436497e7b05d16).damping,
        mass: (0, $c9413732978cdb3f$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$82758965a89f707b$var$isSpringType(options, $82758965a89f707b$var$physicsKeys) && $82758965a89f707b$var$isSpringType(options, $82758965a89f707b$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $c9413732978cdb3f$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $4f6da8ccc8600efd$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $c9413732978cdb3f$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $82758965a89f707b$export$b36281d89752ae66(optionsOrVisualDuration = (0, $c9413732978cdb3f$export$86436497e7b05d16).visualDuration, bounce = (0, $c9413732978cdb3f$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $82758965a89f707b$var$getSpringOptions({
        ...options,
        velocity: -(0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $c9413732978cdb3f$export$86436497e7b05d16).restSpeed.granular : (0, $c9413732978cdb3f$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $c9413732978cdb3f$export$86436497e7b05d16).restDelta.granular : (0, $c9413732978cdb3f$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $4f6da8ccc8600efd$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $401008e9d5f74fe1$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $791aed85419bcffb$export$cbdd6b3d40ea54e2)(generator), (0, $791aed85419bcffb$export$f4ff70a5b4808fd8));
            const easing = (0, $eb004f7d2b5718d6$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$82758965a89f707b$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $b5a3690ef6f44f5b$export$7f1511d09ee75a99)(options, 100, $82758965a89f707b$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



function $ba5ac069275dbf73$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $82758965a89f707b$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $401008e9d5f74fe1$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $57af3ee8bec457d2$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $57af3ee8bec457d2$var$subdivisionPrecision = 0.0000001;
const $57af3ee8bec457d2$var$subdivisionMaxIterations = 12;
function $57af3ee8bec457d2$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $57af3ee8bec457d2$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $57af3ee8bec457d2$var$subdivisionPrecision && ++i < $57af3ee8bec457d2$var$subdivisionMaxIterations);
    return currentT;
}
function $57af3ee8bec457d2$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $38f396ca024a6caf$export$8793edee2d425525;
    const getTForX = (aX)=>$57af3ee8bec457d2$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $57af3ee8bec457d2$var$calcBezier(getTForX(t), mY1, mY2);
}


const $980d56239806356f$export$929e5a82286172a6 = /*@__PURE__*/ (0, $57af3ee8bec457d2$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $980d56239806356f$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $57af3ee8bec457d2$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $980d56239806356f$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $57af3ee8bec457d2$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $8bd839818ddbada4$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $22df7bbf8a49630c$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $1c56aa062ce7094f$export$77edfce482316a60 = /*@__PURE__*/ (0, $57af3ee8bec457d2$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $1c56aa062ce7094f$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $22df7bbf8a49630c$export$2c07eeff45156d4d)($1c56aa062ce7094f$export$77edfce482316a60);
const $1c56aa062ce7094f$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $8bd839818ddbada4$export$f946554fb8aeaf0d)($1c56aa062ce7094f$export$b01116c84cdfe1a2);


const $a70defeabf9cd3d4$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $1c56aa062ce7094f$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $2c2be87cef1619fa$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $2c2be87cef1619fa$export$c8d67a19199d1a50 = (0, $22df7bbf8a49630c$export$2c07eeff45156d4d)($2c2be87cef1619fa$export$e444123e42d03385);
const $2c2be87cef1619fa$export$30d3455eee55bed5 = (0, $8bd839818ddbada4$export$f946554fb8aeaf0d)($2c2be87cef1619fa$export$e444123e42d03385);




const $3764fc89bbf451c5$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $88e92b4a54d1afd1$var$easingLookup = {
    linear: (0, $38f396ca024a6caf$export$8793edee2d425525),
    easeIn: $980d56239806356f$export$929e5a82286172a6,
    easeInOut: $980d56239806356f$export$c07234257a03d5e9,
    easeOut: $980d56239806356f$export$57636bb43b1ccbb0,
    circIn: $2c2be87cef1619fa$export$e444123e42d03385,
    circInOut: $2c2be87cef1619fa$export$30d3455eee55bed5,
    circOut: $2c2be87cef1619fa$export$c8d67a19199d1a50,
    backIn: $1c56aa062ce7094f$export$b01116c84cdfe1a2,
    backInOut: $1c56aa062ce7094f$export$ddc5fd596f6c71b2,
    backOut: $1c56aa062ce7094f$export$77edfce482316a60,
    anticipate: $a70defeabf9cd3d4$export$6b0af63b873d419e
};
const $88e92b4a54d1afd1$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $88e92b4a54d1afd1$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $3764fc89bbf451c5$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $fc095028715896dd$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $57af3ee8bec457d2$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($88e92b4a54d1afd1$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $fc095028715896dd$export$f5708dca728d7177)($88e92b4a54d1afd1$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $88e92b4a54d1afd1$var$easingLookup[definition];
    }
    return definition;
};

const $0503b22d2b65ceb9$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $9c39606140f23b1b$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



function $c167b11cf20d0293$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $dfee85868ac3d151$export$dd826089e3c5e502).mix || (0, $908bd09a64cfcbe5$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $38f396ca024a6caf$export$8793edee2d425525) : ease;
            mixer = (0, $8dfb3194b07560fa$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $c167b11cf20d0293$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $fc095028715896dd$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $c167b11cf20d0293$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $9c39606140f23b1b$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $13e5abe4b979d17a$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $9c39606140f23b1b$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $96f78e1f0b108a3b$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $13e5abe4b979d17a$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $0021d43f8fd53acf$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $3ab0b86785a170ec$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $980d56239806356f$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $3ab0b86785a170ec$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $0503b22d2b65ceb9$export$216948827bbdc797)(ease) ? ease.map((0, $88e92b4a54d1afd1$export$ef97fe084f156ca4)) : (0, $88e92b4a54d1afd1$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $0021d43f8fd53acf$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $96f78e1f0b108a3b$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $c167b11cf20d0293$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $3ab0b86785a170ec$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



const $5825e42da5ef5514$var$isNotNull = (value)=>value !== null;
function $5825e42da5ef5514$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($5825e42da5ef5514$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $b9acc7ad1ecea516$var$transitionTypeMap = {
    decay: (0, $ba5ac069275dbf73$export$ee3ff3a17106998),
    inertia: $ba5ac069275dbf73$export$ee3ff3a17106998,
    tween: (0, $3ab0b86785a170ec$export$d25ddfdf17c3ad3e),
    keyframes: (0, $3ab0b86785a170ec$export$d25ddfdf17c3ad3e),
    spring: $82758965a89f707b$export$b36281d89752ae66
};
function $b9acc7ad1ecea516$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $b9acc7ad1ecea516$var$transitionTypeMap[transition.type];
}


class $33f5995bc1ce35b2$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}


const $7b31ec8dd32e8087$var$percentToProgress = (percent)=>percent / 100;
class $7b31ec8dd32e8087$export$3394f837405475c7 extends (0, $33f5995bc1ce35b2$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now()) this.tick((0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $6c76de8f1380e08b$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $b9acc7ad1ecea516$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $3ab0b86785a170ec$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $3ab0b86785a170ec$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $3ab0b86785a170ec$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $8dfb3194b07560fa$export$a4627e546088548d)($7b31ec8dd32e8087$var$percentToProgress, (0, $908bd09a64cfcbe5$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $791aed85419bcffb$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $ba5ac069275dbf73$export$ee3ff3a17106998)) state.value = (0, $5825e42da5ef5514$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get time() {
        return (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        this.driver?.start(false);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $a99f267236875cbb$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $6c76de8f1380e08b$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $7b31ec8dd32e8087$export$ee9b76de7353d815(options) {
    return new $7b31ec8dd32e8087$export$3394f837405475c7(options);
}







const $78c8d07653ccae3b$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $a4863745c1310776$export$37a5fde709c1db82(element, name, value) {
    (0, $78c8d07653ccae3b$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $01c957d16e5c4dfc$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $ab737a1b2805e540$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $01c957d16e5c4dfc$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);








/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $5bc95b9aa91936c2$export$e3ad02c335474dee = {};


function $b7476ce2b73bf6ef$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $01c957d16e5c4dfc$export$7c73462e0d25e514)(callback);
    return ()=>(0, $5bc95b9aa91936c2$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $6b9f3983238102b9$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $b7476ce2b73bf6ef$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $9037c2d854186b7a$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $8a7120bd31d9bfcf$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $9037c2d854186b7a$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $9037c2d854186b7a$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $9037c2d854186b7a$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $9037c2d854186b7a$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $01e831c475bdb50e$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $6b9f3983238102b9$export$866c1d07a1ac2ab)() ? (0, $eb004f7d2b5718d6$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $3764fc89bbf451c5$export$ff43f99925d7366b)(easing)) return (0, $9037c2d854186b7a$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$01e831c475bdb50e$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $8a7120bd31d9bfcf$export$2cf569f5e2221176).easeOut);
    else return (0, $8a7120bd31d9bfcf$export$2cf569f5e2221176)[easing];
}


function $5faada7a42375e42$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $01e831c475bdb50e$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $93753a2081bc00ed$export$84ce9a476f53d110).value) (0, $6c76de8f1380e08b$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $93753a2081bc00ed$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $6c76de8f1380e08b$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $8ca4d854252a7d90$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $bf95a46452ab994b$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $8ca4d854252a7d90$export$6ab7812f1bac68be)(type) && (0, $6b9f3983238102b9$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $14464246be964ec9$export$6c0f9803d8aa7219 extends (0, $33f5995bc1ce35b2$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $fc095028715896dd$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $bf95a46452ab994b$export$a31269144d66b4a)(options);
        this.animation = (0, $5faada7a42375e42$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $5825e42da5ef5514$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $a4863745c1310776$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get time() {
        return (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $ab737a1b2805e540$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            return 0, $38f396ca024a6caf$export$8793edee2d425525;
        } else return observe(this);
    }
}




const $d1e1d86cfa5e3405$var$unsupportedEasingFunctions = {
    anticipate: $a70defeabf9cd3d4$export$6b0af63b873d419e,
    backInOut: $1c56aa062ce7094f$export$ddc5fd596f6c71b2,
    circInOut: $2c2be87cef1619fa$export$30d3455eee55bed5
};
function $d1e1d86cfa5e3405$var$isUnsupportedEase(key) {
    return key in $d1e1d86cfa5e3405$var$unsupportedEasingFunctions;
}
function $d1e1d86cfa5e3405$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $d1e1d86cfa5e3405$var$isUnsupportedEase(transition.ease)) transition.ease = $d1e1d86cfa5e3405$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $b3a51a361fdef14f$var$sampleDelta = 10; //ms
class $b3a51a361fdef14f$export$bd2cd6a048093d96 extends (0, $14464246be964ec9$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $d1e1d86cfa5e3405$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $b9acc7ad1ecea516$export$98db6ef1242dfa2)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $7b31ec8dd32e8087$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $b3a51a361fdef14f$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $b3a51a361fdef14f$var$sampleDelta);
        sampleAnimation.stop();
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $83b1b8fa4d0652fe$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $418805e9b08dff8a$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $25b85ba990d27fc6$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $25b85ba990d27fc6$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $83b1b8fa4d0652fe$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $83b1b8fa4d0652fe$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $fc095028715896dd$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $25b85ba990d27fc6$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $8ca4d854252a7d90$export$6ab7812f1bac68be)(type)) && velocity;
}


function $e3fd621be4248095$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type;
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $1c4bc6496635d0a0$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $1c4bc6496635d0a0$var$supportsWaapi = /*@__PURE__*/ (0, $01c957d16e5c4dfc$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $1c4bc6496635d0a0$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $1c4bc6496635d0a0$var$supportsWaapi() && name && $1c4bc6496635d0a0$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $01a3c2b42cd9af8e$var$MAX_RESOLVE_DELAY = 40;
class $01a3c2b42cd9af8e$export$b9855e2a7dee3dd2 extends (0, $33f5995bc1ce35b2$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $d6218563c70fe564$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $25b85ba990d27fc6$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            if ((0, $dfee85868ac3d151$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $5825e42da5ef5514$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $e3fd621be4248095$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $01a3c2b42cd9af8e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $1c4bc6496635d0a0$export$ea92bde116fda821)(resolvedOptions) ? new (0, $b3a51a361fdef14f$export$bd2cd6a048093d96)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $7b31ec8dd32e8087$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>this.notifyFinished()).catch((0, $38f396ca024a6caf$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $d6218563c70fe564$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}



const $31705dd6e965115c$var$isNotNull = (value)=>value !== null;
function $31705dd6e965115c$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($31705dd6e965115c$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



const $8d503e63c4556a11$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $8d503e63c4556a11$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $8d503e63c4556a11$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $8d503e63c4556a11$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $8d503e63c4556a11$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $8d503e63c4556a11$var$keyframesTransition;
    else if ((0, $21de3bfd13be6c1d$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $8d503e63c4556a11$var$criticallyDampedSpring(keyframes[1]) : $8d503e63c4556a11$var$underDampedSpring;
    return $8d503e63c4556a11$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $2afddaac882169e8$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $359bf4018752b33c$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $507ac92f9c6e3809$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $2afddaac882169e8$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $8d503e63c4556a11$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $e3fd621be4248095$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $dfee85868ac3d151$export$dd826089e3c5e502).instantAnimations || (0, $dfee85868ac3d151$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            (0, $e3fd621be4248095$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $31705dd6e965115c$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $95a89474cd9c2897$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $7b31ec8dd32e8087$export$3394f837405475c7)(options) : new (0, $01a3c2b42cd9af8e$export$b9855e2a7dee3dd2)(options);
    };


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $9b66a142be6d759d$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $9b66a142be6d759d$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $9b66a142be6d759d$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $507ac92f9c6e3809$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $12044ed968f5561b$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $95a89474cd9c2897$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $317fcd766e0f028f$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $359bf4018752b33c$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $dd3d0cfb441d941e$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $95a89474cd9c2897$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $c2c10c5ca322ec4b$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}



function $560cafc72ff3600c$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $77934b8d1c686df2$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $b58e24a4f199c871$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $9b66a142be6d759d$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $77934b8d1c686df2$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $77934b8d1c686df2$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($77934b8d1c686df2$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $560cafc72ff3600c$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $8014285130ca9f7f$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $77934b8d1c686df2$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $77934b8d1c686df2$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $b58e24a4f199c871$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $9b66a142be6d759d$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





function $bad6aaae1dd02c4b$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




const $db0b254d32c01b07$var$numVariantProps = (0, $53cb262a3dd5a1e0$export$1405a65085f40b9).length;
function $db0b254d32c01b07$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $db0b254d32c01b07$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $db0b254d32c01b07$var$numVariantProps; i++){
        const name = (0, $53cb262a3dd5a1e0$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $301484e5a72a11e0$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}





const $2b084848d9f0bf6b$var$reversePriorityOrder = [
    ...(0, $53cb262a3dd5a1e0$export$16e45afcc206d3a8)
].reverse();
const $2b084848d9f0bf6b$var$numAnimationTypes = (0, $53cb262a3dd5a1e0$export$16e45afcc206d3a8).length;
function $2b084848d9f0bf6b$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $8014285130ca9f7f$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $2b084848d9f0bf6b$export$bb53502b7a672aa8(visualElement) {
    let animate = $2b084848d9f0bf6b$var$animateList(visualElement);
    let state = $2b084848d9f0bf6b$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $b58e24a4f199c871$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $db0b254d32c01b07$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $2b084848d9f0bf6b$var$numAnimationTypes; i++){
            const type = $2b084848d9f0bf6b$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $301484e5a72a11e0$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $f30b2a5cf584d33c$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $2b084848d9f0bf6b$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $bd1d2bd7a20ceed0$export$9153ad4c4999f4a0)(next) && (0, $bd1d2bd7a20ceed0$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $bad6aaae1dd02c4b$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && isInitialRender && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $b58e24a4f199c871$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $560cafc72ff3600c$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $b58e24a4f199c871$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $2b084848d9f0bf6b$var$createState();
            isInitialRender = true;
        }
    };
}
function $2b084848d9f0bf6b$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $bad6aaae1dd02c4b$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $2b084848d9f0bf6b$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $2b084848d9f0bf6b$var$createState() {
    return {
        animate: $2b084848d9f0bf6b$var$createTypeState(true),
        whileInView: $2b084848d9f0bf6b$var$createTypeState(),
        whileHover: $2b084848d9f0bf6b$var$createTypeState(),
        whileTap: $2b084848d9f0bf6b$var$createTypeState(),
        whileDrag: $2b084848d9f0bf6b$var$createTypeState(),
        whileFocus: $2b084848d9f0bf6b$var$createTypeState(),
        exit: $2b084848d9f0bf6b$var$createTypeState()
    };
}


class $17ca0551d93d6898$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $19bb6406fb7ba545$export$b45b3fe5caabdca extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $2b084848d9f0bf6b$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $f30b2a5cf584d33c$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}



let $214df3e55875cd62$var$id = 0;
class $214df3e55875cd62$export$4989d1eb6104cc6c extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $214df3e55875cd62$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $adc79304457d70a9$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $19bb6406fb7ba545$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $214df3e55875cd62$export$4989d1eb6104cc6c)
    }
};




const $1dfe484c8eb65fc5$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $1dfe484c8eb65fc5$export$1b3dd616664938e4() {
    return $1dfe484c8eb65fc5$export$9e9bc3c487fccc00.x || $1dfe484c8eb65fc5$export$9e9bc3c487fccc00.y;
}


function $061311b3c5e93d4f$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00).x || (0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00).x = (0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00).x = (0, $1dfe484c8eb65fc5$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




function $14262807fdfabaf4$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



const $74f89e085ce5dcca$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $20de773ff31dcd8d$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $20de773ff31dcd8d$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $74f89e085ce5dcca$export$a4cf9c8a4b063a6e)(event) && handler(event, $20de773ff31dcd8d$export$12f84bb882d06e1a(event));
};


function $ac9d29587ef3d418$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $14262807fdfabaf4$export$b1d829ddf82884aa)(target, eventName, (0, $20de773ff31dcd8d$export$c404e80f92c98d29)(handler), options);
}





const $422ee56d179300ba$var$SCALE_PRECISION = 0.0001;
const $422ee56d179300ba$var$SCALE_MIN = 1 - $422ee56d179300ba$var$SCALE_PRECISION;
const $422ee56d179300ba$var$SCALE_MAX = 1 + $422ee56d179300ba$var$SCALE_PRECISION;
const $422ee56d179300ba$var$TRANSLATE_PRECISION = 0.01;
const $422ee56d179300ba$var$TRANSLATE_MIN = 0 - $422ee56d179300ba$var$TRANSLATE_PRECISION;
const $422ee56d179300ba$var$TRANSLATE_MAX = 0 + $422ee56d179300ba$var$TRANSLATE_PRECISION;
function $422ee56d179300ba$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $422ee56d179300ba$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $422ee56d179300ba$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $422ee56d179300ba$export$c1c127004b72a37(target) / $422ee56d179300ba$export$c1c127004b72a37(source);
    delta.translate = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $422ee56d179300ba$var$SCALE_MIN && delta.scale <= $422ee56d179300ba$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $422ee56d179300ba$var$TRANSLATE_MIN && delta.translate <= $422ee56d179300ba$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $422ee56d179300ba$export$c0d25e96fc67d310(delta, source, target, origin) {
    $422ee56d179300ba$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $422ee56d179300ba$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $422ee56d179300ba$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $422ee56d179300ba$export$c1c127004b72a37(relative);
}
function $422ee56d179300ba$export$426154f9d100f99(target, relative, parent) {
    $422ee56d179300ba$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $422ee56d179300ba$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $422ee56d179300ba$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $422ee56d179300ba$export$c1c127004b72a37(layout);
}
function $422ee56d179300ba$export$2785bfcc929c5650(target, layout, parent) {
    $422ee56d179300ba$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $422ee56d179300ba$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}



function $0d0f14d919ad9c9e$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $ec7c36ca90ee4142$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};








const $4e7210f0bc88fa38$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $4e7210f0bc88fa38$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $4e7210f0bc88fa38$export$9f17032d917177de(a.x, b.x);
    const yDelta = $4e7210f0bc88fa38$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


/**
 * @internal
 */ class $6cd7445115377e74$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3 } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $6cd7445115377e74$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $4e7210f0bc88fa38$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $95a89474cd9c2897$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $6cd7445115377e74$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $95a89474cd9c2897$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $6cd7445115377e74$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $6cd7445115377e74$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $74f89e085ce5dcca$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $20de773ff31dcd8d$export$12f84bb882d06e1a)(event);
        const initialInfo = $6cd7445115377e74$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $95a89474cd9c2897$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $6cd7445115377e74$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $8dfb3194b07560fa$export$a4627e546088548d)((0, $ac9d29587ef3d418$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $ac9d29587ef3d418$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $ac9d29587ef3d418$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $6cd7445115377e74$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $6cd7445115377e74$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $6cd7445115377e74$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $6cd7445115377e74$var$subtractPoint(point, $6cd7445115377e74$var$lastDevicePoint(history)),
        offset: $6cd7445115377e74$var$subtractPoint(point, $6cd7445115377e74$var$startDevicePoint(history)),
        velocity: $6cd7445115377e74$var$getVelocity(history, 0.1)
    };
}
function $6cd7445115377e74$var$startDevicePoint(history) {
    return history[0];
}
function $6cd7445115377e74$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $6cd7445115377e74$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $6cd7445115377e74$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $0f83839b9b6e3889$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}





/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $e8ab6139179c2561$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $e8ab6139179c2561$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $e8ab6139179c2561$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $e8ab6139179c2561$export$690c180aa5775042(layoutBox.x, left, right),
        y: $e8ab6139179c2561$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $e8ab6139179c2561$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $e8ab6139179c2561$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $e8ab6139179c2561$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $e8ab6139179c2561$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $e8ab6139179c2561$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $422ee56d179300ba$export$c1c127004b72a37)(source);
    const targetLength = (0, $422ee56d179300ba$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $9c39606140f23b1b$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $9c39606140f23b1b$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $e8ab6139179c2561$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $e8ab6139179c2561$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $e8ab6139179c2561$export$7c5eaef8f4723d22(dragElastic = $e8ab6139179c2561$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $e8ab6139179c2561$export$a3366d3bac43a742;
    return {
        x: $e8ab6139179c2561$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $e8ab6139179c2561$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $e8ab6139179c2561$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $e8ab6139179c2561$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $e8ab6139179c2561$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $e8ab6139179c2561$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $479b57d75d79f942$export$f0a15892c27dc07c = new WeakMap();
class $479b57d75d79f942$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $20de773ff31dcd8d$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $061311b3c5e93d4f$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $c572ffa671c2bc09$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $422ee56d179300ba$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $317fcd766e0f028f$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $479b57d75d79f942$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>(0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $6cd7445115377e74$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $ec7c36ca90ee4142$export$d533d84f9871c879)(this.visualElement)
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$479b57d75d79f942$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $e8ab6139179c2561$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $a7f5a52353a78153$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $e8ab6139179c2561$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $e8ab6139179c2561$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $e8ab6139179c2561$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $a7f5a52353a78153$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $fc095028715896dd$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $07607abcfa7c0ab6$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $e8ab6139179c2561$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $9a2bd418b4578e65$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $9a2bd418b4578e65$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
            if (!$479b57d75d79f942$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $317fcd766e0f028f$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $359bf4018752b33c$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$479b57d75d79f942$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $a7f5a52353a78153$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $e8ab6139179c2561$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
            if (!$479b57d75d79f942$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $479b57d75d79f942$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $ac9d29587ef3d418$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $a7f5a52353a78153$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $95a89474cd9c2897$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $14262807fdfabaf4$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $e8ab6139179c2561$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $479b57d75d79f942$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $479b57d75d79f942$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $4702ebbc9984da45$export$5d97dc2872682820 extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $38f396ca024a6caf$export$8793edee2d425525);
        this.removeListeners = (0, $38f396ca024a6caf$export$8793edee2d425525);
        this.controls = new (0, $479b57d75d79f942$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $38f396ca024a6caf$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $0e2c3f79ee634562$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $0e2c3f79ee634562$export$b4f8f1ee75ce5859 extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $38f396ca024a6caf$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $6cd7445115377e74$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $ec7c36ca90ee4142$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $0e2c3f79ee634562$var$asyncHandler(onPanSessionStart),
            onStart: $0e2c3f79ee634562$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $ac9d29587ef3d418$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}





var $4Iuzv = parcelRequire("4Iuzv");

var $4Iuzv = parcelRequire("4Iuzv");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $a82b5c6633252065$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $4Iuzv.useContext)((0, $47ad9ed32fbb74bf$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $4Iuzv.useId)();
    (0, $4Iuzv.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $4Iuzv.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $a82b5c6633252065$export$8249053f690ea39a() {
    return $a82b5c6633252065$export$ee27c052bca048fb((0, $4Iuzv.useContext)((0, $47ad9ed32fbb74bf$export$f224e4635b6f8ce2)));
}
function $a82b5c6633252065$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $5716ff21ca967367$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $49f37554b700ff47$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $49f37554b700ff47$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $c572ffa671c2bc09$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $49f37554b700ff47$export$fafff692be55225d(latest, node.target.x);
        const y = $49f37554b700ff47$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};



const $29cd0d9f52a145ae$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $418805e9b08dff8a$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $418805e9b08dff8a$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $1a564b85be8208d8$var$hasTakenAnySnapshot = false;
class $1a564b85be8208d8$var$MeasureLayoutWithContext extends (0, $4Iuzv.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $3063faa9fe482faa$export$de9e7791c71225fd)($1a564b85be8208d8$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($1a564b85be8208d8$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $5716ff21ca967367$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        $1a564b85be8208d8$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $afa024ccba882b1b$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $1a564b85be8208d8$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $1a564b85be8208d8$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $a82b5c6633252065$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $4Iuzv.useContext)((0, $0e4236be71a40dd4$export$a3579ca508007a95));
    return (0, $3c47adbabe8a32cb$exports.jsx)($1a564b85be8208d8$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $4Iuzv.useContext)((0, $e42eaf0b8833144b$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $1a564b85be8208d8$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $49f37554b700ff47$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $49f37554b700ff47$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $49f37554b700ff47$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $49f37554b700ff47$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $49f37554b700ff47$export$5eafb6257a5844c),
    boxShadow: (0, $29cd0d9f52a145ae$export$eb0bc629e74dcf8)
};


function $7679c8ec2898b850$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $89a4623aed107637$export$17eda790a720ec57(element) {
    return (0, $7679c8ec2898b850$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $87ef20dd3ff2e464$export$66957ea77182581d(element) {
    return (0, $89a4623aed107637$export$17eda790a720ec57)(element) && element.tagName === "svg";
}





function $debbbee72ccccccb$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $3c4a286c67dcb5f1$export$605d60a2578142d3)(value) ? value : (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $359bf4018752b33c$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}




const $3a9c12ccc3b1d380$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $7cf80b36e38eafe8$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $8739612c7250ccbb$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $8739612c7250ccbb$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $3a9c12ccc3b1d380$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}




/**
 * Timeout defined in ms
 */ function $c17009e1dfaf6473$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $95a89474cd9c2897$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(checkElapsed);
}
function $c17009e1dfaf6473$export$fcd451ca460f8a2a(callback, timeout) {
    return $c17009e1dfaf6473$export$1391212d75b2ee65(callback, (0, $0f83839b9b6e3889$export$fc3e7e8557f8c8c7)(timeout));
}





const $ba60351f76d3478e$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $ba60351f76d3478e$var$numBorders = $ba60351f76d3478e$var$borders.length;
const $ba60351f76d3478e$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $ba60351f76d3478e$var$isPx = (value)=>typeof value === "number" || (0, $c572ffa671c2bc09$export$91c0eda1d06bf008).test(value);
function $ba60351f76d3478e$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $ba60351f76d3478e$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $ba60351f76d3478e$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $ba60351f76d3478e$var$numBorders; i++){
        const borderLabel = `border${$ba60351f76d3478e$var$borders[i]}Radius`;
        let followRadius = $ba60351f76d3478e$var$getRadius(follow, borderLabel);
        let leadRadius = $ba60351f76d3478e$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $ba60351f76d3478e$var$isPx(followRadius) === $ba60351f76d3478e$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)($ba60351f76d3478e$var$asNumber(followRadius), $ba60351f76d3478e$var$asNumber(leadRadius), progress), 0);
            if ((0, $c572ffa671c2bc09$export$626336c2cd4b14de).test(leadRadius) || (0, $c572ffa671c2bc09$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $ba60351f76d3478e$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $ba60351f76d3478e$var$easeCrossfadeIn = /*@__PURE__*/ $ba60351f76d3478e$var$compress(0, 0.5, (0, $2c2be87cef1619fa$export$c8d67a19199d1a50));
const $ba60351f76d3478e$var$easeCrossfadeOut = /*@__PURE__*/ $ba60351f76d3478e$var$compress(0.5, 0.95, (0, $38f396ca024a6caf$export$8793edee2d425525));
function $ba60351f76d3478e$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $9c39606140f23b1b$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $2002a73bc4c4a451$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $2002a73bc4c4a451$export$c53fd88f45d77e4b(box, originBox) {
    $2002a73bc4c4a451$export$a0230ae482601ae8(box.x, originBox.x);
    $2002a73bc4c4a451$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $2002a73bc4c4a451$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}






/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $f709e42cc4e84456$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $98986c5ac90dc9e9$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $98986c5ac90dc9e9$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $f709e42cc4e84456$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $c572ffa671c2bc09$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $f709e42cc4e84456$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $f709e42cc4e84456$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f709e42cc4e84456$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $f709e42cc4e84456$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $f709e42cc4e84456$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $f709e42cc4e84456$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f709e42cc4e84456$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $f709e42cc4e84456$export$42b76f1d0d16d5b(box.x, transforms, $f709e42cc4e84456$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $f709e42cc4e84456$export$42b76f1d0d16d5b(box.y, transforms, $f709e42cc4e84456$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $e5a2394a91a016b7$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $e5a2394a91a016b7$export$a7ec7642fe550fb6(delta) {
    return $e5a2394a91a016b7$var$isAxisDeltaZero(delta.x) && $e5a2394a91a016b7$var$isAxisDeltaZero(delta.y);
}
function $e5a2394a91a016b7$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $e5a2394a91a016b7$export$8d5cf76bb7daff09(a, b) {
    return $e5a2394a91a016b7$export$7a9a6f114ddd0fdb(a.x, b.x) && $e5a2394a91a016b7$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $e5a2394a91a016b7$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $e5a2394a91a016b7$export$ef641b782d85522(a, b) {
    return $e5a2394a91a016b7$export$22adf28bfca1c186(a.x, b.x) && $e5a2394a91a016b7$export$22adf28bfca1c186(a.y, b.y);
}
function $e5a2394a91a016b7$export$c5706146bc63213(box) {
    return (0, $422ee56d179300ba$export$c1c127004b72a37)(box.x) / (0, $422ee56d179300ba$export$c1c127004b72a37)(box.y);
}
function $e5a2394a91a016b7$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $0afd2595b3b9f57e$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $8739612c7250ccbb$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $8739612c7250ccbb$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $eb1e4b9c88ef3021$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $6dfb7f60d8a6af2f$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $6dfb7f60d8a6af2f$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $6dfb7f60d8a6af2f$var$animationTarget = 1000;
let $6dfb7f60d8a6af2f$var$id = 0;
function $6dfb7f60d8a6af2f$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $6dfb7f60d8a6af2f$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $12044ed968f5561b$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $95a89474cd9c2897$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $6dfb7f60d8a6af2f$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $6dfb7f60d8a6af2f$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $6dfb7f60d8a6af2f$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $93753a2081bc00ed$export$84ce9a476f53d110).value) $6dfb7f60d8a6af2f$var$metrics.nodes = $6dfb7f60d8a6af2f$var$metrics.calculatedTargetDeltas = $6dfb7f60d8a6af2f$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($6dfb7f60d8a6af2f$export$131f2f0cc5fe9609);
                this.nodes.forEach($6dfb7f60d8a6af2f$var$resolveTargetDelta);
                this.nodes.forEach($6dfb7f60d8a6af2f$var$calcProjection);
                this.nodes.forEach($6dfb7f60d8a6af2f$export$c2664f37bc951031);
                if ((0, $93753a2081bc00ed$export$84ce9a476f53d110).addProjectionMetrics) (0, $93753a2081bc00ed$export$84ce9a476f53d110).addProjectionMetrics($6dfb7f60d8a6af2f$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $7cf80b36e38eafe8$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $5c95bc33b1b87b66$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $89a4623aed107637$export$17eda790a720ec57)(instance) && !(0, $87ef20dd3ff2e464$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $95a89474cd9c2897$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $c17009e1dfaf6473$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $5716ff21ca967367$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $5716ff21ca967367$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($6dfb7f60d8a6af2f$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $6dfb7f60d8a6af2f$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $e5a2394a91a016b7$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, $507ac92f9c6e3809$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $6dfb7f60d8a6af2f$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($6dfb7f60d8a6af2f$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $6dfb7f60d8a6af2f$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($6dfb7f60d8a6af2f$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($6dfb7f60d8a6af2f$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($6dfb7f60d8a6af2f$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Write
                 */ this.nodes.forEach($6dfb7f60d8a6af2f$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($6dfb7f60d8a6af2f$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($6dfb7f60d8a6af2f$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $07d2abf88a6ff3f7$export$2da9be4cfdb689b1).now();
            (0, $95a89474cd9c2897$export$fff89137e9e818ce).delta = (0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp);
            (0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp = now;
            (0, $95a89474cd9c2897$export$fff89137e9e818ce).isProcessing = true;
            (0, $95a89474cd9c2897$export$1811c3a7e3af92f0).update.process((0, $95a89474cd9c2897$export$fff89137e9e818ce));
            (0, $95a89474cd9c2897$export$1811c3a7e3af92f0).preRender.process((0, $95a89474cd9c2897$export$fff89137e9e818ce));
            (0, $95a89474cd9c2897$export$1811c3a7e3af92f0).render.process((0, $95a89474cd9c2897$export$fff89137e9e818ce));
            (0, $95a89474cd9c2897$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $afa024ccba882b1b$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($6dfb7f60d8a6af2f$var$clearSnapshot);
            this.sharedNodes.forEach($6dfb7f60d8a6af2f$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $95a89474cd9c2897$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $422ee56d179300ba$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $422ee56d179300ba$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $e5a2394a91a016b7$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $b411a0e1e2035a6e$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $6dfb7f60d8a6af2f$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($6dfb7f60d8a6af2f$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $98986c5ac90dc9e9$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $98986c5ac90dc9e9$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $98986c5ac90dc9e9$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $98986c5ac90dc9e9$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $98986c5ac90dc9e9$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $b411a0e1e2035a6e$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $98986c5ac90dc9e9$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $b411a0e1e2035a6e$export$a545127cf1fbb600)(this.latestValues)) (0, $98986c5ac90dc9e9$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $b411a0e1e2035a6e$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $b411a0e1e2035a6e$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $f709e42cc4e84456$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $b411a0e1e2035a6e$export$a545127cf1fbb600)(this.latestValues)) (0, $f709e42cc4e84456$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                    (0, $422ee56d179300ba$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $422ee56d179300ba$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $98986c5ac90dc9e9$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                    (0, $422ee56d179300ba$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $93753a2081bc00ed$export$84ce9a476f53d110).value) $6dfb7f60d8a6af2f$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $b411a0e1e2035a6e$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $b411a0e1e2035a6e$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $98986c5ac90dc9e9$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $2002a73bc4c4a451$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $2002a73bc4c4a451$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $422ee56d179300ba$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $e5a2394a91a016b7$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $e5a2394a91a016b7$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $93753a2081bc00ed$export$84ce9a476f53d110).value) $6dfb7f60d8a6af2f$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $0ec9f723b7ee27bd$export$3d227df54007d73a)();
            this.projectionDelta = (0, $0ec9f723b7ee27bd$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $0ec9f723b7ee27bd$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $0ec9f723b7ee27bd$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($6dfb7f60d8a6af2f$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $6dfb7f60d8a6af2f$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $6dfb7f60d8a6af2f$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $422ee56d179300ba$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $6dfb7f60d8a6af2f$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $e5a2394a91a016b7$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                    (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $ba60351f76d3478e$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $95a89474cd9c2897$export$2cef06c20297c17d).update(()=>{
                (0, $5716ff21ca967367$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $6c76de8f1380e08b$export$d921fb2475e2900c).layout++;
                this.motionValue || (this.motionValue = (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(0));
                this.currentAnimation = (0, $debbbee72ccccccb$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $6c76de8f1380e08b$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $6c76de8f1380e08b$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($6dfb7f60d8a6af2f$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $6dfb7f60d8a6af2f$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                const xLength = (0, $422ee56d179300ba$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $422ee56d179300ba$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $2002a73bc4c4a451$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $98986c5ac90dc9e9$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $422ee56d179300ba$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $0afd2595b3b9f57e$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $6dfb7f60d8a6af2f$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $6dfb7f60d8a6af2f$var$transformAxes.length; i++){
                $6dfb7f60d8a6af2f$var$resetDistortingTransform(`rotate${$6dfb7f60d8a6af2f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $6dfb7f60d8a6af2f$var$resetDistortingTransform(`skew${$6dfb7f60d8a6af2f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $aeacffbc55454f4a$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $aeacffbc55454f4a$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $b411a0e1e2035a6e$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $eb1e4b9c88ef3021$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $3063faa9fe482faa$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $3063faa9fe482faa$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $aeacffbc55454f4a$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($6dfb7f60d8a6af2f$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $6dfb7f60d8a6af2f$var$updateLayout(node) {
    node.updateLayout();
}
function $6dfb7f60d8a6af2f$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $422ee56d179300ba$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($6dfb7f60d8a6af2f$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $0d0f14d919ad9c9e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $422ee56d179300ba$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $0ec9f723b7ee27bd$export$3d227df54007d73a)();
        (0, $422ee56d179300ba$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $0ec9f723b7ee27bd$export$3d227df54007d73a)();
        if (isShared) (0, $422ee56d179300ba$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $422ee56d179300ba$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $e5a2394a91a016b7$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                    (0, $422ee56d179300ba$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $0ec9f723b7ee27bd$export$6459fc9e86be362e)();
                    (0, $422ee56d179300ba$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $e5a2394a91a016b7$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $6dfb7f60d8a6af2f$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $93753a2081bc00ed$export$84ce9a476f53d110).value) $6dfb7f60d8a6af2f$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $6dfb7f60d8a6af2f$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $6dfb7f60d8a6af2f$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $6dfb7f60d8a6af2f$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $6dfb7f60d8a6af2f$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $6dfb7f60d8a6af2f$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $6dfb7f60d8a6af2f$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $6dfb7f60d8a6af2f$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $6dfb7f60d8a6af2f$var$calcProjection(node) {
    node.calcProjection();
}
function $6dfb7f60d8a6af2f$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $6dfb7f60d8a6af2f$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $6dfb7f60d8a6af2f$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $6dfb7f60d8a6af2f$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $20ee05cfbd62a026$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $6dfb7f60d8a6af2f$export$6ffd3e6ae339a132(output, from, to, p) {
    $6dfb7f60d8a6af2f$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $6dfb7f60d8a6af2f$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $6dfb7f60d8a6af2f$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $6dfb7f60d8a6af2f$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $6dfb7f60d8a6af2f$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $6dfb7f60d8a6af2f$var$roundPoint = $6dfb7f60d8a6af2f$var$userAgentContains("applewebkit/") && !$6dfb7f60d8a6af2f$var$userAgentContains("chrome/") ? Math.round : (0, $38f396ca024a6caf$export$8793edee2d425525);
function $6dfb7f60d8a6af2f$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $6dfb7f60d8a6af2f$var$roundPoint(axis.min);
    axis.max = $6dfb7f60d8a6af2f$var$roundPoint(axis.max);
}
function $6dfb7f60d8a6af2f$var$roundBox(box) {
    $6dfb7f60d8a6af2f$var$roundAxis(box.x);
    $6dfb7f60d8a6af2f$var$roundAxis(box.y);
}
function $6dfb7f60d8a6af2f$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $422ee56d179300ba$export$28d0384c4b79bde2)((0, $e5a2394a91a016b7$export$c5706146bc63213)(snapshot), (0, $e5a2394a91a016b7$export$c5706146bc63213)(layout), 0.2);
}
function $6dfb7f60d8a6af2f$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $2f8a621969049024$export$2d029a49a09b6177 = (0, $6dfb7f60d8a6af2f$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $14262807fdfabaf4$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $d19bd765f944ecd1$export$b91509fcf893b648 = {
    current: undefined
};
const $d19bd765f944ecd1$export$b61a9eb3dbde8858 = (0, $6dfb7f60d8a6af2f$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$d19bd765f944ecd1$export$b91509fcf893b648.current) {
            const documentNode = new (0, $2f8a621969049024$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $d19bd765f944ecd1$export$b91509fcf893b648.current = documentNode;
        }
        return $d19bd765f944ecd1$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $245146582bb6cd1b$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $0e2c3f79ee634562$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $4702ebbc9984da45$export$5d97dc2872682820),
        ProjectionNode: (0, $d19bd765f944ecd1$export$b61a9eb3dbde8858),
        MeasureLayout: $1a564b85be8208d8$export$779f5fb01ad751cd
    }
};



function $91a44f18e3af19bb$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $85f8fb4ef14ffb95$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $91a44f18e3af19bb$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $4cc36a2cfdb7b226$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $1dfe484c8eb65fc5$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $4cc36a2cfdb7b226$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $85f8fb4ef14ffb95$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$4cc36a2cfdb7b226$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$4cc36a2cfdb7b226$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}




function $ae70025908d65fd9$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $20de773ff31dcd8d$export$12f84bb882d06e1a)(event)));
}
class $ae70025908d65fd9$export$93a81ea037eac456 extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $4cc36a2cfdb7b226$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $ae70025908d65fd9$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$ae70025908d65fd9$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $889dd1ec168036b9$export$d4826db40d47595b extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $8dfb3194b07560fa$export$a4627e546088548d)((0, $14262807fdfabaf4$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $14262807fdfabaf4$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}



/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $f8b4f69a3140e200$export$1b3bfaa9684536aa(element) {
    return (0, $7679c8ec2898b850$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element;
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $925b23c12abac03a$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $925b23c12abac03a$export$e841ada32ff745b(parent, child.parentElement);
};




const $1f341f0a7876b6cc$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $1f341f0a7876b6cc$export$5f6976e2f961e8b7(element) {
    return $1f341f0a7876b6cc$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $6b28927a5d235415$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $2888348b98488bdc$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $2888348b98488bdc$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $2888348b98488bdc$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $2888348b98488bdc$var$filterEvents(()=>{
        if ((0, $6b28927a5d235415$export$7987404a4e35b84b).has(element)) return;
        $2888348b98488bdc$var$firePointerEvent(element, "down");
        const handleKeyup = $2888348b98488bdc$var$filterEvents(()=>{
            $2888348b98488bdc$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$2888348b98488bdc$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $837f51b625526157$var$isValidPressEvent(event) {
    return (0, $74f89e085ce5dcca$export$a4cf9c8a4b063a6e)(event) && !(0, $1dfe484c8eb65fc5$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $837f51b625526157$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $85f8fb4ef14ffb95$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$837f51b625526157$var$isValidPressEvent(startEvent)) return;
        (0, $6b28927a5d235415$export$7987404a4e35b84b).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $6b28927a5d235415$export$7987404a4e35b84b).has(target)) (0, $6b28927a5d235415$export$7987404a4e35b84b).delete(target);
            if (!$837f51b625526157$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $925b23c12abac03a$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $f8b4f69a3140e200$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $2888348b98488bdc$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $1f341f0a7876b6cc$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}




function $f6bfdfa1b0401f44$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $95a89474cd9c2897$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $20de773ff31dcd8d$export$12f84bb882d06e1a)(event)));
}
class $f6bfdfa1b0401f44$export$f026abdbba7f0c9e extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $837f51b625526157$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $f6bfdfa1b0401f44$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$f6bfdfa1b0401f44$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $3ff9a0c26bbe4cec$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $3ff9a0c26bbe4cec$var$observers = new WeakMap();
const $3ff9a0c26bbe4cec$var$fireObserverCallback = (entry)=>{
    const callback = $3ff9a0c26bbe4cec$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $3ff9a0c26bbe4cec$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($3ff9a0c26bbe4cec$var$fireObserverCallback);
};
function $3ff9a0c26bbe4cec$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$3ff9a0c26bbe4cec$var$observers.has(lookupRoot)) $3ff9a0c26bbe4cec$var$observers.set(lookupRoot, {});
    const rootObservers = $3ff9a0c26bbe4cec$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($3ff9a0c26bbe4cec$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $3ff9a0c26bbe4cec$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $3ff9a0c26bbe4cec$var$initIntersectionObserver(options);
    $3ff9a0c26bbe4cec$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $3ff9a0c26bbe4cec$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $a16d1149cadffe11$var$thresholdNames = {
    some: 0,
    all: 1
};
class $a16d1149cadffe11$export$150851c8cc2f0c72 extends (0, $17ca0551d93d6898$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $a16d1149cadffe11$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $3ff9a0c26bbe4cec$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($a16d1149cadffe11$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $a16d1149cadffe11$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $9f1a616c44f1bfec$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $a16d1149cadffe11$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $f6bfdfa1b0401f44$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $889dd1ec168036b9$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $ae70025908d65fd9$export$93a81ea037eac456)
    }
};




const $8227f8bb605908b9$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $d19bd765f944ecd1$export$b61a9eb3dbde8858),
        MeasureLayout: $1a564b85be8208d8$export$779f5fb01ad751cd
    }
};


const $0a8430963dc66330$export$d596cd8841d25433 = {
    ...(0, $adc79304457d70a9$export$7f9953c70dacfd7f),
    ...(0, $9f1a616c44f1bfec$export$e5b72898e5a201f1),
    ...(0, $245146582bb6cd1b$export$d7d5d435647ed5a0),
    ...(0, $8227f8bb605908b9$export$b3219800bda33a1f)
};


const $846f4d4559abcf5e$export$e25e478948902b8b = /*@__PURE__*/ (0, $284eaa2fc3f0b527$export$a28d6df673050e18)((0, $0a8430963dc66330$export$d596cd8841d25433), (0, $da054e8f0ed05935$export$56ba0183203348f5));


var $4Iuzv = parcelRequire("4Iuzv");
function $bdfb39e93bf2e24c$export$d0af34c3a9c3efcb(value, event, callback) {
    /**
     * useInsertionEffect will create subscriptions before any other
     * effects will run. Effects run upwards through the tree so it
     * can be that binding a useLayoutEffect higher up the tree can
     * miss changes from lower down the tree.
     */ (0, $4Iuzv.useInsertionEffect)(()=>value.on(event, callback), [
        value,
        event,
        callback
    ]);
}




var $4Iuzv = parcelRequire("4Iuzv");


function $e3d4432ef0cc3a3a$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $95a89474cd9c2897$export$2cef06c20297c17d).preUpdate(onFrame, true);
    return ()=>(0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(onFrame);
}





const $3954ae151a2b4519$var$resizeHandlers = new WeakMap();
let $3954ae151a2b4519$var$observer;
const $3954ae151a2b4519$var$getSize = (borderBoxAxis, svgAxis, htmlAxis)=>(target, borderBoxSize)=>{
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, $89a4623aed107637$export$17eda790a720ec57)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
const $3954ae151a2b4519$var$getWidth = /*@__PURE__*/ $3954ae151a2b4519$var$getSize("inline", "width", "offsetWidth");
const $3954ae151a2b4519$var$getHeight = /*@__PURE__*/ $3954ae151a2b4519$var$getSize("block", "height", "offsetHeight");
function $3954ae151a2b4519$var$notifyTarget({ target: target, borderBoxSize: borderBoxSize }) {
    $3954ae151a2b4519$var$resizeHandlers.get(target)?.forEach((handler)=>{
        handler(target, {
            get width () {
                return $3954ae151a2b4519$var$getWidth(target, borderBoxSize);
            },
            get height () {
                return $3954ae151a2b4519$var$getHeight(target, borderBoxSize);
            }
        });
    });
}
function $3954ae151a2b4519$var$notifyAll(entries) {
    entries.forEach($3954ae151a2b4519$var$notifyTarget);
}
function $3954ae151a2b4519$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $3954ae151a2b4519$var$observer = new ResizeObserver($3954ae151a2b4519$var$notifyAll);
}
function $3954ae151a2b4519$export$81a0e12ec749d682(target, handler) {
    if (!$3954ae151a2b4519$var$observer) $3954ae151a2b4519$var$createResizeObserver();
    const elements = (0, $91a44f18e3af19bb$export$90ceba2564a894f8)(target);
    elements.forEach((element)=>{
        let elementHandlers = $3954ae151a2b4519$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $3954ae151a2b4519$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $3954ae151a2b4519$var$observer?.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $3954ae151a2b4519$var$resizeHandlers.get(element);
            elementHandlers?.delete(handler);
            if (!elementHandlers?.size) $3954ae151a2b4519$var$observer?.unobserve(element);
        });
    };
}


const $8ffeccf0db71f871$var$windowCallbacks = new Set();
let $8ffeccf0db71f871$var$windowResizeHandler;
function $8ffeccf0db71f871$var$createWindowResizeHandler() {
    $8ffeccf0db71f871$var$windowResizeHandler = ()=>{
        const info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        $8ffeccf0db71f871$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $8ffeccf0db71f871$var$windowResizeHandler);
}
function $8ffeccf0db71f871$export$7fc81011b72cd94d(callback) {
    $8ffeccf0db71f871$var$windowCallbacks.add(callback);
    if (!$8ffeccf0db71f871$var$windowResizeHandler) $8ffeccf0db71f871$var$createWindowResizeHandler();
    return ()=>{
        $8ffeccf0db71f871$var$windowCallbacks.delete(callback);
        if (!$8ffeccf0db71f871$var$windowCallbacks.size && typeof $8ffeccf0db71f871$var$windowResizeHandler === "function") {
            window.removeEventListener("resize", $8ffeccf0db71f871$var$windowResizeHandler);
            $8ffeccf0db71f871$var$windowResizeHandler = undefined;
        }
    };
}


function $5f32ef31172763cc$export$4380c87abf28fdf(a, b) {
    return typeof a === "function" ? (0, $8ffeccf0db71f871$export$7fc81011b72cd94d)(a) : (0, $3954ae151a2b4519$export$81a0e12ec749d682)(a, b);
}




/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ const $fdba865ca2ecb4ab$var$maxElapsed = 50;
const $fdba865ca2ecb4ab$var$createAxisInfo = ()=>({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    });
const $fdba865ca2ecb4ab$export$38ba9ec5092d2d70 = ()=>({
        time: 0,
        x: $fdba865ca2ecb4ab$var$createAxisInfo(),
        y: $fdba865ca2ecb4ab$var$createAxisInfo()
    });
const $fdba865ca2ecb4ab$var$keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function $fdba865ca2ecb4ab$var$updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length: length, position: position } = $fdba865ca2ecb4ab$var$keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element[`scroll${position}`];
    axis.scrollLength = element[`scroll${length}`] - element[`client${length}`];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, $9c39606140f23b1b$export$504d7abb21fa8c9)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity = elapsed > $fdba865ca2ecb4ab$var$maxElapsed ? 0 : (0, $b68d897340517dfd$export$eab0632f7ad4f9d7)(axis.current - prev, elapsed);
}
function $fdba865ca2ecb4ab$export$55f50a00c84f0ed3(element, info, time) {
    $fdba865ca2ecb4ab$var$updateAxisInfo(element, "x", info, time);
    $fdba865ca2ecb4ab$var$updateAxisInfo(element, "y", info, time);
    info.time = time;
}







function $ec22686121e33046$export$6858938830d6a6db(element, container) {
    const inset = {
        x: 0,
        y: 0
    };
    let current = element;
    while(current && current !== container){
        if ((0, $f8b4f69a3140e200$export$1b3bfaa9684536aa)(current)) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current.tagName === "svg") {
            /**
             * This isn't an ideal approach to measuring the offset of <svg /> tags.
             * It would be preferable, given they behave like HTMLElements in most ways
             * to use offsetLeft/Top. But these don't exist on <svg />. Likewise we
             * can't use .getBBox() like most SVG elements as these provide the offset
             * relative to the SVG itself, which for <svg /> is usually 0x0.
             */ const svgBoundingBox = current.getBoundingClientRect();
            current = current.parentElement;
            const parentBoundingBox = current.getBoundingClientRect();
            inset.x += svgBoundingBox.left - parentBoundingBox.left;
            inset.y += svgBoundingBox.top - parentBoundingBox.top;
        } else if (current instanceof SVGGraphicsElement) {
            const { x: x, y: y } = current.getBBox();
            inset.x += x;
            inset.y += y;
            let svg = null;
            let parent = current.parentNode;
            while(!svg){
                if (parent.tagName === "svg") svg = parent;
                parent = current.parentNode;
            }
            current = svg;
        } else break;
    }
    return inset;
}


const $f74404cf402646a8$export$5329d185756d2568 = {
    start: 0,
    center: 0.5,
    end: 1
};
function $f74404cf402646a8$export$1a4fccdf0f25754b(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if (edge in $f74404cf402646a8$export$5329d185756d2568) edge = $f74404cf402646a8$export$5329d185756d2568[edge];
    /**
     * Handle unit values
     */ if (typeof edge === "string") {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if (typeof edge === "number") delta = length * edge;
    return inset + delta;
}


const $be7dba93e9b3d3dd$var$defaultOffset = [
    0,
    0
];
function $be7dba93e9b3d3dd$export$1d98ea10734f1dc1(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : $be7dba93e9b3d3dd$var$defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if (typeof offset === "number") /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if (typeof offset === "string") {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, $f74404cf402646a8$export$5329d185756d2568)[offset] ? offset : `0`
        ];
    }
    targetPoint = (0, $f74404cf402646a8$export$1a4fccdf0f25754b)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, $f74404cf402646a8$export$1a4fccdf0f25754b)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}


const $0ae89ba281171f06$export$e59548524dcf6540 = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};


const $a7d4f9c1336a0763$var$point = {
    x: 0,
    y: 0
};
function $a7d4f9c1336a0763$var$getTargetSize(target) {
    return "getBBox" in target && target.tagName !== "svg" ? target.getBBox() : {
        width: target.clientWidth,
        height: target.clientHeight
    };
}
function $a7d4f9c1336a0763$export$44b097f22602edfc(container, info, options) {
    const { offset: offsetDefinition = (0, $0ae89ba281171f06$export$e59548524dcf6540).All } = options;
    const { target: target = container, axis: axis = "y" } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? (0, $ec22686121e33046$export$6858938830d6a6db)(target, container) : $a7d4f9c1336a0763$var$point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ const targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : $a7d4f9c1336a0763$var$getTargetSize(target);
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for(let i = 0; i < numOffsets; i++){
        const offset = (0, $be7dba93e9b3d3dd$export$1d98ea10734f1dc1)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, $c167b11cf20d0293$export$89e29e4ab65e70a9)(info[axis].offset, (0, $96f78e1f0b108a3b$export$24dbcec0b26e6d9d)(offsetDefinition), {
            clamp: false
        });
        info[axis].interpolatorOffsets = [
            ...info[axis].offset
        ];
    }
    info[axis].progress = (0, $7338642ed55f7b49$export$7d15b64cf5a3a4c4)(0, 1, info[axis].interpolate(info[axis].current));
}


function $35a20b5a3c381b3b$var$measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while(node && node !== container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function $35a20b5a3c381b3b$export$9dd72aeec3645b49(element, onScroll, info, options = {}) {
    return {
        measure: (time)=>{
            $35a20b5a3c381b3b$var$measure(element, options.target, info);
            (0, $fdba865ca2ecb4ab$export$55f50a00c84f0ed3)(element, info, time);
            if (options.offset || options.target) (0, $a7d4f9c1336a0763$export$44b097f22602edfc)(element, info, options);
        },
        notify: ()=>onScroll(info)
    };
}


const $e66adf9ab82262f2$var$scrollListeners = new WeakMap();
const $e66adf9ab82262f2$var$resizeListeners = new WeakMap();
const $e66adf9ab82262f2$var$onScrollHandlers = new WeakMap();
const $e66adf9ab82262f2$var$getEventTarget = (element)=>element === document.scrollingElement ? window : element;
function $e66adf9ab82262f2$export$153bd4cd67dcc6cc(onScroll, { container: container = document.scrollingElement, ...options } = {}) {
    if (!container) return 0, $38f396ca024a6caf$export$8793edee2d425525;
    let containerHandlers = $e66adf9ab82262f2$var$onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        $e66adf9ab82262f2$var$onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ const info = (0, $fdba865ca2ecb4ab$export$38ba9ec5092d2d70)();
    const containerHandler = (0, $35a20b5a3c381b3b$export$9dd72aeec3645b49)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!$e66adf9ab82262f2$var$scrollListeners.has(container)) {
        const measureAll = ()=>{
            for (const handler of containerHandlers)handler.measure((0, $95a89474cd9c2897$export$fff89137e9e818ce).timestamp);
            (0, $95a89474cd9c2897$export$2cef06c20297c17d).preUpdate(notifyAll);
        };
        const notifyAll = ()=>{
            for (const handler of containerHandlers)handler.notify();
        };
        const listener = ()=>(0, $95a89474cd9c2897$export$2cef06c20297c17d).read(measureAll);
        $e66adf9ab82262f2$var$scrollListeners.set(container, listener);
        const target = $e66adf9ab82262f2$var$getEventTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $e66adf9ab82262f2$var$resizeListeners.set(container, (0, $5f32ef31172763cc$export$4380c87abf28fdf)(container, listener));
        target.addEventListener("scroll", listener, {
            passive: true
        });
        listener();
    }
    const listener = $e66adf9ab82262f2$var$scrollListeners.get(container);
    (0, $95a89474cd9c2897$export$2cef06c20297c17d).read(listener, false, true);
    return ()=>{
        (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(listener);
        /**
         * Check if we even have any handlers for this container.
         */ const currentHandlers = $e66adf9ab82262f2$var$onScrollHandlers.get(container);
        if (!currentHandlers) return;
        currentHandlers.delete(containerHandler);
        if (currentHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ const scrollListener = $e66adf9ab82262f2$var$scrollListeners.get(container);
        $e66adf9ab82262f2$var$scrollListeners.delete(container);
        if (scrollListener) {
            $e66adf9ab82262f2$var$getEventTarget(container).removeEventListener("scroll", scrollListener);
            $e66adf9ab82262f2$var$resizeListeners.get(container)?.();
            window.removeEventListener("resize", scrollListener);
        }
    };
}


const $8dc708dbb0300a1c$var$timelineCache = new Map();
function $8dc708dbb0300a1c$var$scrollTimelineFallback(options) {
    const currentTime = {
        value: 0
    };
    const cancel = (0, $e66adf9ab82262f2$export$153bd4cd67dcc6cc)((info)=>{
        currentTime.value = info[options.axis].progress * 100;
    }, options);
    return {
        currentTime: currentTime,
        cancel: cancel
    };
}
function $8dc708dbb0300a1c$export$37623781dd5ede44({ source: source, container: container, ...options }) {
    const { axis: axis } = options;
    if (source) container = source;
    const containerCache = $8dc708dbb0300a1c$var$timelineCache.get(container) ?? new Map();
    $8dc708dbb0300a1c$var$timelineCache.set(container, containerCache);
    const targetKey = options.target ?? "self";
    const targetCache = containerCache.get(targetKey) ?? {};
    const axisKey = axis + (options.offset ?? []).join(",");
    if (!targetCache[axisKey]) targetCache[axisKey] = !options.target && (0, $ab737a1b2805e540$export$20d68f04f30763a5)() ? new ScrollTimeline({
        source: container,
        axis: axis
    }) : $8dc708dbb0300a1c$var$scrollTimelineFallback({
        container: container,
        ...options
    });
    return targetCache[axisKey];
}


function $96c52aacd3b48bb7$export$985c7860f270efe(animation, options) {
    const timeline = (0, $8dc708dbb0300a1c$export$37623781dd5ede44)(options);
    return animation.attachTimeline({
        timeline: options.target ? undefined : timeline,
        observe: (valueAnimation)=>{
            valueAnimation.pause();
            return (0, $e3d4432ef0cc3a3a$export$b4f1bbab0c442a76)((progress)=>{
                valueAnimation.time = valueAnimation.duration * progress;
            }, timeline);
        }
    });
}





/**
 * If the onScroll function has two arguments, it's expecting
 * more specific information about the scroll from scrollInfo.
 */ function $59a9826ec2c6307d$var$isOnScrollWithInfo(onScroll) {
    return onScroll.length === 2;
}
function $59a9826ec2c6307d$export$d0170c19979d54c9(onScroll, options) {
    if ($59a9826ec2c6307d$var$isOnScrollWithInfo(onScroll)) return (0, $e66adf9ab82262f2$export$153bd4cd67dcc6cc)((info)=>{
        onScroll(info[options.axis].progress, info);
    }, options);
    else return (0, $e3d4432ef0cc3a3a$export$b4f1bbab0c442a76)(onScroll, (0, $8dc708dbb0300a1c$export$37623781dd5ede44)(options));
}


function $a8683a9b11d05aa9$export$209876d7b1ac8f3(onScroll, { axis: axis = "y", container: container = document.scrollingElement, ...options } = {}) {
    if (!container) return 0, $38f396ca024a6caf$export$8793edee2d425525;
    const optionsWithDefaults = {
        axis: axis,
        container: container,
        ...options
    };
    return typeof onScroll === "function" ? (0, $59a9826ec2c6307d$export$d0170c19979d54c9)(onScroll, optionsWithDefaults) : (0, $96c52aacd3b48bb7$export$985c7860f270efe)(onScroll, optionsWithDefaults);
}




const $81805334ae760255$var$createScrollMotionValues = ()=>({
        scrollX: (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(0),
        scrollY: (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(0),
        scrollXProgress: (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(0),
        scrollYProgress: (0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(0)
    });
const $81805334ae760255$var$isRefPending = (ref)=>{
    if (!ref) return false;
    return !ref.current;
};
function $81805334ae760255$export$d928051c8cd740b({ container: container, target: target, ...options } = {}) {
    const values = (0, $d2760f4a4b2f578c$export$fe4300aa8eebea86)($81805334ae760255$var$createScrollMotionValues);
    const scrollAnimation = (0, $4Iuzv.useRef)(null);
    const needsStart = (0, $4Iuzv.useRef)(false);
    const start = (0, $4Iuzv.useCallback)(()=>{
        scrollAnimation.current = (0, $a8683a9b11d05aa9$export$209876d7b1ac8f3)((_progress, { x: x, y: y })=>{
            values.scrollX.set(x.current);
            values.scrollXProgress.set(x.progress);
            values.scrollY.set(y.current);
            values.scrollYProgress.set(y.progress);
        }, {
            ...options,
            container: container?.current || undefined,
            target: target?.current || undefined
        });
        return ()=>{
            scrollAnimation.current?.();
        };
    }, [
        container,
        target,
        JSON.stringify(options.offset)
    ]);
    (0, $b52b43714f18dcbf$export$700979bc83e7db82)(()=>{
        needsStart.current = false;
        if ($81805334ae760255$var$isRefPending(container) || $81805334ae760255$var$isRefPending(target)) {
            needsStart.current = true;
            return;
        } else return start();
    }, [
        start
    ]);
    (0, $4Iuzv.useEffect)(()=>{
        if (needsStart.current) {
            (0, $fc095028715896dd$export$f5708dca728d7177)(!$81805334ae760255$var$isRefPending(container), "Container ref is defined but not hydrated", "use-scroll-ref");
            (0, $fc095028715896dd$export$f5708dca728d7177)(!$81805334ae760255$var$isRefPending(target), "Target ref is defined but not hydrated", "use-scroll-ref");
            return start();
        } else return;
    }, [
        start
    ]);
    return values;
}


function $b9c51211d37e4ed9$export$51186ad6e864892a(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0, $c167b11cf20d0293$export$89e29e4ab65e70a9)(inputRange, outputRange, options);
    return useImmediate ? interpolator(inputValue) : interpolator;
}







var $4Iuzv = parcelRequire("4Iuzv");


/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $ec60f2c63267ab18$export$15b697acf84c78b9(initial) {
    const value = (0, $d2760f4a4b2f578c$export$fe4300aa8eebea86)(()=>(0, $190a8a8284ab6cc9$export$ce8bdc721e76545f)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ const { isStatic: isStatic } = (0, $4Iuzv.useContext)((0, $5bcd9ec5c3a0a98c$export$22a697fb29aac98d));
    if (isStatic) {
        const [, setLatest] = (0, $4Iuzv.useState)(initial);
        (0, $4Iuzv.useEffect)(()=>value.on("change", setLatest), []);
    }
    return value;
}


function $e6e4b7107112b1fc$export$7dee4fa9fc2b33f3(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */ const value = (0, $ec60f2c63267ab18$export$15b697acf84c78b9)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */ const updateValue = ()=>value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */ updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */ (0, $b52b43714f18dcbf$export$700979bc83e7db82)(()=>{
        const scheduleUpdate = ()=>(0, $95a89474cd9c2897$export$2cef06c20297c17d).preRender(updateValue, false, true);
        const subscriptions = values.map((v)=>v.on("change", scheduleUpdate));
        return ()=>{
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            (0, $95a89474cd9c2897$export$ec99c0ef4978dccb)(updateValue);
        };
    });
    return value;
}




function $4734b48729031a12$export$e3d20747ab930783(compute) {
    /**
     * Open session of collectMotionValues. Any MotionValue that calls get()
     * will be saved into this array.
     */ (0, $190a8a8284ab6cc9$export$67fcd818a264039d).current = [];
    compute();
    const value = (0, $e6e4b7107112b1fc$export$7dee4fa9fc2b33f3)((0, $190a8a8284ab6cc9$export$67fcd818a264039d).current, compute);
    /**
     * Synchronously close session of collectMotionValues.
     */ (0, $190a8a8284ab6cc9$export$67fcd818a264039d).current = undefined;
    return value;
}


function $996cd024c6b6d358$export$a87ba948fb2b39ec(input, inputRangeOrTransformer, outputRange, options) {
    if (typeof input === "function") return (0, $4734b48729031a12$export$e3d20747ab930783)(input);
    const transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : (0, $b9c51211d37e4ed9$export$51186ad6e864892a)(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input) ? $996cd024c6b6d358$var$useListTransform(input, transformer) : $996cd024c6b6d358$var$useListTransform([
        input
    ], ([latest])=>transformer(latest));
}
function $996cd024c6b6d358$var$useListTransform(values, transformer) {
    const latest = (0, $d2760f4a4b2f578c$export$fe4300aa8eebea86)(()=>[]);
    return (0, $e6e4b7107112b1fc$export$7dee4fa9fc2b33f3)(values, ()=>{
        latest.length = 0;
        const numValues = values.length;
        for(let i = 0; i < numValues; i++)latest[i] = values[i].get();
        return transformer(latest);
    });
}


function $92bd4bdc218fb1d5$var$KineticCard({ data: data, index: index }) {
    const ref = (0, $4Iuzv.useRef)(null);
    const { scrollYProgress: scrollYProgress } = (0, $81805334ae760255$export$d928051c8cd740b)({
        target: ref,
        offset: [
            "start end",
            "end start"
        ]
    });
    const imageY = (0, $996cd024c6b6d358$export$a87ba948fb2b39ec)(scrollYProgress, [
        0,
        1
    ], [
        "-12%",
        "12%"
    ]);
    const opacity = (0, $996cd024c6b6d358$export$a87ba948fb2b39ec)(scrollYProgress, [
        0,
        0.15,
        0.85,
        1
    ], [
        0,
        1,
        1,
        0
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $846f4d4559abcf5e$export$e25e478948902b8b).article, {
        ref: ref,
        style: {
            opacity: opacity
        },
        className: "w-full h-[75vh] min-h-[600px] overflow-hidden rounded-2xl bg-[#111] shadow-2xl sticky top-24",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "absolute inset-0 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $846f4d4559abcf5e$export$e25e478948902b8b).div, {
                        style: {
                            y: imageY
                        },
                        className: "absolute inset-[-15%] w-[130%] h-[130%]",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                            src: data.facilityImg[0],
                            alt: data.title,
                            className: "w-full h-full object-cover"
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-gradient-to-t from-black  to-transparent"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "absolute inset-x-0 bottom-0 p-6 md:p-8 pb-10 flex flex-col text-white",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center gap-2 mb-3 opacity-40",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                className: "text-[8px] font-black tracking-[0.4em] uppercase italic",
                                children: [
                                    "Facility // 0",
                                    index + 1
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-6 h-[1px] bg-white/30"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center gap-1.5 mb-1.5",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                size: 12,
                                className: "text-[#BF092F]"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                className: "text-[9px] font-bold uppercase tracking-[0.3em] text-white/70",
                                children: data.location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                        className: "text-2xl md:text-3xl font-black uppercase tracking-tighter leading-[0.9] mb-6 drop-shadow-2xl",
                        children: data.title
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-6 mb-8 pt-4 border-t border-white/10",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "space-y-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-[7px] uppercase tracking-[0.3em] text-[#BF092F] font-black",
                                        children: "Capacity"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-xs font-bold tracking-tight text-white/90",
                                        children: data.productionCapacity
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "space-y-0.5",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-[7px] uppercase tracking-[0.3em] text-[#BF092F] font-black",
                                        children: "Total Area"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-xs font-bold tracking-tight text-white/90",
                                        children: data.totalArea
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                        to: `/facilities/${data.id}`,
                        className: "flex items-center justify-between group bg-white text-black h-14 px-6 rounded-xl font-black text-[9px] uppercase tracking-[0.4em] shadow-2xl active:scale-95 transition-all",
                        children: [
                            "View Facility",
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                size: 18,
                                strokeWidth: 3,
                                className: "text-[#BF092F] group-hover:translate-x-1 transition-transform"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $846f4d4559abcf5e$export$e25e478948902b8b).div, {
                className: "absolute bottom-0 left-0 right-0 h-1.5 bg-[#BF092F] origin-left shadow-[0_0_10px_#BF092F]",
                style: {
                    scaleX: scrollYProgress
                }
            })
        ]
    });
}
function $92bd4bdc218fb1d5$export$2e2bcd8739ae039() {
    const [activeIndex, setActiveIndex] = (0, $4Iuzv.useState)(0);
    // SEO: Structured Data for Manufacturing Facilities
    const facilitySchema = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "Arc Engineering Global Manufacturing Facilities",
        itemListElement: (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((f, i)=>({
                "@type": "ListItem",
                position: i + 1,
                item: {
                    "@type": "LocalBusiness",
                    name: f.title,
                    image: f.facilityImg[0],
                    address: {
                        "@type": "PostalAddress",
                        addressLocality: f.location
                    },
                    description: `ISO-certified production facility specializing in ${f.highlights?.join(", ")}`
                }
            }))
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        className: "bg-[#fcfcfc] py-24 px-6 md:px-20 text-[#44444E]",
        "aria-labelledby": "facilities-title",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                    type: "application/ld+json",
                    children: JSON.stringify(facilitySchema)
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                className: "max-w-[1400px] mx-auto mb-24",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex items-center gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "h-8 w-1 bg-[#BF092F]",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                size: 14,
                                className: "text-[#BF092F] animate-pulse",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                className: "text-sm uppercase font-bold tracking-[0.4em]",
                                children: "Global Infrastructure"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex flex-col lg:flex-row lg:items-end justify-between gap-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                id: "facilities-title",
                                className: "text-3xl md:text-5xl font-semibold leading-tight uppercase tracking-tight",
                                children: [
                                    "The ",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[#BF092F]",
                                        children: "Engine"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                    " of Production"
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                className: "max-w-md text-[#44444E]/50 font-bold uppercase tracking-widest text-[10px] leading-relaxed pb-1 border-l-2 border-[#44444E]/10 pl-6 lg:ml-8",
                                children: [
                                    "Precision ",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("strong", {
                                        children: "manufacturing"
                                    }),
                                    " via ISO-certified high-capacity terminals and ",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("strong", {
                                        children: "industrial fabrication"
                                    }),
                                    " ",
                                    "hubs."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "lg:hidden w-full flex flex-col items-center pb-20",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "w-[99%] flex flex-col gap-10",
                    children: (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((f, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($92bd4bdc218fb1d5$var$KineticCard, {
                            data: f,
                            index: i
                        }, f.id))
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "hidden lg:flex max-w-[1400px] mx-auto gap-32 relative",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                        className: "w-1/2 sticky top-[calc(50vh-300px)] h-[600px] z-10",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "w-full h-full rounded-[2rem] p-0 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.15)] bg-black ring-1 ring-white/5 ring-inset overflow-hidden relative",
                            children: [
                                (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((f, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $846f4d4559abcf5e$export$e25e478948902b8b).img, {
                                        src: f.facilityImg[0],
                                        alt: "" // Decorative in this context as the text section handles the SEO
                                        ,
                                        animate: {
                                            opacity: activeIndex === i ? 1 : 0
                                        },
                                        transition: {
                                            duration: 0.6,
                                            ease: [
                                                0.16,
                                                1,
                                                0.3,
                                                1
                                            ]
                                        },
                                        className: "absolute inset-0 w-full h-full object-cover"
                                    }, f.id)),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "absolute inset-0 rounded-[2rem] border-[1px] border-white/10 pointer-events-none"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "w-1/2 pt-10",
                        children: (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((c, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($92bd4bdc218fb1d5$var$Section, {
                                data: c,
                                index: i,
                                onActive: ()=>setActiveIndex(i)
                            }, c.id))
                    })
                ]
            })
        ]
    });
}
function $92bd4bdc218fb1d5$var$Section({ data: data, index: index, onActive: onActive, isMobile: isMobile }) {
    const ref = (0, $4Iuzv.useRef)(null);
    const { scrollYProgress: scrollYProgress } = (0, $81805334ae760255$export$d928051c8cd740b)({
        target: ref,
        offset: [
            "center end",
            "center start"
        ]
    });
    const height = (0, $996cd024c6b6d358$export$a87ba948fb2b39ec)(scrollYProgress, [
        0,
        1
    ], [
        "0%",
        "100%"
    ]);
    (0, $bdfb39e93bf2e24c$export$d0af34c3a9c3efcb)(scrollYProgress, "change", (latest)=>{
        if (latest > 0.1 && latest < 0.9) onActive();
    });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
        ref: ref,
        className: `relative mb-12 ${isMobile ? "pl-0" : "pl-12 min-h-[80vh]"}`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: `absolute left-0 top-0 bottom-0 w-[2px] bg-[#44444E]/10 ${isMobile ? "hidden" : "block"}`,
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $846f4d4559abcf5e$export$e25e478948902b8b).div, {
                        className: "w-full bg-[#BF092F]",
                        style: {
                            height: height
                        }
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $846f4d4559abcf5e$export$e25e478948902b8b).div, {
                        className: "absolute -left-[5px] w-[12px] h-[12px] rounded-full border-[3px] border-[#BF092F] bg-white z-10",
                        style: {
                            top: height
                        },
                        animate: {
                            boxShadow: [
                                "0 0 0px rgba(191,9,47,0)",
                                "0 0 15px rgba(191,9,47,0.8)",
                                "0 0 0px rgba(191,9,47,0)"
                            ]
                        },
                        transition: {
                            duration: 2,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "bg-white p-8 rounded-3xl border border-[#eeeeee] shadow-[0_10px_30px_-5px_rgba(0,0,0,0.05)]",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                className: "text-[#BF092F] font-bold tracking-[0.2em] text-[10px] uppercase mb-4 block",
                                children: [
                                    "0",
                                    index + 1,
                                    " // Infrastructure"
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                className: "text-3xl font-bold text-[#44444E] uppercase tracking-tighter mb-4",
                                children: data.title
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-[#44444E]/40 mb-6",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                        size: 12,
                                        className: "text-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("address", {
                                        className: "text-[10px] font-bold uppercase tracking-widest not-italic",
                                        children: data.location
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-4 mb-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "bg-[#f8f8f8] p-4 rounded-2xl border border-[#f0f0f0]",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "block text-[8px] font-bold text-[#44444E]/40 uppercase mb-1",
                                        children: "Total Area"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-xs font-black text-[#44444E]",
                                        children: data.totalArea
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "bg-[#f8f8f8] p-4 rounded-2xl border border-[#f0f0f0]",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "block text-[8px] font-bold text-[#44444E]/40 uppercase mb-1",
                                        children: "Production Capacity"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-xs font-black text-[#44444E]",
                                        children: data.productionCapacity
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                        className: "space-y-3 mb-8",
                        "aria-label": "Facility Highlights",
                        children: data.highlights?.slice(0, 3).map((text, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                className: "flex items-center gap-3 text-[#44444E]/60",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $be1846e1ca97d842$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F] flex-shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[10px] font-medium uppercase tracking-wide",
                                        children: text
                                    })
                                ]
                            }, idx))
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                        to: `/facilities/${data.id}`,
                        title: `View technical specifications for ${data.title}`,
                        className: "inline-flex items-center gap-4 text-xs font-bold uppercase tracking-[0.2em] text-[#BF092F] group",
                        children: [
                            "Explore Unit",
                            " ",
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                size: 16,
                                className: "group-hover:translate-x-2 transition-transform duration-300",
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


const $45d916c3adf9efb4$var$HomePage = ()=>{
    // SEO: Breadcrumb Schema using your specific domain
    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://arcengltd.com/"
            }
        ]
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "Arc Engineering | Precision Power & Generator Container Solutions"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "Arc Engineering: Global leaders in Generator Containers and E-House manufacturing. High-performance power systems engineered to UK standards."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("link", {
                        rel: "canonical",
                        href: "https://arcengltd.com/"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:title",
                        content: "Arc Engineering | Power & Container Solutions"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:description",
                        content: "Bespoke engineering solutions for global power infrastructure."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:url",
                        content: "https://arcengltd.com/"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(breadcrumbSchema)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $caaf1152e864e856$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $154171f69b15d666$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $793560686aa44278$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0117375c56681734$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $92bd4bdc218fb1d5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a855ff4f4b23843d$export$2e2bcd8739ae039), {})
        ]
    });
};
var $45d916c3adf9efb4$export$2e2bcd8739ae039 = $45d916c3adf9efb4$var$HomePage;




var $4Iuzv = parcelRequire("4Iuzv");




var $4Iuzv = parcelRequire("4Iuzv");


const $78362d5230cbcfa0$var$ProductCard = ({ product: product, categorySlug: categorySlug })=>{
    const [hover, setHover] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const handleNavigate = ()=>{
        // ROUTING: Matches /products/:category/:id structure
        const slug = categorySlug || "item";
        navigate(`/products/${slug}/${product.id}`);
    };
    const getOptimizedUrl = (url)=>{
        if (!url || !url.includes("cloudinary.com")) return url;
        // Cloudinary dynamic optimization for global performance
        return url.replace("/upload/", "/upload/f_auto,q_auto/");
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
        className: "group relative flex flex-col h-full bg-white rounded-2xl shadow-xl border border-gray-100 cursor-pointer overflow-hidden transition-all duration-500 hover:shadow-2xl hover:border-[#BF092F]/20 hover:-translate-y-2",
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        onClick: handleNavigate,
        "aria-labelledby": `product-name-${product.id}`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute top-4 right-4 z-20",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                    className: "text-[10px] font-mono font-bold text-gray-300 group-hover:text-[#BF092F] transition-colors tracking-widest uppercase",
                    children: product.AGPPartNumber || "SPEC_READY"
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "h-64 min-h-[16rem] relative overflow-hidden bg-gray-50 border-b border-gray-50",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                        src: getOptimizedUrl(product.images[0]),
                        alt: `Arc Engineering Product: ${product.name} (${product.Make})`,
                        className: `w-full h-full object-cover grayscale transition-all duration-700 opacity-90 ${hover ? "grayscale-0 scale-110 opacity-100" : ""}`,
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-gradient-to-t from-white/20 to-transparent pointer-events-none",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "p-8 flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $90b1c37bd27f04c4$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[10px] text-gray-400 font-bold uppercase tracking-[0.2em]",
                                        children: product.Make || "Industrial Unit"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                id: `product-name-${product.id}`,
                                className: "text-xl font-bold text-[#44444E] tracking-tight group-hover:text-[#BF092F] transition-colors mb-3 leading-snug min-h-[3.5rem] line-clamp-2",
                                children: product.name
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-[12px] text-gray-400 tracking-widest leading-relaxed line-clamp-3 min-h-[3rem]",
                                children: product.shortDescription || `High-performance ${product.name} engineered for critical infrastructure and industrial deployment.`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mt-auto pt-6 border-t border-gray-100 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b123b081500fb353$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[11px] font-bold text-[#44444E] uppercase tracking-widest",
                                        children: product.manufacturerPartNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-[#BF092F] font-bold text-[11px] uppercase tracking-[0.2em] group-hover:translate-x-1 transition-transform",
                                children: [
                                    "View Specs",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                        size: 16
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `absolute bottom-0 left-0 h-1 bg-[#BF092F] transition-all duration-500 ${hover ? "w-full" : "w-0"}`,
                "aria-hidden": "true"
            })
        ]
    });
};
var $78362d5230cbcfa0$export$2e2bcd8739ae039 = $78362d5230cbcfa0$var$ProductCard;



/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $273f1e3d788a4bec$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $273f1e3d788a4bec$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("chevron-right", $273f1e3d788a4bec$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $204a1dc86520e3d2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
            key: "sc7q7i"
        }
    ]
];
const $204a1dc86520e3d2$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("funnel", $204a1dc86520e3d2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $32e68b54ee1d3289$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8",
            key: "5wwlr5"
        }
    ],
    [
        "path",
        {
            d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
            key: "1d0kgt"
        }
    ]
];
const $32e68b54ee1d3289$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("house", $32e68b54ee1d3289$export$3efd853dbb351e94);



const $d6cd840ca211de61$var$ProductPage = ()=>{
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const location = (0, $b11369f2b382bb4b$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const categorySlug = queryParams.get("category");
    const isGeneralOverview = !categorySlug;
    const scrollTargetRef = (0, $4Iuzv.useRef)(null);
    // --- RECURSIVE LOOKUP (Functionality Preserved) ---
    const findCategoryRecursively = (items, slug)=>{
        for (const item of items){
            if (item.slug === slug) return item;
            if (item.subCategories) {
                const found = findCategoryRecursively(item.subCategories, slug);
                if (found) return found;
            }
        }
        return null;
    };
    const currentCategory = categorySlug ? findCategoryRecursively((0, $646411876a15270d$export$b6aad051bad07f12), categorySlug) : null;
    const [selectedCategory, setSelectedCategory] = (0, $4Iuzv.useState)(currentCategory ? currentCategory.category || currentCategory.name : "");
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const [currentPage, setCurrentPage] = (0, $4Iuzv.useState)(1);
    const itemsPerPage = 12;
    // SEO: Structured Data for the Product Registry
    const catalogSchema = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: isGeneralOverview ? "Arc Engineering Product Registry" : `${selectedCategory} Catalog`,
        description: isGeneralOverview ? "Unified database for industrial generator systems and power infrastructure." : currentCategory?.description,
        url: `https://arcengltd.com/products${categorySlug ? `?category=${categorySlug}` : ""}`
    };
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
        setCurrentPage(1);
        if (currentCategory) setSelectedCategory(currentCategory.category || currentCategory.name);
        else setSelectedCategory("");
    }, [
        categorySlug,
        currentCategory
    ]);
    const hasSubCategories = currentCategory?.subCategories?.length > 0;
    const displayItems = hasSubCategories ? currentCategory.subCategories : currentCategory?.items || [];
    const totalItems = displayItems.length;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentDisplayItems = displayItems.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
    const startRange = totalItems === 0 ? 0 : indexOfFirstItem + 1;
    const endRange = Math.min(indexOfLastItem, totalItems);
    const handlePageChange = (pageNumber)=>{
        setCurrentPage(pageNumber);
        setTimeout(()=>{
            if (scrollTargetRef.current) scrollTargetRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }, 50);
    };
    const TopPagination = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "flex items-center gap-6",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "hidden sm:flex items-center gap-2 border-r border-gray-100 pr-6",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                            className: "text-[10px] font-mono text-gray-400 uppercase tracking-widest",
                            children: "Displaying"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                            className: "text-[11px] font-bold text-[#44444E] font-mono",
                            children: [
                                startRange,
                                "-",
                                endRange,
                                " ",
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                    className: "text-gray-300 mx-1",
                                    children: "/"
                                }),
                                " ",
                                totalItems
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex items-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                            className: "text-[10px] font-mono text-gray-400 uppercase tracking-widest hidden md:block",
                            children: [
                                "Page ",
                                currentPage,
                                " of ",
                                totalPages
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex gap-1",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                    onClick: ()=>handlePageChange(currentPage - 1),
                                    disabled: currentPage === 1,
                                    className: "p-1.5 cursor-pointer rounded-lg border border-gray-100 text-[#44444E] disabled:opacity-20 hover:bg-gray-50 hover:border-[#BF092F] hover:text-[#BF092F] transition-all",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                        size: 16
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                    onClick: ()=>handlePageChange(currentPage + 1),
                                    disabled: currentPage === totalPages,
                                    className: "p-1.5 cursor-pointer rounded-lg border border-gray-100 text-[#44444E] disabled:opacity-20 hover:bg-gray-50 hover:border-[#BF092F] hover:text-[#BF092F] transition-all",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                        size: 16
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    const AllCategoriesOverview = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "container mx-auto px-4 md:px-6 py-7 relative z-10",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex items-center gap-4 mb-8",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "h-8 w-1 bg-[#BF092F]"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                            className: "text-sm text-[#44444E] uppercase tracking-[0.4em]",
                            children: "Product Categories"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8",
                    children: (0, $646411876a15270d$export$b6aad051bad07f12).map((category, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d87703466cb4334d$export$2e2bcd8739ae039), {
                            category: category
                        }, idx))
                })
            ]
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: isGeneralOverview ? "Industrial Product Registry | Arc Engineering" : `${selectedCategory} Systems | Arc Engineering`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: isGeneralOverview ? "Browse our unified database for generator systems and critical power infrastructure." : currentCategory?.description
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(catalogSchema)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>navigate("/products"),
                                            className: `cursor-pointer text-[10px] md:text-xs tracking-widest uppercase transition-all duration-300 ${isGeneralOverview ? "bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg" : "text-white/50 hover:text-white"}`,
                                            children: "Product Categories"
                                        }),
                                        !isGeneralOverview && currentCategory && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-white/20 text-xs font-mono",
                                                    children: ">"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg",
                                                    children: currentCategory.category || currentCategory.name
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                            className: `font-semibold text-3xl md:text-5xl lg:text-5xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                            children: [
                                                isGeneralOverview ? "Product" : currentCategory?.category || currentCategory?.name,
                                                " ",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[#BF092F]",
                                                    children: isGeneralOverview ? "Registry" : "Catalog"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-4 max-w-3xl",
                                            children: isGeneralOverview ? "Accessing unified database for generator systems." : currentCategory?.description
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                className: "container mx-auto -translate-y-12 relative z-30",
                children: isGeneralOverview ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "pt-12",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(AllCategoriesOverview, {})
                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "pt-20 px-4 flex flex-col lg:grid lg:grid-cols-12 gap-8 items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                            className: "lg:col-span-3 space-y-8 h-full",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "rounded-2xl bg-[#44444E] shadow-2xl border-t-4 border-[#BF092F] sticky top-[20vh] overflow-hidden transition-all duration-500",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "p-8",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex items-center gap-3 mb-8",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $204a1dc86520e3d2$export$2e2bcd8739ae039), {
                                                    size: 16,
                                                    className: "text-[#BF092F]"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                    className: "text-[12px] text-white tracking-[0.4em] uppercase",
                                                    children: "Refine Registry"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "lg:hidden relative",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("select", {
                                                    value: categorySlug || "",
                                                    onChange: (e)=>navigate(`/products?category=${e.target.value}`),
                                                    className: "w-full bg-white/5 border border-white/10 text-white text-[12px] uppercase tracking-[0.2em] px-4 py-4 pr-10 rounded-xl cursor-pointer focus:outline-none focus:border-[#BF092F] appearance-none truncate",
                                                    style: {
                                                        textOverflow: "ellipsis"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                            value: "",
                                                            className: "bg-[#44444E]",
                                                            children: "All Products"
                                                        }),
                                                        (0, $646411876a15270d$export$b6aad051bad07f12).map((cat)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                                        value: cat.slug,
                                                                        className: "bg-[#44444E] font-bold",
                                                                        children: cat.category || cat.name
                                                                    }),
                                                                    cat.subCategories?.map((sub)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("option", {
                                                                            value: sub.slug,
                                                                            className: "bg-[#44444E] text-white/60",
                                                                            children: [
                                                                                "\xa0\xa0\u2014 ",
                                                                                sub.name
                                                                            ]
                                                                        }, sub.slug))
                                                                ]
                                                            }, cat.slug))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-[#BF092F]",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                        size: 16,
                                                        className: "rotate-90"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                            className: "hidden lg:block space-y-2",
                                            children: (0, $646411876a15270d$export$b6aad051bad07f12).map((cat, idx)=>{
                                                const catName = cat.category || cat.name;
                                                const isParentActive = selectedCategory === catName || cat.subCategories?.some((sub)=>sub.name === selectedCategory);
                                                return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                                    className: "space-y-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            onClick: ()=>navigate(`/products?category=${cat.slug}`),
                                                            className: `cursor-pointer px-4 py-4 rounded-xl text-[12px] uppercase tracking-[0.2em] transition-all flex items-center justify-between group ${isParentActive ? "bg-white/10 text-white border-l-4 border-[#BF092F]" : "text-white/40 hover:text-white hover:bg-white/5"}`,
                                                            children: [
                                                                catName,
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                                    size: 14,
                                                                    className: `transition-transform duration-300 ${isParentActive ? "text-[#BF092F] translate-x-1" : "opacity-0 group-hover:opacity-100"}`
                                                                })
                                                            ]
                                                        }),
                                                        isParentActive && cat.subCategories && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                                            className: "ml-4 pl-4 border-l border-white/5 space-y-1 pb-2",
                                                            children: cat.subCategories.map((sub, sIdx)=>{
                                                                const isSubActive = categorySlug === sub.slug;
                                                                return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                                                    onClick: ()=>navigate(`/products?category=${sub.slug}`),
                                                                    className: `cursor-pointer px-4 py-2 rounded-lg text-[10px] uppercase tracking-[0.15em] transition-all flex items-center justify-between group ${isSubActive ? "text-[#BF092F] font-bold" : "text-white/30 hover:text-white/60"}`,
                                                                    children: [
                                                                        sub.name,
                                                                        isSubActive && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                            className: "w-1 h-1 rounded-full bg-[#BF092F]"
                                                                        })
                                                                    ]
                                                                }, sIdx);
                                                            })
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("section", {
                            className: "lg:col-span-9",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                ref: scrollTargetRef,
                                className: "bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-gray-100 min-h-[600px] flex flex-col scroll-mt-32",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center justify-between mb-12 border-b border-gray-100 pb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                className: "tracking-widest border-l-4 border-[#BF092F] pl-4 text-[#44444E] uppercase text-sm font-bold",
                                                children: hasSubCategories ? "Available Categories" : "Available Items"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(TopPagination, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 flex-grow",
                                        children: currentDisplayItems.map((item, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "transition-all duration-500 hover:-translate-y-2",
                                                children: hasSubCategories ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d87703466cb4334d$export$2e2bcd8739ae039), {
                                                    category: item,
                                                    onClick: ()=>navigate(`/products?category=${item.slug}`)
                                                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $78362d5230cbcfa0$export$2e2bcd8739ae039), {
                                                    product: item,
                                                    categorySlug: categorySlug
                                                })
                                            }, idx))
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "mt-16 pt-8 border-t border-gray-100 flex flex-col items-center gap-6",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "text-[11px] font-mono text-gray-400 uppercase tracking-widest",
                                                children: [
                                                    "Showing ",
                                                    startRange,
                                                    " to ",
                                                    endRange,
                                                    " of ",
                                                    totalItems,
                                                    " Items"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center justify-center gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                        onClick: ()=>handlePageChange(currentPage - 1),
                                                        disabled: currentPage === 1,
                                                        className: "p-3 cursor-pointer rounded-xl border border-gray-200 text-[#44444E] disabled:opacity-30 hover:border-[#BF092F] transition-all",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                                            size: 20
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "flex items-center gap-2",
                                                        children: [
                                                            ...Array(totalPages)
                                                        ].map((_, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                                onClick: ()=>handlePageChange(i + 1),
                                                                className: `cursor-pointer w-10 h-10 rounded-xl text-xs font-bold transition-all ${currentPage === i + 1 ? "bg-[#BF092F] text-white shadow-lg" : "bg-gray-50 text-gray-400 hover:bg-gray-100"}`,
                                                                children: String(i + 1).padStart(2, "0")
                                                            }, i))
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                        onClick: ()=>handlePageChange(currentPage + 1),
                                                        disabled: currentPage === totalPages,
                                                        className: "p-3 cursor-pointer rounded-xl border border-gray-200 text-[#44444E] disabled:opacity-30 hover:border-[#BF092F] transition-all",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                            size: 20
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
            })
        ]
    });
};
var $d6cd840ca211de61$export$2e2bcd8739ae039 = $d6cd840ca211de61$var$ProductPage;




var $4Iuzv = parcelRequire("4Iuzv");



/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7cad495efa28bb9c$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "M12 11h4",
            key: "1jrz19"
        }
    ],
    [
        "path",
        {
            d: "M12 16h4",
            key: "n85exb"
        }
    ],
    [
        "path",
        {
            d: "M8 11h.01",
            key: "1dfujw"
        }
    ],
    [
        "path",
        {
            d: "M8 16h.01",
            key: "18s6g9"
        }
    ]
];
const $7cad495efa28bb9c$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("clipboard-list", $7cad495efa28bb9c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1208b96e0d5edaaf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 15V3",
            key: "m9g1x1"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "path",
        {
            d: "m7 10 5 5 5-5",
            key: "brsn70"
        }
    ]
];
const $1208b96e0d5edaaf$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("download", $1208b96e0d5edaaf$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2f654b16da3c707a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
            key: "1rqfz7"
        }
    ],
    [
        "path",
        {
            d: "M14 2v4a2 2 0 0 0 2 2h4",
            key: "tnqrlb"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $2f654b16da3c707a$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("file-text", $2f654b16da3c707a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c7e61a75e5ec445f$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "6",
            key: "1vlfrh"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "2",
            key: "1c9p78"
        }
    ]
];
const $c7e61a75e5ec445f$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("target", $c7e61a75e5ec445f$export$3efd853dbb351e94);


const $84c5a9e942c2a800$var$TAB_DETAILS = "details";
const $84c5a9e942c2a800$var$TAB_DOWNLOADS = "downloads";
const $84c5a9e942c2a800$var$ProductDetailPage = ()=>{
    const { categorySlug: categorySlug, id: id } = (0, $b11369f2b382bb4b$export$99eaa27ddbbb95ef)();
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const [isModalOpen, setIsModalOpen] = (0, $4Iuzv.useState)(false);
    const [activeIndex, setActiveIndex] = (0, $4Iuzv.useState)(0);
    const [activeTab, setActiveTab] = (0, $4Iuzv.useState)($84c5a9e942c2a800$var$TAB_DETAILS);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
    }, [
        id
    ]);
    (0, $4Iuzv.useEffect)(()=>{
        setActiveIndex(0);
    }, [
        id
    ]);
    const handleCloseModal = ()=>setIsModalOpen(false);
    const handleOpenModal = ()=>setIsModalOpen(true);
    (0, $4Iuzv.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") handleCloseModal();
        };
        if (isModalOpen) window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        isModalOpen
    ]);
    // --- RECURSIVE LOOKUP (Functionality Preserved) ---
    const getProductData = ()=>{
        for (const cat of (0, $646411876a15270d$export$b6aad051bad07f12)){
            if (cat.subCategories) for (const sub of cat.subCategories){
                const subProduct = sub.items?.find((item)=>item.id === id);
                if (subProduct && sub.slug === categorySlug) return {
                    category: sub,
                    product: subProduct
                };
            }
            const topLevelProduct = cat.items?.find((item)=>item.id === id);
            if (topLevelProduct && cat.slug === categorySlug) return {
                category: cat,
                product: topLevelProduct
            };
        }
        return {
            category: null,
            product: null
        };
    };
    const { category: category, product: product } = getProductData();
    if (!category || !product) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "min-h-screen bg-[#44444E] flex items-center justify-center font-mono text-white p-20 text-center",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                    className: "text-xl mb-4",
                    children: "ERROR_404 // REGISTRY_ENTRY_NOT_FOUND"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                    onClick: ()=>navigate("/products"),
                    className: "text-[#BF092F] underline cursor-pointer uppercase text-xs tracking-widest",
                    children: "Return to Registry"
                })
            ]
        })
    });
    // SEO: Structured Product Data
    const productSchema = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": product.name,
        "image": product.images,
        "description": product.shortDescription,
        "brand": {
            "@type": "Brand",
            "name": product.Make || "Arc Engineering"
        },
        "sku": product.AGPPartNumber,
        "mpn": product.manufacturerPartNumber,
        "offers": {
            "@type": "Offer",
            "url": `https://arcengltd.com/products/${categorySlug}/${id}`,
            "availability": "https://schema.org/InStock"
        }
    };
    const productImages = product.images || [];
    const totalImages = productImages.length;
    const goToNext = ()=>setActiveIndex((prev)=>(prev + 1) % totalImages);
    const goToPrev = ()=>setActiveIndex((prev)=>(prev - 1 + totalImages) % totalImages);
    const formatDetailKey = (key)=>key.replace(/([A-Z])/g, " $1").replace(/_/g, " ").trim();
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: `${product.name} | Technical Specifications | Arc Engineering`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: `${product.name} - ${product.shortDescription} Part No: ${product.AGPPartNumber}`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(productSchema)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center gap-2 mb-6 overflow-x-auto whitespace-nowrap scrollbar-hide pb-2 scroll-smooth",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "group flex items-center gap-1 text-white/50 hover:text-white transition-colors px-2",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 12
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono select-none",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>navigate("/products"),
                                            className: "cursor-pointer text-[10px] md:text-xs tracking-widest uppercase text-white/50 hover:text-white transition-colors px-2",
                                            children: "Product Categories"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono select-none",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>navigate(`/products?category=${categorySlug}`),
                                            className: "cursor-pointer text-[10px] md:text-xs tracking-widest uppercase text-white/50 hover:text-white transition-colors px-2",
                                            children: category.category || category.name
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono select-none",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20 flex-shrink-0",
                                            children: product.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                    className: `font-semibold text-2xl md:text-4xl lg:text-5xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: [
                                        product.name.split(" ")[0],
                                        " ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: product.name.split(" ").slice(1).join(" ")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: `flex flex-wrap gap-8 mt-8 transition-all duration-1000 delay-300 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: [
                                        {
                                            label: "Make",
                                            val: product.Make,
                                            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $90b1c37bd27f04c4$export$2e2bcd8739ae039), {
                                                size: 14
                                            })
                                        },
                                        {
                                            label: "Mfr_PN",
                                            val: product.manufacturerPartNumber,
                                            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c7e61a75e5ec445f$export$2e2bcd8739ae039), {
                                                size: 14
                                            })
                                        },
                                        {
                                            label: "AGP_ID",
                                            val: product.AGPPartNumber,
                                            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                                size: 14
                                            })
                                        }
                                    ].map((item, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex flex-col border-l-2 border-[#BF092F] pl-4",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-2 mb-1",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-[#BF092F]",
                                                            children: item.icon
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                            className: "text-[10px] font-bold text-white/40 uppercase tracking-[0.3em]",
                                                            children: item.label
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-sm md:text-lg font-mono font-bold text-white tracking-tight",
                                                    children: item.val || "N/A"
                                                })
                                            ]
                                        }, i))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("main", {
                className: "container mx-auto py-7 relative z-30 px-4",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "lg:col-span-8 bg-white border border-gray-100 shadow-xl rounded-2xl p-3 flex flex-col md:flex-row gap-3 h-[500px] md:h-[600px] overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-full md:w-24 flex md:flex-col gap-2 overflow-auto p-2 bg-gray-50 rounded-xl",
                                        children: productImages.map((img, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                onClick: ()=>setActiveIndex(i),
                                                className: `cursor-pointer flex-shrink-0 w-16 h-16 md:w-full md:h-20 border-2 transition-all rounded-lg overflow-hidden ${i === activeIndex ? "border-[#BF092F]" : "border-transparent grayscale hover:grayscale-0"}`,
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                    src: img,
                                                    className: "w-full h-full object-cover",
                                                    alt: `Gallery view ${i + 1}`
                                                })
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex-grow relative bg-white overflow-hidden group flex items-center justify-center cursor-zoom-in rounded-xl",
                                        onClick: handleOpenModal,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: productImages[activeIndex],
                                                className: "rounded-2xl max-h-full max-w-full object-contain p-8 transition-transform duration-700 group-hover:scale-105",
                                                alt: `${product.name} main view`
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    goToPrev();
                                                },
                                                className: "cursor-pointer absolute left-4 top-1/2 -translate-y-1/2 p-4 bg-white/90 text-[#44444E] hover:bg-[#BF092F] hover:text-white shadow-lg rounded-full transition-all",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                                    size: 20
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    goToNext();
                                                },
                                                className: "cursor-pointer absolute right-4 top-1/2 -translate-y-1/2 p-4 bg-white/90 text-[#44444E] hover:bg-[#BF092F] hover:text-white shadow-lg rounded-full transition-all",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                    size: 20
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "lg:col-span-4 flex flex-col gap-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "bg-[#44444E] p-8 text-white rounded-2xl border-t-4 border-[#BF092F] shadow-2xl",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                className: "text-[12px] font-bold uppercase tracking-[0.4em] mb-6 text-white/40",
                                                children: "Summary"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "font-medium tracking-widest leading-loose mb-10 text-white/80",
                                                children: product.shortDescription
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                                onClick: ()=>navigate("/contact"),
                                                className: "cursor-pointer w-full py-4 bg-white text-[#44444E] hover:bg-[#BF092F] hover:text-white uppercase tracking-[0.3em] transition-all rounded-xl shadow-lg flex items-center justify-center gap-4",
                                                children: [
                                                    "Request Quote ",
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c7e61a75e5ec445f$export$2e2bcd8739ae039), {
                                                        size: 14
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "bg-white border border-gray-100 p-8 rounded-2xl shadow-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h4", {
                                                className: "text-[11px] font-bold uppercase tracking-[0.3em] text-[#44444E] mb-6 flex items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $52df24fc950c96b6$export$2e2bcd8739ae039), {
                                                        size: 14,
                                                        className: "text-[#BF092F]"
                                                    }),
                                                    " Operational Uses"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "space-y-4",
                                                children: product.uses?.map((use, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex gap-3 text-[12px] font-bold text-gray-500 tracking-wider",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[#BF092F]",
                                                                children: "/"
                                                            }),
                                                            " ",
                                                            use
                                                        ]
                                                    }, i))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "mt-12 bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-gray-100",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "grid grid-cols-1 lg:grid-cols-12 gap-12",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "lg:col-span-4",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "border-l-4 border-[#BF092F] pl-4 text-[#44444E] uppercase text-sm font-bold",
                                        children: "Analysis & Description"
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "lg:col-span-8",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-[16px] text-gray-500 font-medium leading-relaxed whitespace-pre-line",
                                        children: product.description
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mt-12 bg-white border border-gray-100 rounded-2xl overflow-hidden shadow-xl",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex bg-gray-50 border-b border-gray-100",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                        onClick: ()=>setActiveTab($84c5a9e942c2a800$var$TAB_DETAILS),
                                        className: `cursor-pointer px-8 py-6 text-[11px] font-bold uppercase tracking-[0.3em] transition-all ${activeTab === $84c5a9e942c2a800$var$TAB_DETAILS ? "bg-white text-[#BF092F] border-t-4 border-[#BF092F]" : "text-gray-400 hover:text-[#44444E]"}`,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7cad495efa28bb9c$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "inline mr-2"
                                            }),
                                            " Technical Registry"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                        onClick: ()=>setActiveTab($84c5a9e942c2a800$var$TAB_DOWNLOADS),
                                        className: `cursor-pointer px-8 py-6 text-[11px] font-bold uppercase tracking-[0.3em] transition-all ${activeTab === $84c5a9e942c2a800$var$TAB_DOWNLOADS ? "bg-white text-[#BF092F] border-t-4 border-[#BF092F]" : "text-gray-400 hover:text-[#44444E]"}`,
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2f654b16da3c707a$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "inline mr-2"
                                            }),
                                            " Documentation"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "p-8 md:p-12",
                                children: activeTab === $84c5a9e942c2a800$var$TAB_DETAILS ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2 gap-px bg-gray-100 border border-gray-100",
                                    children: Object.entries(product.details || {}).map(([key, value])=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex flex-col p-6 bg-white hover:bg-gray-50 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("dt", {
                                                    className: "text-[10px] font-bold text-[#BF092F] uppercase tracking-[0.2em] mb-2",
                                                    children: formatDetailKey(key)
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("dd", {
                                                    className: "text-sm font-bold text-[#44444E] tracking-tight",
                                                    children: typeof value === "object" && value !== null ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "mt-2 space-y-1 border-l border-gray-100 pl-3",
                                                        children: Object.entries(value).map(([subKey, subVal])=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                className: "flex items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                        className: "text-[9px] text-[#BF092F]/50",
                                                                        children: "\u25CF"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                                        className: "text-[11px] text-gray-400 uppercase tracking-wider font-semibold",
                                                                        children: [
                                                                            subKey,
                                                                            ":"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                        className: "text-sm text-[#44444E]",
                                                                        children: subVal
                                                                    })
                                                                ]
                                                            }, subKey))
                                                    }) : value
                                                })
                                            ]
                                        }, key))
                                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "space-y-3",
                                    children: product.downloads?.map((d, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("a", {
                                            href: d.url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "cursor-pointer flex items-center justify-between p-6 bg-[#44444E] rounded-xl text-white hover:bg-[#BF092F] transition-all group",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-sm font-bold",
                                                    children: d.name
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1208b96e0d5edaaf$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "text-[#BF092F] group-hover:text-white transition-colors"
                                                })
                                            ]
                                        }, i))
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
            }),
            isModalOpen && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-[#1A1A1E]/95 backdrop-blur-xl",
                        onClick: handleCloseModal
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                        onClick: handleCloseModal,
                        className: "cursor-pointer absolute top-10 right-10 text-white/50 hover:text-[#BF092F] transition-all z-[110] group",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6ceff59181ea43fa$export$2e2bcd8739ae039), {
                            size: 40,
                            className: "group-hover:rotate-90 transition-transform"
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "relative flex flex-col md:flex-row gap-6 items-center max-w-7xl w-full max-h-[90vh] z-[105]",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "hidden md:flex flex-col gap-2 overflow-y-auto max-h-[500px] p-2",
                                children: productImages.map((img, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            setActiveIndex(i);
                                        },
                                        className: `cursor-pointer w-16 h-16 border-2 transition-all rounded-lg overflow-hidden shrink-0 ${i === activeIndex ? "border-[#BF092F]" : "border-white/20 hover:border-white/50"}`,
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                            src: img,
                                            className: "w-full h-full object-cover",
                                            alt: `Thumb ${i}`
                                        })
                                    }, i))
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "relative flex-grow flex items-center justify-center bg-white rounded-2xl p-4 md:p-8 shadow-2xl h-full overflow-hidden",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                        src: productImages[activeIndex],
                                        className: "max-w-full max-h-[70vh] object-contain",
                                        alt: `${product.name} enlarged view`
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            goToPrev();
                                        },
                                        className: "cursor-pointer absolute left-4 p-4 bg-[#44444E]/10 hover:bg-[#BF092F] text-[#44444E] hover:text-white rounded-full transition-all",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                            size: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            goToNext();
                                        },
                                        className: "cursor-pointer absolute right-4 p-4 bg-[#44444E]/10 hover:bg-[#BF092F] text-[#44444E] hover:text-white rounded-full transition-all",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                            size: 24
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $84c5a9e942c2a800$export$2e2bcd8739ae039 = $84c5a9e942c2a800$var$ProductDetailPage;




var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ccfb168b016548a6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $ccfb168b016548a6$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("circle-check-big", $ccfb168b016548a6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fed10cf43c8a993c$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16 14",
            key: "68esgv"
        }
    ]
];
const $fed10cf43c8a993c$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("clock", $fed10cf43c8a993c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $97bf0a16e1eec75c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
];
const $97bf0a16e1eec75c$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("send", $97bf0a16e1eec75c$export$3efd853dbb351e94);



var $7fb1f93ca477d275$exports = {};
function $7fb1f93ca477d275$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$7fb1f93ca477d275$exports = $7fb1f93ca477d275$var$_assertThisInitialized, $7fb1f93ca477d275$exports.__esModule = true, $7fb1f93ca477d275$exports["default"] = $7fb1f93ca477d275$exports;


var $b0135d22a8a2f5b0$exports = {};
var $3115ec248ad0f7f5$exports = {};
function $3115ec248ad0f7f5$var$_setPrototypeOf(t, e) {
    return $3115ec248ad0f7f5$exports = $3115ec248ad0f7f5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3115ec248ad0f7f5$exports.__esModule = true, $3115ec248ad0f7f5$exports["default"] = $3115ec248ad0f7f5$exports, $3115ec248ad0f7f5$var$_setPrototypeOf(t, e);
}
$3115ec248ad0f7f5$exports = $3115ec248ad0f7f5$var$_setPrototypeOf, $3115ec248ad0f7f5$exports.__esModule = true, $3115ec248ad0f7f5$exports["default"] = $3115ec248ad0f7f5$exports;


function $b0135d22a8a2f5b0$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $3115ec248ad0f7f5$exports(t, o);
}
$b0135d22a8a2f5b0$exports = $b0135d22a8a2f5b0$var$_inheritsLoose, $b0135d22a8a2f5b0$exports.__esModule = true, $b0135d22a8a2f5b0$exports["default"] = $b0135d22a8a2f5b0$exports;



var $4Iuzv = parcelRequire("4Iuzv");
var $bb03018efdf291ef$var$G = Object.defineProperty, $bb03018efdf291ef$var$K = Object.defineProperties;
var $bb03018efdf291ef$var$V = Object.getOwnPropertyDescriptors;
var $bb03018efdf291ef$var$w = Object.getOwnPropertySymbols;
var $bb03018efdf291ef$var$P = Object.prototype.hasOwnProperty, $bb03018efdf291ef$var$D = Object.prototype.propertyIsEnumerable;
var $bb03018efdf291ef$var$I = (t, e, r)=>e in t ? $bb03018efdf291ef$var$G(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $bb03018efdf291ef$var$d = (t, e)=>{
    for(var r in e || (e = {}))$bb03018efdf291ef$var$P.call(e, r) && $bb03018efdf291ef$var$I(t, r, e[r]);
    if ($bb03018efdf291ef$var$w) for (var r of $bb03018efdf291ef$var$w(e))$bb03018efdf291ef$var$D.call(e, r) && $bb03018efdf291ef$var$I(t, r, e[r]);
    return t;
}, $bb03018efdf291ef$var$R = (t, e)=>$bb03018efdf291ef$var$K(t, $bb03018efdf291ef$var$V(e));
var $bb03018efdf291ef$var$M = (t, e)=>{
    var r = {};
    for(var n in t)$bb03018efdf291ef$var$P.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
    if (t != null && $bb03018efdf291ef$var$w) for (var n of $bb03018efdf291ef$var$w(t))e.indexOf(n) < 0 && $bb03018efdf291ef$var$D.call(t, n) && (r[n] = t[n]);
    return r;
};
var $bb03018efdf291ef$var$l = (t, e, r)=>($bb03018efdf291ef$var$I(t, typeof e != "symbol" ? e + "" : e, r), r);
var $bb03018efdf291ef$var$x = (t, e, r)=>new Promise((n, s)=>{
        var a = (c)=>{
            try {
                o(r.next(c));
            } catch (i) {
                s(i);
            }
        }, u = (c)=>{
            try {
                o(r.throw(c));
            } catch (i) {
                s(i);
            }
        }, o = (c)=>c.done ? n(c.value) : Promise.resolve(c.value).then(a, u);
        o((r = r.apply(t, e)).next());
    });
var $bb03018efdf291ef$var$L = "hCaptcha-script", $bb03018efdf291ef$var$b = "hCaptchaOnLoad", $bb03018efdf291ef$var$T = "script-error";
var $bb03018efdf291ef$var$g = "@hCaptcha/loader";
function $bb03018efdf291ef$var$U(t) {
    return Object.entries(t).filter(([, e])=>e || e === !1).map(([e, r])=>`${encodeURIComponent(e)}=${encodeURIComponent(String(r))}`).join("&");
}
function $bb03018efdf291ef$var$O(t) {
    let e = t && t.ownerDocument || document, r = e.defaultView || e.parentWindow || window;
    return {
        document: e,
        window: r
    };
}
function $bb03018efdf291ef$var$S(t) {
    return t || document.head;
}
function $bb03018efdf291ef$var$B(t) {
    var e;
    t.setTag("source", $bb03018efdf291ef$var$g), t.setTag("url", document.URL), t.setContext("os", {
        UA: navigator.userAgent
    }), t.setContext("browser", $bb03018efdf291ef$var$d({}, $bb03018efdf291ef$var$z())), t.setContext("device", $bb03018efdf291ef$var$R($bb03018efdf291ef$var$d({}, $bb03018efdf291ef$var$J()), {
        screen_width_pixels: screen.width,
        screen_height_pixels: screen.height,
        language: navigator.language,
        orientation: ((e = screen.orientation) == null ? void 0 : e.type) || "Unknown",
        processor_count: navigator.hardwareConcurrency,
        platform: navigator.platform
    }));
}
function $bb03018efdf291ef$var$z() {
    var n, s, a, u, o, c;
    let t = navigator.userAgent, e, r;
    return t.indexOf("Firefox") !== -1 ? (e = "Firefox", r = (n = t.match(/Firefox\/([\d.]+)/)) == null ? void 0 : n[1]) : t.indexOf("Edg") !== -1 ? (e = "Microsoft Edge", r = (s = t.match(/Edg\/([\d.]+)/)) == null ? void 0 : s[1]) : t.indexOf("Chrome") !== -1 && t.indexOf("Safari") !== -1 ? (e = "Chrome", r = (a = t.match(/Chrome\/([\d.]+)/)) == null ? void 0 : a[1]) : t.indexOf("Safari") !== -1 && t.indexOf("Chrome") === -1 ? (e = "Safari", r = (u = t.match(/Version\/([\d.]+)/)) == null ? void 0 : u[1]) : t.indexOf("Opera") !== -1 || t.indexOf("OPR") !== -1 ? (e = "Opera", r = (o = t.match(/(Opera|OPR)\/([\d.]+)/)) == null ? void 0 : o[2]) : t.indexOf("MSIE") !== -1 || t.indexOf("Trident") !== -1 ? (e = "Internet Explorer", r = (c = t.match(/(MSIE |rv:)([\d.]+)/)) == null ? void 0 : c[2]) : (e = "Unknown", r = "Unknown"), {
        name: e,
        version: r
    };
}
function $bb03018efdf291ef$var$F(t) {
    return new Promise((e)=>setTimeout(e, t));
}
function $bb03018efdf291ef$var$J() {
    let t = navigator.userAgent, e;
    t.indexOf("Win") !== -1 ? e = "Windows" : t.indexOf("Mac") !== -1 ? e = "Mac" : t.indexOf("Linux") !== -1 ? e = "Linux" : t.indexOf("Android") !== -1 ? e = "Android" : t.indexOf("like Mac") !== -1 || t.indexOf("iPhone") !== -1 || t.indexOf("iPad") !== -1 ? e = "iOS" : e = "Unknown";
    let r;
    return /Mobile|iPhone|iPod|Android/i.test(t) ? r = "Mobile" : /Tablet|iPad/i.test(t) ? r = "Tablet" : r = "Desktop", {
        model: e,
        family: e,
        device: r
    };
}
var $bb03018efdf291ef$var$Q = class k {
    constructor(e){
        $bb03018efdf291ef$var$l(this, "_parent");
        $bb03018efdf291ef$var$l(this, "breadcrumbs", []);
        $bb03018efdf291ef$var$l(this, "context", {});
        $bb03018efdf291ef$var$l(this, "extra", {});
        $bb03018efdf291ef$var$l(this, "tags", {});
        $bb03018efdf291ef$var$l(this, "request");
        $bb03018efdf291ef$var$l(this, "user");
        this._parent = e;
    }
    get parent() {
        return this._parent;
    }
    child() {
        return new k(this);
    }
    setRequest(e) {
        return this.request = e, this;
    }
    removeRequest() {
        return this.request = void 0, this;
    }
    addBreadcrumb(e) {
        return typeof e.timestamp > "u" && (e.timestamp = new Date().toISOString()), this.breadcrumbs.push(e), this;
    }
    setExtra(e, r) {
        return this.extra[e] = r, this;
    }
    removeExtra(e) {
        return delete this.extra[e], this;
    }
    setContext(e, r) {
        return typeof r.type > "u" && (r.type = e), this.context[e] = r, this;
    }
    removeContext(e) {
        return delete this.context[e], this;
    }
    setTags(e) {
        return this.tags = $bb03018efdf291ef$var$d($bb03018efdf291ef$var$d({}, this.tags), e), this;
    }
    setTag(e, r) {
        return this.tags[e] = r, this;
    }
    removeTag(e) {
        return delete this.tags[e], this;
    }
    setUser(e) {
        return this.user = e, this;
    }
    removeUser() {
        return this.user = void 0, this;
    }
    toBody() {
        let e = [], r = this;
        for(; r;)e.push(r), r = r.parent;
        return e.reverse().reduce((n, s)=>{
            var a;
            return n.breadcrumbs = [
                ...(a = n.breadcrumbs) != null ? a : [],
                ...s.breadcrumbs
            ], n.extra = $bb03018efdf291ef$var$d($bb03018efdf291ef$var$d({}, n.extra), s.extra), n.contexts = $bb03018efdf291ef$var$d($bb03018efdf291ef$var$d({}, n.contexts), s.context), n.tags = $bb03018efdf291ef$var$d($bb03018efdf291ef$var$d({}, n.tags), s.tags), s.user && (n.user = s.user), s.request && (n.request = s.request), n;
        }, {
            breadcrumbs: [],
            extra: {},
            contexts: {},
            tags: {},
            request: void 0,
            user: void 0
        });
    }
    clear() {
        this.breadcrumbs = [], this.context = {}, this.tags = {}, this.user = void 0;
    }
}, $bb03018efdf291ef$var$Z = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, $bb03018efdf291ef$var$ee = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i, $bb03018efdf291ef$var$te = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, $bb03018efdf291ef$var$re = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/, $bb03018efdf291ef$var$A = "?", $bb03018efdf291ef$var$j = "An unknown error occurred", $bb03018efdf291ef$var$ne = "0.0.4";
function $bb03018efdf291ef$var$se(t) {
    for(let e = 0; e < t.length; e++)t[e] = Math.floor(Math.random() * 256);
    return t;
}
function $bb03018efdf291ef$var$p(t) {
    return (t + 256).toString(16).substring(1);
}
function $bb03018efdf291ef$var$oe() {
    let t = $bb03018efdf291ef$var$se(new Array(16));
    return t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, $bb03018efdf291ef$var$p(t[0]) + $bb03018efdf291ef$var$p(t[1]) + $bb03018efdf291ef$var$p(t[2]) + $bb03018efdf291ef$var$p(t[3]) + "-" + $bb03018efdf291ef$var$p(t[4]) + $bb03018efdf291ef$var$p(t[5]) + "-" + $bb03018efdf291ef$var$p(t[6]) + $bb03018efdf291ef$var$p(t[7]) + "-" + $bb03018efdf291ef$var$p(t[8]) + $bb03018efdf291ef$var$p(t[9]) + "-" + $bb03018efdf291ef$var$p(t[10]) + $bb03018efdf291ef$var$p(t[11]) + $bb03018efdf291ef$var$p(t[12]) + $bb03018efdf291ef$var$p(t[13]) + $bb03018efdf291ef$var$p(t[14]) + $bb03018efdf291ef$var$p(t[15]);
}
var $bb03018efdf291ef$var$ie = [
    [
        $bb03018efdf291ef$var$Z,
        "chrome"
    ],
    [
        $bb03018efdf291ef$var$te,
        "winjs"
    ],
    [
        $bb03018efdf291ef$var$ee,
        "gecko"
    ]
];
function $bb03018efdf291ef$var$ae(t) {
    var n, s, a, u;
    if (!t.stack) return null;
    let e = [], r = (a = (s = (n = t.stack).split) == null ? void 0 : s.call(n, `
`)) != null ? a : [];
    for(let o = 0; o < r.length; ++o){
        let c = null, i = null, h = null;
        for (let [y, E] of $bb03018efdf291ef$var$ie)if (i = y.exec(r[o]), i) {
            h = E;
            break;
        }
        if (!(!i || !h)) {
            if (h === "chrome") c = {
                filename: (u = i[2]) != null && u.startsWith("address at ") ? i[2].substring(11) : i[2],
                function: i[1] || $bb03018efdf291ef$var$A,
                lineno: i[3] ? +i[3] : null,
                colno: i[4] ? +i[4] : null
            };
            else if (h === "winjs") c = {
                filename: i[2],
                function: i[1] || $bb03018efdf291ef$var$A,
                lineno: +i[3],
                colno: i[4] ? +i[4] : null
            };
            else if (h === "gecko") o === 0 && !i[5] && t.columnNumber !== void 0 && e.length > 0 && (e[0].column = t.columnNumber + 1), c = {
                filename: i[3],
                function: i[1] || $bb03018efdf291ef$var$A,
                lineno: i[4] ? +i[4] : null,
                colno: i[5] ? +i[5] : null
            };
            else continue;
            !c.function && c.lineno && (c.function = $bb03018efdf291ef$var$A), e.push(c);
        }
    }
    return e.length ? e.reverse() : null;
}
function $bb03018efdf291ef$var$ce(t) {
    let e = $bb03018efdf291ef$var$ae(t);
    return {
        type: t.name,
        value: t.message,
        stacktrace: {
            frames: e != null ? e : []
        }
    };
}
function $bb03018efdf291ef$var$ue(t) {
    let e = $bb03018efdf291ef$var$re.exec(t), r = e ? e.slice(1) : [];
    if (r.length !== 6) throw new Error("Invalid DSN");
    let n = r[5].split("/"), s = n.slice(0, -1).join("/");
    return r[0] + "://" + r[3] + (r[4] ? ":" + r[4] : "") + (s ? "/" + s : "") + "/api/" + n.pop() + "/envelope/?sentry_version=7&sentry_key=" + r[1] + (r[2] ? "&sentry_secret=" + r[2] : "");
}
function $bb03018efdf291ef$var$le(t, e, r) {
    var s, a;
    let n = $bb03018efdf291ef$var$d({
        event_id: $bb03018efdf291ef$var$oe().replaceAll("-", ""),
        platform: "javascript",
        sdk: {
            name: "@hcaptcha/sentry",
            version: $bb03018efdf291ef$var$ne
        },
        environment: e,
        release: r,
        timestamp: Date.now() / 1e3
    }, t.scope.toBody());
    if (t.type === "exception") {
        n.message = (a = (s = t.error) == null ? void 0 : s.message) != null ? a : "Unknown error", n.fingerprint = [
            n.message
        ];
        let u = [], o = t.error;
        for(let c = 0; c < 5 && o && (u.push($bb03018efdf291ef$var$ce(o)), !(!o.cause || !(o.cause instanceof Error))); c++)o = o.cause;
        n.exception = {
            values: u.reverse()
        };
    }
    return t.type === "message" && (n.message = t.message, n.level = t.level), n;
}
function $bb03018efdf291ef$var$de(t) {
    if (t instanceof Error) return t;
    if (typeof t == "string") return new Error(t);
    if (typeof t == "object" && t !== null && !Array.isArray(t)) {
        let r = t, { message: n } = r, s = $bb03018efdf291ef$var$M(r, [
            "message"
        ]), a = new Error(typeof n == "string" ? n : $bb03018efdf291ef$var$j);
        return Object.assign(a, s);
    }
    let e = new Error($bb03018efdf291ef$var$j);
    return Object.assign(e, {
        cause: t
    });
}
function $bb03018efdf291ef$var$pe(t, e, r) {
    return $bb03018efdf291ef$var$x(this, null, function*() {
        var n, s;
        try {
            if (typeof fetch < "u" && typeof AbortSignal < "u") {
                let a;
                if (r) {
                    let c = new AbortController;
                    a = c.signal, setTimeout(()=>c.abort(), r);
                }
                let u = yield fetch(t, $bb03018efdf291ef$var$R($bb03018efdf291ef$var$d({}, e), {
                    signal: a
                })), o = yield u.text();
                return {
                    status: u.status,
                    body: o
                };
            }
            return yield new Promise((a, u)=>{
                var c, i;
                let o = new XMLHttpRequest;
                if (o.open((c = e == null ? void 0 : e.method) != null ? c : "GET", t), o.onload = ()=>a({
                        status: o.status,
                        body: o.responseText
                    }), o.onerror = ()=>u(new Error("XHR Network Error")), e == null ? void 0 : e.headers) for (let [h, y] of Object.entries(e.headers))o.setRequestHeader(h, y);
                if (r) {
                    let h = setTimeout(()=>{
                        o.abort(), u(new Error("Request timed out"));
                    }, r);
                    o.onloadend = ()=>{
                        clearTimeout(h);
                    };
                }
                o.send((i = e == null ? void 0 : e.body) == null ? void 0 : i.toString());
            });
        } catch (a) {
            return {
                status: 0,
                body: (s = (n = a == null ? void 0 : a.toString) == null ? void 0 : n.call(a)) != null ? s : "Unknown error"
            };
        }
    });
}
var $bb03018efdf291ef$var$f, $bb03018efdf291ef$var$N = ($bb03018efdf291ef$var$f = class {
    constructor(e){
        $bb03018efdf291ef$var$l(this, "apiURL");
        $bb03018efdf291ef$var$l(this, "dsn");
        $bb03018efdf291ef$var$l(this, "environment");
        $bb03018efdf291ef$var$l(this, "release");
        $bb03018efdf291ef$var$l(this, "sampleRate");
        $bb03018efdf291ef$var$l(this, "debug");
        $bb03018efdf291ef$var$l(this, "_scope");
        $bb03018efdf291ef$var$l(this, "shouldBuffer", !1);
        $bb03018efdf291ef$var$l(this, "bufferlimit", 20);
        $bb03018efdf291ef$var$l(this, "buffer", []);
        var r, n, s, a, u;
        this.environment = e.environment, this.release = e.release, this.sampleRate = (r = e.sampleRate) != null ? r : 1, this.debug = (n = e.debug) != null ? n : !1, this._scope = (s = e.scope) != null ? s : new $bb03018efdf291ef$var$Q, this.apiURL = $bb03018efdf291ef$var$ue(e.dsn), this.dsn = e.dsn, this.shouldBuffer = (a = e.buffer) != null ? a : !1, this.bufferlimit = (u = e.bufferLimit) != null ? u : 20;
    }
    static init(e) {
        $bb03018efdf291ef$var$f._instance || ($bb03018efdf291ef$var$f._instance = new $bb03018efdf291ef$var$f(e));
    }
    static get instance() {
        if (!$bb03018efdf291ef$var$f._instance) throw new Error("Sentry has not been initialized");
        return $bb03018efdf291ef$var$f._instance;
    }
    log(...e) {
        this.debug && console.log(...e);
    }
    get scope() {
        return this._scope;
    }
    static get scope() {
        return $bb03018efdf291ef$var$f.instance.scope;
    }
    withScope(e) {
        let r = this._scope.child();
        e(r);
    }
    static withScope(e) {
        $bb03018efdf291ef$var$f.instance.withScope(e);
    }
    captureException(e, r) {
        this.captureEvent({
            type: "exception",
            level: "error",
            error: $bb03018efdf291ef$var$de(e),
            scope: r != null ? r : this._scope
        });
    }
    static captureException(e, r) {
        $bb03018efdf291ef$var$f.instance.captureException(e, r);
    }
    captureMessage(e, r = "info", n) {
        this.captureEvent({
            type: "message",
            level: r,
            message: e,
            scope: n != null ? n : this._scope
        });
    }
    static captureMessage(e, r = "info", n) {
        $bb03018efdf291ef$var$f.instance.captureMessage(e, r, n);
    }
    captureEvent(e) {
        if (Math.random() >= this.sampleRate) {
            this.log("Dropped event due to sample rate");
            return;
        }
        if (this.shouldBuffer) {
            if (this.buffer.length >= this.bufferlimit) return;
            this.buffer.push(e);
        } else this.sendEvent(e);
    }
    sendEvent(e, r = 5e3) {
        return $bb03018efdf291ef$var$x(this, null, function*() {
            try {
                this.log("Sending sentry event", e);
                let n = $bb03018efdf291ef$var$le(e, this.environment, this.release), s = {
                    event_id: n.event_id,
                    dsn: this.dsn
                }, a = {
                    type: "event"
                }, u = JSON.stringify(s) + `
` + JSON.stringify(a) + `
` + JSON.stringify(n), o = yield $bb03018efdf291ef$var$pe(this.apiURL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-sentry-envelope"
                    },
                    body: u
                }, r);
                this.log("Sentry response", o.status), o.status !== 200 && (console.log(o.body), console.error("Failed to send event to Sentry", o));
            } catch (n) {
                console.error("Failed to send event", n);
            }
        });
    }
    flush(e = 5e3) {
        return $bb03018efdf291ef$var$x(this, null, function*() {
            try {
                this.log("Flushing sentry events", this.buffer.length);
                let r = this.buffer.splice(0, this.buffer.length).map((n)=>this.sendEvent(n, e));
                yield Promise.all(r), this.log("Flushed all events");
            } catch (r) {
                console.error("Failed to flush events", r);
            }
        });
    }
    static flush(e = 5e3) {
        return $bb03018efdf291ef$var$f.instance.flush(e);
    }
    static reset() {
        $bb03018efdf291ef$var$f._instance = void 0;
    }
}, $bb03018efdf291ef$var$l($bb03018efdf291ef$var$f, "_instance"), $bb03018efdf291ef$var$f);
var $bb03018efdf291ef$var$fe = "https://d233059272824702afc8c43834c4912d@sentry.hcaptcha.com/6", $bb03018efdf291ef$var$he = "2.3.0", $bb03018efdf291ef$var$me = "production";
function $bb03018efdf291ef$var$H(t = !0) {
    if (!t) return $bb03018efdf291ef$var$q();
    $bb03018efdf291ef$var$N.init({
        dsn: $bb03018efdf291ef$var$fe,
        release: $bb03018efdf291ef$var$he,
        environment: $bb03018efdf291ef$var$me
    });
    let e = $bb03018efdf291ef$var$N.scope;
    return $bb03018efdf291ef$var$B(e), $bb03018efdf291ef$var$q(e);
}
function $bb03018efdf291ef$var$q(t = null) {
    return {
        addBreadcrumb: (e)=>{
            t && t.addBreadcrumb(e);
        },
        captureRequest: (e)=>{
            t && t.setRequest(e);
        },
        captureException: (e)=>{
            t && $bb03018efdf291ef$var$N.captureException(e, t);
        }
    };
}
function $bb03018efdf291ef$var$W({ scriptLocation: t, query: e, loadAsync: r = !0, crossOrigin: n = "anonymous", apihost: s = "https://js.hcaptcha.com", cleanup: a = !1, secureApi: u = !1, scriptSource: o = "" } = {}, c) {
    let i = $bb03018efdf291ef$var$S(t), h = $bb03018efdf291ef$var$O(i);
    return new Promise((y, E)=>{
        let m = h.document.createElement("script");
        m.id = $bb03018efdf291ef$var$L, o ? m.src = `${o}?onload=${$bb03018efdf291ef$var$b}` : u ? m.src = `${s}/1/secure-api.js?onload=${$bb03018efdf291ef$var$b}` : m.src = `${s}/1/api.js?onload=${$bb03018efdf291ef$var$b}`, m.crossOrigin = n, m.async = r;
        let _ = (v, X)=>{
            try {
                !u && a && i.removeChild(m), X(v);
            } catch (Y) {
                E(Y);
            }
        };
        m.onload = (v)=>_(v, y), m.onerror = (v)=>{
            c && c(m.src), _(v, E);
        }, m.src += e !== "" ? `&${e}` : "", i.appendChild(m);
    });
}
var $bb03018efdf291ef$var$C = [];
function $bb03018efdf291ef$var$be(t = {
    cleanup: !1
}, e) {
    try {
        e.addBreadcrumb({
            category: $bb03018efdf291ef$var$g,
            message: "hCaptcha loader params",
            data: t
        });
        let r = $bb03018efdf291ef$var$S(t.scriptLocation), n = $bb03018efdf291ef$var$O(r), s = $bb03018efdf291ef$var$C.find(({ scope: u })=>u === n.window);
        if (s) return e.addBreadcrumb({
            category: $bb03018efdf291ef$var$g,
            message: "hCaptcha already loaded"
        }), s.promise;
        let a = new Promise((u, o)=>$bb03018efdf291ef$var$x(this, null, function*() {
                try {
                    n.window[$bb03018efdf291ef$var$b] = ()=>{
                        e.addBreadcrumb({
                            category: $bb03018efdf291ef$var$g,
                            message: "hCaptcha script called onload function"
                        }), u(n.window.hcaptcha);
                    };
                    let c = $bb03018efdf291ef$var$U({
                        custom: t.custom,
                        render: t.render,
                        sentry: t.sentry,
                        assethost: t.assethost,
                        imghost: t.imghost,
                        reportapi: t.reportapi,
                        endpoint: t.endpoint,
                        host: t.host,
                        recaptchacompat: t.recaptchacompat,
                        hl: t.hl,
                        uj: t.uj
                    });
                    yield $bb03018efdf291ef$var$W($bb03018efdf291ef$var$d({
                        query: c
                    }, t), (i)=>{
                        e.captureRequest({
                            url: i,
                            method: "GET"
                        });
                    }), e.addBreadcrumb({
                        category: $bb03018efdf291ef$var$g,
                        message: "hCaptcha loaded",
                        data: s
                    });
                } catch (c) {
                    e.addBreadcrumb({
                        category: $bb03018efdf291ef$var$g,
                        message: "hCaptcha failed to load"
                    });
                    let i = $bb03018efdf291ef$var$C.findIndex((h)=>h.scope === n.window);
                    i !== -1 && $bb03018efdf291ef$var$C.splice(i, 1), o(new Error($bb03018efdf291ef$var$T));
                }
            }));
        return $bb03018efdf291ef$var$C.push({
            promise: a,
            scope: n.window
        }), a;
    } catch (r) {
        return e.captureException(r), Promise.reject(new Error($bb03018efdf291ef$var$T));
    }
}
function $bb03018efdf291ef$var$$(t, e, r = 0) {
    return $bb03018efdf291ef$var$x(this, null, function*() {
        var u, o;
        let n = (u = t.maxRetries) != null ? u : 2, s = (o = t.retryDelay) != null ? o : 1e3, a = r < n ? "Retry loading hCaptcha Api" : "Exceeded maximum retries";
        try {
            return yield $bb03018efdf291ef$var$be(t, e);
        } catch (c) {
            return e.addBreadcrumb({
                category: $bb03018efdf291ef$var$g,
                message: a
            }), r >= n ? (e.captureException(c), Promise.reject(c)) : (e.addBreadcrumb({
                category: $bb03018efdf291ef$var$g,
                message: `Waiting ${s}ms before retry attempt ${r + 1}`
            }), yield $bb03018efdf291ef$var$F(s), r += 1, $bb03018efdf291ef$var$$(t, e, r));
        }
    });
}
function $bb03018efdf291ef$export$5b4338a936fac718() {
    return $bb03018efdf291ef$var$x(this, arguments, function*(t = {}) {
        let e = $bb03018efdf291ef$var$H(t.sentry);
        return yield $bb03018efdf291ef$var$$(t, e);
    });
}


function $83d7dbc1c0ece011$export$fd8d2ba2926cdfb6(element) {
    var doc = element && element.ownerDocument || document;
    var win = doc.defaultView || doc.parentWindow || window;
    return {
        document: doc,
        window: win
    };
}
function $83d7dbc1c0ece011$export$a939d66a5741a5ae(element) {
    return element || document.head;
}


var $d0fa3eaaef8c49f4$var$HCaptcha = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($b0135d22a8a2f5b0$exports)))(HCaptcha, _React$Component);
    function HCaptcha(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        /**
     * Internal reference to track hCaptcha API
     *
     * Required as window is relative to initialization in application
     * not where the script and iFrames have been loaded.
     */ _this._hcaptcha = undefined;
        // API Methods
        _this.renderCaptcha = _this.renderCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.resetCaptcha = _this.resetCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.removeCaptcha = _this.removeCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.isReady = _this.isReady.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this._onReady = null;
        // Event Handlers
        _this.loadCaptcha = _this.loadCaptcha.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.handleOnLoad = _this.handleOnLoad.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.handleSubmit = _this.handleSubmit.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.handleExpire = _this.handleExpire.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.handleError = _this.handleError.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.handleOpen = _this.handleOpen.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.handleClose = _this.handleClose.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.handleChallengeExpired = _this.handleChallengeExpired.bind((0, (/*@__PURE__*/$parcel$interopDefault($7fb1f93ca477d275$exports)))(_this));
        _this.ref = /*#__PURE__*/ $4Iuzv.createRef();
        _this.apiScriptRequested = false;
        _this.sentryHub = null;
        _this.captchaId = '';
        /**
     * Tracks the currently pending async execute() promise.
     * Stores { resolve, reject } so we can cancel on unmount/errors/etc.
     */ _this._pendingExecute = null;
        _this.state = {
            isApiReady: false,
            isRemoved: false,
            elementId: props.id
        };
        return _this;
    }
    var _proto = HCaptcha.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        // Once captcha is mounted intialize hCaptcha - hCaptcha
        var element = (0, $83d7dbc1c0ece011$export$a939d66a5741a5ae)(this.props.scriptLocation);
        var frame = (0, $83d7dbc1c0ece011$export$fd8d2ba2926cdfb6)(element);
        this._hcaptcha = frame.window.hcaptcha || undefined;
        var isApiReady = typeof this._hcaptcha !== 'undefined';
        /*
     * Check if hCaptcha has already been loaded,
     * If Yes, render the captcha
     * If No, create script tag and wait to render the captcha
     */ if (isApiReady) {
            this.setState({
                isApiReady: true
            }, function() {
                _this2.renderCaptcha();
            });
            return;
        }
        this.loadCaptcha();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        this._cancelPendingExecute('react-component-unmounted');
        if (!this.isReady()) return;
        // Reset any stored variables / timers when unmounting
        hcaptcha.reset(captchaId);
        hcaptcha.remove(captchaId);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        // Prevent component re-rendering when these internal state variables are updated
        if (this.state.isApiReady !== nextState.isApiReady || this.state.isRemoved !== nextState.isRemoved) return false;
        return true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this3 = this;
        // Prop Keys that could change
        var keys = [
            'sitekey',
            'size',
            'theme',
            'tabindex',
            'languageOverride',
            'endpoint'
        ];
        // See if any props changed during component update
        var match = keys.every(function(key) {
            return prevProps[key] === _this3.props[key];
        });
        // If they have changed, remove current captcha and render a new one
        if (!match) this.removeCaptcha(function() {
            _this3.renderCaptcha();
        });
    };
    _proto.loadCaptcha = function loadCaptcha() {
        if (this.apiScriptRequested) return;
        var _this$props = this.props, apihost = _this$props.apihost, assethost = _this$props.assethost, endpoint = _this$props.endpoint, host = _this$props.host, imghost = _this$props.imghost, hl = _this$props.languageOverride, reCaptchaCompat = _this$props.reCaptchaCompat, reportapi = _this$props.reportapi, sentry = _this$props.sentry, custom = _this$props.custom, loadAsync = _this$props.loadAsync, scriptLocation = _this$props.scriptLocation, scriptSource = _this$props.scriptSource, secureApi = _this$props.secureApi, _this$props$cleanup = _this$props.cleanup, cleanup = _this$props$cleanup === void 0 ? true : _this$props$cleanup, userJourneys = _this$props.userJourneys;
        var mountParams = {
            render: 'explicit',
            apihost: apihost,
            assethost: assethost,
            endpoint: endpoint,
            hl: hl,
            host: host,
            imghost: imghost,
            recaptchacompat: reCaptchaCompat === false ? 'off' : null,
            reportapi: reportapi,
            sentry: sentry,
            custom: custom,
            loadAsync: loadAsync,
            scriptLocation: scriptLocation,
            scriptSource: scriptSource,
            secureApi: secureApi,
            cleanup: cleanup,
            uj: userJourneys !== undefined ? userJourneys : false
        };
        (0, $bb03018efdf291ef$export$5b4338a936fac718)(mountParams).then(this.handleOnLoad, this.handleError)["catch"](this.handleError);
        this.apiScriptRequested = true;
    };
    _proto.renderCaptcha = function renderCaptcha(onRender) {
        var _this4 = this;
        var onReady = this.props.onReady;
        var isApiReady = this.state.isApiReady;
        var captchaId = this.captchaId;
        // Prevent calling hCaptcha render on two conditions:
        // • API is not ready
        // • Component has already been mounted
        if (!isApiReady || captchaId) return;
        var renderParams = Object.assign({
            "open-callback": this.handleOpen,
            "close-callback": this.handleClose,
            "error-callback": this.handleError,
            "chalexpired-callback": this.handleChallengeExpired,
            "expired-callback": this.handleExpire,
            "callback": this.handleSubmit
        }, this.props, {
            hl: this.props.hl || this.props.languageOverride,
            languageOverride: undefined
        });
        var hcaptcha = this._hcaptcha;
        //Render hCaptcha widget and provide necessary callbacks - hCaptcha
        var id = hcaptcha.render(this.ref.current, renderParams);
        this.captchaId = id;
        this.setState({
            isRemoved: false
        }, function() {
            onRender && onRender();
            onReady && onReady();
            _this4._onReady && _this4._onReady(id);
        });
    };
    _proto.resetCaptcha = function resetCaptcha() {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        // Reset captcha state, removes stored token and unticks checkbox
        hcaptcha.reset(captchaId);
        this._cancelPendingExecute('hcaptcha-reset');
    };
    _proto.removeCaptcha = function removeCaptcha(callback) {
        var _this5 = this;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        this._cancelPendingExecute('hcaptcha-removed');
        if (!this.isReady()) return;
        this.setState({
            isRemoved: true
        }, function() {
            _this5.captchaId = '';
            hcaptcha.remove(captchaId);
            callback && callback();
        });
    };
    _proto.handleOnLoad = function handleOnLoad() {
        var _this6 = this;
        this.setState({
            isApiReady: true
        }, function() {
            var element = (0, $83d7dbc1c0ece011$export$a939d66a5741a5ae)(_this6.props.scriptLocation);
            var frame = (0, $83d7dbc1c0ece011$export$fd8d2ba2926cdfb6)(element);
            _this6._hcaptcha = frame.window.hcaptcha;
            // render captcha and wait for captcha id
            _this6.renderCaptcha(function() {
                // trigger onLoad if it exists
                var onLoad = _this6.props.onLoad;
                if (onLoad) onLoad();
            });
        });
    };
    _proto.handleSubmit = function handleSubmit(event) {
        var onVerify = this.props.onVerify;
        var isRemoved = this.state.isRemoved;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (typeof hcaptcha === 'undefined' || isRemoved) return;
        var token = hcaptcha.getResponse(captchaId); //Get response token from hCaptcha widget
        var ekey = hcaptcha.getRespKey(captchaId); //Get current challenge session id from hCaptcha widget
        if (onVerify) onVerify(token, ekey); //Dispatch event to verify user response
    };
    _proto.handleExpire = function handleExpire() {
        var onExpire = this.props.onExpire;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        hcaptcha.reset(captchaId); // If hCaptcha runs into error, reset captcha - hCaptcha
        if (onExpire) onExpire();
    };
    _proto.handleError = function handleError(event) {
        var onError = this.props.onError;
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (this.isReady()) // If hCaptcha runs into error, reset captcha - hCaptcha
        hcaptcha.reset(captchaId);
        if (onError) onError(event);
    };
    _proto.isReady = function isReady() {
        var _this$state = this.state, isApiReady = _this$state.isApiReady, isRemoved = _this$state.isRemoved;
        return isApiReady && !isRemoved;
    };
    _proto._cancelPendingExecute = function _cancelPendingExecute(reason) {
        if (!this._pendingExecute) return;
        var pending = this._pendingExecute;
        this._pendingExecute = null;
        var error = new Error(reason);
        pending.reject(error);
    };
    _proto.handleOpen = function handleOpen() {
        if (!this.isReady() || !this.props.onOpen) return;
        this.props.onOpen();
    };
    _proto.handleClose = function handleClose() {
        if (!this.isReady() || !this.props.onClose) return;
        this.props.onClose();
    };
    _proto.handleChallengeExpired = function handleChallengeExpired() {
        if (!this.isReady() || !this.props.onChalExpired) return;
        this.props.onChalExpired();
    };
    _proto.execute = function execute(opts) {
        var _this7 = this;
        if (opts === void 0) opts = null;
        opts = typeof opts === 'object' ? opts : null;
        try {
            var hcaptcha = this._hcaptcha;
            var captchaId = this.captchaId;
            // Is an async execute and there's already 1 pending, cancel the old one.
            if (opts && opts.async && this._pendingExecute) this._cancelPendingExecute('hcaptcha-execute-replaced');
            if (!this.isReady()) {
                if (opts && opts.async) return new Promise(function(resolve, reject) {
                    _this7._pendingExecute = {
                        resolve: resolve,
                        reject: reject
                    };
                    _this7._onReady = function(id) {
                        if (!_this7._pendingExecute) return;
                        try {
                            var _result = hcaptcha.execute(id, opts);
                            if (_result && typeof _result.then === 'function') _result.then(function(val) {
                                _this7._pendingExecute = null;
                                resolve(val);
                            })["catch"](function(err) {
                                _this7._pendingExecute = null;
                                reject(err);
                            });
                            else {
                                _this7._pendingExecute = null;
                                reject(new Error('hcaptcha-execute-no-promise'));
                            }
                        } catch (e) {
                            _this7._pendingExecute = null;
                            reject(e);
                        }
                    };
                });
                else {
                    // Non-async: don't return a promise.
                    this._onReady = function(id) {
                        hcaptcha.execute(id, opts);
                    };
                    return null;
                }
            }
            // hCaptcha is ready, execute directly.
            var result = hcaptcha.execute(captchaId, opts);
            // If it's async execute, track it.
            if (opts && opts.async && result && typeof result.then === 'function') return new Promise(function(resolve, reject) {
                _this7._pendingExecute = {
                    resolve: resolve,
                    reject: reject
                };
                result.then(function(val) {
                    _this7._pendingExecute = null;
                    resolve(val);
                })["catch"](function(err) {
                    _this7._pendingExecute = null;
                    reject(err);
                });
            });
            return result;
        } catch (error) {
            if (opts && opts.async) return Promise.reject(error);
            return null;
        }
    };
    _proto.close = function close() {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        this._cancelPendingExecute('hcaptcha-closed');
        if (!this.isReady()) return;
        return hcaptcha.close(captchaId);
    };
    _proto.setData = function setData(data) {
        var hcaptcha = this._hcaptcha;
        var captchaId = this.captchaId;
        if (!this.isReady()) return;
        if (data && typeof data !== "object") data = null;
        hcaptcha.setData(captchaId, data);
    };
    _proto.getResponse = function getResponse() {
        var hcaptcha = this._hcaptcha;
        return hcaptcha.getResponse(this.captchaId);
    };
    _proto.getRespKey = function getRespKey() {
        var hcaptcha = this._hcaptcha;
        return hcaptcha.getRespKey(this.captchaId);
    };
    _proto.render = function render() {
        var elementId = this.state.elementId;
        return /*#__PURE__*/ $4Iuzv.createElement("div", {
            ref: this.ref,
            id: elementId
        });
    };
    return HCaptcha;
}($4Iuzv.Component);
var $d0fa3eaaef8c49f4$export$2e2bcd8739ae039 = $d0fa3eaaef8c49f4$var$HCaptcha;


function $547c8b3753650fa9$export$2e2bcd8739ae039() {
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const captchaRef = (0, $4Iuzv.useRef)(null);
    const [formData, setFormData] = (0, $4Iuzv.useState)({
        name: "",
        email: "",
        phone: "",
        company: "",
        service: "",
        message: ""
    });
    const [submitted, setSubmitted] = (0, $4Iuzv.useState)(false);
    const [loading, setLoading] = (0, $4Iuzv.useState)(false);
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const [captchaToken, setCaptchaToken] = (0, $4Iuzv.useState)(null);
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
    }, []);
    // SEO: Structured Data for Contact Page
    const contactSchema = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "mainEntity": {
            "@type": "Organization",
            "name": "Arc Engineering Solutions Ltd",
            "url": "https://arcengltd.com",
            "logo": "https://arcengltd.com/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+44-7492-949230",
                "contactType": "customer service",
                "email": "info@arcengltd.com",
                "areaServed": [
                    "GB",
                    "Europe",
                    "Worldwide"
                ],
                "availableLanguage": "en"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "W3 Winchester Avenue, Blaby",
                "addressLocality": "Leicester",
                "postalCode": "LE8 4GZ",
                "addressCountry": "GB"
            }
        }
    };
    const handleChange = (e)=>setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!captchaToken) {
            alert("Please complete the security verification.");
            return;
        }
        setLoading(true);
        const object = {
            ...formData,
            "h-captcha-response": captchaToken,
            access_key: "924ccab0-0d44-4ee7-9b26-dbd417a45269",
            subject: `New Technical Enquiry from ${formData.name}`,
            from_name: "Arc Engineering Web Terminal"
        };
        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify(object)
            });
            const result = await response.json();
            if (result.success) {
                setSubmitted(true);
                setCaptchaToken(null);
                if (captchaRef.current) captchaRef.current.resetCaptcha();
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    company: "",
                    service: "",
                    message: ""
                });
            } else alert(result.message || "Transmission failed.");
        } catch (error) {
            alert("Terminal error. Check connection.");
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "Contact Our Engineering Team | Arc Engineering Solutions"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "Get in touch with Arc Engineering for bespoke generator packages and turnkey electrical projects. Global support based in Leicester, UK."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(contactSchema)
                    })
                ]
            }),
            submitted && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "fixed inset-0 z-[100] flex items-center justify-center px-4",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-[#44444E]/80 backdrop-blur-sm",
                        onClick: ()=>setSubmitted(false)
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "relative bg-white rounded-2xl shadow-2xl p-8 md:p-12 max-w-md w-full text-center border-t-8 border-[#BF092F]",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                onClick: ()=>setSubmitted(false),
                                className: "absolute top-4 right-4 text-gray-400 hover:text-[#BF092F] transition-colors",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6ceff59181ea43fa$export$2e2bcd8739ae039), {
                                    size: 24
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "flex justify-center mb-6",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "bg-green-100 p-4 rounded-full",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ccfb168b016548a6$export$2e2bcd8739ae039), {
                                        className: "text-green-600",
                                        size: 48
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                className: "text-2xl font-bold text-[#44444E] mb-2 uppercase tracking-tighter",
                                children: "Transmission Successful"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-gray-500 text-sm uppercase tracking-widest font-medium mb-8",
                                children: "Your enquiry has been received. Our engineering team will contact you shortly."
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                onClick: ()=>setSubmitted(false),
                                className: "w-full py-4 bg-[#44444E] text-white text-xs font-black uppercase tracking-[0.3em] hover:bg-[#BF092F] transition-all rounded-xl shadow-lg",
                                children: "Back to Terminal"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20",
                                            children: "Contact Us"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                    className: `font-semibold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: [
                                        "Contact ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: "Us"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-2",
                                    children: "Communications Terminal & Global Support"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                className: "container mx-auto -translate-y-24 relative z-30 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "pt-30",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: `lg:col-span-8 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "bg-white px-4 md:px-8 py-10 md:py-12 rounded-2xl shadow-xl border border-gray-100 relative overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "absolute top-8 right-8 text-6xl font-black text-gray-50 select-none hidden md:block",
                                            children: "FORM"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                            className: "tracking-widest border-l-4 border-[#BF092F] pl-4 mb-10 text-[#44444E] uppercase text-sm font-bold",
                                            children: "Send Message"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("form", {
                                            onSubmit: handleSubmit,
                                            className: "space-y-8 relative z-10",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-2 gap-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$Input, {
                                                            label: "Identity / Full Name",
                                                            name: "name",
                                                            value: formData.name,
                                                            onChange: handleChange,
                                                            required: true,
                                                            placeholder: "J. Doe"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$Input, {
                                                            label: "Email Address",
                                                            name: "email",
                                                            type: "email",
                                                            value: formData.email,
                                                            onChange: handleChange,
                                                            required: true,
                                                            placeholder: "Contact@domain.com"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-2 gap-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$Input, {
                                                            label: "Phone Number",
                                                            name: "phone",
                                                            value: formData.phone,
                                                            onChange: handleChange,
                                                            placeholder: "+44 000 000"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$Input, {
                                                            label: "Corporate Entity",
                                                            name: "company",
                                                            value: formData.company,
                                                            onChange: handleChange,
                                                            placeholder: "Company LTD"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("label", {
                                                            className: "block text-[12px] text-[#44444E] uppercase tracking-[0.2em] mb-3 font-bold",
                                                            children: "Service Classification"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "relative",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("select", {
                                                                    name: "service",
                                                                    required: true,
                                                                    value: formData.service,
                                                                    onChange: handleChange,
                                                                    className: "w-full bg-gray-50 border-b-2 border-gray-200 py-4 tracking-widest focus:outline-none focus:border-[#BF092F] appearance-none cursor-pointer",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                                            value: "",
                                                                            children: "Select Project Scope"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                                            value: "generator-packages",
                                                                            children: "Generator Packages"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                                            value: "electrical-accessories",
                                                                            children: "Electrical Accessories"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                                            value: "bespoke-engineering",
                                                                            children: "Bespoke Turnkey Projects"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                                            value: "others",
                                                                            children: "Others"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                    className: "absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none text-[#44444E]",
                                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                                                        size: 16,
                                                                        className: "-rotate-90"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("textarea", {
                                                    rows: 5,
                                                    name: "message",
                                                    value: formData.message,
                                                    onChange: handleChange,
                                                    required: true,
                                                    placeholder: "PROVIDE DETAILED TECHNICAL REQUIREMENTS...",
                                                    className: "w-full bg-gray-50 border-b-2 border-gray-200 py-4 tracking-widest focus:outline-none focus:border-[#BF092F] resize-none"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "py-2 relative z-[60]",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d0fa3eaaef8c49f4$export$2e2bcd8739ae039), {
                                                        sitekey: "50b2fe65-b00b-4b9e-ad62-3ba471098be2",
                                                        onVerify: (token)=>setCaptchaToken(token),
                                                        onExpire: ()=>setCaptchaToken(null),
                                                        ref: captchaRef,
                                                        theme: "light"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                                    type: "submit",
                                                    disabled: loading,
                                                    className: "w-full sm:w-auto inline-flex items-center justify-center gap-4 px-10 py-4 bg-[#44444E] text-white uppercase tracking-[0.3em] hover:bg-[#BF092F] transition-all rounded-xl shadow-xl group font-bold disabled:opacity-50",
                                                    children: [
                                                        loading ? "Transmitting..." : "Send Message",
                                                        " ",
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $97bf0a16e1eec75c$export$2e2bcd8739ae039), {
                                                            size: 16,
                                                            className: "group-hover:translate-x-1 transition-transform"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                                className: `lg:col-span-4 space-y-8 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "rounded-2xl bg-[#44444E] shadow-2xl border-t-4 border-[#BF092F] overflow-hidden h-full",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "p-8 border-b border-white/10",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                    className: "text-[12px] text-white tracking-[0.4em] mb-8 font-bold",
                                                    children: "TERMINAL INFO"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "space-y-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$ContactRow, {
                                                            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $29e92dec75ed73a3$export$2e2bcd8739ae039), {
                                                                size: 18
                                                            }),
                                                            label: "Direct Line",
                                                            value: "+44 7492 949230",
                                                            href: "tel:+447492949230"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$ContactRow, {
                                                            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $f0a72ea34a993d6e$export$2e2bcd8739ae039), {
                                                                size: 18
                                                            }),
                                                            label: "Enquiries",
                                                            value: "info@arcengltd.com",
                                                            href: "mailto:info@arcengltd.com"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$ContactRow, {
                                                            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                                                size: 18
                                                            }),
                                                            label: "Address",
                                                            value: "W3 Winchester Avenue, Blaby, Leicester, LE8 4GZ, UK"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "p-8 bg-black/20",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                                    className: "text-[12px] text-white/40 uppercase tracking-[0.4em] mb-6 flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $fed10cf43c8a993c$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        " Operational Hours"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "space-y-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex justify-between text-[11px] uppercase tracking-widest",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-white/50",
                                                                    children: "Mon \u2013 Fri"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-white font-bold",
                                                                    children: "09:00 \u2013 17:00"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex justify-between text-[11px] uppercase tracking-widest",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-white/50",
                                                                    children: "Saturday"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-white font-bold",
                                                                    children: "10:00 \u2013 14:00"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "p-6 flex gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$IconButton, {
                                                    icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $7dfa7cc464d9286c$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$IconButton, {
                                                    icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0ff9218d15909c02$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($547c8b3753650fa9$var$IconButton, {
                                                    icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c6007ae527fb4279$export$2e2bcd8739ae039), {
                                                        size: 18
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
            })
        ]
    });
}
/* Sub-Components (Preserved) */ function $547c8b3753650fa9$var$ContactRow({ icon: icon, label: label, value: value, href: href }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "flex gap-4 items-start group",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "w-10 h-10 bg-white/10 text-[#BF092F] flex items-center justify-center shrink-0 rounded-lg border border-white/5 group-hover:bg-[#BF092F] transition-colors",
                children: icon
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                        className: "text-[12px] text-white/30 uppercase tracking-[0.3em] mb-1 font-bold",
                        children: label
                    }),
                    href ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("a", {
                        href: href,
                        className: "text-xs text-white uppercase tracking-widest hover:text-[#BF092F] transition-colors font-medium",
                        children: value
                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "text-xs text-white/80 uppercase tracking-widest leading-relaxed font-medium",
                        children: value
                    })
                ]
            })
        ]
    });
}
function $547c8b3753650fa9$var$IconButton({ icon: icon }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
        className: "w-12 h-12 flex items-center justify-center bg-white/5 text-white/40 border border-white/5 hover:bg-[#BF092F] hover:text-white transition-all rounded-lg",
        children: icon
    });
}
function $547c8b3753650fa9$var$Input({ label: label, ...props }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "w-full",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("label", {
                className: "block text-[12px] text-[#44444E] uppercase tracking-[0.2em] mb-2 font-bold",
                children: label
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("input", {
                ...props,
                className: "w-full bg-gray-50 border-b-2 border-gray-200 py-3 tracking-widest focus:outline-none focus:border-[#BF092F] transition-colors"
            })
        ]
    });
}


// src/components/ScrollToTop.js

var $4Iuzv = parcelRequire("4Iuzv");

function $a6f3d1fb087ebfd1$export$2e2bcd8739ae039() {
    const { pathname: pathname } = (0, $b11369f2b382bb4b$export$45d76561a5302f2b)();
    (0, $4Iuzv.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, [
        pathname
    ]);
    return null;
}




var $4Iuzv = parcelRequire("4Iuzv");





const $d0ff8f2651a3f322$var$SearchResultsPage = ()=>{
    const { query: query } = (0, $b11369f2b382bb4b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const decodedQuery = decodeURIComponent(query);
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const [currentPage, setCurrentPage] = (0, $4Iuzv.useState)(1);
    const itemsPerPage = 12;
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
        setCurrentPage(1);
        // Dynamic Title & Meta (Native fallback if not using Helmet)
        document.title = `Search: ${decodedQuery.toUpperCase()} | Arc Engineering Solutions`;
    }, [
        query,
        decodedQuery
    ]);
    // Optimized flattening logic
    const allItems = (0, $646411876a15270d$export$b6aad051bad07f12).flatMap((category)=>{
        const baseSlug = category.slug;
        if (category.type === "parent" && category.subCategories) return category.subCategories.flatMap((sub)=>(sub.items || []).map((item)=>({
                    ...item,
                    categorySlug: sub.slug
                })));
        return (category.items || []).map((item)=>({
                ...item,
                categorySlug: baseSlug
            }));
    });
    const results = allItems.filter((item)=>{
        const searchTerm = decodedQuery.toLowerCase();
        return item.name?.toLowerCase().includes(searchTerm) || item.manufacturerPartNumber?.toLowerCase().includes(searchTerm) || item.description?.toLowerCase().includes(searchTerm) // SEO: Search in description too
        ;
    });
    const totalPages = Math.ceil(results.length / itemsPerPage) || 1;
    const paginatedResults = results.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const handlePageChange = (pageNumber)=>{
        setCurrentPage(pageNumber);
        // SEO UX: Scroll back to the results header, not the very top
        const mainSection = document.getElementById("main-content");
        mainSection?.scrollIntoView({
            behavior: "smooth"
        });
    };
    const BoxedPagination = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
            "aria-label": "Pagination",
            className: "flex items-center gap-4",
            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                        className: "text-[10px] font-mono text-gray-400 uppercase tracking-widest",
                        children: [
                            "Index ",
                            currentPage,
                            " / ",
                            totalPages
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                onClick: ()=>handlePageChange(currentPage - 1),
                                disabled: currentPage === 1,
                                className: "p-1.5 cursor-pointer rounded-lg border border-gray-100 disabled:opacity-20 hover:border-[#BF092F] transition-all",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                onClick: ()=>handlePageChange(currentPage + 1),
                                disabled: currentPage === totalPages,
                                className: "p-1.5 cursor-pointer rounded-lg border border-gray-100 disabled:opacity-20 hover:border-[#BF092F] transition-all",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                    size: 16
                                })
                            })
                        ]
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                name: "description",
                content: `Technical registry results for ${decodedQuery}. Browse engineering specifications and part details at Arc Engineering.`
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                name: "robots",
                content: "noindex, follow"
            }),
            " ",
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("link", {
                rel: "canonical",
                href: `https://arcengltd.com/search/${encodeURIComponent(query)}`
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                type: "application/ld+json",
                children: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "SearchResultsPage",
                    "name": `Search Results for ${decodedQuery}`,
                    "description": `Found ${results.length} items matching ${decodedQuery}`,
                    "url": window.location.href,
                    "breadcrumb": {
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            {
                                "@type": "ListItem",
                                "position": 1,
                                "name": "Home",
                                "item": "https://arcengltd.com/"
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "name": "Products",
                                "item": "https://arcengltd.com/products"
                            },
                            {
                                "@type": "ListItem",
                                "position": 3,
                                "name": "Search"
                            }
                        ]
                    }
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    "aria-label": "Breadcrumb",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("ol", {
                                        className: "flex items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                                    onClick: ()=>navigate("/"),
                                                    className: "group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-[10px] md:text-xs tracking-widest uppercase font-bold",
                                                            children: "Home"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                className: "text-white/20 text-xs font-mono",
                                                children: ">"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                className: "flex items-center",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                    onClick: ()=>navigate("/products"),
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase text-white/50 hover:text-white transition-colors font-bold",
                                                    children: "Products"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                className: "text-white/20 text-xs font-mono",
                                                children: ">"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("li", {
                                                "aria-current": "page",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg font-bold",
                                                    children: [
                                                        "Search: ",
                                                        decodedQuery
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    role: "status",
                                    "aria-live": "polite",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                            className: `font-semibold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                            children: [
                                                "Registry ",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[#BF092F]",
                                                    children: "Query"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                            className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-4 max-w-3xl",
                                            children: [
                                                "Displaying system matches for:",
                                                " ",
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("strong", {
                                                    className: "text-white font-mono italic font-normal",
                                                    children: [
                                                        '"',
                                                        decodedQuery,
                                                        '"'
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                className: "container mx-auto py-7 relative z-30 px-4",
                id: "main-content",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-gray-100 min-h-[600px] flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex items-center justify-between mb-12 border-b border-gray-100 pb-8",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex items-center gap-4",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "h-6 w-1 bg-[#BF092F]",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                            className: "tracking-widest text-[#44444E] uppercase text-sm font-bold",
                                            children: results.length > 0 ? "Search Findings" : "System Alert"
                                        })
                                    ]
                                }),
                                totalPages > 1 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(BoxedPagination, {})
                            ]
                        }),
                        results.length === 0 ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex flex-col items-center justify-center py-20 text-center",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $092d6d02f27aae3b$export$2e2bcd8739ae039), {
                                    size: 48,
                                    className: "text-gray-200 mb-6"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                    className: "text-xl font-bold text-[#44444E] mb-2 uppercase tracking-tight",
                                    children: "No Records Found"
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-gray-400 text-sm mb-8",
                                    children: "Refine your query or check our category directory."
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                    onClick: ()=>navigate("/products"),
                                    className: "flex items-center gap-3 px-8 py-4 bg-[#44444E] text-white text-[10px] font-bold uppercase tracking-[0.2em] rounded-xl hover:bg-[#BF092F] transition-all shadow-lg",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        " Return to Registry"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 flex-grow",
                                    children: paginatedResults.map((item, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                            className: "transition-all duration-500 hover:-translate-y-2",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $78362d5230cbcfa0$export$2e2bcd8739ae039), {
                                                product: item,
                                                categorySlug: item.categorySlug
                                            })
                                        }, item.id || idx))
                                }),
                                totalPages > 1 && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                    className: "mt-12 pt-8 border-t border-gray-100 flex justify-center",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(BoxedPagination, {})
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]",
                "aria-hidden": "true"
            })
        ]
    });
};
var $d0ff8f2651a3f322$export$2e2bcd8739ae039 = $d0ff8f2651a3f322$var$SearchResultsPage;




var $4Iuzv = parcelRequire("4Iuzv");



var $4Iuzv = parcelRequire("4Iuzv");


function $0a84bc2492a6b1fb$export$2e2bcd8739ae039({ facility: facility }) {
    const [hover, setHover] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
        className: "group relative flex flex-col h-full bg-white rounded-2xl shadow-xl border border-gray-100 cursor-pointer overflow-hidden transition-all duration-500 hover:shadow-2xl hover:border-[#BF092F]/20",
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        onClick: ()=>navigate(`/facilities/${facility.id}`),
        "aria-labelledby": `facility-title-${facility.id}`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "h-56 relative overflow-hidden bg-[#44444E]",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                        src: facility.facilityImg[0],
                        alt: `Arc Engineering ${facility.title} - ${facility.location} Manufacturing Hub`,
                        className: `w-full h-full object-cover grayscale transition-all duration-1000 opacity-80 group-hover:opacity-100 group-hover:grayscale-0 group-hover:scale-105`,
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-60",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute bottom-4 left-4 flex gap-2",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "px-3 py-1 bg-[#BF092F] rounded-2xl text-white text-[9px] font-black uppercase tracking-widest shadow-lg",
                            children: [
                                "UNIT: ",
                                facility.id.toUpperCase()
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "p-6 flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2 mb-1",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                        size: 12,
                                        className: "text-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[9px] text-gray-400 font-bold uppercase tracking-[0.2em]",
                                        children: "Manufacturing Hub"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                id: `facility-title-${facility.id}`,
                                className: "text-xl font-bold text-[#44444E] tracking-tight group-hover:text-[#BF092F] transition-colors leading-tight mb-2",
                                children: facility.title
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                        size: 12,
                                        className: "text-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("address", {
                                        className: "not-italic text-[10px] font-bold tracking-widest uppercase text-gray-400",
                                        children: facility.location
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-2 gap-px bg-gray-100 border border-gray-100 rounded-xl overflow-hidden mb-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "bg-gray-50/50 p-4 flex flex-col group-hover:bg-white transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                        className: "text-[8px] text-gray-400 uppercase font-black tracking-widest mb-1 flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $937c5640447fbab0$export$2e2bcd8739ae039), {
                                                size: 10,
                                                "aria-hidden": "true"
                                            }),
                                            " Footprint"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[11px] font-bold text-[#44444E] uppercase",
                                        children: facility.totalArea
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "bg-gray-50/50 p-4 flex flex-col group-hover:bg-white transition-colors",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                        className: "text-[8px] text-gray-400 uppercase font-black tracking-widest mb-1 flex items-center gap-1",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $74612ecec2deb067$export$2e2bcd8739ae039), {
                                                size: 10,
                                                "aria-hidden": "true"
                                            }),
                                            " Output"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                        className: "text-[11px] font-bold text-[#44444E] uppercase",
                                        children: [
                                            facility.productionCapacity.split(" ")[2],
                                            " TONS/YR"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                        className: "space-y-2 mb-8 list-none",
                        children: facility.highlights?.map((item, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                className: "flex items-start gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "mt-1.5 w-1 h-1 bg-[#BF092F] shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-[12px] text-gray-500 leading-tight font-light tracking-wide",
                                        children: item
                                    })
                                ]
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "mt-auto pt-6 border-t border-gray-100 flex items-center justify-between",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "flex items-center gap-2 text-[#BF092F] font-black text-[10px] uppercase tracking-[0.2em] group-hover:translate-x-1 transition-transform",
                            children: [
                                "More Details",
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                    size: 14,
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `absolute bottom-0 left-0 h-1 bg-[#BF092F] transition-all duration-700 ${hover ? "w-full" : "w-0"}`,
                "aria-hidden": "true"
            })
        ]
    });
}





function $19a76bbdacc7b0e9$export$2e2bcd8739ae039() {
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const visibleFacilities = (0, $1d8abed9f39d100d$export$135a7dba28bbc197);
    // SEO: Structured Data Schema for Search Engines
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "BusinessAudience",
        "name": "Arc Engineering Global Manufacturing",
        "description": "Strategic manufacturing hubs for Generator Enclosures and E-Houses.",
        "hasPart": (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((f)=>({
                "@type": "Place",
                "name": f.title,
                "address": f.location
            }))
    };
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "Strategic Manufacturing Facilities | Arc Engineering Solutions"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "Explore our global production hubs in the UK, UAE, and India. High-capacity fabrication of Generator Containers and E-Houses to UK quality standards."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "keywords",
                        content: "Engineering Facilities, Generator Container Manufacturing, E-House Fabrication, UK Engineering Hubs"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("link", {
                        rel: "canonical",
                        href: "https://arcengltd.com/facilities"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(schemaData)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl shadow-xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    "aria-label": "Breadcrumb",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            "aria-hidden": "true",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20",
                                            children: "Facilities"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                    className: `font-semibold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: [
                                        "Strategic ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: "Facilities"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-4 max-w-3xl font-medium",
                                    children: "Global Infrastructure & Production Hubs"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("main", {
                className: "container mx-auto relative z-30",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "container mx-auto px-4 md:px-6 py-7 relative z-10",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-4 mb-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-8 w-1 bg-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                        className: "text-sm text-[#44444E] uppercase tracking-[0.4em]",
                                        children: "Operational Facilities"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                children: visibleFacilities.map((facility)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                        className: "px-0",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $0a84bc2492a6b1fb$export$2e2bcd8739ae039), {
                                            facility: facility
                                        })
                                    }, facility.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("section", {
                        className: "container mx-auto px-4 md:px-6",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-gray-200 pt-12 pb-12",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "rounded-2xl flex flex-col gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37581b884d168f82$export$2e2bcd8739ae039), {
                                            className: "text-[#BF092F]",
                                            size: 32,
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                            className: "text-xl text-[#44444E] font-bold uppercase",
                                            children: "PRECISION SCALE"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-sm text-gray-500 leading-relaxed font-light tracking-wide",
                                            children: "Integrated manufacturing processes ensuring high-volume output with surgical accuracy across all units."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "rounded-2xl bg-[#44444E] p-8 text-white md:col-span-2 flex flex-col justify-center border-t-4 border-[#BF092F] shadow-xl",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                            className: "text-2xl mb-2 uppercase italic text-[#BF092F] font-bold",
                                            children: "Unified Quality Standard"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-white/70 font-light tracking-widest",
                                            children: "Every facility operates under the same rigorous ISO certifications and engineering protocols, delivering identical excellence regardless of location."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]",
                "aria-hidden": "true"
            })
        ]
    });
}





var $4Iuzv = parcelRequire("4Iuzv");


/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ba8bf023ef8fc70d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $ba8bf023ef8fc70d$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("arrow-left", $ba8bf023ef8fc70d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3ab167f7b18ea73b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 3v16a2 2 0 0 0 2 2h16",
            key: "c24i48"
        }
    ],
    [
        "path",
        {
            d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
            key: "q0gr47"
        }
    ]
];
const $3ab167f7b18ea73b$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("chart-area", $3ab167f7b18ea73b$export$3efd853dbb351e94);


function $3d6cce588754bb8f$export$2e2bcd8739ae039() {
    const { id: id } = (0, $b11369f2b382bb4b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const facility = (0, $1d8abed9f39d100d$export$135a7dba28bbc197).find((f)=>f.id === id);
    const [lightboxOpen, setLightboxOpen] = (0, $4Iuzv.useState)(false);
    const [currentIndex, setCurrentIndex] = (0, $4Iuzv.useState)(0);
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
    }, [
        id
    ]);
    // SEO: Industrial Hub Schema
    const hubSchema = facility ? {
        "@context": "https://schema.org",
        "@type": "IndustrialBusiness",
        name: `${facility.title} | Arc Engineering Solutions Ltd`,
        description: facility.desc,
        address: {
            "@type": "PostalAddress",
            addressLocality: facility.location,
            addressCountry: facility.location.includes("UK") ? "GB" : "Global"
        }
    } : null;
    const allImages = facility ? [
        ...facility.facilityImg.map((img)=>({
                img: img,
                title: "Infrastructure View",
                desc: facility.title
            })),
        ...facility.capabilityImg || []
    ] : [];
    const openLightbox = (index)=>{
        setCurrentIndex(index);
        setLightboxOpen(true);
        document.body.style.overflow = "hidden";
    };
    const closeLightbox = ()=>{
        setLightboxOpen(false);
        document.body.style.overflow = "unset";
    };
    const showNext = (0, $4Iuzv.useCallback)((e)=>{
        e?.stopPropagation();
        setCurrentIndex((prev)=>(prev + 1) % allImages.length);
    }, [
        allImages.length
    ]);
    const showPrev = (0, $4Iuzv.useCallback)((e)=>{
        e?.stopPropagation();
        setCurrentIndex((prev)=>(prev - 1 + allImages.length) % allImages.length);
    }, [
        allImages.length
    ]);
    (0, $4Iuzv.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (!lightboxOpen) return;
            if (e.key === "Escape") closeLightbox();
            if (e.key === "ArrowRight") showNext();
            if (e.key === "ArrowLeft") showPrev();
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        lightboxOpen,
        showNext,
        showPrev
    ]);
    if (!facility) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "h-screen flex flex-col items-center justify-center bg-[#F8F9FA]",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                className: "text-4xl font-bold text-[#44444E]",
                children: "404 // FACILITY_NOT_FOUND"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                onClick: ()=>navigate("/facilities"),
                className: "mt-6 px-8 py-3 bg-[#BF092F] text-white rounded-xl font-bold",
                children: "Return to Terminal"
            })
        ]
    });
    const currentData = allImages[currentIndex];
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("html", {
                        lang: "en-GB"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: `${facility.title} | Infrastructure & Capabilities | Arc Engineering`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: `Technical specifications for ${facility.title} in ${facility.location}. High-capacity manufacturing for Generator Containers and E-Houses to British Standards.`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "keywords",
                        content: `Arc Engineering ${facility.location}, Industrial Fabrication ${facility.location}, E-House Manufacturing, Generator Container Production`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(hubSchema)
                    })
                ]
            }),
            lightboxOpen && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "fixed inset-0 z-[100] flex items-center justify-center bg-[#1A1A1E]/95 backdrop-blur-xl md:p-4",
                onClick: closeLightbox,
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                        onClick: closeLightbox,
                        className: "cursor-pointer absolute top-6 right-6 text-white/50 hover:text-[#BF092F] transition-all z-[120] group",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6ceff59181ea43fa$export$2e2bcd8739ae039), {
                            size: 32,
                            className: "md:w-10 md:h-10 group-hover:rotate-90 transition-transform"
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "w-full h-full md:h-auto max-w-7xl flex flex-col items-center justify-center gap-4 md:gap-6",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "relative w-full flex items-center justify-center group px-4 md:px-24",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: showPrev,
                                        className: "cursor-pointer absolute left-2 md:left-0 text-white/20 hover:text-[#BF092F] transition-all p-2 z-[110] hover:scale-110",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                            size: 40,
                                            className: "md:w-[60px]",
                                            strokeWidth: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "relative w-full flex justify-center",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                            src: currentData?.img,
                                            /* Mobile: h-[50vh] or auto width to fill screen 
               Desktop: max-h-[75vh] 
            */ className: "w-full md:w-auto h-auto max-h-[60vh] md:max-h-[75vh] object-contain select-none rounded-lg md:rounded-2xl shadow-2xl",
                                            alt: currentData?.title || "Facility Detail"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: showNext,
                                        className: "cursor-pointer absolute right-2 md:right-0 text-white/20 hover:text-[#BF092F] transition-all p-2 z-[110] hover:scale-110",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                            size: 40,
                                            className: "md:w-[60px]",
                                            strokeWidth: 1
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-[90%] md:w-full max-w-4xl bg-[#44444E] border border-white/10 p-5 md:p-6 rounded-2xl shadow-2xl",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex items-start justify-between gap-4 md:gap-8",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-3 mb-1 md:mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "h-3 w-1 bg-[#BF092F]"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                            className: "text-white font-black uppercase tracking-widest text-[10px] md:text-sm",
                                                            children: currentData?.title || "Operational View"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-white/60 leading-relaxed font-light tracking-wide italic text-xs md:text-sm",
                                                    children: currentData?.desc || "Technical documentation for " + facility.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "text-right shrink-0",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                className: "text-white/40 text-[10px] md:text-[12px] font-black tracking-tighter",
                                                children: [
                                                    currentIndex + 1,
                                                    " / ",
                                                    allImages.length
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    "aria-label": "Breadcrumb",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            "aria-hidden": "true",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>navigate("/facilities"),
                                            className: "cursor-pointer text-[10px] md:text-xs tracking-widest uppercase text-white/50 hover:text-white transition-colors",
                                            children: "Facilities"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            "aria-hidden": "true",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg",
                                            children: facility.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                    className: `font-semibold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: [
                                        facility.title.split(" ")[0],
                                        " ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: facility.title.split(" ").slice(1).join(" ")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                    className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-4 max-w-3xl font-medium",
                                    children: [
                                        "Technical infrastructure data for operational unit:",
                                        " ",
                                        facility.title,
                                        "."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                className: "container mx-auto -translate-y-12 relative z-30 pb-20",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "pt-20 px-4 flex flex-col lg:grid lg:grid-cols-12 gap-8 items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                            className: "lg:col-span-4 space-y-8",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "rounded-2xl bg-[#44444E] shadow-2xl border-t-4 border-[#BF092F] lg:sticky lg:top-[20vh] overflow-hidden transition-all duration-500",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "p-5 border-b border-white/10 w-full overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("label", {
                                                className: "text-[9px] text-white/30 uppercase tracking-[0.2em] font-black block mb-3",
                                                children: "Facility Registry"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "relative group w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("select", {
                                                        value: facility.id,
                                                        onChange: (e)=>navigate(`/facilities/${e.target.value}`),
                                                        className: "w-full bg-white/5 border border-white/10 pl-4 pr-12 py-3 rounded-xl text-white text-sm font-bold appearance-none cursor-pointer hover:bg-white/10 transition-all truncate",
                                                        children: (0, $1d8abed9f39d100d$export$135a7dba28bbc197).map((f)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                                value: f.id,
                                                                className: "bg-[#1A1A1E]",
                                                                children: f.title
                                                            }, f.id))
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            className: "rotate-90 text-[#BF092F]"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "p-6 lg:p-8 flex flex-col gap-4 cursor-pointer lg:cursor-default border-b border-white/10",
                                        onClick: ()=>{
                                            if (window.innerWidth < 1024) {
                                                const content = document.getElementById("facility-specs-content");
                                                const preview = document.getElementById("facility-mobile-preview");
                                                content.classList.toggle("hidden");
                                                preview.classList.toggle("hidden");
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $52df24fc950c96b6$export$2e2bcd8739ae039), {
                                                                size: 16,
                                                                className: "text-[#BF092F]"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                                className: "text-[12px] text-white tracking-[0.4em] uppercase font-bold",
                                                                children: "Technical Specs"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                        size: 18,
                                                        className: "text-white/40 lg:hidden transform rotate-90"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                id: "facility-mobile-preview",
                                                className: "flex flex-col gap-2 lg:hidden border-t border-white/5 pt-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-[#BF092F]"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[10px] text-white/50 uppercase font-bold tracking-wider",
                                                                children: "Loc:"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[10px] text-white font-bold",
                                                                children: facility.location
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3ab167f7b18ea73b$export$2e2bcd8739ae039), {
                                                                size: 12,
                                                                className: "text-[#BF092F]"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[10px] text-white/50 uppercase font-bold tracking-wider",
                                                                children: "Area:"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[10px] text-white font-bold",
                                                                children: facility.totalArea
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        id: "facility-specs-content",
                                        className: "hidden lg:block",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "p-8 space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($3d6cce588754bb8f$var$SidebarStat, {
                                                        label: "Location",
                                                        value: facility.location,
                                                        icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($3d6cce588754bb8f$var$SidebarStat, {
                                                        label: "Total Area",
                                                        value: facility.totalArea,
                                                        icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3ab167f7b18ea73b$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($3d6cce588754bb8f$var$SidebarStat, {
                                                        label: "Standards",
                                                        value: facility.productionCapacity,
                                                        icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                                            size: 16
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "p-8 bg-black/20",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                                    onClick: ()=>navigate("/facilities"),
                                                    className: "cursor-pointer w-full py-4 bg-[#BF092F] text-white text-[11px] font-bold uppercase tracking-[0.3em] rounded-xl flex items-center justify-center gap-2 hover:bg-white hover:text-[#44444E] transition-all shadow-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ba8bf023ef8fc70d$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        " Back to Registry"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
                            className: "lg:col-span-8 space-y-16 md:space-y-24 lg:pl-12 xl:pl-20 py-10 px-4 sm:px-6 lg:px-0",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "relative group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                                            className: "mb-5 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "absolute -left-6 -top-10 text-[130px] font-black text-gray-100/40 select-none pointer-events-none group-hover:text-[#BF092F]/10 transition-all duration-700 font-mono",
                                                    children: "01"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-4 mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "h-[3px] w-12 bg-[#BF092F]"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-[10px] font-black uppercase tracking-[0.6em] text-[#BF092F]",
                                                                    children: "Facility_Detail"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                            className: "text-2xl md:text-3xl font-semibold text-[#44444E] tracking-tighter uppercase leading-none flex flex-col md:flex-row md:items-baseline gap-2",
                                                            children: "Infrastructure Capabilities_"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "mt-5 h-[1px] w-full bg-gray-100"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-lg md:text-xl leading-relaxed text-gray-500 font-medium tracking-tight max-w-4xl",
                                            children: facility.desc
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "space-y-8 relative group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                                            className: "mb-10 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "absolute -left-6 -top-10 text-[130px] font-black text-gray-100/40 select-none pointer-events-none group-hover:text-[#BF092F]/10 transition-all duration-700 font-mono",
                                                    children: "02"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-4 mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "h-[3px] w-12 bg-[#BF092F]"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-[10px] font-black uppercase tracking-[0.6em] text-[#BF092F]",
                                                                    children: "Visual_Telemetry"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                            className: "text-2xl md:text-3xl font-semibold text-[#44444E] tracking-tighter uppercase leading-none flex flex-col md:flex-row md:items-baseline gap-2",
                                                            children: "Site Gallery_"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "mt-7 h-[1px] w-full bg-gray-100"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6",
                                            children: facility.facilityImg.map((src, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("figure", {
                                                    className: "group/img relative aspect-square rounded-[2rem] overflow-hidden bg-gray-50 border border-gray-100 shadow-sm cursor-zoom-in",
                                                    onClick: ()=>openLightbox(index),
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                            src: src,
                                                            className: "w-full h-full object-cover grayscale-[0.3] group-hover/img:grayscale-0 transition-all duration-1000 group-hover/img:scale-110",
                                                            alt: "Facility",
                                                            loading: "lazy"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "absolute inset-0 bg-[#44444E]/40 opacity-0 group-hover/img:opacity-100 transition-all flex items-center justify-center",
                                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $de1c4da7ce3700ef$export$2e2bcd8739ae039), {
                                                                className: "text-white",
                                                                size: 24
                                                            })
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "pt-20 border-t border-gray-100 relative group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                                            className: "mb-10 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "absolute -left-6 -top-10 text-[130px] font-black text-gray-100/40 select-none pointer-events-none group-hover:text-[#BF092F]/10 transition-all duration-700 font-mono",
                                                    children: "03"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-4 mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "h-[3px] w-12 bg-[#BF092F]"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-[10px] font-black uppercase tracking-[0.6em] text-[#BF092F]",
                                                                    children: "Asset_Registry"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                            className: "text-2xl md:text-3xl font-semibold text-[#44444E] tracking-tighter uppercase leading-none flex flex-col md:flex-row md:items-baseline gap-2",
                                                            children: "Tech Machinery_"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "mt-7 h-[1px] w-full bg-gray-100"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-2 gap-10",
                                            children: facility.capabilityImg?.map((cap, index)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                                    className: "group/cap cursor-pointer",
                                                    onClick: ()=>openLightbox(facility.facilityImg.length + index),
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "relative aspect-[16/10] rounded-2xl overflow-hidden mb-6 shadow-md group-hover/cap:shadow-2xl transition-all duration-1000 border border-gray-50",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                                    src: cap.img,
                                                                    className: "w-full h-full object-cover transition-transform duration-1000 group-hover/cap:scale-110",
                                                                    alt: cap.title
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                    className: "absolute bottom-0 left-0 bg-[#BF092F] text-white p-3 rounded-tr-2xl shadow-lg",
                                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                                                        size: 18
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "px-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                                    className: "text-xl font-black text-[#44444E] uppercase tracking-tighter group-hover/cap:text-[#BF092F] transition-colors",
                                                                    children: cap.title
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                    className: "text-gray-500 text-sm font-medium italic mt-2",
                                                                    children: cap.desc
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, index))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]",
                "aria-hidden": "true"
            })
        ]
    });
}
function $3d6cce588754bb8f$var$SidebarStat({ label: label, value: value, icon: icon }) {
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "bg-white/5 p-4 rounded-xl border border-white/5 group hover:border-[#BF092F]/50 transition-colors",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex items-center gap-3 mb-1",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "text-[#BF092F]",
                        "aria-hidden": "true",
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "text-[10px] text-white/30 uppercase tracking-[0.2em] font-bold",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                className: "text-white font-bold tracking-wide",
                children: value
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e95f2feed69b2044$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $e95f2feed69b2044$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("users", $e95f2feed69b2044$export$3efd853dbb351e94);



function $2739a9d4c3b2215f$export$2e2bcd8739ae039() {
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl shadow-xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20",
                                            children: "Careers"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                    className: `font-semibold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: [
                                        "Join Our ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: "Team"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-2",
                                    children: "Powering Innovation & Engineering Excellence"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("main", {
                className: "container mx-auto relative z-30 -translate-y-24",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "pt-30",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: `px-2 lg:col-span-7 space-y-8 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "bg-white px-4 md:px-6 py-8 md:py-10 rounded-2xl shadow-xl border border-gray-100 h-full flex flex-col justify-center",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                    className: "tracking-widest border-l-4 border-[#BF092F] pl-4 mb-8 text-[#44444E] font-bold text-sm uppercase",
                                                    children: "OUR VISION"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-2xl font-medium text-[#44444E] leading-snug",
                                                    children: "At Art GenPower Solutions Ltd, we are always looking for talented individuals to drive the future of power infrastructure."
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "mt-6 text-gray-500 leading-relaxed text-sm",
                                                    children: "From experienced Project Engineers to emerging technical talent, we value precision, integrity, and an uncompromising commitment to quality."
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: `px-2 lg:col-span-5 transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "h-full bg-[#44444E] px-4 md:px-6 py-10 md:py-12 text-white rounded-2xl shadow-2xl relative overflow-hidden group flex flex-col justify-center",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3a2fd91635d2c54c$export$2e2bcd8739ae039), {
                                                    className: "absolute -right-10 -bottom-10 text-white/5 size-48 rotate-12 transition-transform group-hover:rotate-0 duration-700"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "relative z-10",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                            className: "text-3xl font-semibold mb-6 uppercase italic text-[#BF092F]",
                                                            children: "Apply Now"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                            className: "text-white/70 leading-relaxed mb-10 text-sm",
                                                            children: "Submit your CV or reach out to our recruitment desk for current vacancies."
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "group/link border-b border-white/10 pb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-[10px] font-bold text-white/30 uppercase tracking-[0.2em] block mb-2",
                                                                    children: "Primary Recruitment Desk"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("a", {
                                                                    href: "mailto:info@arcengltd.com",
                                                                    className: "flex items-center gap-3 text-xl font-medium hover:text-[#BF092F] transition-colors",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $f0a72ea34a993d6e$export$2e2bcd8739ae039), {
                                                                            size: 20,
                                                                            className: "text-[#BF092F]"
                                                                        }),
                                                                        "info@arcengltd.com"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "px-2 grid grid-cols-1 md:grid-cols-2 gap-6 mt-8",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "bg-white px-4 md:px-6 py-6 rounded-2xl border border-gray-100 flex items-center gap-4 shadow-sm hover:shadow-md transition-shadow",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e95f2feed69b2044$export$2e2bcd8739ae039), {
                                                className: "text-[#BF092F]",
                                                size: 24
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-sm font-medium tracking-wide text-[#44444E] uppercase",
                                                children: "Collaborative Environment"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "bg-white px-4 md:px-6 py-6 rounded-2xl border border-gray-100 flex items-center gap-4 shadow-sm hover:shadow-md transition-shadow",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $90b1c37bd27f04c4$export$2e2bcd8739ae039), {
                                                className: "text-[#BF092F]",
                                                size: 24
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-sm font-medium tracking-wide text-[#44444E] uppercase",
                                                children: "Cutting-Edge Tech"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-gray-200 pt-12 pb-12 px-4 md:px-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "px-2 rounded-2xl flex flex-col gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3a2fd91635d2c54c$export$2e2bcd8739ae039), {
                                        className: "text-[#BF092F]",
                                        size: 32
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                        className: "text-xl text-[#44444E] font-bold uppercase tracking-tight",
                                        children: "CAREER PATHS"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-sm text-gray-500 leading-relaxed",
                                        children: "We offer Project Engineer roles spanning electrical systems, mechanical design, and integrated power solutions."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "rounded-2xl bg-[#44444E] p-8 text-white md:col-span-2 flex flex-col justify-center border-t-4 border-[#BF092F] shadow-xl",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                        className: "text-2xl mb-2 uppercase italic text-[#BF092F] font-bold",
                                        children: "Unified Talent Standard"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-white/70",
                                        children: "Art GenPower Solutions Ltd seeks individuals who embody our core values of technical precision and unwavering reliability in the power sector."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");





var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c279dd8a250f1c3e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
            key: "1t2lqe"
        }
    ],
    [
        "path",
        {
            d: "M10 21.9V14L2.1 9.1",
            key: "o7czzq"
        }
    ],
    [
        "path",
        {
            d: "m10 14 11.9-6.9",
            key: "zm5e20"
        }
    ],
    [
        "path",
        {
            d: "M14 19.8v-8.1",
            key: "159ecu"
        }
    ],
    [
        "path",
        {
            d: "M18 17.5V9.4",
            key: "11uown"
        }
    ]
];
const $c279dd8a250f1c3e$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("container", $c279dd8a250f1c3e$export$3efd853dbb351e94);


function $de26d236376ff0c5$export$2e2bcd8739ae039({ project: project }) {
    const [hover, setHover] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const handleNavigate = ()=>{
        navigate(`/projects/${project.id}`);
    };
    /**
   * Helper to extract a clean string for the preview text, 
   * handling both flat strings and nested arrays in the new API.
   */ const getPreviewDescription = ()=>{
        const desc = project.description?.[0];
        if (Array.isArray(desc)) return desc[0];
        return desc || "Verified industrial deployment and technical installation record.";
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
        className: "group relative flex flex-col h-full bg-white rounded-2xl shadow-xl border border-gray-100 cursor-pointer overflow-hidden transition-all duration-500 hover:shadow-2xl hover:border-[#BF092F]/20 hover:-translate-y-2 hover:scale-[1.02]",
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        onClick: handleNavigate,
        "aria-labelledby": `project-title-${project.id}`,
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "h-64 min-h-[16rem] relative overflow-hidden bg-gray-50 border-b border-gray-50",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                        src: project.imageUrls[0],
                        /* SEO: Descriptive alt text including location and type for image indexing */ alt: `Arc Engineering Project: ${project.name} - ${project.type} installation in ${project.location}`,
                        className: `w-full h-full object-cover grayscale transition-all duration-700 opacity-90 ${hover ? "grayscale-0 scale-110 opacity-100" : ""}`,
                        loading: "lazy"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 bg-gradient-to-t from-white/20 to-transparent",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "p-8 flex flex-col flex-grow",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("address", {
                                        className: "not-italic text-[10px] text-gray-400 font-bold uppercase tracking-[0.2em]",
                                        children: project.location
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                id: `project-title-${project.id}`,
                                className: "text-xl font-bold text-[#44444E] tracking-tight group-hover:text-[#BF092F] transition-colors mb-3 leading-snug min-h-[3.5rem] line-clamp-2",
                                children: project.name
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-[12px] text-gray-400 tracking-widest leading-relaxed line-clamp-3 min-h-[3rem]",
                                children: getPreviewDescription()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mt-auto pt-6 border-t border-gray-100 flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c279dd8a250f1c3e$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-[#BF092F]",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[11px] font-bold text-[#44444E] uppercase tracking-widest",
                                        children: project.type
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-[#BF092F] font-bold text-[11px] uppercase tracking-[0.2em] group-hover:translate-x-1 transition-transform",
                                children: [
                                    "View Project",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                        size: 16,
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: `absolute bottom-0 left-0 h-1 bg-[#BF092F] transition-all duration-500 ${hover ? 'w-full' : 'w-0'}`,
                "aria-hidden": "true"
            })
        ]
    });
}



const $b4e1afa35f5ea44b$var$projectTypes = [
    "All",
    ...(0, $b68fddb3388eb08a$export$39babdfab504f3da).map((cat)=>cat.categoryName)
];
function $b4e1afa35f5ea44b$export$2e2bcd8739ae039() {
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const location = (0, $b11369f2b382bb4b$export$45d76561a5302f2b)();
    const queryParams = new URLSearchParams(location.search);
    const typeQuery = queryParams.get("type") || null;
    const isGeneralOverview = !typeQuery;
    const [selectedType, setSelectedType] = (0, $4Iuzv.useState)(typeQuery || "All");
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    // SEO: Structured Data Schema
    const registrySchema = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "Arc Engineering Project Registry",
        description: "Documenting global deployments and bespoke engineering solutions.",
        url: "https://arcengltd.com/projects"
    };
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
        if (typeQuery) setSelectedType(typeQuery);
        else setSelectedType("All");
    }, [
        typeQuery
    ]);
    const getFilteredProjects = ()=>{
        if (selectedType === "All") return (0, $b68fddb3388eb08a$export$39babdfab504f3da).flatMap((cat)=>cat.projects);
        const category = (0, $b68fddb3388eb08a$export$39babdfab504f3da).find((cat)=>cat.categoryName === selectedType);
        return category ? category.projects : [];
    };
    const filteredProjects = getFilteredProjects();
    const AllProjectsOverview = ()=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "container mx-auto px-4 md:px-6 py-7 relative z-10",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex items-center gap-4 mb-8",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "h-8 w-1 bg-[#BF092F]"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                            className: "text-sm text-[#44444E] uppercase tracking-[0.4em]",
                            children: "Deployment Sectors"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8",
                    children: (0, $b68fddb3388eb08a$export$39babdfab504f3da).map((category)=>{
                        const count = category.projects.length;
                        return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            onClick: ()=>navigate(`/projects?type=${category.categoryName}`),
                            className: "group relative flex flex-col bg-white rounded-2xl shadow-xl border border-gray-100 cursor-pointer overflow-hidden transition-all duration-500 hover:shadow-2xl hover:border-[#BF092F]/20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "h-48 bg-[#44444E] relative overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                            src: category.categoryImage,
                                            alt: category.categoryName,
                                            className: "w-full h-full object-cover opacity-40 grayscale group-hover:grayscale-0 group-hover:scale-110 group-hover:opacity-100 transition-all duration-700"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "absolute inset-0 bg-gradient-to-t from-[#44444E] via-transparent to-transparent opacity-60"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "absolute inset-0 bg-gradient-to-br from-[#BF092F]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "p-8 flex flex-col justify-between flex-grow",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                                    className: "text-xl font-bold text-[#44444E] tracking-tight group-hover:text-[#BF092F] transition-colors mb-3",
                                                    children: [
                                                        category.categoryName,
                                                        " Systems"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-[12px] text-gray-400 tracking-widest leading-relaxed line-clamp-2",
                                                    children: category.categoryDescription
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "mt-8 flex justify-between items-center pt-6 border-t border-gray-100",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            className: "text-[#BF092F]"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                            className: "text-[11px] font-bold text-[#44444E] uppercase tracking-widest",
                                                            children: [
                                                                count,
                                                                " Projects"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "text-gray-300 group-hover:text-[#BF092F] group-hover:translate-x-1 transition-all"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, category.categoryId);
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: isGeneralOverview ? "Engineering Logs | Arc Engineering" : `${selectedType} Series | Arc Engineering`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "Documenting global deployments and bespoke engineering solutions across critical power infrastructure."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(registrySchema)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>navigate("/projects"),
                                            className: `text-[10px] md:text-xs tracking-widest uppercase transition-all duration-300 ${isGeneralOverview ? "bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20" : "cursor-pointer text-white/50 hover:text-white"}`,
                                            children: "Project Registry"
                                        }),
                                        !isGeneralOverview && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $3c47adbabe8a32cb$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-white/20 text-xs font-mono",
                                                    children: ">"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20",
                                                    children: selectedType
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                    className: `font-semibold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`,
                                    children: [
                                        isGeneralOverview ? "Engineering" : selectedType,
                                        " ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: isGeneralOverview ? "Logs" : "Series"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-4 max-w-3xl font-medium",
                                    children: isGeneralOverview ? "Documenting global deployments and bespoke engineering solutions across critical power infrastructure." : (0, $b68fddb3388eb08a$export$39babdfab504f3da).find((c)=>c.categoryName === selectedType)?.categoryDescription || `Technical data for the ${selectedType} infrastructure range.`
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                className: "container mx-auto -translate-y-12 relative z-30",
                children: isGeneralOverview ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "pt-12",
                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(AllProjectsOverview, {})
                }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "pt-20 px-4 flex flex-col lg:grid lg:grid-cols-12 gap-8 items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                            className: "lg:col-span-3 space-y-8 h-full",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "rounded-2xl bg-[#44444E] shadow-2xl border-t-4 border-[#BF092F] sticky top-[20vh] overflow-hidden",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "p-8",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex items-center gap-3 mb-8",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $204a1dc86520e3d2$export$2e2bcd8739ae039), {
                                                    size: 16,
                                                    className: "text-[#BF092F]"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                    className: "text-[12px] text-white tracking-[0.4em] uppercase",
                                                    children: "Filter Logs"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "lg:hidden relative",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("select", {
                                                value: selectedType,
                                                onChange: (e)=>navigate(`/projects?type=${e.target.value}`),
                                                className: "w-full bg-white/5 border border-white/10 text-white text-[12px] uppercase tracking-[0.2em] px-4 py-4 rounded-xl cursor-pointer focus:outline-none focus:border-[#BF092F]",
                                                children: $b4e1afa35f5ea44b$var$projectTypes.map((type)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                        value: type,
                                                        className: "bg-[#44444E]",
                                                        children: type
                                                    }, type))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                            className: "hidden lg:block space-y-2",
                                            children: $b4e1afa35f5ea44b$var$projectTypes.map((type, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                                    onClick: ()=>navigate(`/projects?type=${type}`),
                                                    className: `cursor-pointer px-4 py-4 rounded-xl text-[12px] uppercase tracking-[0.2em] transition-all flex items-center justify-between group ${selectedType === type ? "bg-white/10 text-white border-l-4 border-[#BF092F]" : "text-white/40 hover:text-white hover:bg-white/5"}`,
                                                    children: [
                                                        type,
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            className: `transition-transform duration-300 ${selectedType === type ? "text-[#BF092F] translate-x-1" : "opacity-0 group-hover:opacity-100"}`
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("section", {
                            className: "lg:col-span-9",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-gray-100 min-h-[600px]",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center justify-between mb-12 border-b border-gray-100 pb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                className: "tracking-widest border-l-4 border-[#BF092F] pl-4 text-[#44444E] uppercase text-sm font-bold",
                                                children: "Active Deployments"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                className: "text-xs font-mono text-gray-400 uppercase tracking-widest font-bold",
                                                children: [
                                                    "Records: ",
                                                    filteredProjects.length
                                                ]
                                            })
                                        ]
                                    }),
                                    filteredProjects.length > 0 ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 gap-8",
                                        children: filteredProjects.map((project)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $de26d236376ff0c5$export$2e2bcd8739ae039), {
                                                project: project
                                            }, project.id))
                                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "py-20 text-center",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-gray-400 uppercase tracking-[0.3em] text-sm",
                                            children: "No Projects Found In This Category"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");


/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ee446b325d4cf308$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
            key: "vktsd0"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "kqv944"
        }
    ]
];
const $ee446b325d4cf308$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("tag", $ee446b325d4cf308$export$3efd853dbb351e94);



function $2165d4d91a7da09f$export$2e2bcd8739ae039() {
    const { id: id } = (0, $b11369f2b382bb4b$export$99eaa27ddbbb95ef)();
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const project = (0, $b68fddb3388eb08a$export$39babdfab504f3da).flatMap((cat)=>cat.projects).find((p)=>String(p.id) === id);
    const [lightboxOpen, setLightboxOpen] = (0, $4Iuzv.useState)(false);
    const [currentIndex, setCurrentIndex] = (0, $4Iuzv.useState)(0);
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const scrollContainerRef = (0, $4Iuzv.useRef)(null);
    const scroll = (direction)=>{
        if (scrollContainerRef.current) {
            const { clientWidth: clientWidth } = scrollContainerRef.current;
            const scrollAmount = direction === "left" ? -clientWidth : clientWidth;
            scrollContainerRef.current.scrollBy({
                left: scrollAmount,
                behavior: "smooth"
            });
        }
    };
    // Find current category and projects (from previous step)
    const currentCategory = (0, $b68fddb3388eb08a$export$39babdfab504f3da).find((cat)=>cat.projects.some((p)=>String(p.id) === id));
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
    }, [
        id
    ]);
    // SEO: Technical Log Schema
    const technicalLogSchema = project ? {
        "@context": "https://schema.org",
        "@type": "TechArticle",
        headline: project.name,
        image: project.imageUrls,
        author: {
            "@type": "Organization",
            name: "Arc Engineering Solutions Ltd"
        },
        description: Array.isArray(project.description[0]) ? project.description[1] : project.description[0],
        publisher: {
            "@type": "Organization",
            name: "Arc Engineering Solutions Ltd",
            logo: {
                "@type": "ImageObject",
                url: "https://arcengltd.com/logo.png"
            }
        }
    } : null;
    const showNext = (0, $4Iuzv.useCallback)((e)=>{
        e?.stopPropagation();
        if (project?.imageUrls) setCurrentIndex((prev)=>(prev + 1) % project.imageUrls.length);
    }, [
        project?.imageUrls
    ]);
    const showPrev = (0, $4Iuzv.useCallback)((e)=>{
        e?.stopPropagation();
        if (project?.imageUrls) setCurrentIndex((prev)=>(prev - 1 + project.imageUrls.length) % project.imageUrls.length);
    }, [
        project?.imageUrls
    ]);
    const getRandomProjects = (0, $4Iuzv.useCallback)(()=>{
        let siblings = currentCategory?.projects.filter((p)=>String(p.id) !== id) || [];
        let others = (0, $b68fddb3388eb08a$export$39babdfab504f3da).filter((cat)=>cat.categoryName !== currentCategory?.categoryName).flatMap((cat)=>cat.projects);
        const shuffle = (array)=>[
                ...array
            ].sort(()=>Math.random() - 0.5);
        // Combine all, shuffle, and take the top 5
        return shuffle([
            ...siblings,
            ...others
        ]).slice(0, 5);
    }, [
        id,
        currentCategory,
        (0, $b68fddb3388eb08a$export$39babdfab504f3da)
    ]);
    const [relatedProjects, setRelatedProjects] = (0, $4Iuzv.useState)([]);
    (0, $4Iuzv.useEffect)(()=>{
        setRelatedProjects(getRandomProjects());
    }, [
        id,
        getRandomProjects
    ]);
    (0, $4Iuzv.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (!lightboxOpen) return;
            if (e.key === "Escape") closeLightbox();
            if (e.key === "ArrowRight") showNext();
            if (e.key === "ArrowLeft") showPrev();
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, [
        lightboxOpen,
        showNext,
        showPrev
    ]);
    if (!project) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen flex flex-col items-center justify-center bg-[#F8F9FA]",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                className: "text-4xl font-bold text-[#44444E]",
                children: "404 // LOG_NOT_FOUND"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                onClick: ()=>navigate("/projects"),
                className: "mt-6 px-8 py-3 bg-[#BF092F] text-white rounded-xl font-bold",
                children: "Return to Terminal"
            })
        ]
    });
    const openLightbox = (index)=>{
        setCurrentIndex(index);
        setLightboxOpen(true);
        document.body.style.overflow = "hidden";
    };
    const closeLightbox = ()=>{
        setLightboxOpen(false);
        document.body.style.overflow = "unset";
    };
    const specs = [
        {
            label: "Client",
            value: project?.client,
            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2f654b16da3c707a$export$2e2bcd8739ae039), {
                size: 16
            })
        },
        {
            label: "Category",
            value: project?.type,
            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ee446b325d4cf308$export$2e2bcd8739ae039), {
                size: 16
            })
        },
        {
            label: "Location",
            value: project?.location,
            icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                size: 16
            })
        }
    ];
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: `${project.name} | Case Study | Arc Engineering`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: `Technical field log for ${project.name} in ${project.location}. Deployment of ${project.type} systems by Arc Engineering.`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(technicalLogSchema)
                    })
                ]
            }),
            lightboxOpen && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "fixed inset-0 z-[100] flex items-center justify-center bg-[#1A1A1E]/95 backdrop-blur-xl p-4",
                onClick: closeLightbox,
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                        onClick: closeLightbox,
                        className: "cursor-pointer absolute top-10 right-10 text-white/50 hover:text-[#BF092F] transition-all z-[110] group",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6ceff59181ea43fa$export$2e2bcd8739ae039), {
                            size: 40,
                            className: "group-hover:rotate-90 transition-transform"
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "max-w-7xl w-full flex flex-col items-center gap-2 md:gap-6",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "relative flex items-center justify-center group px-0 md:px-24",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: showPrev,
                                        className: "cursor-pointer absolute left-0 text-white/20 hover:text-[#BF092F] transition-all p-2 z-[110] hover:scale-110",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                            size: 60,
                                            strokeWidth: 1
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "relative border border-white/10 shadow-2xl rounded-2xl overflow-hidden",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                            src: project.imageUrls[currentIndex],
                                            className: "max-h-[70vh] md:max-h-[65vh] w-auto block select-none",
                                            alt: "Technical View"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: showNext,
                                        className: "cursor-pointer absolute right-0 text-white/20 hover:text-[#BF092F] transition-all p-2 z-[110] hover:scale-110",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                            size: 60,
                                            strokeWidth: 1
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "w-full max-w-4xl bg-[#44444E] border border-white/10 p-3 md:p-6 rounded-2xl shadow-2xl shrink-0",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "flex items-start justify-between gap-4 md:gap-8",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex-1",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-3 mb-1 md:mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "h-4 w-1 bg-[#BF092F]"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                            className: "text-white font-black uppercase tracking-widest text-[10px] md:text-sm",
                                                            children: "Field Documentation View"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                                    className: "text-white/60 leading-relaxed text-[11px] md:text-base italic",
                                                    children: [
                                                        "Project: ",
                                                        project.name
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "text-right shrink-0",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                className: "text-white/40 text-[10px] md:text-[12px] tracking-tighter font-black",
                                                children: [
                                                    currentIndex + 1,
                                                    " / ",
                                                    project.imageUrls.length
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>navigate("/projects"),
                                            className: "cursor-pointer text-[10px] md:text-xs tracking-widest uppercase text-white/50 hover:text-white transition-colors",
                                            children: "Project Registry"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            onClick: ()=>navigate(`/projects?type=${project.type}`),
                                            className: "cursor-pointer text-[10px] md:text-xs tracking-widest uppercase text-white/50 hover:text-white transition-colors",
                                            children: project.type
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20",
                                            children: project.name.length > 25 ? `${project.name.substring(0, 25)}...` : project.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                                    className: `font-semibold text-3xl md:text-5xl lg:text-6xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: project.name
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                    className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-4 max-w-3xl font-medium",
                                    children: [
                                        "Technical field log and deployment data for site ID: ",
                                        project.id,
                                        "."
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                className: "container mx-auto -translate-y-12 relative z-30 pb-20",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "pt-20 px-4 flex flex-col lg:grid lg:grid-cols-12 gap-8 items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                            className: "lg:col-span-4 space-y-8",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "rounded-2xl bg-[#44444E] shadow-2xl border-t-4 border-[#BF092F] sticky top-[20vh] overflow-hidden transition-all duration-500",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "p-5 border-b border-white/10 w-full overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("label", {
                                                htmlFor: "project-switcher",
                                                className: "text-[9px] text-white/30 uppercase tracking-[0.2em] font-black block mb-3",
                                                children: "Project Registry"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "relative group w-full max-w-full",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("select", {
                                                        id: "project-switcher",
                                                        value: id,
                                                        onChange: (e)=>navigate(`/projects/${e.target.value}`),
                                                        className: "w-full max-w-full bg-white/5 border border-white/10 pl-4 pr-12 py-3 rounded-xl  text-white text-sm font-bold appearance-none cursor-pointer  focus:outline-none focus:ring-1 focus:ring-[#BF092F] transition-all  hover:bg-white/10 truncate box-border",
                                                        style: {
                                                            textOverflow: "ellipsis"
                                                        },
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("optgroup", {
                                                            label: currentCategory?.categoryName || "Categories",
                                                            className: "bg-[#1A1A1E]",
                                                            children: currentCategory?.projects.map((p)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("option", {
                                                                    value: p.id,
                                                                    className: "bg-[#1A1A1E] text-white",
                                                                    children: [
                                                                        p.id,
                                                                        " | ",
                                                                        p.name
                                                                    ]
                                                                }, p.id))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "absolute right-0 top-0 bottom-0 flex items-center pr-3 pointer-events-none",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "h-2/3 border-l border-white/10 pl-3 flex items-center",
                                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                                size: 14,
                                                                className: "rotate-90 text-[#BF092F] opacity-70 group-hover:opacity-100"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "p-6 lg:p-8 flex flex-col gap-4 cursor-pointer lg:cursor-default border-b border-white/10",
                                        onClick: ()=>{
                                            if (window.innerWidth < 1024) {
                                                const content = document.getElementById("specs-content");
                                                const preview = document.getElementById("mobile-preview");
                                                content.classList.toggle("hidden");
                                                preview.classList.toggle("hidden");
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-center gap-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $52df24fc950c96b6$export$2e2bcd8739ae039), {
                                                                size: 16,
                                                                className: "text-[#BF092F]"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                                className: "text-[12px] text-white tracking-[0.4em] uppercase font-bold",
                                                                children: "Technical Specs"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                        size: 18,
                                                        className: "text-white/40 lg:hidden transform rotate-90"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                id: "mobile-preview",
                                                className: "flex flex-col gap-2 lg:hidden border-t border-white/5 pt-4",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("dl", {
                                                    className: "flex flex-col gap-2",
                                                    children: [
                                                        " ",
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2f654b16da3c707a$export$2e2bcd8739ae039), {
                                                                    size: 12,
                                                                    className: "text-[#BF092F]",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("dt", {
                                                                    className: "text-[10px] text-white/50 uppercase font-bold tracking-wider",
                                                                    children: "Client:"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("dd", {
                                                                    className: "text-[10px] text-white font-bold",
                                                                    children: project?.client
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ee446b325d4cf308$export$2e2bcd8739ae039), {
                                                                    size: 12,
                                                                    className: "text-[#BF092F]",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("dt", {
                                                                    className: "text-[10px] text-white/50 uppercase font-bold tracking-wider",
                                                                    children: "Category:"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("dd", {
                                                                    className: "text-[10px] text-white font-bold",
                                                                    children: project?.type
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        id: "specs-content",
                                        className: "hidden lg:block",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "p-8 space-y-4",
                                                children: specs.map((spec, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "bg-white/5 p-4 rounded-xl border border-white/5 hover:border-[#BF092F]/50 transition-colors",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                className: "flex items-center gap-3 mb-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                        className: "text-[#BF092F]",
                                                                        children: spec.icon
                                                                    }),
                                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                        className: "text-[10px] text-white/30 uppercase tracking-[0.2em] font-bold",
                                                                        children: spec.label
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-white font-bold tracking-wide",
                                                                children: spec.value
                                                            })
                                                        ]
                                                    }, i))
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "p-8 bg-black/20",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                                    onClick: ()=>navigate(`/projects?type=${project.type}`),
                                                    className: "cursor-pointer w-full py-4 bg-[#BF092F] text-white text-[11px] font-bold uppercase tracking-[0.3em] rounded-xl flex items-center justify-center gap-2 hover:bg-white hover:text-[#44444E] transition-all shadow-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ba8bf023ef8fc70d$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        " Back to Registry"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
                            className: "lg:col-span-8 space-y-16 md:space-y-24 lg:pl-12 xl:pl-20 py-10 px-4 sm:px-6 lg:px-0",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "relative group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                                            className: "mb-5 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "absolute -left-6 -top-10 text-[130px] font-black text-gray-100/40 select-none pointer-events-none group-hover:text-[#BF092F]/10 transition-all duration-700 font-mono",
                                                    children: "01"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-4 mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "h-[3px] w-12 bg-[#BF092F]"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-[10px] font-black uppercase tracking-[0.6em] text-[#BF092F]",
                                                                    children: "Technical_Summary"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                            className: "text-2xl md:text-3xl font-semibold text-[#44444E] tracking-tighter uppercase leading-none flex flex-col md:flex-row md:items-baseline gap-2",
                                                            children: "Project Brief_"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "mt-5 h-[1px] w-full bg-gray-100"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "grid grid-cols-1 gap-8",
                                            children: project.description.map((desc, idx)=>Array.isArray(desc) ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "grid sm:grid-cols-2 gap-px bg-gray-100 border border-gray-100 rounded-3xl overflow-hidden shadow-sm",
                                                    children: desc.map((item, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "bg-white p-8 hover:bg-gray-50 transition-colors group",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                                                                    className: "text-[9px] font-black text-[#BF092F] mb-3 tracking-widest uppercase opacity-50 group-hover:opacity-100 transition-opacity",
                                                                    children: [
                                                                        "Feature_0",
                                                                        i + 1
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                    className: "text-sm font-bold text-[#44444E] leading-relaxed uppercase tracking-normal",
                                                                    children: item
                                                                })
                                                            ]
                                                        }, i))
                                                }, idx) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "relative",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                        className: "text-lg md:text-xl leading-relaxed text-gray-500 font-medium tracking-tight max-w-3xl",
                                                        children: desc
                                                    })
                                                }, idx))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "space-y-8 relative group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                                            className: "mb-10 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "absolute -left-6 -top-10 text-[130px] font-black text-gray-100/40 select-none pointer-events-none group-hover:text-[#BF092F]/10 transition-all duration-700 font-mono",
                                                    children: "02"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-4 mb-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "h-[3px] w-12 bg-[#BF092F]"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                    className: "text-[10px] font-black uppercase tracking-[0.6em] text-[#BF092F]",
                                                                    children: "Visual_Data_Logs"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                            className: "text-2xl md:text-3xl font-semibold text-[#44444E] tracking-tighter uppercase leading-none flex flex-col md:flex-row md:items-baseline gap-2",
                                                            children: "Field Gallery_"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                            className: "mt-7 h-[1px] w-full bg-gray-100"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "relative group aspect-[16/10] md:aspect-video rounded-2xl overflow-hidden bg-gray-50 border border-gray-100 shadow-2xl cursor-zoom-in",
                                            onClick: ()=>openLightbox(currentIndex),
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                    src: project.imageUrls[currentIndex],
                                                    className: "w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105",
                                                    alt: "Technical View"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            showPrev();
                                                        },
                                                        className: "cursor-pointer p-4 text-white hover:text-[#BF092F] transition-colors",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                                            size: 32,
                                                            strokeWidth: 1
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            showNext();
                                                        },
                                                        className: "cursor-pointer p-4 text-white hover:text-[#BF092F] transition-colors",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                            size: 32,
                                                            strokeWidth: 1
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "absolute bottom-8 right-8 px-5 py-2.5 bg-white/90 backdrop-blur-md rounded-2xl shadow-xl flex items-center gap-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $de1c4da7ce3700ef$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            className: "text-[#BF092F]"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-[9px] font-black uppercase tracking-widest text-[#44444E]",
                                                            children: "Expand View"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "flex gap-4 overflow-x-auto py-4 scrollbar-hide px-2",
                                            children: project.imageUrls.map((url, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                    onClick: ()=>setCurrentIndex(i),
                                                    className: `cursor-pointer relative shrink-0 w-28 h-18 rounded-2xl overflow-hidden transition-all duration-500 ${i === currentIndex ? "ring-2 ring-[#BF092F] ring-offset-4 scale-95" : "opacity-30 hover:opacity-100 grayscale hover:grayscale-0"}`,
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                        src: url,
                                                        className: "w-full h-full object-cover",
                                                        alt: "Thumbnail"
                                                    })
                                                }, i))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "space-y-8 relative group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                                            className: "mb-10 relative",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "absolute -left-6 -top-10 text-[130px] font-black text-gray-100/40 select-none pointer-events-none group-hover:text-[#BF092F]/10 transition-all duration-700 font-mono",
                                                    children: "03"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "relative flex flex-col md:flex-row md:items-end justify-between gap-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                    className: "flex items-center gap-4 mb-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                            className: "h-[3px] w-12 bg-[#BF092F]"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                            className: "text-[10px] font-black uppercase tracking-[0.6em] text-[#BF092F]",
                                                                            children: "Archive_Discovery"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                                    className: "text-2xl md:text-3xl font-semibold text-[#44444E] tracking-tighter uppercase leading-none flex flex-col md:flex-row md:items-baseline gap-2",
                                                                    children: "Related Logs_"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex gap-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                                    onClick: ()=>scroll("left"),
                                                                    className: "cursor-pointer w-12 h-12 rounded-full border border-gray-100 flex items-center justify-center hover:bg-[#BF092F] hover:text-white transition-all shadow-sm hover:shadow-lg hover:shadow-[#BF092F]/20",
                                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $604caf45884f5678$export$2e2bcd8739ae039), {
                                                                        size: 18
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                                                    onClick: ()=>scroll("right"),
                                                                    className: "cursor-pointer w-12 h-12 rounded-full border border-gray-100 flex items-center justify-center hover:bg-[#BF092F] hover:text-white transition-all shadow-sm hover:shadow-lg hover:shadow-[#BF092F]/20",
                                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                                        size: 18
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    className: "mt-7 h-[1px] w-full bg-gray-100"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            ref: scrollContainerRef,
                                            className: "flex gap-10 overflow-x-auto pb-10 scrollbar-hide snap-x",
                                            children: relatedProjects.map((item)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    onClick: ()=>navigate(`/projects/${item.id}`),
                                                    className: "cursor-pointer group/card shrink-0 w-[85vw] md:w-[420px] snap-start relative",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "relative aspect-[16/10] rounded-2xl overflow-hidden mb-6 shadow-sm group-hover/card:shadow-2xl transition-all duration-700 bg-gray-100",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                                    src: item.imageUrls[0],
                                                                    className: "w-full h-full object-cover transition-transform duration-1000 group-hover/card:scale-110 ",
                                                                    alt: item.name
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                    className: "absolute inset-0 bg-gradient-to-t from-[#44444E]/60 to-transparent group-hover/card:opacity-0 transition-opacity duration-500"
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                    className: "absolute top-4 left-4 px-3 py-1.5 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg translate-y-2 opacity-0 group-hover/card:translate-y-0 group-hover/card:opacity-100 transition-all duration-500",
                                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                        className: "text-[8px] font-black text-white uppercase tracking-[0.2em]",
                                                                        children: item.type
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                    className: "absolute bottom-4 right-4 w-6 h-6 border-r-2 border-b-2 border-white/30 group-hover/card:border-[#BF092F] transition-colors duration-500"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "relative pl-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                    className: "flex items-center gap-2 mb-3",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                            className: "text-[10px] uppercase font-bold text-[#BF092F] bg-[#BF092F]/5 px-2 py-0.5 rounded",
                                                                            children: item.type
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                            className: "h-px w-8 bg-gray-100 group-hover/card:w-12 group-hover/card:bg-[#BF092F]/30 transition-all duration-500"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                                    className: "text-xl font-bold text-[#44444E] uppercase tracking-tighter leading-tight group-hover/card:text-[#BF092F] transition-colors duration-300",
                                                                    children: item.name
                                                                }),
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                                    className: "flex items-center gap-2 mt-4 opacity-0 -translate-x-4 group-hover/card:opacity-100 group-hover/card:translate-x-0 transition-all duration-500 delay-75",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                            className: "text-[10px] font-black uppercase tracking-widest text-gray-400",
                                                                            children: "VIEW_PROJECT_LOG"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                                            size: 14,
                                                                            className: "text-[#BF092F]"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.id))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]",
                "aria-hidden": "true"
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9102b08aefb321b4$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $9102b08aefb321b4$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("info", $9102b08aefb321b4$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e51bb68e0d76a8d2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
            key: "e7tb2h"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "22",
            y2: "12",
            key: "a4e8g8"
        }
    ],
    [
        "circle",
        {
            cx: "18.5",
            cy: "15.5",
            r: "2.5",
            key: "b5zd12"
        }
    ],
    [
        "path",
        {
            d: "M20.27 17.27 22 19",
            key: "1l4muz"
        }
    ]
];
const $e51bb68e0d76a8d2$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("package-search", $e51bb68e0d76a8d2$export$3efd853dbb351e94);





var $4Iuzv = parcelRequire("4Iuzv");
const $1827938f424989d8$export$21d125155bb0f111 = [
    {
        title: "AutoCAD",
        description: "Advanced engineering design tools used for precise 2D drafting, 3D modeling, and structural computations.",
        image: "https://media.arcengltd.com/skill-images/AutoCAD.webp"
    },
    {
        title: "Solid Works",
        description: "Hands-on expertise in structural analysis, piping layouts, skid design, and engineering optimization.",
        image: "https://media.arcengltd.com/skill-images/SolidWorks.webp"
    },
    {
        title: "STAAD.Pro",
        description: "High-end CAD and CAE tools enabling efficient design workflows and detailed model visualization.",
        image: "https://media.arcengltd.com/skill-images/STAAD.Pro.webp"
    },
    {
        title: "3D Solid Modelling",
        description: "Comprehensive modelling and documentation tools used across mechanical, civil, and energy sectors.",
        image: "https://media.arcengltd.com/skill-images/3D_Solid_Modelling.webp"
    },
    {
        title: "2D Technical Documentation",
        description: "Professional-grade drafting, analysis, and documentation applications for engineering teams.",
        image: "https://media.arcengltd.com/skill-images/2D_Technical_Documentation.webp"
    },
    {
        title: "Structural Analysis",
        description: "Advanced simulation and validation tools for structural and mechanical designs.",
        image: "https://media.arcengltd.com/skill-images/Structural_Analysis.webp"
    },
    {
        title: "Piping Design",
        description: "Specialized software for piping, instrumentation, and CAD optimization.",
        image: "https://media.arcengltd.com/skill-images/Piping_Design.webp"
    },
    {
        title: "Skid & Packaging Design",
        description: "3D CAD tools for assembly, analysis, and detailed project documentation.",
        image: "https://media.arcengltd.com/skill-images/Skid_Packaging_Design.webp"
    },
    {
        title: "Value Engineering",
        description: "Simulation tools for civil and structural engineering projects.",
        image: "https://media.arcengltd.com/skill-images/Value_Engineering.webp"
    },
    {
        title: "Advanced Design Infrastructure",
        description: "Collaboration-focused CAD suite for multi-discipline engineering teams.",
        image: "https://media.arcengltd.com/skill-images/Advance_Design_Infrastructure.webp"
    }
];




const $1449da937569f1f7$export$e7c6dfb55e24bf33 = [
    {
        title: "E-Houses & Switchgear",
        subtitle: "Integrated Power Distribution",
        icon: (0, $90b1c37bd27f04c4$export$2e2bcd8739ae039),
        img: "https://res.cloudinary.com/dc912sjxj/image/upload/v1768330248/E-House_E-Pod_Art_Genpower_Solutions_Ltd_ESI_02_kq90fj.webp"
    },
    {
        title: "Acoustic Enclosures",
        subtitle: "Noise Suppression Systems",
        icon: (0, $74612ecec2deb067$export$2e2bcd8739ae039),
        img: "https://res.cloudinary.com/dc912sjxj/image/upload/v1768329341/Art_Genpower_Solutions_Ltd_ESI_Container_02_axoz6j.webp"
    },
    {
        title: "Custom Fuel Systems",
        subtitle: "Critical Supply & Management",
        icon: (0, $937c5640447fbab0$export$2e2bcd8739ae039),
        img: "https://res.cloudinary.com/dc912sjxj/image/upload/v1768331854/Pump_Skids_and_Chemical_Injection_Art_Genpower_Solutions_Ltd___ESI_03_jdh8w1.webp"
    }
];
const $1449da937569f1f7$export$b079994e1de5a808 = [
    {
        icon: (0, $90b1c37bd27f04c4$export$2e2bcd8739ae039),
        title: "Bespoke Engineering",
        desc: "Specializing in E-Houses, power modules, and custom generator packaging tailored to extreme industrial specs."
    },
    {
        icon: (0, $37581b884d168f82$export$2e2bcd8739ae039),
        title: "Global Production",
        desc: "Leveraging high-capacity manufacturing terminals to deliver large-scale infrastructure across UK and Europe."
    },
    {
        icon: (0, $e1dea707e9b51b32$export$2e2bcd8739ae039),
        title: "QA Compliance",
        desc: "Every project undergoes rigorous Factory Acceptance Testing (FAT) to ensure ISO-certified reliability."
    }
];
const $1449da937569f1f7$export$d8e0752bfe0e6e6d = "https://res.cloudinary.com/dc912sjxj/image/upload/b_white,f_auto,q_auto,c_pad,w_700,h_500/v1773164178/agp-placeholder-logo_uke2bq.webp";


function $be253a6164c93d9b$export$2e2bcd8739ae039() {
    const [selected, setSelected] = (0, $4Iuzv.useState)(0);
    const [imageLoaded, setImageLoaded] = (0, $4Iuzv.useState)(false);
    const sectionRef = (0, $4Iuzv.useRef)(null);
    const [hasRevealed, setHasRevealed] = (0, $4Iuzv.useState)(false);
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setHasRevealed(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    (0, $4Iuzv.useEffect)(()=>{
        setImageLoaded(false);
        const timer = setTimeout(()=>setImageLoaded(true), 50);
        return ()=>clearTimeout(timer);
    }, [
        selected
    ]);
    const reveal = (isVisible, delay = "0ms")=>({
            transform: isVisible ? "translateY(0)" : "translateY(30px)",
            opacity: isVisible ? 1 : 0,
            transition: `all 1000ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}`
        });
    const firstHalf = (0, $1827938f424989d8$export$21d125155bb0f111).slice(0, 5);
    const secondHalf = (0, $1827938f424989d8$export$21d125155bb0f111).slice(5);
    const renderTab = (skill, actualIndex)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
            role: "tab",
            "aria-selected": selected === actualIndex,
            "aria-controls": `skill-panel-${actualIndex}`,
            id: `skill-tab-${actualIndex}`,
            onClick: ()=>setSelected(actualIndex),
            className: `cursor-pointer group relative px-6 py-5 text-left transition-all duration-300 border-b border-white/5 flex items-center justify-between w-full ${selected === actualIndex ? "bg-white text-[#44444E]" : "bg-transparent text-white/40 hover:text-white hover:bg-white/5"}`,
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                            className: `text-[8px] font-black uppercase tracking-[0.3em] mb-1 ${selected === actualIndex ? "text-[#BF092F]" : "text-white/20"}`,
                            children: [
                                "MODULE 0",
                                actualIndex + 1
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                            className: "text-[11px] font-bold uppercase tracking-[0.2em]",
                            children: skill.title
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: `w-1.5 h-1.5 rounded-full transition-all ${selected === actualIndex ? "bg-[#BF092F] scale-125" : "bg-white/10"}`,
                    "aria-hidden": "true"
                }),
                selected === actualIndex && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "absolute left-0 top-0 bottom-0 w-1 bg-[#BF092F]",
                    "aria-hidden": "true"
                })
            ]
        }, actualIndex);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative bg-white py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-20 overflow-hidden border-t border-gray-100",
        "aria-labelledby": "skills-heading",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                type: "application/ld+json",
                children: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Service",
                    name: "Arc Engineering Technical Capabilities",
                    description: "BS EN compliant engineering proficiency across UK-standard design and manufacturing.",
                    hasOfferCatalog: {
                        "@type": "OfferCatalog",
                        name: "Engineering Skills",
                        itemListElement: (0, $1827938f424989d8$export$21d125155bb0f111).map((s, i)=>({
                                "@type": "Offer",
                                itemOffered: {
                                    "@type": "Service",
                                    name: s.title,
                                    description: s.description
                                }
                            }))
                    }
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute top-10 right-[-5%] md:right-[-2%] text-[8rem] sm:text-[12rem] md:text-[15rem] font-black text-gray-50 select-none pointer-events-none tracking-tighter uppercase leading-none z-0",
                "aria-hidden": "true",
                children: "TECH"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: "flex flex-col md:flex-row md:items-end justify-between mb-16 md:mb-20 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                style: reveal(hasRevealed),
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "w-12 h-[2px] bg-[#BF092F]",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] tracking-[0.4em] text-[#BF092F] font-bold uppercase",
                                                children: "Technical Capabilities"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                        id: "skills-heading",
                                        className: "text-3xl sm:text-4xl md:text-6xl font-bold text-[#44444E] leading-[1.1] tracking-tight",
                                        children: [
                                            "Engineering ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-gray-300 font-light",
                                                children: "Technical"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Toolkit."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "max-w-sm",
                                style: reveal(hasRevealed, "200ms"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-xs sm:text-sm text-gray-400 uppercase tracking-widest leading-relaxed border-l border-gray-100 pl-6 py-1",
                                    children: "BS EN compliant engineering proficiency across UK-standard design, precision manufacturing, and mission-critical systems."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("nav", {
                        className: "lg:hidden flex overflow-x-auto pb-6 mb-4 gap-2 scrollbar-hide snap-x",
                        "aria-label": "Technical modules",
                        children: (0, $1827938f424989d8$export$21d125155bb0f111).map((skill, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                onClick: ()=>setSelected(idx),
                                className: `shrink-0 px-6 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest border transition-all active:scale-95 ${selected === idx ? "bg-[#BF092F] border-[#BF092F] text-white shadow-lg shadow-red-100" : "bg-white border-gray-200 text-gray-400"}`,
                                children: skill.title
                            }, idx))
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                        className: "grid grid-cols-1 lg:grid-cols-12 shadow-2xl rounded-2xl md:rounded-[2.5rem] overflow-hidden border border-gray-100 bg-[#44444E]",
                        style: reveal(hasRevealed, "400ms"),
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("aside", {
                                className: "hidden lg:flex lg:col-span-3 bg-[#44444E] flex-col border-r border-white/5 h-full",
                                role: "tablist",
                                "aria-orientation": "vertical",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "p-6 border-b border-white/10 bg-black/10",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                            className: "text-[9px] font-black text-white/30 uppercase tracking-[0.4em]",
                                            children: "Design & Integration"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "flex-1 overflow-y-auto scrollbar-hide",
                                        children: firstHalf.map((skill, index)=>renderTab(skill, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("figure", {
                                className: "lg:col-span-6 relative aspect-[4/5] md:aspect-video lg:aspect-auto lg:h-[600px] bg-[#1A1A1E] overflow-hidden",
                                id: `skill-panel-${selected}`,
                                role: "tabpanel",
                                "aria-labelledby": `skill-tab-${selected}`,
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                        src: (0, $1827938f424989d8$export$21d125155bb0f111)[selected].image,
                                        alt: `Arc Engineering specialist capability: ${(0, $1827938f424989d8$export$21d125155bb0f111)[selected].title}`,
                                        className: `w-full h-full object-cover transition-all duration-1000 ${imageLoaded ? "opacity-60 scale-100" : "opacity-0 scale-105"}`,
                                        loading: "lazy"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("figcaption", {
                                        className: "absolute bottom-0 left-0 right-0 p-8 md:p-12 bg-gradient-to-t from-black via-black/80 to-transparent",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center gap-3 mb-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $52df24fc950c96b6$export$2e2bcd8739ae039), {
                                                        className: "text-[#BF092F]",
                                                        size: 18,
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("span", {
                                                        className: "text-[10px] font-black text-white uppercase tracking-[0.4em]",
                                                        children: [
                                                            "Active Module: ",
                                                            (0, $1827938f424989d8$export$21d125155bb0f111)[selected].title
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-white text-sm md:text-lg font-medium leading-relaxed max-w-xl italic border-l-2 border-[#BF092F] pl-6",
                                                children: (0, $1827938f424989d8$export$21d125155bb0f111)[selected].description
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("aside", {
                                className: "hidden lg:flex lg:col-span-3 bg-[#44444E] flex-col h-full",
                                role: "tablist",
                                "aria-orientation": "vertical",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "p-6 border-b border-white/10 bg-black/10",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                            className: "text-[9px] font-black text-white/30 uppercase tracking-[0.4em]",
                                            children: "Manufacturing & Scale"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "flex-1 overflow-y-auto scrollbar-hide",
                                        children: secondHalf.map((skill, index)=>renderTab(skill, index + 5))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("footer", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-12 md:mt-16",
                        style: reveal(hasRevealed, "600ms"),
                        children: (0, $1449da937569f1f7$export$b079994e1de5a808).map((tenet, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "bg-white p-8 lg:p-10 rounded-3xl shadow-xl border border-gray-50 transition-all hover:shadow-2xl hover:border-[#BF092F]/10 group",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-14 h-14 bg-gray-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-[#BF092F]/5 transition-colors",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(tenet.icon, {
                                            className: "text-[#BF092F]",
                                            size: 32,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                className: "text-sm font-black text-[#44444E] uppercase mb-4 tracking-widest",
                                                children: tenet.title
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[11px] font-bold text-gray-400 uppercase tracking-[0.2em] leading-relaxed",
                                                children: tenet.desc
                                            })
                                        ]
                                    })
                                ]
                            }, idx))
                    })
                ]
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");
/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $11189a96f8661453$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M7 7h10v10",
            key: "1tivn9"
        }
    ],
    [
        "path",
        {
            d: "M7 17 17 7",
            key: "1vkiza"
        }
    ]
];
const $11189a96f8661453$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("arrow-up-right", $11189a96f8661453$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $76e1a9e2a8898432$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
            key: "1b4qmf"
        }
    ],
    [
        "path",
        {
            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
            key: "i71pzd"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
            key: "10jefs"
        }
    ],
    [
        "path",
        {
            d: "M10 6h4",
            key: "1itunk"
        }
    ],
    [
        "path",
        {
            d: "M10 10h4",
            key: "tcdvrf"
        }
    ],
    [
        "path",
        {
            d: "M10 14h4",
            key: "kelpxr"
        }
    ],
    [
        "path",
        {
            d: "M10 18h4",
            key: "1ulq68"
        }
    ]
];
const $76e1a9e2a8898432$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("building-2", $76e1a9e2a8898432$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6bdc8ee6cbea55a7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5",
            key: "1p9q5i"
        }
    ],
    [
        "path",
        {
            d: "M14 6a6 6 0 0 1 6 6v3",
            key: "1hnv84"
        }
    ],
    [
        "path",
        {
            d: "M4 15v-3a6 6 0 0 1 6-6",
            key: "9ciidu"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "15",
            width: "20",
            height: "4",
            rx: "1",
            key: "g3x8cw"
        }
    ]
];
const $6bdc8ee6cbea55a7$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("hard-hat", $6bdc8ee6cbea55a7$export$3efd853dbb351e94);


const $20b8d8dd93486dac$var$CorporateProfile = ()=>{
    const sectionRef = (0, $4Iuzv.useRef)(null);
    const [hasRevealed, setHasRevealed] = (0, $4Iuzv.useState)(false);
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setHasRevealed(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    const reveal = (isVisible, delay = "0ms")=>({
            transform: isVisible ? "translateY(0)" : "translateY(30px)",
            opacity: isVisible ? 1 : 0,
            transition: `all 1000ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}`
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative bg-white py-16 md:py-24 lg:pb-32 lg:pt-10 px-6 md:px-12 lg:px-20 overflow-hidden border-t border-gray-50",
        "aria-labelledby": "corporate-heading",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute top-10 right-[-5%] md:right-[-2%] text-[8rem] sm:text-[12rem] md:text-[15rem] font-black text-gray-50 select-none pointer-events-none tracking-tighter uppercase leading-none z-0",
                "aria-hidden": "true",
                children: "ARC"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: "flex flex-col md:flex-row md:items-end justify-between mb-16 md:mb-20 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                style: reveal(hasRevealed),
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "w-12 h-[2px] bg-[#BF092F]",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] tracking-[0.4em] text-[#BF092F] font-bold uppercase",
                                                children: "Corporate Identity"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                        id: "corporate-heading",
                                        className: "text-3xl sm:text-4xl md:text-6xl font-bold text-[#44444E] leading-[1.1] tracking-tight",
                                        children: [
                                            "Engineering",
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-gray-300 font-light",
                                                children: "without"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {
                                                className: "hidden sm:block"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Boundaries."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "max-w-sm",
                                style: reveal(hasRevealed, "200ms"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-xs sm:text-sm text-gray-400 uppercase tracking-widest leading-relaxed border-l border-gray-100 pl-6 py-1",
                                    children: "Strategic manufacturing operations providing UK-standard engineering with global scale for European and worldwide power requirements."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                className: "lg:col-span-5 space-y-8 order-2 lg:order-1",
                                style: reveal(hasRevealed, "400ms"),
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "space-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                                        className: "text-[#BF092F]",
                                                        size: 28,
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                        className: "text-xl md:text-2xl font-bold text-[#44444E]",
                                                        children: "UK Standards, Global Delivery"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "space-y-4 text-gray-600",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                        className: "leading-loose text-base md:text-lg",
                                                        children: "Arc Engineering Solutions Ltd specializes in the manufacture of high-specification metal structures. We bridge the gap between British engineering quality and large-scale manufacturing to serve the UK and European infrastructure sectors."
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                        className: "text-sm leading-relaxed text-gray-500",
                                                        children: "Our expertise covers specialized industrial tanks, reservoirs, and precision metal containers, ensuring all units meet the stringent compliance required for UK and EU power projects."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "flex flex-wrap gap-3",
                                        role: "list",
                                        children: [
                                            {
                                                label: "Data Centers",
                                                icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $914ea2a5dc385aff$export$2e2bcd8739ae039), {
                                                    size: 14
                                                })
                                            },
                                            {
                                                label: "UK Power Grid",
                                                icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $76e1a9e2a8898432$export$2e2bcd8739ae039), {
                                                    size: 14
                                                })
                                            },
                                            {
                                                label: "EU Installation",
                                                icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6bdc8ee6cbea55a7$export$2e2bcd8739ae039), {
                                                    size: 14
                                                })
                                            }
                                        ].map((sector, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                role: "listitem",
                                                className: "flex items-center gap-3 px-4 py-3 bg-gray-50 rounded-xl border border-gray-100 hover:border-[#BF092F]/20 transition-all",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[#BF092F]",
                                                        children: sector.icon
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        className: "text-[10px] font-black text-[#44444E] uppercase tracking-widest",
                                                        children: sector.label
                                                    })
                                                ]
                                            }, i))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "lg:col-span-7 grid grid-cols-1 md:grid-cols-12 gap-4 order-1 lg:order-2",
                                style: reveal(hasRevealed, "600ms"),
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("figure", {
                                        className: "md:col-span-8 overflow-hidden rounded-3xl shadow-xl relative group h-[280px] sm:h-[350px] md:h-[450px]",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                src: "https://media.arcengltd.com/facility-images/Hamriyah_Facility_03.webp",
                                                className: "w-full h-full object-cover transition-transform duration-700 group-hover:scale-105",
                                                alt: "Strategic manufacturing hub for UK and European export",
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("figcaption", {
                                                className: "absolute bottom-4 left-4 right-4 p-4 md:p-6 bg-white/95 backdrop-blur-sm rounded-2xl flex items-center justify-between border border-white/20",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-[9px] font-bold text-[#BF092F] uppercase tracking-[0.2em]",
                                                                children: "Global Scale"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-xs md:text-sm font-bold text-[#44444E]",
                                                                children: "Primary Manufacturing Facility"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $914ea2a5dc385aff$export$2e2bcd8739ae039), {
                                                        size: 18,
                                                        className: "text-gray-400",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "hidden md:flex md:col-span-4 flex-col gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("figure", {
                                                className: "h-[210px] rounded-3xl overflow-hidden shadow-lg border-2 border-white",
                                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                                    src: "https://media.arcengltd.com/cdn-cgi/image/width=1200,format=auto,quality=auto/project-images/ARC_Project_Sajja_PowerPack_04.webp",
                                                    className: "w-full h-full object-cover",
                                                    alt: "Precision engineering project for the power sector",
                                                    loading: "lazy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "bg-[#44444E] flex-grow rounded-3xl p-6 flex flex-col justify-between text-white shadow-xl relative overflow-hidden group",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "h-8 w-8 bg-[#BF092F] rounded-lg flex items-center justify-center relative z-10",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $11189a96f8661453$export$2e2bcd8739ae039), {
                                                            size: 18,
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "relative z-10",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-sm font-bold uppercase tracking-tight",
                                                                children: "Technical Delivery"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-[9px] uppercase tracking-widest opacity-50 mt-1",
                                                                children: "International Logistics"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37581b884d168f82$export$2e2bcd8739ae039), {
                                                        className: "absolute -right-4 -bottom-4 text-white/5 group-hover:text-white/10 transition-colors",
                                                        size: 100,
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                        className: "mt-16 md:mt-24 p-6 md:p-10 bg-gray-50 rounded-[2rem] border border-gray-100 flex flex-col lg:flex-row items-center justify-between gap-8",
                        style: reveal(hasRevealed, "800ms"),
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-14 h-14 rounded-2xl bg-white shadow-sm flex items-center justify-center flex-shrink-0",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37581b884d168f82$export$2e2bcd8739ae039), {
                                            className: "text-[#BF092F]",
                                            size: 28,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                className: "text-lg md:text-xl font-bold text-[#44444E]",
                                                children: "Engineering Specifications"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-xs text-gray-400 max-w-sm",
                                                children: "Review our compliance frameworks and technical standards for UK and European projects."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("a", {
                                href: "https://res.cloudinary.com/dc912sjxj/image/upload/v1767916702/Art_Genpower_Solutions_Ltd_AGP_Profile_tpmncv.pdf",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                className: "w-full lg:w-auto group flex items-center justify-center gap-4 px-10 py-5 bg-[#BF092F] text-white rounded-2xl hover:bg-[#44444E] transition-all shadow-lg active:scale-95",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[10px] font-black uppercase tracking-[0.2em]",
                                        children: "View Corporate Profile"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $11189a96f8661453$export$2e2bcd8739ae039), {
                                        className: "group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform",
                                        size: 18,
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $20b8d8dd93486dac$export$2e2bcd8739ae039 = $20b8d8dd93486dac$var$CorporateProfile;




var $4Iuzv = parcelRequire("4Iuzv");

const $242e8617d8b749fc$var$HybridModel = ()=>{
    const sectionRef = (0, $4Iuzv.useRef)(null);
    const [hasRevealed, setHasRevealed] = (0, $4Iuzv.useState)(false);
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setHasRevealed(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    const reveal = (isVisible, delay = "0ms")=>({
            transform: isVisible ? "translateY(0)" : "translateY(30px)",
            opacity: isVisible ? 1 : 0,
            transition: `all 1000ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}`
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative bg-white py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-20 overflow-hidden border-t border-gray-100",
        "aria-labelledby": "hybrid-heading",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute top-10 right-[-5%] md:right-[-2%] text-[8rem] sm:text-[12rem] md:text-[15rem] font-black text-gray-50 select-none pointer-events-none tracking-tighter uppercase leading-none z-0",
                "aria-hidden": "true",
                children: "HUB"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: "flex flex-col md:flex-row md:items-end justify-between mb-12 md:mb-20 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                style: reveal(hasRevealed),
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "w-12 h-[2px] bg-[#BF092F]",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] tracking-[0.4em] text-[#BF092F] font-bold uppercase",
                                                children: "Strategic Framework"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                        id: "hybrid-heading",
                                        className: "text-3xl sm:text-4xl md:text-6xl font-bold text-[#44444E] leading-[1.1] tracking-tight",
                                        children: [
                                            "The ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-gray-300 font-light",
                                                children: "Hybrid"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {
                                                className: "hidden sm:block"
                                            }),
                                            "Supply ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Model."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "max-w-sm",
                                style: reveal(hasRevealed, "200ms"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-xs sm:text-sm text-gray-400 uppercase tracking-widest leading-relaxed border-l border-gray-100 pl-6 py-1",
                                    children: "Providing UK-led project management with global production scale for seamless European and international delivery."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12 gap-16",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "lg:col-span-5 space-y-12",
                                style: reveal(hasRevealed, "400ms"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "group relative bg-[#44444E] p-10 rounded-2xl text-white shadow-2xl overflow-hidden aspect-[4/5] flex flex-col justify-between",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $914ea2a5dc385aff$export$2e2bcd8739ae039), {
                                            className: "absolute -right-16 -bottom-16 text-white/5 group-hover:text-[#BF092F]/10 transition-all duration-1000",
                                            size: 350,
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "relative z-10",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                                    className: "text-[#BF092F] mb-6",
                                                    size: 40,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                                    className: "text-3xl font-bold uppercase tracking-tight leading-none mb-6",
                                                    children: [
                                                        "UK-Led ",
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                        " Governance"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-white/50 text-sm leading-relaxed max-w-sm",
                                                    children: "Strategic project management and commercial governance driven from our Leicester headquarters, ensuring British engineering standards and UKCA/CE compliance for every contract."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "relative z-10 flex items-center gap-4 pt-8 border-t border-white/10",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                                    className: "text-[#BF092F] animate-pulse",
                                                    size: 18,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-[10px] font-bold uppercase tracking-widest text-white/40",
                                                    children: "Compliance Optimized"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "lg:col-span-7 flex flex-col justify-between",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "space-y-8",
                                    style: reveal(hasRevealed, "600ms"),
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "bg-gray-50 rounded-2xl p-10 border border-gray-100 group hover:border-[#BF092F]/30 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-4 mb-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $74612ecec2deb067$export$2e2bcd8739ae039), {
                                                            className: "text-[#BF092F]",
                                                            size: 32,
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h4", {
                                                            className: "text-xl font-bold text-[#44444E] uppercase tracking-tight",
                                                            children: "Global Production Scale"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-baseline gap-3 mb-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-5xl sm:text-6xl font-black text-[#44444E] tracking-tighter",
                                                            children: "41,000"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-xs font-bold text-gray-400 uppercase tracking-[0.2em]",
                                                            children: "SQM Floor"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-sm text-gray-500 leading-loose",
                                                    children: "Utilizing high-capacity industrial hubs in Hamriyah and Sajja to handle hyperscale infrastructure. This model allows Arc Engineering to serve the UK and Europe with the lead times of a local partner and the capacity of a global leader."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                                            style: reveal(hasRevealed, "800ms"),
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "p-8 border border-gray-100 rounded-2xl",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                            className: "text-[10px] font-black uppercase tracking-[0.2em] text-[#BF092F] mb-4",
                                                            children: "UK Engineering Standards"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                            className: "text-[12px] text-gray-500 leading-relaxed font-medium",
                                                            children: "Seamless supply chain integration ensuring all products meet stringent British and European technical requirements."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "p-8 border border-gray-100 rounded-2xl",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h5", {
                                                            className: "text-[10px] font-black uppercase tracking-[0.2em] text-[#BF092F] mb-4",
                                                            children: "European Logistics"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                            className: "text-[12px] text-gray-500 leading-relaxed font-medium",
                                                            children: "Logistics-optimized manufacturing designed for rapid delivery across the UK and European infrastructure sectors."
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $242e8617d8b749fc$export$2e2bcd8739ae039 = $242e8617d8b749fc$var$HybridModel;




var $4Iuzv = parcelRequire("4Iuzv");


const $d4b019096e895ec6$var$ManufacturingScale = ()=>{
    const sectionRef = (0, $4Iuzv.useRef)(null);
    const [hasRevealed, setHasRevealed] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setHasRevealed(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    const reveal = (isVisible, delay = "0ms")=>({
            transform: isVisible ? "translateY(0)" : "translateY(30px)",
            opacity: isVisible ? 1 : 0,
            transition: `all 1000ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}`
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative bg-white py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-20 overflow-hidden border-t border-gray-100",
        "aria-labelledby": "scale-heading",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute top-10 right-[-5%] md:right-[-2%] text-[8rem] sm:text-[12rem] md:text-[15rem] font-black text-gray-50 select-none pointer-events-none tracking-tighter uppercase leading-none z-0",
                "aria-hidden": "true",
                children: "SCALE"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: "flex flex-col md:flex-row md:items-end justify-between mb-12 md:mb-20 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                style: reveal(hasRevealed),
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "w-12 h-[2px] bg-[#BF092F]",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] tracking-[0.4em] text-[#BF092F] font-bold uppercase",
                                                children: "Production Capacity"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                        id: "scale-heading",
                                        className: "text-3xl sm:text-4xl md:text-6xl font-bold text-[#44444E] leading-[1.1] tracking-tight",
                                        children: [
                                            "Reliability ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-gray-300 font-light",
                                                children: "built on"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {
                                                className: "hidden sm:block"
                                            }),
                                            "Global ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Infrastructure."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "max-w-sm",
                                style: reveal(hasRevealed, "200ms"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-xs sm:text-sm text-gray-400 uppercase tracking-widest leading-relaxed border-l border-gray-100 pl-6 py-1",
                                    children: "Providing UK and European markets with project continuity through a massive, high-specification manufacturing footprint."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                className: "lg:col-span-7 space-y-8 order-2 lg:order-1",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                                        style: reveal(hasRevealed, "400ms"),
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "bg-gray-50 p-8 rounded-2xl border border-gray-100 group hover:border-[#BF092F]/30 transition-all",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c0b373e8f780a95a$export$2e2bcd8739ae039), {
                                                        className: "text-[#BF092F] mb-6",
                                                        size: 28,
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        className: "flex items-baseline gap-2 mb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-5xl font-black text-[#44444E] tracking-tighter",
                                                                children: "41k"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                                className: "text-[10px] font-bold text-gray-400 uppercase tracking-widest",
                                                                children: "SQM"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                        className: "text-[11px] font-black uppercase tracking-widest text-gray-400",
                                                        children: "Infrastructure Capacity"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "bg-gray-50 p-8 rounded-2xl border border-gray-100 group hover:border-[#BF092F]/30 transition-all",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $37581b884d168f82$export$2e2bcd8739ae039), {
                                                        className: "text-[#BF092F] mb-6",
                                                        size: 28,
                                                        "aria-hidden": "true"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "text-5xl font-black text-[#44444E] tracking-tighter mb-2",
                                                        children: "05"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                                        className: "text-[11px] font-black uppercase tracking-widest text-gray-400",
                                                        children: "Specialized Facilities"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "bg-white p-8 md:p-10 rounded-2xl border border-gray-100 shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-8 group",
                                        style: reveal(hasRevealed, "600ms"),
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                className: "flex items-center gap-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "w-16 h-16 bg-[#44444E] rounded-xl flex items-center justify-center text-white group-hover:bg-[#BF092F] transition-colors duration-500 shadow-lg shadow-gray-200",
                                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e95f2feed69b2044$export$2e2bcd8739ae039), {
                                                            size: 32,
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                                className: "text-4xl font-black text-[#44444E] tracking-tighter",
                                                                children: "260+"
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-[10px] font-bold text-gray-400 uppercase tracking-widest",
                                                                children: "Technical Experts"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                className: "flex flex-wrap gap-2",
                                                role: "list",
                                                children: [
                                                    "Qualified Welders",
                                                    "Specialist Fabricators",
                                                    "Chartered Engineers"
                                                ].map((role)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                        role: "listitem",
                                                        className: "text-[9px] font-black uppercase tracking-[0.3em] bg-gray-50 px-4 py-2 rounded-lg text-gray-500 border border-gray-100",
                                                        children: role
                                                    }, role))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "pt-4",
                                        style: reveal(hasRevealed, "800ms"),
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-sm text-gray-500 leading-loose border-l-4 border-[#BF092F] pl-8 italic max-w-2xl",
                                            children: "Our facilities are optimized for parallel production, designed to meet the hyperscale delivery requirements of mission-critical UK and European data center projects."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "lg:col-span-5 order-1 lg:order-2",
                                style: reveal(hasRevealed, "400ms"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("article", {
                                    className: "relative group h-full bg-[#44444E] p-10 md:p-12 rounded-2xl text-white shadow-2xl overflow-hidden flex flex-col justify-between min-h-[450px] md:min-h-[500px]",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $88751b2d8fd25e0f$export$2e2bcd8739ae039), {
                                            className: "absolute -right-12 -bottom-12 text-white/5 group-hover:text-[#BF092F]/10 transition-all duration-1000 scale-110",
                                            size: 350,
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "relative z-10",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    className: "flex items-center gap-3 mb-8",
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                                            className: "text-[#BF092F] animate-pulse",
                                                            size: 24,
                                                            "aria-hidden": "true"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-[10px] font-black uppercase tracking-[0.4em] text-white/40",
                                                            children: "Business Continuity"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h3", {
                                                    className: "text-3xl font-bold uppercase tracking-tight leading-none mb-8",
                                                    children: [
                                                        "Security of ",
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                                        " ",
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                            className: "text-[#BF092F]",
                                                            children: "Supply."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                    className: "text-white/50 text-sm leading-loose mb-10",
                                                    children: "Reliability for our UK and European partners is built on physical ownership. We de-risk project timelines through control over our manufacturing line and British-standard quality oversight."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "relative z-10 pt-8 border-t border-white/10 flex items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                            className: "text-[10px] font-black uppercase tracking-[0.2em] text-[#BF092F]",
                                                            children: "Operation Mode"
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                            className: "text-[11px] text-white/40 uppercase font-bold",
                                                            children: "Parallel Delivery"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                    onClick: ()=>{
                                                        navigate("/facilities");
                                                    },
                                                    className: "cursor-pointer w-12 h-12 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#BF092F] group-hover:border-[#BF092F] transition-all",
                                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                                        size: 18,
                                                        className: "group-hover:translate-x-1 transition-transform",
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $d4b019096e895ec6$export$2e2bcd8739ae039 = $d4b019096e895ec6$var$ManufacturingScale;




var $4Iuzv = parcelRequire("4Iuzv");




const $43d15f87cc272b00$var$ProductScope = ()=>{
    const sectionRef = (0, $4Iuzv.useRef)(null);
    const [hasRevealed, setHasRevealed] = (0, $4Iuzv.useState)(false);
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    (0, $4Iuzv.useEffect)(()=>{
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) setHasRevealed(true);
        }, {
            threshold: 0.1
        });
        if (sectionRef.current) observer.observe(sectionRef.current);
        return ()=>observer.disconnect();
    }, []);
    const reveal = (isVisible, delay = "0ms")=>({
            transform: isVisible ? "translateY(0)" : "translateY(30px)",
            opacity: isVisible ? 1 : 0,
            transition: `all 1000ms cubic-bezier(0.16, 1, 0.3, 1) ${delay}`
        });
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
        ref: sectionRef,
        className: "relative bg-white py-16 md:py-24 lg:py-32 px-6 md:px-12 lg:px-20 overflow-hidden border-t border-gray-100",
        "aria-labelledby": "scope-heading",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute top-10 right-[-5%] md:right-[-2%] text-[8rem] sm:text-[12rem] md:text-[15rem] font-black text-gray-50 select-none pointer-events-none tracking-tighter uppercase leading-none z-0",
                "aria-hidden": "true",
                children: "SCOPE"
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "max-w-7xl mx-auto relative z-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                        className: "flex flex-col md:flex-row md:items-end justify-between mb-16 md:mb-20 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                style: reveal(hasRevealed),
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        className: "flex items-center gap-3 mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "w-12 h-[2px] bg-[#BF092F]",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] tracking-[0.4em] text-[#BF092F] font-bold uppercase",
                                                children: "Product Portfolio"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                        id: "scope-heading",
                                        className: "text-3xl sm:text-4xl md:text-6xl font-bold text-[#44444E] leading-[1.1] tracking-tight",
                                        children: [
                                            "Our ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-gray-300 font-light",
                                                children: "technical"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {
                                                className: "hidden sm:block"
                                            }),
                                            "Product ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: "Scope."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "max-w-sm",
                                style: reveal(hasRevealed, "200ms"),
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-xs sm:text-sm text-gray-400 uppercase tracking-widest leading-relaxed border-l border-gray-100 pl-6 py-1",
                                    children: "High-specification engineering solutions meeting UKCA and CE standards for mission-critical infrastructure across the UK and Europe."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "flex justify-center",
                        style: reveal(hasRevealed, "400ms"),
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 w-full max-w-5xl",
                            children: (0, $646411876a15270d$export$b6aad051bad07f12).map((cat, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                    className: "group relative flex flex-col h-full transition-all duration-500",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "flex-1 h-full",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d87703466cb4334d$export$2e2bcd8739ae039), {
                                            category: cat,
                                            onClick: ()=>navigate(`/products?category=${cat.slug}`),
                                            // Use h-full to ensure equal heights in the row
                                            className: "h-full shadow-sm hover:shadow-xl border-gray-100/50"
                                        })
                                    })
                                }, idx))
                        })
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("footer", {
                        className: "mt-16 md:mt-24 pt-12 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between gap-8",
                        style: reveal(hasRevealed, "600ms"),
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-14 h-14 rounded-2xl bg-gray-50 flex items-center justify-center text-[#44444E] shadow-inner",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                                            className: "text-[#BF092F]",
                                            size: 28,
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-[10px] font-black uppercase tracking-[0.2em] text-[#BF092F]",
                                                children: "Compliance Assurance"
                                            }),
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                className: "text-sm text-gray-500 max-w-sm",
                                                children: "All strategic product lines are manufactured to ISO 9001:2015, UKCA, and CE British engineering standards."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                onClick: ()=>navigate("/products"),
                                className: "cursor-pointer w-full md:w-auto group flex items-center justify-center gap-6 px-10 py-5 bg-white border border-gray-100 rounded-2xl text-[10px] font-black uppercase tracking-[0.3em] text-[#44444E] hover:border-[#BF092F] hover:text-[#BF092F] transition-all shadow-sm hover:shadow-md active:scale-95",
                                children: [
                                    "Explore Technical Range",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1f891ca354fd6960$export$2e2bcd8739ae039), {
                                        size: 16,
                                        className: "group-hover:translate-x-2 transition-transform",
                                        "aria-hidden": "true"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $43d15f87cc272b00$export$2e2bcd8739ae039 = $43d15f87cc272b00$var$ProductScope;


function $204ff08d366b382d$export$2e2bcd8739ae039() {
    const navigate = (0, $b11369f2b382bb4b$export$9770f232ac06a008)();
    const [isVisible, setIsVisible] = (0, $4Iuzv.useState)(false);
    const [activeSection, setActiveSection] = (0, $4Iuzv.useState)("Corporate Profile");
    const sidebarLinks = [
        {
            label: "Corporate Profile",
            id: "corp-profile",
            icon: (0, $9102b08aefb321b4$export$2e2bcd8739ae039)
        },
        {
            label: "Engineering Skills",
            id: "engineering-skills",
            icon: (0, $90b1c37bd27f04c4$export$2e2bcd8739ae039)
        },
        {
            label: "Hybrid Model",
            id: "hybrid-model",
            icon: (0, $914ea2a5dc385aff$export$2e2bcd8739ae039)
        },
        {
            label: "Manufacturing Scale",
            id: "manufacturing-scale",
            icon: (0, $37581b884d168f82$export$2e2bcd8739ae039)
        },
        {
            label: "Product Scope",
            id: "product-scope",
            icon: (0, $e51bb68e0d76a8d2$export$2e2bcd8739ae039)
        }
    ];
    // SCROLL SPY: Highlights sidebar as sections pass the middle of the screen
    (0, $4Iuzv.useEffect)(()=>{
        const observerOptions = {
            root: null,
            // Target a narrow 10% strip in the dead center of the window
            rootMargin: "-45% 0px -45% 0px",
            threshold: 0
        };
        const observerCallback = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const link = sidebarLinks.find((l)=>l.id === entry.target.id);
                    if (link) setActiveSection(link.label);
                }
            });
        };
        const observer = new IntersectionObserver(observerCallback, observerOptions);
        const articles = document.querySelectorAll("section > article[id]");
        articles.forEach((article)=>observer.observe(article));
        return ()=>observer.disconnect();
    }, [
        sidebarLinks
    ]);
    (0, $4Iuzv.useEffect)(()=>{
        setIsVisible(true);
        window.scrollTo(0, 0);
    }, []);
    // MANUAL SCROLL: Calculates the center of the element relative to the window center
    const scrollToSection = (label, id)=>{
        setActiveSection(label);
        const element = document.getElementById(id);
        if (!element) return;
        const targetPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const viewportCenter = window.innerHeight / 2;
        const elementHalfHeight = element.getBoundingClientRect().height / 2;
        // The precise "Center" destination
        const startPosition = window.pageYOffset;
        const distance = targetPosition - viewportCenter + elementHalfHeight - startPosition;
        const duration = 1000; // 1 second for a premium feel
        let start = null;
        // Standard "Cubic Out" easing for that "luxury car" braking feel
        const easeOutCubic = (t)=>1 - Math.pow(1 - t, 3);
        const animation = (currentTime)=>{
            if (start === null) start = currentTime;
            const progress = currentTime - start;
            const percentage = Math.min(progress / duration, 1);
            window.scrollTo(0, startPosition + distance * easeOutCubic(percentage));
            if (progress < duration) requestAnimationFrame(animation);
        };
        requestAnimationFrame(animation);
    };
    const orgSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Arc Engineering Solutions Ltd",
        url: "https://arcengltd.com",
        address: {
            "@type": "PostalAddress",
            addressCountry: "GB"
        },
        description: "UK-based engineering specialists providing power infrastructure for UK, Europe, and global markets."
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white text-[#44444E] font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("html", {
                        lang: "en-GB"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "About Us | UK Engineering & Global Infrastructure | Arc Engineering"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "Arc Engineering Solutions Ltd: UK-led engineering and manufacturing. Serving UK and European clients with bespoke power solutions."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(orgSchema)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "pt-22 px-2 md:px-2",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("header", {
                    className: "shadow-xl relative h-[28vh] min-h-[300px] w-full flex items-center bg-[#44444E] overflow-hidden rounded-2xl",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                            className: "container mx-auto px-4 md:px-6 relative z-20",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("nav", {
                                    className: "hidden md:flex items-center flex-wrap gap-3 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                            onClick: ()=>navigate("/"),
                                            className: "cursor-pointer group flex items-center gap-1 text-white/50 hover:text-white transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[10px] md:text-xs tracking-widest uppercase",
                                                    children: "Home"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-white/20 text-xs font-mono",
                                            children: ">"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                            className: "text-[10px] md:text-xs tracking-widest uppercase bg-[#BF092F] text-white px-4 py-1.5 rounded-2xl shadow-lg shadow-[#BF092F]/20",
                                            children: "About Arc Engineering"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                    className: `font-semibold text-3xl md:text-5xl lg:text-5xl text-white leading-[1.1] tracking-[-0.02em] max-w-4xl transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`,
                                    children: [
                                        "Engineering ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: "Power."
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("br", {}),
                                        "Manufacturing ",
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                            className: "text-[#BF092F]",
                                            children: "Precision."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-white/60 text-lg md:text-xl tracking-wide leading-relaxed mt-4 max-w-3xl font-medium",
                                    children: "Arc Engineering Solutions Ltd \u2014 UK-managed engineering bridging the gap between bespoke design and global production."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                className: "container mx-auto -translate-y-12 relative z-30 pb-20",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "pt-20 px-4 flex flex-col lg:grid lg:grid-cols-12 gap-8 items-stretch",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("aside", {
                            className: "lg:col-span-3 space-y-8 h-full",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "rounded-2xl bg-[#44444E] shadow-2xl border-t-4 border-[#BF092F] sticky top-[20vh] overflow-hidden",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "p-8",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex items-center gap-3 mb-8",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $9102b08aefb321b4$export$2e2bcd8739ae039), {
                                                    size: 16,
                                                    className: "text-[#BF092F]"
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h2", {
                                                    className: "text-[12px] text-white tracking-[0.4em] uppercase font-bold",
                                                    children: "Corporate Registry"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "lg:hidden relative",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("select", {
                                                value: activeSection,
                                                onChange: (e)=>{
                                                    const selected = sidebarLinks.find((l)=>l.label === e.target.value);
                                                    scrollToSection(selected.label, selected.id);
                                                },
                                                className: "w-full bg-white/5 border border-white/10 text-white text-[12px] uppercase tracking-[0.2em] px-4 py-4 rounded-xl cursor-pointer focus:outline-none focus:border-[#BF092F]",
                                                children: sidebarLinks.map((link)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("option", {
                                                        value: link.label,
                                                        className: "bg-[#44444E]",
                                                        children: link.label
                                                    }, link.id))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("ul", {
                                            className: "hidden lg:block space-y-2",
                                            children: sidebarLinks.map((link, idx)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("li", {
                                                    onClick: ()=>scrollToSection(link.label, link.id),
                                                    className: `cursor-pointer px-4 py-4 rounded-xl text-[12px] uppercase tracking-[0.2em] transition-all flex items-center justify-between group ${activeSection === link.label ? "bg-white/10 text-white border-l-4 border-[#BF092F]" : "text-white/40 hover:text-white hover:bg-white/5"}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                            className: "flex items-center gap-3",
                                                            children: [
                                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)(link.icon, {
                                                                    size: 14,
                                                                    className: activeSection === link.label ? "text-[#BF092F]" : ""
                                                                }),
                                                                link.label
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $273f1e3d788a4bec$export$2e2bcd8739ae039), {
                                                            size: 14,
                                                            className: `transition-transform duration-300 ${activeSection === link.label ? "text-[#BF092F] translate-x-1" : "opacity-0 group-hover:opacity-100"}`
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("section", {
                            className: "lg:col-span-9 space-y-12",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                    id: "corp-profile",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $20b8d8dd93486dac$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                    id: "engineering-skills",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $be253a6164c93d9b$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                    id: "hybrid-model",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $242e8617d8b749fc$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                    id: "manufacturing-scale",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d4b019096e895ec6$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("article", {
                                    id: "product-scope",
                                    children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $43d15f87cc272b00$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]",
                "aria-hidden": "true"
            })
        ]
    });
}




var $4Iuzv = parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $74f5fcefd2e81216$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $74f5fcefd2e81216$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("triangle-alert", $74f5fcefd2e81216$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c109bfb125c5420c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
            key: "1lielz"
        }
    ]
];
const $c109bfb125c5420c$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("message-square", $c109bfb125c5420c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $84eaf25c827ab6e5$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "3",
            rx: "1",
            key: "1tu5fj"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "16",
            y: "3",
            rx: "1",
            key: "1v8r4q"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "1x03jg"
        }
    ],
    [
        "path",
        {
            d: "M21 16h-3a2 2 0 0 0-2 2v3",
            key: "177gqh"
        }
    ],
    [
        "path",
        {
            d: "M21 21v.01",
            key: "ents32"
        }
    ],
    [
        "path",
        {
            d: "M12 7v3a2 2 0 0 1-2 2H7",
            key: "8crl2c"
        }
    ],
    [
        "path",
        {
            d: "M3 12h.01",
            key: "nlz23k"
        }
    ],
    [
        "path",
        {
            d: "M12 3h.01",
            key: "n36tog"
        }
    ],
    [
        "path",
        {
            d: "M12 16v.01",
            key: "133mhm"
        }
    ],
    [
        "path",
        {
            d: "M16 12h1",
            key: "1slzba"
        }
    ],
    [
        "path",
        {
            d: "M21 12v.01",
            key: "1lwtk9"
        }
    ],
    [
        "path",
        {
            d: "M12 21v-1",
            key: "1880an"
        }
    ]
];
const $84eaf25c827ab6e5$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("qr-code", $84eaf25c827ab6e5$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $28b1ba1c11c444e6$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "18",
            cy: "5",
            r: "3",
            key: "gq8acd"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "12",
            r: "3",
            key: "w7nqdw"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "19",
            r: "3",
            key: "1xt0gg"
        }
    ],
    [
        "line",
        {
            x1: "8.59",
            x2: "15.42",
            y1: "13.51",
            y2: "17.49",
            key: "47mynk"
        }
    ],
    [
        "line",
        {
            x1: "15.41",
            x2: "8.59",
            y1: "6.51",
            y2: "10.49",
            key: "1n3mei"
        }
    ]
];
const $28b1ba1c11c444e6$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("share-2", $28b1ba1c11c444e6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $055ed21f0689709c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $055ed21f0689709c$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("user", $055ed21f0689709c$export$3efd853dbb351e94);



var $4Iuzv = parcelRequire("4Iuzv");
var $6e7fbd91c84d756a$var$__defProp = Object.defineProperty;
var $6e7fbd91c84d756a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6e7fbd91c84d756a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6e7fbd91c84d756a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6e7fbd91c84d756a$var$__defNormalProp = (obj, key, value)=>key in obj ? $6e7fbd91c84d756a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6e7fbd91c84d756a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6e7fbd91c84d756a$var$__hasOwnProp.call(b, prop)) $6e7fbd91c84d756a$var$__defNormalProp(a, prop, b[prop]);
    if ($6e7fbd91c84d756a$var$__getOwnPropSymbols) {
        for (var prop of $6e7fbd91c84d756a$var$__getOwnPropSymbols(b))if ($6e7fbd91c84d756a$var$__propIsEnum.call(b, prop)) $6e7fbd91c84d756a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6e7fbd91c84d756a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6e7fbd91c84d756a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6e7fbd91c84d756a$var$__getOwnPropSymbols) {
        for (var prop of $6e7fbd91c84d756a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6e7fbd91c84d756a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var $6e7fbd91c84d756a$var$qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class _QrCode {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code with the given version number,
        // error correction level, data codeword bytes, and mask number.
        // This is a low-level API that most users should not use directly.
        // A mid-level API is the encodeSegments() function.
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            // The modules of this QR Code (false = light, true = dark).
            // Immutable after constructor finishes. Accessed through getModule().
            this.modules = [];
            // Indicates function modules that are not subjected to masking. Discarded when constructor finishes.
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        /*-- Static factory functions (high level) --*/ // Returns a QR Code representing the given Unicode text string at the given error correction level.
        // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
        // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
        // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
        // ecl argument if it can be done without increasing the version.
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        // Returns a QR Code representing the given binary data at the given error correction level.
        // This function always encodes using the binary segment mode, not any text mode. The maximum number of
        // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
        // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        /*-- Static factory functions (mid level) --*/ // Returns a QR Code representing the given segments with the given encoding parameters.
        // The smallest possible QR Code version within the given range is automatically
        // chosen for the output. Iff boostEcl is true, then the ECC level of the result
        // may be higher than the ecl argument if it can be done without increasing the
        // version. The mask number is either between 0 to 7 (inclusive) to force that
        // mask, or -1 to automatically choose an appropriate mask (which may be slow).
        // This function allows the user to create a custom sequence of segments that switches
        // between modes (such as alphanumeric and byte) to encode text in less space.
        // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        /*-- Accessor methods --*/ // Returns the color of the module (pixel) at the given coordinates, which is false
        // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
        // If the given coordinates are out of bounds, then false (light) is returned.
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        // Modified to expose modules for easy access
        getModules() {
            return this.modules;
        }
        /*-- Private helper methods for constructor: Drawing function modules --*/ // Reads this object's version field, and draws and marks all function modules.
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        // Draws two copies of the format bits (with its own error correction code)
        // based on the given mask and this object's error correction level field.
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        // Draws two copies of the version bits (with its own error correction code),
        // based on this object's version field, iff 7 <= version <= 40.
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        // Draws a 9*9 finder pattern including the border separator,
        // with the center module at (x, y). Modules can be out of bounds.
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        // Draws a 5*5 alignment pattern, with the center module
        // at (x, y). All modules must be in bounds.
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        // Sets the color of a module and marks it as a function module.
        // Only used by the constructor. Coordinates must be in bounds.
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        /*-- Private helper methods for constructor: Codewords and masking --*/ // Returns a new byte string representing the given data with the appropriate error correction
        // codewords appended to it, based on this object's version and error correction level.
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
        // data area of this QR Code. Function modules need to be marked off before this is called.
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        // XORs the codeword modules in this QR Code with the given mask pattern.
        // The function modules must be marked and the codeword bits must be drawn
        // before masking. Due to the arithmetic of XOR, calling applyMask() with
        // the same mask value a second time will undo the mask. A final well-formed
        // QR Code needs exactly one (not zero, two, etc.) mask applied.
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        // Calculates and returns the penalty score based on state of this QR Code's current modules.
        // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        /*-- Private helper functions --*/ // Returns an ascending list of positions of alignment patterns for this version number.
        // Each position is in the range [0,177), and are used on both the x and y axes.
        // This could be implemented as lookup table of 40 variable-length lists of integers.
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        // Returns the number of data bits that can be stored in a QR Code of the given version number, after
        // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
        // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
        // QR Code of the given version number and error correction level, with remainder bits discarded.
        // This stateless pure function could be implemented as a (40*4)-cell lookup table.
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
        // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
        // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        // Can only be called immediately after a light run is added, and
        // returns either 0, 1, or 2. A helper function for getPenaltyScore().
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    /*-- Constants and tables --*/ // The minimum version number supported in the QR Code Model 2 standard.
    _QrCode.MIN_VERSION = 1;
    // The maximum version number supported in the QR Code Model 2 standard.
    _QrCode.MAX_VERSION = 40;
    // For use in getPenaltyScore(), when evaluating which mask is best.
    _QrCode.PENALTY_N1 = 3;
    _QrCode.PENALTY_N2 = 3;
    _QrCode.PENALTY_N3 = 40;
    _QrCode.PENALTY_N4 = 10;
    _QrCode.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Low
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        // Medium
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        // Quartile
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    _QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        // Low
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        // Medium
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        // Quartile
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    let QrCode = _QrCode;
    qrcodegen2.QrCode = _QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class _QrSegment {
        /*-- Constructor (low level) and fields --*/ // Creates a new QR Code segment with the given attributes and data.
        // The character count (numChars) must agree with the mode and the bit buffer length,
        // but the constraint isn't checked. The given bit buffer is cloned and stored.
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        /*-- Static factory functions (mid level) --*/ // Returns a segment representing the given binary data encoded in
        // byte mode. All input byte arrays are acceptable. Any text string
        // can be converted to UTF-8 bytes and encoded as a byte mode segment.
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        // Returns a segment representing the given string of decimal digits encoded in numeric mode.
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substring(i, i + n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        // Returns a segment representing the given text string encoded in alphanumeric mode.
        // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
        // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
        // The result may use various segment modes and switch modes to optimize the length of the bit stream.
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        // Returns a segment representing an Extended Channel Interpretation
        // (ECI) designator with the given assignment value.
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        // Tests whether the given string can be encoded as a segment in numeric mode.
        // A string is encodable iff each character is in the range 0 to 9.
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        // Tests whether the given string can be encoded as a segment in alphanumeric mode.
        // A string is encodable iff each character is in the following set: 0 to 9, A to Z
        // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        /*-- Methods --*/ // Returns a new copy of the data bits of this segment.
        getData() {
            return this.bitData.slice();
        }
        // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
        // the given version. The result is infinity if a segment has too many characters to fit its length field.
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        // Returns a new array of bytes representing the given string encoded in UTF-8.
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substring(i + 1, i + 3), 16));
                i += 2;
            }
            return result;
        }
    };
    /*-- Constants --*/ // Describes precisely all strings that are encodable in numeric mode.
    _QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    // Describes precisely all strings that are encodable in alphanumeric mode.
    _QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    // The set of all legal characters in alphanumeric mode,
    // where each character value maps to the index in the string.
    _QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    let QrSegment = _QrSegment;
    qrcodegen2.QrSegment = _QrSegment;
})($6e7fbd91c84d756a$var$qrcodegen || ($6e7fbd91c84d756a$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class _Ecc {
            // The QR Code can tolerate about 30% erroneous codewords
            /*-- Constructor and fields --*/ constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        /*-- Constants --*/ _Ecc.LOW = new _Ecc(0, 1);
        // The QR Code can tolerate about  7% erroneous codewords
        _Ecc.MEDIUM = new _Ecc(1, 0);
        // The QR Code can tolerate about 15% erroneous codewords
        _Ecc.QUARTILE = new _Ecc(2, 3);
        // The QR Code can tolerate about 25% erroneous codewords
        _Ecc.HIGH = new _Ecc(3, 2);
        let Ecc = _Ecc;
        QrCode2.Ecc = _Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})($6e7fbd91c84d756a$var$qrcodegen || ($6e7fbd91c84d756a$var$qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class _Mode {
            /*-- Constructor and fields --*/ constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            /*-- Method --*/ // (Package-private) Returns the bit width of the character count field for a segment in
            // this mode in a QR Code at the given version number. The result is in the range [0, 16].
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        /*-- Constants --*/ _Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        _Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        _Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        _Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        _Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        let Mode = _Mode;
        QrSegment2.Mode = _Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})($6e7fbd91c84d756a$var$qrcodegen || ($6e7fbd91c84d756a$var$qrcodegen = {}));
var $6e7fbd91c84d756a$var$qrcodegen_default = $6e7fbd91c84d756a$var$qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var $6e7fbd91c84d756a$var$ERROR_LEVEL_MAP = {
    L: $6e7fbd91c84d756a$var$qrcodegen_default.QrCode.Ecc.LOW,
    M: $6e7fbd91c84d756a$var$qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: $6e7fbd91c84d756a$var$qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: $6e7fbd91c84d756a$var$qrcodegen_default.QrCode.Ecc.HIGH
};
var $6e7fbd91c84d756a$var$DEFAULT_SIZE = 128;
var $6e7fbd91c84d756a$var$DEFAULT_LEVEL = "L";
var $6e7fbd91c84d756a$var$DEFAULT_BGCOLOR = "#FFFFFF";
var $6e7fbd91c84d756a$var$DEFAULT_FGCOLOR = "#000000";
var $6e7fbd91c84d756a$var$DEFAULT_INCLUDEMARGIN = false;
var $6e7fbd91c84d756a$var$DEFAULT_MINVERSION = 1;
var $6e7fbd91c84d756a$var$SPEC_MARGIN_SIZE = 4;
var $6e7fbd91c84d756a$var$DEFAULT_MARGIN_SIZE = 0;
var $6e7fbd91c84d756a$var$DEFAULT_IMG_SCALE = 0.1;
function $6e7fbd91c84d756a$var$generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function $6e7fbd91c84d756a$var$excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function $6e7fbd91c84d756a$var$getImageSettings(cells, size, margin, imageSettings) {
    if (imageSettings == null) return null;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * $6e7fbd91c84d756a$var$DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    const opacity = imageSettings.opacity == null ? 1 : imageSettings.opacity;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    const crossOrigin = imageSettings.crossOrigin;
    return {
        x: x,
        y: y,
        h: h,
        w: w,
        excavation: excavation,
        opacity: opacity,
        crossOrigin: crossOrigin
    };
}
function $6e7fbd91c84d756a$var$getMarginSize(includeMargin, marginSize) {
    if (marginSize != null) return Math.max(Math.floor(marginSize), 0);
    return includeMargin ? $6e7fbd91c84d756a$var$SPEC_MARGIN_SIZE : $6e7fbd91c84d756a$var$DEFAULT_MARGIN_SIZE;
}
function $6e7fbd91c84d756a$var$useQRCode({ value: value, level: level, minVersion: minVersion, includeMargin: includeMargin, marginSize: marginSize, imageSettings: imageSettings, size: size, boostLevel: boostLevel }) {
    let qrcode = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useMemo(()=>{
        const values = Array.isArray(value) ? value : [
            value
        ];
        const segments = values.reduce((accum, v)=>{
            accum.push(...$6e7fbd91c84d756a$var$qrcodegen_default.QrSegment.makeSegments(v));
            return accum;
        }, []);
        return $6e7fbd91c84d756a$var$qrcodegen_default.QrCode.encodeSegments(segments, $6e7fbd91c84d756a$var$ERROR_LEVEL_MAP[level], minVersion, void 0, void 0, boostLevel);
    }, [
        value,
        level,
        minVersion,
        boostLevel
    ]);
    const { cells: cells, margin: margin, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useMemo(()=>{
        let cells2 = qrcode.getModules();
        const margin2 = $6e7fbd91c84d756a$var$getMarginSize(includeMargin, marginSize);
        const numCells2 = cells2.length + margin2 * 2;
        const calculatedImageSettings2 = $6e7fbd91c84d756a$var$getImageSettings(cells2, size, margin2, imageSettings);
        return {
            cells: cells2,
            margin: margin2,
            numCells: numCells2,
            calculatedImageSettings: calculatedImageSettings2
        };
    }, [
        qrcode,
        size,
        imageSettings,
        includeMargin,
        marginSize
    ]);
    return {
        qrcode: qrcode,
        margin: margin,
        cells: cells,
        numCells: numCells,
        calculatedImageSettings: calculatedImageSettings
    };
}
var $6e7fbd91c84d756a$var$SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
var $6e7fbd91c84d756a$export$7e3713cf0c0fe9d0 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).forwardRef(function QRCodeCanvas2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $6e7fbd91c84d756a$var$DEFAULT_SIZE, level: level = $6e7fbd91c84d756a$var$DEFAULT_LEVEL, bgColor: bgColor = $6e7fbd91c84d756a$var$DEFAULT_BGCOLOR, fgColor: fgColor = $6e7fbd91c84d756a$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $6e7fbd91c84d756a$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $6e7fbd91c84d756a$var$DEFAULT_MINVERSION, boostLevel: boostLevel, marginSize: marginSize, imageSettings: imageSettings } = _a, extraProps = $6e7fbd91c84d756a$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "marginSize",
        "imageSettings"
    ]);
    const _b = extraProps, { style: style } = _b, otherProps = $6e7fbd91c84d756a$var$__objRest(_b, [
        "style"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useRef(null);
    const _image = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useRef(null);
    const setCanvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useCallback((node)=>{
        _canvas.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
    }, [
        forwardedRef
    ]);
    const [isImgLoaded, setIsImageLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useState(false);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $6e7fbd91c84d756a$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useEffect(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cellsToDraw = cells;
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cellsToDraw = $6e7fbd91c84d756a$var$excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if ($6e7fbd91c84d756a$var$SUPPORTS_PATH2D) ctx.fill(new Path2D($6e7fbd91c84d756a$var$generatePath(cellsToDraw, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (calculatedImageSettings) ctx.globalAlpha = calculatedImageSettings.opacity;
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = $6e7fbd91c84d756a$var$__spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image,
        crossOrigin: calculatedImageSettings == null ? void 0 : calculatedImageSettings.crossOrigin
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("canvas", $6e7fbd91c84d756a$var$__spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: setCanvasRef,
        role: "img"
    }, otherProps)), img);
});
$6e7fbd91c84d756a$export$7e3713cf0c0fe9d0.displayName = "QRCodeCanvas";
var $6e7fbd91c84d756a$export$10307208e61210e9 = (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).forwardRef(function QRCodeSVG2(props, forwardedRef) {
    const _a = props, { value: value, size: size = $6e7fbd91c84d756a$var$DEFAULT_SIZE, level: level = $6e7fbd91c84d756a$var$DEFAULT_LEVEL, bgColor: bgColor = $6e7fbd91c84d756a$var$DEFAULT_BGCOLOR, fgColor: fgColor = $6e7fbd91c84d756a$var$DEFAULT_FGCOLOR, includeMargin: includeMargin = $6e7fbd91c84d756a$var$DEFAULT_INCLUDEMARGIN, minVersion: minVersion = $6e7fbd91c84d756a$var$DEFAULT_MINVERSION, boostLevel: boostLevel, title: title, marginSize: marginSize, imageSettings: imageSettings } = _a, otherProps = $6e7fbd91c84d756a$var$__objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "minVersion",
        "boostLevel",
        "title",
        "marginSize",
        "imageSettings"
    ]);
    const { margin: margin, cells: cells, numCells: numCells, calculatedImageSettings: calculatedImageSettings } = $6e7fbd91c84d756a$var$useQRCode({
        value: value,
        level: level,
        minVersion: minVersion,
        boostLevel: boostLevel,
        includeMargin: includeMargin,
        marginSize: marginSize,
        imageSettings: imageSettings,
        size: size
    });
    let cellsToDraw = cells;
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cellsToDraw = $6e7fbd91c84d756a$var$excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("image", {
            href: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none",
            opacity: calculatedImageSettings.opacity,
            crossOrigin: calculatedImageSettings.crossOrigin
        });
    }
    const fgPath = $6e7fbd91c84d756a$var$generatePath(cellsToDraw, margin);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("svg", $6e7fbd91c84d756a$var$__spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`,
        ref: forwardedRef,
        role: "img"
    }, otherProps), !!title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("title", null, title), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($4Iuzv))).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
});
$6e7fbd91c84d756a$export$10307208e61210e9.displayName = "QRCodeSVG";


/**
 * Employee Data Registry
 * Structure: [slug]: { name, role, company, id, phone, email, website, linkedin, whatsapp, profileImage, bio }
 */ const $52c3a594f09d67a9$export$162c001b8b55fbc3 = {
    "arunava-maity": {
        name: "Arunava Maity",
        role: "Head of Operation, UK",
        company: "Arc Engineering Solutions Ltd",
        id: "ARC-101-AM",
        phone: "+44 7492949230",
        email: "arun@arcengltd.com",
        website: "https://www.arcengltd.com/",
        linkedin: "www.linkedin.com/in/arunava-maity-6236a017/",
        whatsapp: "447492949230",
        profileImage: "https://res.cloudinary.com/dc912sjxj/image/upload/c_fill,g_face,w_400,h_400,f_auto,q_auto/v1772547762/maity-arunava_AGP_People_quyu6u.webp",
        bio: "Global Energy Executive (MBA, PMP) | Scaling High-Value Power Generation Projects."
    },
    "m-lalan": {
        name: "M. Lalan",
        role: "Head of Sales and BD, UK",
        company: "Arc Engineering Solutions Ltd",
        id: "ARC-102-ML",
        phone: "+44 7743977718",
        email: "lalan@arcengltd.com",
        website: "https://www.arcengltd.com/",
        linkedin: "https://www.linkedin.com/in/mlalan/",
        whatsapp: "447743977718",
        profileImage: "https://res.cloudinary.com/dc912sjxj/image/upload/c_fill,g_face,w_400,h_400,f_auto,q_auto/v1772547529/lalan-m_AGP_People_uztnoc.webp",
        bio: "MBA | Global energy leader delivering Net Zero value through strategic partnerships, cost focus, and UK operations."
    }
};


const $c26637f7df90bb36$var$DigitalBusinessCard = ()=>{
    const { username: username } = (0, $b11369f2b382bb4b$export$99eaa27ddbbb95ef)();
    const [activeTab, setActiveTab] = (0, $4Iuzv.useState)("card");
    const [currentUrl, setCurrentUrl] = (0, $4Iuzv.useState)("");
    // Get data based ONLY on the URL param
    const data = (0, $52c3a594f09d67a9$export$162c001b8b55fbc3)[username];
    (0, $4Iuzv.useEffect)(()=>{
        setCurrentUrl(window.location.href);
    }, [
        username
    ]);
    // If no employee is found, show an error state instead of a default person
    if (!data) return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
        className: "min-h-screen bg-[#1A1A1E] flex flex-col items-center justify-center p-4 font-sans",
        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
            className: "w-full max-w-md bg-[#44444E] rounded-[2.5rem] shadow-2xl border-t-4 overflow-hidden relative p-12 text-center border border-white/5",
            children: [
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                    className: "absolute inset-0 opacity-[0.05] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
                }),
                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                    className: "relative z-10",
                    children: [
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                            className: "w-20 h-20 bg-white/5 rounded-3xl flex items-center justify-center mx-auto mb-6 border border-white/10 shadow-inner",
                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $74f5fcefd2e81216$export$2e2bcd8739ae039), {
                                size: 40,
                                className: "text-[#BF092F]"
                            })
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                            className: "text-2xl font-bold text-white uppercase tracking-tighter mb-2",
                            children: [
                                "Access ",
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                    className: "text-[#BF092F]",
                                    children: "Denied"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("p", {
                            className: "text-white/40 text-[10px] uppercase tracking-[0.3em] font-mono mb-8",
                            children: [
                                "Registry ID: ",
                                username || "Unknown"
                            ]
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                            className: "text-white/60 text-sm leading-relaxed mb-10",
                            children: "The digital profile you are looking for does not exist or has been decommissioned from the AGP Industrial database."
                        }),
                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("a", {
                            href: "/",
                            className: "inline-flex items-center gap-2 px-6 py-3 bg-[#BF092F] text-white rounded-xl text-[10px] font-bold uppercase tracking-widest hover:bg-[#d10a34] transition-all active:scale-95",
                            children: [
                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ba8bf023ef8fc70d$export$2e2bcd8739ae039), {
                                    size: 14
                                }),
                                " Return to Portal"
                            ]
                        })
                    ]
                })
            ]
        })
    });
    const getBase64FromUrl = async (url)=>{
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = ()=>resolve(reader.result.split(",")[1]);
            });
        } catch (err) {
            return null;
        }
    };
    const handleShare = async ()=>{
        if (navigator.share) try {
            await navigator.share({
                title: `${data.name} | AGP Industrial`,
                text: `Contact details for ${data.name} - ${data.role}`,
                url: currentUrl
            });
        } catch (err) {
            if (err.name !== "AbortError") console.error("Share failed:", err);
        }
        else try {
            await navigator.clipboard.writeText(currentUrl);
            alert("Link copied to clipboard!");
        } catch (err) {
            console.error("Clipboard failed:", err);
        }
    };
    const handleSaveContact = async ()=>{
        const photo = await getBase64FromUrl(data.profileImage);
        const vcard = [
            "BEGIN:VCARD",
            "VERSION:3.0",
            `FN:${data.name}`,
            `ORG:${data.company}`,
            `TITLE:${data.role}`,
            `TEL;TYPE=CELL,VOICE:${data.phone}`,
            `TEL;TYPE=WHATSAPP,VOICE:${data.whatsapp}`,
            `EMAIL;TYPE=INTERNET,PREF:${data.email}`,
            `URL:${data.website}`,
            photo ? `PHOTO;ENCODING=b;TYPE=JPEG:${photo}` : "",
            "REV:" + new Date().toISOString(),
            "END:VCARD"
        ].filter(Boolean).join("\r\n");
        const blob = new Blob([
            vcard
        ], {
            type: "text/vcard;charset=utf-8"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Contact_${data.name.replace(/\s/g, "_")}.vcf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-[#1A1A1E] flex flex-col items-center justify-center p-4 font-sans selection:bg-[#BF092F] selection:text-white",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "flex bg-[#44444E] p-1.5 rounded-2xl mb-8 border border-white/10 w-full max-w-[300px] shadow-2xl z-20",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                        onClick: ()=>setActiveTab("card"),
                        className: `flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-[10px] uppercase tracking-[0.2em] font-bold transition-all duration-300 ${activeTab === "card" ? "bg-[#BF092F] text-white shadow-lg" : "text-white/40 hover:text-white"}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $055ed21f0689709c$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            " Profile"
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                        onClick: ()=>setActiveTab("qr"),
                        className: `flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl text-[10px] uppercase tracking-[0.2em] font-bold transition-all duration-300 ${activeTab === "qr" ? "bg-[#BF092F] text-white shadow-lg" : "text-white/40 hover:text-white"}`,
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $84eaf25c827ab6e5$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            " QR Code"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "w-full max-w-md bg-[#44444E] rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.5)] border-t-4 border-[#BF092F] overflow-hidden relative min-h-[700px] flex flex-col border border-white/5",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 opacity-[0.05] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                        className: "absolute inset-0 flex items-center justify-center pointer-events-none z-0 overflow-hidden",
                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                            src: "https://media.arcengltd.com/arc-profile/arc-logo-remove_bg.webp",
                            alt: "Watermark",
                            className: "w-[120%] max-w-none object-contain opacity-[0.1] brightness-200 grayscale"
                        })
                    }),
                    activeTab === "card" ? /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "animate-in fade-in slide-in-from-bottom-4 duration-500 flex flex-col h-full relative z-10",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "p-8 pb-0 flex justify-between items-start",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "bg-white/5 p-2 rounded-lg border border-white/10 shadow-inner",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $90b1c37bd27f04c4$export$2e2bcd8739ae039), {
                                            size: 16,
                                            className: "text-[#BF092F]"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("button", {
                                        onClick: handleShare,
                                        className: "bg-white/5 p-2.5 rounded-lg border border-white/10 text-white/40 hover:text-white active:scale-90",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $28b1ba1c11c444e6$export$2e2bcd8739ae039), {
                                            size: 18
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "p-8 pt-4 pb-4 text-center",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "w-32 h-32 rounded-3xl overflow-hidden border-2 border-[#BF092F] shadow-2xl mx-auto bg-gray-800 mb-6",
                                        children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("img", {
                                            src: data.profileImage,
                                            alt: data.name,
                                            className: "w-full h-full object-cover"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h1", {
                                        className: "text-3xl font-bold text-white tracking-tight leading-none",
                                        children: [
                                            data.name.split(" ")[0],
                                            " ",
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                className: "text-[#BF092F]",
                                                children: data.name.split(" ").slice(1).join(" ")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                        className: "text-white/40 text-[9px] font-bold uppercase tracking-[0.4em] mt-3",
                                        children: data.role
                                    })
                                ]
                            }),
                            data.bio && /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "px-8 py-2",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "bg-white/5 rounded-2xl p-4 border border-white/10 relative overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                            className: "flex items-center gap-2 mb-2 text-[#BF092F]",
                                            children: [
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $9102b08aefb321b4$export$2e2bcd8739ae039), {
                                                    size: 14
                                                }),
                                                /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                                    className: "text-[8px] font-bold uppercase tracking-widest",
                                                    children: "Professional Profile"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                            className: "text-white/60 text-[11px] leading-relaxed italic",
                                            children: data.bio
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "px-8 py-4 flex-grow",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "space-y-4 relative",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "absolute left-[15px] top-2 bottom-2 w-px bg-white/5"
                                        }),
                                        [
                                            {
                                                icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $29e92dec75ed73a3$export$2e2bcd8739ae039), {
                                                    size: 16
                                                }),
                                                label: "Mobile",
                                                val: data.phone,
                                                link: `tel:${data.phone}`
                                            },
                                            {
                                                icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c109bfb125c5420c$export$2e2bcd8739ae039), {
                                                    size: 16
                                                }),
                                                label: "WhatsApp",
                                                val: "Instant Chat",
                                                link: `https://wa.me/${data.whatsapp}`
                                            },
                                            {
                                                icon: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $914ea2a5dc385aff$export$2e2bcd8739ae039), {
                                                    size: 16
                                                }),
                                                label: "Portfolio",
                                                val: "arcengltd.com",
                                                link: data.website
                                            }
                                        ].map((node, i)=>/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("a", {
                                                href: node.link,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: "group flex items-center gap-6 relative pl-8 py-1 transition-all",
                                                children: [
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "absolute left-0 top-1/2 -translate-y-1/2 w-4 h-px bg-white/10 group-hover:bg-[#BF092F] transition-all"
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                                        className: "w-8 h-8 rounded-lg bg-white/5 flex items-center justify-center text-white/20 group-hover:text-[#BF092F] border border-white/5",
                                                        children: node.icon
                                                    }),
                                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-[8px] font-bold text-[#BF092F] uppercase tracking-widest leading-none mb-1",
                                                                children: node.label
                                                            }),
                                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                                                className: "text-[13px] text-white/70 font-medium group-hover:text-white transition-colors",
                                                                children: node.val
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "p-8 mt-auto",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                    onClick: handleSaveContact,
                                    className: "w-full flex items-center justify-center gap-3 py-4 bg-[#BF092F] hover:bg-[#d10a34] text-white rounded-2xl text-[11px] font-bold uppercase tracking-[0.2em] transition-all shadow-lg active:scale-95",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $1208b96e0d5edaaf$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        " Save Contact Info"
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "animate-in fade-in zoom-in-95 duration-500 flex flex-col items-center justify-center h-full p-12 relative z-10 text-center",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "p-6 bg-white rounded-[2.5rem] shadow-2xl mb-8 border-4 border-white/10",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $6e7fbd91c84d756a$export$10307208e61210e9), {
                                    value: currentUrl,
                                    size: 220,
                                    level: "H",
                                    fgColor: "#44444E"
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h3", {
                                className: "text-white text-sm font-bold tracking-widest uppercase mb-1",
                                children: "Registry Access"
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-white/30 text-[9px] uppercase tracking-[0.3em] font-mono",
                                children: data.id
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                className: "text-white/20 text-[10px] mt-6 max-w-[200px]",
                                children: "Scan this code to open the digital profile on any mobile device."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "mt-8 flex items-center gap-2 opacity-10",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $e1dea707e9b51b32$export$2e2bcd8739ae039), {
                        size: 14,
                        className: "text-white"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                        className: "text-[10px] text-white uppercase tracking-[0.4em]",
                        children: "Official AGP Industrial ID"
                    })
                ]
            })
        ]
    });
};
var $c26637f7df90bb36$export$2e2bcd8739ae039 = $c26637f7df90bb36$var$DigitalBusinessCard;



parcelRequire("4Iuzv");

/**
 * @license lucide-react v0.515.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f1eeec1e7587f58a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "M12 8v4",
            key: "1got3b"
        }
    ],
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ]
];
const $f1eeec1e7587f58a$export$2e2bcd8739ae039 = (0, $aadec6bfdddb2a4a$export$2e2bcd8739ae039)("shield-alert", $f1eeec1e7587f58a$export$3efd853dbb351e94);



const $643686657c7af80d$var$ErrorPage = ()=>{
    const error = (0, $b11369f2b382bb4b$export$ed527bf60f6e05f2)();
    // SEO: Structured Data to maintain site hierarchy even on 404
    const errorSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://arcengltd.com"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Error 404"
            }
        ]
    };
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        className: "min-h-screen bg-white flex flex-col items-center justify-center p-4 md:p-6 font-sans select-none overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "404 Page Not Found | Arc Engineering Solutions Ltd"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "robots",
                        content: "noindex, follow"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "The page you are looking for does not exist within the Arc Engineering infrastructure. Return home for industrial power solutions."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("script", {
                        type: "application/ld+json",
                        children: JSON.stringify(errorSchema)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "absolute inset-0 overflow-hidden pointer-events-none opacity-[0.04]",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("h1", {
                    className: "text-[20rem] md:text-[35rem] font-black text-[#44444E] absolute -bottom-20 -left-20 md:-bottom-48 md:-left-32 leading-none tracking-tighter",
                    children: "404"
                })
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                className: "relative z-10 max-w-xl w-full",
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "bg-white/90 backdrop-blur-md border border-gray-100 rounded-[2rem] p-8 md:p-12 shadow-[0_30px_60px_rgba(0,0,0,0.06)] text-center",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "flex justify-center mb-8",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                    className: "relative group",
                                    children: [
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "absolute inset-0 bg-[#BF092F]/5 rounded-2xl rotate-3 group-hover:rotate-6 transition-transform duration-500"
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "relative h-24 w-24 rounded-2xl border border-gray-100 flex items-center justify-center bg-white shadow-sm transition-all duration-500 group-hover:-rotate-2",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $902440550a78fec8$export$2e2bcd8739ae039), {
                                                size: 48,
                                                className: "text-[#BF092F] animate-pulse",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                            className: "absolute -top-3 -right-3 h-10 w-10 rounded-xl bg-[#44444E] flex items-center justify-center text-white shadow-lg border-2 border-white",
                                            children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $f1eeec1e7587f58a$export$2e2bcd8739ae039), {
                                                size: 18,
                                                className: "text-[#BF092F]"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center justify-center gap-3 mb-4",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-[1px] w-6 bg-[#BF092F]/40"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[#44444E]/60 uppercase tracking-[0.4em] text-[9px] font-black",
                                        children: "Registry Link Failure"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-[1px] w-6 bg-[#BF092F]/40"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("h2", {
                                className: "text-4xl md:text-5xl font-bold text-[#44444E] uppercase tracking-tighter mb-4 leading-none",
                                children: [
                                    "404 ",
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                        className: "text-[#BF092F]",
                                        children: "Invalid Path"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                className: "flex justify-center mb-10",
                                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("p", {
                                    className: "text-gray-400 uppercase tracking-widest text-[10px] font-bold leading-relaxed max-w-xs border-l-2 border-[#BF092F] pl-4 text-left",
                                    children: "The requested directory entry does not exist or has been moved within the Arc Engineering infrastructure."
                                })
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex flex-col sm:flex-row items-center justify-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $b11369f2b382bb4b$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        className: "group w-full sm:w-auto flex items-center justify-center gap-3 bg-[#44444E] text-white px-8 py-4 rounded-xl uppercase text-[10px] font-black tracking-[0.2em] transition-all hover:bg-[#BF092F] shadow-xl active:scale-95",
                                        "aria-label": "Return to homepage",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $32e68b54ee1d3289$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            "Return to Terminal"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("button", {
                                        onClick: ()=>window.history.back(),
                                        className: "cursor-pointer group w-full sm:w-auto flex items-center justify-center gap-3 text-[#44444E] px-8 py-4 rounded-xl uppercase text-[10px] font-black tracking-[0.2em] border border-gray-200 hover:border-[#44444E] bg-white transition-all active:scale-95",
                                        "aria-label": "Go back to previous page",
                                        children: [
                                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $ba8bf023ef8fc70d$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "group-hover:-translate-x-1 transition-transform"
                                            }),
                                            "Previous State"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                        className: "mt-8 flex flex-col items-center gap-3 opacity-30",
                        children: [
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-1 w-1 rounded-full bg-[#BF092F]"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-[1px] w-24 bg-gray-400"
                                    }),
                                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                                        className: "h-1 w-1 rounded-full bg-[#44444E]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("span", {
                                className: "text-[8px] uppercase tracking-[0.4em] font-black text-gray-600",
                                children: "Arc Engineering Solutions Ltd"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("div", {
                className: "fixed inset-0 -z-10 opacity-[0.015] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]"
            })
        ]
    });
};
var $643686657c7af80d$export$2e2bcd8739ae039 = $643686657c7af80d$var$ErrorPage;


/**
 * Root Component
 * Global controller with enhanced SEO for UK/Global Engineering markets.
 */ const $fd878d1a2b2f022b$var$Root = ()=>{
    const location = (0, $b11369f2b382bb4b$export$45d76561a5302f2b)();
    (0, $4Iuzv.useEffect)(()=>{
        const isDigitalCardPage = location.pathname.startsWith("/people/");
        const handleWidgetVisibility = ()=>{
            if (window.Tawk_API && typeof window.Tawk_API.hideWidget === "function") {
                if (isDigitalCardPage) window.Tawk_API.hideWidget();
                else window.Tawk_API.showWidget();
            }
        };
        handleWidgetVisibility();
        if (window.Tawk_API) window.Tawk_API.onLoad = handleWidgetVisibility;
        const timer = setTimeout(handleWidgetVisibility, 200);
        return ()=>clearTimeout(timer);
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$4719288a8f5f7e71), {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)((0, $911b39ee4d517ac3$export$dcef8f9bb9a41431), {
                children: [
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("title", {
                        children: "Arc Engineering | Generator Enclosures & Modular E-Houses"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "description",
                        content: "Arc Engineering Solutions Ltd: Specialist manufacturing of Generator Enclosures, Acoustic Containers, and Modular E-Houses. Serving UK, Europe, and Global markets from hubs in UK & UAE."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "keywords",
                        content: "Generator Enclosures, E-Houses, Acoustic Containers, Modular Power Solutions, Arc Engineering, Steel Fabrication UK, UAE Engineering"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "geo.region",
                        content: "GB;AE"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:title",
                        content: "Arc Engineering Solutions | Global Modular Infrastructure"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:description",
                        content: "Precision-engineered enclosures and E-houses for the power and industrial sectors worldwide."
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:url",
                        content: `https://arcengltd.com${location.pathname}`
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("meta", {
                        name: "robots",
                        content: "index, follow"
                    }),
                    /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("link", {
                        rel: "canonical",
                        href: `https://arcengltd.com${location.pathname}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b11369f2b382bb4b$export$910ae8079b2c2852), {})
        ]
    });
};
const $fd878d1a2b2f022b$var$AppLayout = ()=>{
    return /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $cf5a5aeeefcd27c2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $a6f3d1fb087ebfd1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)("main", {
                id: "main-content",
                children: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b11369f2b382bb4b$export$910ae8079b2c2852), {})
            }),
            /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $4f481b2edf11cb85$export$2e2bcd8739ae039), {})
        ]
    });
};
const $fd878d1a2b2f022b$var$appRouter = (0, $b11369f2b382bb4b$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($fd878d1a2b2f022b$var$Root, {}),
        errorElement: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $643686657c7af80d$export$2e2bcd8739ae039), {}),
        children: [
            {
                element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)($fd878d1a2b2f022b$var$AppLayout, {}),
                children: [
                    {
                        path: "/",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $45d916c3adf9efb4$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/about",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $204ff08d366b382d$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/products",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d6cd840ca211de61$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/products/:categorySlug/:id",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $84c5a9e942c2a800$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/contact",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $547c8b3753650fa9$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/search/:query",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $d0ff8f2651a3f322$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/facilities",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $19a76bbdacc7b0e9$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/facilities/:id",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $3d6cce588754bb8f$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/careers",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2739a9d4c3b2215f$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/projects",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b4e1afa35f5ea44b$export$2e2bcd8739ae039), {})
                    },
                    {
                        path: "/projects/:id",
                        element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $2165d4d91a7da09f$export$2e2bcd8739ae039), {})
                    }
                ]
            },
            {
                path: "people/:username",
                element: /*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $c26637f7df90bb36$export$2e2bcd8739ae039), {})
            }
        ]
    }
]);
const $fd878d1a2b2f022b$var$container = document.getElementById("root");
const $fd878d1a2b2f022b$var$root = (0, $21fa618cfc67d6ae$exports.createRoot)($fd878d1a2b2f022b$var$container);
$fd878d1a2b2f022b$var$root.render(/*#__PURE__*/ (0, $3c47adbabe8a32cb$exports.jsx)((0, $b11369f2b382bb4b$export$323e4fc2fa4753fb), {
    router: $fd878d1a2b2f022b$var$appRouter
}));


//# sourceMappingURL=path0.34606a69.js.map
